webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(28);
	
	__webpack_require__(296);
	
	__webpack_require__(238);
	
	var _vue = __webpack_require__(21);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(14);
	
	var _router = __webpack_require__(193);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _store = __webpack_require__(107);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _declick = __webpack_require__(26);
	
	var _declick2 = _interopRequireDefault(_declick);
	
	var _Application = __webpack_require__(552);
	
	var _Application2 = _interopRequireDefault(_Application);
	
	var _vueAnalytics = __webpack_require__(549);
	
	var _vueAnalytics2 = _interopRequireDefault(_vueAnalytics);
	
	var _vueMeta = __webpack_require__(606);
	
	var _vueMeta2 = _interopRequireDefault(_vueMeta);
	
	var _i18n = __webpack_require__(191);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueMeta2.default, {
	  refreshOnceOnNavigation: true
	});
	if (_declick2.default.googleId) {
	  _vue2.default.use(_vueAnalytics2.default, {
	    id: _declick2.default.googleId,
	    router: _router2.default
	  });
	}
	
	new _vue2.default({
	  el: '#application',
	  template: '<application/>',
	  store: _store2.default,
	  router: _router2.default,
	  i18n: _i18n2.default,
	  components: {
	    Application: _Application2.default
	  },
	  created: function created() {
	    this.autoLogIn();
	  },
	
	  methods: (0, _vuex.mapActions)(['autoLogIn'])
	});

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  domain: "declick.net",
	  basePath: "/",
	  apiUrl: "//declick.net/server/api/",
	  clientUrl: "//declick.net/client/",
	  cmsUrl: "//declick.net/cms/",
	  forumUrl: "//create.declick.net/forum",
	  wikiUrl: "//create.declick.net/wiki/",
	  googleId: "UA-9457907-8",
	  default_circuits_images: "//declick.net/images/default-level.png"
	};

/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(9);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(8);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _vue = __webpack_require__(21);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(184);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _declick = __webpack_require__(26);
	
	var _declick2 = _interopRequireDefault(_declick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	
	exports.default = {
	  createToken: function createToken(username, password) {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      var endpoint, _ref, token;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              endpoint = _declick2.default.apiUrl + 'v1/login';
	              _context.next = 3;
	              return _vue2.default.http.post(endpoint, { username: username, password: password });
	
	            case 3:
	              _ref = _context.sent;
	              token = _ref.body.token;
	              return _context.abrupt('return', token);
	
	            case 6:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	  destroyToken: function destroyToken(token) {
	    var _this2 = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	      var endpoint;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              endpoint = _declick2.default.apiUrl + 'v1/logout';
	              _context2.next = 3;
	              return _vue2.default.http.post(endpoint, {}, { headers: { Authorization: 'Token ' + token } });
	
	            case 3:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2);
	    }))();
	  },
	  createUser: function createUser(_ref2) {
	    var _this3 = this;
	
	    var username = _ref2.username,
	        email = _ref2.email,
	        password = _ref2.password;
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
	      var endpoint;
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              endpoint = _declick2.default.apiUrl + 'v1/users';
	              _context3.next = 3;
	              return _vue2.default.http.post(endpoint, { username: username, email: email, password: password });
	
	            case 3:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this3);
	    }))();
	  },
	  updateUser: function updateUser(id, data, token) {
	    var _this4 = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
	      var endpoint, body, _ref3, user;
	
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              endpoint = _declick2.default.apiUrl + 'v1/users/' + id;
	              body = {
	                email: data.email,
	                id_admin: data.isAdmin,
	                default_project_id: data.defaultProjectId,
	                current_project_id: data.currentProjectId
	              };
	              _context4.next = 4;
	              return _vue2.default.http.patch(endpoint, body, { headers: { Authorization: 'Token ' + token } });
	
	            case 4:
	              _ref3 = _context4.sent;
	              user = _ref3.body;
	              return _context4.abrupt('return', {
	                id: user.id,
	                username: user.username,
	                email: user.email,
	                isAdmin: user.is_admin,
	                defaultProjectId: user.default_project_id,
	                currentProjectId: user.current_project_id
	              });
	
	            case 7:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, _this4);
	    }))();
	  },
	  getUsersByPage: function getUsersByPage(page, filter) {
	    var _this5 = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
	      var endpoint, _ref4, result, users;
	
	      return _regenerator2.default.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              endpoint = _declick2.default.apiUrl + 'v1/users?page=' + page;
	
	              if (filter && filter !== '') {
	                endpoint += '&search=' + filter;
	              }
	              _context5.next = 4;
	              return _vue2.default.http.get(endpoint);
	
	            case 4:
	              _ref4 = _context5.sent;
	              result = _ref4.body;
	              users = result.data.map(function (user) {
	                return {
	                  id: user.id,
	                  username: user.username,
	                  email: user.email,
	                  isAdmin: user.is_admin,
	                  defaultProjectId: user.default_project_id,
	                  currentProjectId: user.current_project_id
	                };
	              });
	              return _context5.abrupt('return', {
	                items: users,
	                currentPage: result.current_page,
	                lastPage: result.last_page
	              });
	
	            case 8:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, _this5);
	    }))();
	  },
	  getUser: function getUser(id) {
	    var _this6 = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
	      var endpoint, _ref5, user;
	
	      return _regenerator2.default.wrap(function _callee6$(_context6) {
	        while (1) {
	          switch (_context6.prev = _context6.next) {
	            case 0:
	              endpoint = _declick2.default.apiUrl + 'v1/users/' + id;
	              _context6.next = 3;
	              return _vue2.default.http.get(endpoint);
	
	            case 3:
	              _ref5 = _context6.sent;
	              user = _ref5.body;
	              return _context6.abrupt('return', {
	                id: user.id,
	                username: user.username,
	                email: user.email,
	                defaultProjectId: user.default_project_id,
	                currentProjectId: user.current_project_id,
	                isAdmin: user.is_admin
	              });
	
	            case 6:
	            case 'end':
	              return _context6.stop();
	          }
	        }
	      }, _callee6, _this6);
	    }))();
	  },
	  getUserByToken: function getUserByToken(token) {
	    var _this7 = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7() {
	      var endpoint, _ref6, user;
	
	      return _regenerator2.default.wrap(function _callee7$(_context7) {
	        while (1) {
	          switch (_context7.prev = _context7.next) {
	            case 0:
	              endpoint = _declick2.default.apiUrl + 'v1/users/me';
	              _context7.next = 3;
	              return _vue2.default.http.get(endpoint, { headers: { Authorization: 'Token ' + token } });
	
	            case 3:
	              _ref6 = _context7.sent;
	              user = _ref6.body;
	              return _context7.abrupt('return', {
	                id: user.id,
	                username: user.username,
	                email: user.email,
	                defaultProjectId: user.default_project_id,
	                currentProjectId: user.current_project_id,
	                isAdmin: user.is_admin
	              });
	
	            case 6:
	            case 'end':
	              return _context7.stop();
	          }
	        }
	      }, _callee7, _this7);
	    }))();
	  },
	  createProject: function createProject(data, token) {
	    var _this8 = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8() {
	      var endpoint, body, _ref7, project;
	
	      return _regenerator2.default.wrap(function _callee8$(_context8) {
	        while (1) {
	          switch (_context8.prev = _context8.next) {
	            case 0:
	              endpoint = _declick2.default.apiUrl + 'v1/projects';
	              body = {
	                name: data.name,
	                is_public: data.isPublic,
	                scene_width: data.sceneWidth,
	                scene_height: data.sceneHeight,
	                description: data.description,
	                instructions: data.instructions
	              };
	              _context8.next = 4;
	              return _vue2.default.http.post(endpoint, body, { headers: { Authorization: 'Token ' + token } });
	
	            case 4:
	              _ref7 = _context8.sent;
	              project = _ref7.body;
	              return _context8.abrupt('return', {
	                id: project.id,
	                name: project.name === '' && project.is_default ? 'Mon projet' : project.name,
	                isPublic: project.is_public,
	                isDefault: project.is_default,
	                sceneWidth: project.scene_width,
	                sceneHeight: project.scene_height,
	                description: project.description,
	                instructions: project.instructions,
	                mainProgramId: project.main_program_id
	              });
	
	            case 7:
	            case 'end':
	              return _context8.stop();
	          }
	        }
	      }, _callee8, _this8);
	    }))();
	  },
	  updateProject: function updateProject(id, data, token) {
	    var _this9 = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee9() {
	      var endpoint, body, _ref8, project;
	
	      return _regenerator2.default.wrap(function _callee9$(_context9) {
	        while (1) {
	          switch (_context9.prev = _context9.next) {
	            case 0:
	              endpoint = _declick2.default.apiUrl + 'v1/projects/' + id;
	              body = {
	                name: data.name,
	                is_public: data.isPublic,
	                scene_width: data.sceneWidth,
	                scene_height: data.sceneHeight,
	                description: data.description,
	                instructions: data.instructions,
	                main_program_id: data.mainProgramId
	              };
	              _context9.next = 4;
	              return _vue2.default.http.patch(endpoint, body, { headers: { Authorization: 'Token ' + token } });
	
	            case 4:
	              _ref8 = _context9.sent;
	              project = _ref8.body;
	              return _context9.abrupt('return', {
	                id: project.id,
	                name: project.name === '' && project.is_default ? 'Mon projet' : project.name,
	                isPublic: project.is_public,
	                isDefault: project.is_default,
	                sceneWidth: project.scene_width,
	                sceneHeight: project.scene_height,
	                description: project.description,
	                instructions: project.instructions,
	                mainProgramId: project.main_program_id
	              });
	
	            case 7:
	            case 'end':
	              return _context9.stop();
	          }
	        }
	      }, _callee9, _this9);
	    }))();
	  },
	  getProject: function getProject(id, token) {
	    var _this10 = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee10() {
	      var endpoint, _ref9, project;
	
	      return _regenerator2.default.wrap(function _callee10$(_context10) {
	        while (1) {
	          switch (_context10.prev = _context10.next) {
	            case 0:
	              endpoint = _declick2.default.apiUrl + 'v1/projects/' + id;
	              _context10.next = 3;
	              return _vue2.default.http.get(endpoint, { headers: { Authorization: 'Token ' + token } });
	
	            case 3:
	              _ref9 = _context10.sent;
	              project = _ref9.body;
	              return _context10.abrupt('return', {
	                id: project.id,
	                name: project.name === '' && project.is_default ? 'Mon projet' : project.name,
	                isPublic: project.is_public,
	                isDefault: project.is_default,
	                sceneWidth: project.scene_width,
	                sceneHeight: project.scene_height,
	                description: project.description,
	                instructions: project.instructions,
	                mainProgramId: project.main_program_id
	              });
	
	            case 6:
	            case 'end':
	              return _context10.stop();
	          }
	        }
	      }, _callee10, _this10);
	    }))();
	  },
	  getAllUserProjects: function getAllUserProjects(id, token) {
	    var _this11 = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee11() {
	      var endpoint, _ref10, projects;
	
	      return _regenerator2.default.wrap(function _callee11$(_context11) {
	        while (1) {
	          switch (_context11.prev = _context11.next) {
	            case 0:
	              endpoint = _declick2.default.apiUrl + 'v1/users/' + id + '/projects';
	              _context11.next = 3;
	              return _vue2.default.http.get(endpoint, { headers: { Authorization: 'Token ' + token } });
	
	            case 3:
	              _ref10 = _context11.sent;
	              projects = _ref10.body;
	              return _context11.abrupt('return', projects.map(function (project) {
	                return {
	                  id: project.id,
	                  name: project.name === '' && project.is_default ? 'Mon projet' : project.name,
	                  isPublic: project.is_public,
	                  isDefault: project.is_default,
	                  sceneWidth: project.scene_width,
	                  sceneHeight: project.scene_height,
	                  description: project.description,
	                  instructions: project.instructions
	                };
	              }));
	
	            case 6:
	            case 'end':
	              return _context11.stop();
	          }
	        }
	      }, _callee11, _this11);
	    }))();
	  },
	  deleteProject: function deleteProject(id, token) {
	    var _this12 = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee12() {
	      var endpoint;
	      return _regenerator2.default.wrap(function _callee12$(_context12) {
	        while (1) {
	          switch (_context12.prev = _context12.next) {
	            case 0:
	              endpoint = _declick2.default.apiUrl + 'v1/projects/' + id;
	              _context12.next = 3;
	              return _vue2.default.http.delete(endpoint, { headers: { Authorization: 'Token ' + token } });
	
	            case 3:
	            case 'end':
	              return _context12.stop();
	          }
	        }
	      }, _callee12, _this12);
	    }))();
	  },
	  getAllProjectResources: function getAllProjectResources(id, token) {
	    var _this13 = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee13() {
	      var endpoint, _ref11, resources;
	
	      return _regenerator2.default.wrap(function _callee13$(_context13) {
	        while (1) {
	          switch (_context13.prev = _context13.next) {
	            case 0:
	              endpoint = _declick2.default.apiUrl + 'v1/projects/' + id + '/resources';
	              _context13.next = 3;
	              return _vue2.default.http.get(endpoint, { headers: { Authorization: 'Token ' + token } });
	
	            case 3:
	              _ref11 = _context13.sent;
	              resources = _ref11.body;
	              return _context13.abrupt('return', resources);
	
	            case 6:
	            case 'end':
	              return _context13.stop();
	          }
	        }
	      }, _callee13, _this13);
	    }))();
	  },
	  getAllCourses: function getAllCourses() {
	    var _this14 = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee14() {
	      var _ref12, courses;
	
	      return _regenerator2.default.wrap(function _callee14$(_context14) {
	        while (1) {
	          switch (_context14.prev = _context14.next) {
	            case 0:
	              _context14.next = 2;
	              return _vue2.default.http.get(_declick2.default.apiUrl + 'v1/circuits');
	
	            case 2:
	              _ref12 = _context14.sent;
	              courses = _ref12.body;
	              return _context14.abrupt('return', courses.map(function (course) {
	                return {
	                  id: course.id,
	                  name: course.name,
	                  imageUrl: _declick2.default.default_circuits_images,
	                  summary: course.short_description,
	                  details: course.description
	                };
	              }));
	
	            case 5:
	            case 'end':
	              return _context14.stop();
	          }
	        }
	      }, _callee14, _this14);
	    }))();
	  },
	  getAllCourseAssessments: function getAllCourseAssessments(id) {
	    var _this15 = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee15() {
	      var endpoint, _ref13, body, assessments, root, result;
	
	      return _regenerator2.default.wrap(function _callee15$(_context15) {
	        while (1) {
	          switch (_context15.prev = _context15.next) {
	            case 0:
	              endpoint = _declick2.default.apiUrl + 'v1/circuits/' + id + '/nodes';
	              _context15.next = 3;
	              return _vue2.default.http.get(endpoint);
	
	            case 3:
	              _ref13 = _context15.sent;
	              body = _ref13.body;
	              assessments = body.map(function (assessment) {
	                return {
	                  id: assessment.id,
	                  name: assessment.name,
	                  url: assessment.link,
	                  circuitId: assessment.circuit_id,
	                  parentId: assessment.parent_id,
	                  position: assessment.position
	                };
	              });
	              root = assessments.filter(function (assessments) {
	                return assessments.parentId === null;
	              })[0];
	              result = orderAssessments(assessments, root);
	              return _context15.abrupt('return', result);
	
	            case 9:
	            case 'end':
	              return _context15.stop();
	          }
	        }
	      }, _callee15, _this15);
	    }))();
	  },
	  registerUserResult: function registerUserResult(userId, assessmentId, data, token) {
	    var _this16 = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee16() {
	      var endpoint, body;
	      return _regenerator2.default.wrap(function _callee16$(_context16) {
	        while (1) {
	          switch (_context16.prev = _context16.next) {
	            case 0:
	              endpoint = _declick2.default.apiUrl + 'v1/users/' + userId + '/results';
	              body = {
	                step_id: assessmentId,
	                passed: data.passed,
	                solution: data.solution
	              };
	
	            case 2:
	            case 'end':
	              return _context16.stop();
	          }
	        }
	      }, _callee16, _this16);
	    }))();
	  },
	  getAllUserResults: function getAllUserResults(id, token) {
	    var _this17 = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee17() {
	      var endpoint, _ref14, body, results;
	
	      return _regenerator2.default.wrap(function _callee17$(_context17) {
	        while (1) {
	          switch (_context17.prev = _context17.next) {
	            case 0:
	              endpoint = _declick2.default.apiUrl + 'v1/users/' + id + '/results';
	              _context17.next = 3;
	              return _vue2.default.http.get(endpoint, { headers: { Authorization: 'Token ' + token } });
	
	            case 3:
	              _ref14 = _context17.sent;
	              body = _ref14.body;
	              results = body.map(function (result) {
	                return {
	                  id: result.id,
	                  userId: result.user_id,
	                  assessmentId: result.step_id,
	                  passed: result.passed,
	                  solution: result.solution
	                };
	              });
	              return _context17.abrupt('return', results);
	
	            case 7:
	            case 'end':
	              return _context17.stop();
	          }
	        }
	      }, _callee17, _this17);
	    }))();
	  },
	  importProject: function importProject(id, token) {
	    var _this18 = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee18() {
	      var endpoint;
	      return _regenerator2.default.wrap(function _callee18$(_context18) {
	        while (1) {
	          switch (_context18.prev = _context18.next) {
	            case 0:
	              endpoint = _declick2.default.apiUrl + 'v1/projects/import/' + id;
	              _context18.next = 3;
	              return _vue2.default.http.post(endpoint, {}, { headers: { Authorization: 'Token ' + token } });
	
	            case 3:
	            case 'end':
	              return _context18.stop();
	          }
	        }
	      }, _callee18, _this18);
	    }))();
	  },
	  resetCircuitNodes: function resetCircuitNodes(token, circuitId, userId) {
	    var _this19 = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee19() {
	      var endpoint;
	      return _regenerator2.default.wrap(function _callee19$(_context19) {
	        while (1) {
	          switch (_context19.prev = _context19.next) {
	            case 0:
	              endpoint = _declick2.default.apiUrl + 'v1/reset/' + circuitId + '/user-id/' + userId;
	              _context19.next = 3;
	              return _vue2.default.http.delete(endpoint, {}, { headers: { Authorization: 'Token ' + token } });
	
	            case 3:
	            case 'end':
	              return _context19.stop();
	          }
	        }
	      }, _callee19, _this19);
	    }))();
	  }
	};
	
	
	function orderAssessments(assessments, root, state) {
	  if (!state) {
	    state = {
	      stack: [],
	      count: 0
	    };
	  }
	  assessments.filter(function (assessment) {
	    return assessment.parentId === root.id;
	  }).sort(function (assessmentA, assessmentB) {
	    return assessmentA.position - assessmentB.position;
	  }).forEach(function (assessment) {
	    assessment.position = state.count++;
	    state.stack.push(assessment);
	    orderAssessments(assessments, assessment, state);
	  });
	  return state.stack;
	}

/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(21);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(14);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _mutations = __webpack_require__(196);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	var _actions = __webpack_require__(194);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _getters = __webpack_require__(195);
	
	var getters = _interopRequireWildcard(_getters);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	exports.default = new _vuex2.default.Store({
	  state: {
	    token: null,
	    user: null,
	    currentProject: null,
	    currentCourse: null,
	    currentCourseResults: null,
	    currentAssessment: null,
	    executeProject: null
	  },
	  getters: getters,
	  mutations: _mutations2.default,
	  actions: actions
	});

/***/ }),
/* 108 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LOG_IN = exports.LOG_IN = 'LOG_IN';
	var LOG_OUT = exports.LOG_OUT = 'LOG_OUT';
	var PROJECT_SELECTION = exports.PROJECT_SELECTION = 'PROJECT_SELECTION';
	var COURSE_SELECTION = exports.COURSE_SELECTION = 'COURSE_SELECTION';
	var ASSESSMENT_SELECTION = exports.ASSESSMENT_SELECTION = 'ASSESSMENT_SELECTION';
	var RECEIVE_RESULTS = exports.RECEIVE_RESULTS = 'RECEIVE_RESULTS';
	var ASSESSMENT_RESULT = exports.ASSESSMENT_RESULT = 'ASSESSMENT_RESULT';

/***/ }),
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/spinner.53ec4ec.gif";

/***/ }),
/* 184 */,
/* 185 */,
/* 186 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'data': 'M25.255,63.302c32.97-3.167,63.481-17.886,96.522-21.262c31.374-3.206,62.175-4.643,94.51-4.328c45.235,0.439,113.158,22.029,128.641,66.525c10.522,30.243,11.189,71.242-8.883,97.309c-23.825,30.939-55.704,40.616-89.128,60.174c-39.078,22.867-39.078,22.867-75.06,47.575c-35.261,24.213-87.611,59.112-92.27,102.089c-2.703,24.943,7.114,54.339,21.787,74.96c28.008,39.363,65.192,80.229,111.434,101.433c55.587,25.485,112.499,36.663,173.848,39.621c57.567,2.778,111.682,2.036,162.889-24.55c39.235-20.368,69.451-54.185,69.977-97.74c0.375-31.134-11.793-55.753-22.851-84.559c-11.122-28.972-16.033-58.073-15.71-88.649c0.292-27.768,11.396-54.101,35.71-70.92c25.972-17.969,54.402-25.999,72.833-52.986c33.826-49.535,12.82-134.523,70.377-170.015c65.75-40.539,163.432,7.745,209.688,53.859c34.891,34.786,57.88,91.84,58.417,139.253c0.237,20.913,3.027,44.543-1.792,64.917c-5.568,23.546-19.611,34.563-39.299,48.274c-40.057,27.902-78.061,62.405-88.834,109.851c-4.686,20.627-9.176,46.802,1.037,66.749c6.909,13.499,19.683,26.981,31.945,36.569c52.711,41.21,131.881,44.271,196.91,44.396c84.241,0.162,148.639-52.938,177.451-124.24c23.287-57.621,31.08-113.144,31.07-174.281c-0.009-49.22-22.069-102.894-12.887-151.773c4.817-25.648,43.632-57.636,68.898-66.53c30.76-10.827,67.95,3.379,96.806,13.133',
	  'width': 7,
	  'color': '#CFBFC7',
	  'opacity': 0.4
	};

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ({"NODE_ENV":"production"});

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EventBus = undefined;
	
	var _vue = __webpack_require__(21);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventBus = exports.EventBus = new _vue2.default();

/***/ }),
/* 189 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  "mapgen": {
	    "drawer": "drawer",
	    "drawer-desc": "visual editor to draw map",
	    "code": "code",
	    "code-desc": "code editor to get map code",
	    "height": "height",
	    "height-desc": "height of the map",
	    "width": "width",
	    "width-desc": "width of the map",
	    "swap-desc": "swap dimensions",
	    "trash-desc": "reset editor",
	    "eraser-desc": "clear map",
	    "draw-border": "draw borders",
	    "maze-generator-desc": "maze generator",
	    "maze-pathfind-desc": "solve an exit path",
	    "previous-tile": "previous tile",
	    "next-tile": "next tile",
	    "tile": "tile",
	    "cells": "cells",
	    "cells-desc": "total cells in map",
	    "clipboard-desc": "copy code in clipboard",
	    "erase-code-desc": "clear code in text area",
	    "export-code": "import code in visual editor",
	    "builder-name-desc": "builder name",
	    "builder-action-desc": "action name",
	    "info": "help to use editor",
	    "help-drawer": "help to use editor",
	    "help-editor": "help to use editor",
	    "alert": {
	      "accept": "yes",
	      "refuse": "no",
	      "remove-all": "remove all blocks",
	      "reset": "reset all params"
	    }
	  }
	};

/***/ }),
/* 190 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  "mapgen": {
	    "drawer": "éditeur",
	    "drawer-desc": "éditeur visuel de carte",
	    "code": "code",
	    "code-desc": "code à récupérer pour créer une carte",
	    "height": "hauteur",
	    "height-desc": "nombre de lignes du niveau",
	    "width": "largeur",
	    "width-desc": "nombre de colonnes du niveau",
	    "swap-desc": "intervertir les dimensions",
	    "trash-desc": "réinitialiser l'éditeur",
	    "eraser-desc": "effacer la carte",
	    "draw-border": "dessiner les bordures",
	    "maze-generator-desc": "générateur de labyrinthe",
	    "maze-pathfind-desc": "calculer le chemin vers la sortie",
	    "previous-tile": "motif de remplissage précédent",
	    "next-tile": "motif de remplissage suivant",
	    "tile": "motif de remplissage",
	    "cells": "cases",
	    "cells-desc": "nombre de cases totales sur la carte",
	    "clipboard-desc": "copier le code dans le presse-papier",
	    "erase-code-desc": "effacer la zone de texte",
	    "export-code": "importer le code dans l'éditeur de plateforme",
	    "builder-name-desc": "nom du maçon",
	    "builder-action-desc": "nom du l'action",
	    "info": "aide pour utiliser l'éditeur",
	    "help-drawer": "aide pour l'éditeur",
	    "help-editor": "aide - zone de texte",
	    "alert": {
	      "accept": "oui",
	      "refuse": "non",
	      "remove-all": "supprimer tous les blocs",
	      "reset": "réinitialisation de tous les paramètres"
	    }
	  }
	};

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.supportedLanguages = undefined;
	
	var _toConsumableArray2 = __webpack_require__(77);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _keys = __webpack_require__(232);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _lodash = __webpack_require__(326);
	
	var _vue = __webpack_require__(21);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueI18n = __webpack_require__(550);
	
	var _vueI18n2 = _interopRequireDefault(_vueI18n);
	
	var _languagesNames = __webpack_require__(324);
	
	var _languagesNames2 = _interopRequireDefault(_languagesNames);
	
	var _messages = __webpack_require__(192);
	
	var _messages2 = _interopRequireDefault(_messages);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueI18n2.default);
	
	var supportedLocales = (0, _keys2.default)(_messages2.default);
	
	var supportedLanguages = exports.supportedLanguages = (0, _lodash.pick)(_languagesNames2.default, supportedLocales);
	
	exports.default = new _vueI18n2.default({
	  locale: autoselectLocale(supportedLocales, 'en'),
	  messages: _messages2.default
	});
	
	
	function autoselectLocale(supportedLocales, defaultLocale) {
	  return getUserLocales().find(function (lang) {
	    return supportedLocales.includes(lang);
	  }) || defaultLocale;
	}
	
	function getUserLocales() {
	  return (0, _lodash.uniq)([navigator.language].concat((0, _toConsumableArray3.default)(navigator.languages || [])).map(function (locale) {
	    return locale.split('-')[0];
	  }));
	}

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _en = __webpack_require__(189);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _fr = __webpack_require__(190);
	
	var _fr2 = _interopRequireDefault(_fr);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    en: _en2.default,
	    fr: _fr2.default
	};

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(21);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(607);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _CmsDocument = __webpack_require__(553);
	
	var _CmsDocument2 = _interopRequireDefault(_CmsDocument);
	
	var _Course = __webpack_require__(564);
	
	var _Course2 = _interopRequireDefault(_Course);
	
	var _CourseList = __webpack_require__(565);
	
	var _CourseList2 = _interopRequireDefault(_CourseList);
	
	var _Progress = __webpack_require__(568);
	
	var _Progress2 = _interopRequireDefault(_Progress);
	
	var _DeclickMap = __webpack_require__(567);
	
	var _DeclickMap2 = _interopRequireDefault(_DeclickMap);
	
	var _declick = __webpack_require__(26);
	
	var _declick2 = _interopRequireDefault(_declick);
	
	var _UserProfile = __webpack_require__(578);
	
	var _UserProfile2 = _interopRequireDefault(_UserProfile);
	
	var _UserEditor = __webpack_require__(577);
	
	var _UserEditor2 = _interopRequireDefault(_UserEditor);
	
	var _HomePage = __webpack_require__(554);
	
	var _HomePage2 = _interopRequireDefault(_HomePage);
	
	var _MapDrawer = __webpack_require__(570);
	
	var _MapDrawer2 = _interopRequireDefault(_MapDrawer);
	
	var _page = __webpack_require__(574);
	
	var _page2 = _interopRequireDefault(_page);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var routes = [{
	  path: '/',
	  name: 'home',
	  component: _HomePage2.default,
	  meta: {
	    id: 4,
	    title: 'Accueil'
	  }
	}, {
	  path: '/users/:id',
	  component: _UserProfile2.default,
	  meta: {
	    title: 'Utilisateurs',
	    keepAlive: false
	  },
	  props: true
	}, {
	  path: '/users/:id/edit',
	  component: _UserEditor2.default,
	  meta: {
	    title: 'Modification de profil utilisateur',
	    keepAlive: false
	  },
	  props: true
	}, {
	  name: 'execute',
	  path: '/execute/:projectId',
	  meta: {
	    useFullscreen: true
	  }
	}, {
	  path: '/explore',
	  component: _CmsDocument2.default,
	  meta: {
	    id: 6,
	    title: 'Découvrir'
	  }
	}, {
	  path: '/history',
	  component: _CmsDocument2.default,
	  meta: {
	    id: 5,
	    title: 'Découvrir'
	  }
	}, {
	  path: '/progress',
	  component: _Progress2.default,
	  meta: { title: 'Progresser' },
	  children: [{
	    path: '',
	    component: _CourseList2.default,
	    meta: { title: 'Liste des parcours' }
	  }, {
	    path: 'course/:id',
	    component: _Course2.default,
	    children: [{
	      path: '',
	      name: 'map',
	      component: _DeclickMap2.default,
	      meta: { title: 'Parcours' },
	      children: [{
	        name: 'step',
	        path: 'run/:assessmentId',
	        meta: {
	          title: 'Étape',
	          useFullscreen: true
	        }
	      }]
	    }]
	  }]
	}, {
	  path: '/create',
	  name: 'create',
	  meta: {
	    title: 'Créer',
	    useFullscreen: true
	  }
	}, {
	  path: '/draw',
	  name: 'draw',
	  component: _MapDrawer2.default,
	  meta: {
	    useFullscreen: true,
	    title: 'Créé tes niveaux'
	  }
	}, {
	  path: '*',
	  name: 'error',
	  component: _page2.default
	}];
	
	exports.default = new _vueRouter2.default({
	  mode: 'history',
	  routes: routes,
	  base: _declick2.default.basePath
	});

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAllUserProjects = exports.updateProject = exports.selectProject = exports.createProject = exports.selectNextAssessment = exports.selectPreviousAssessment = exports.selectAssessment = exports.loadCurrentCourseResults = exports.selectCourse = exports.registerCurrentAssessmentResult = exports.getAllCourses = exports.logOut = exports.logIn = exports.autoLogIn = exports.register = exports.loadExecuteProject = undefined;
	
	var _regenerator = __webpack_require__(9);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray2 = __webpack_require__(76);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _asyncToGenerator2 = __webpack_require__(8);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _mutationTypes = __webpack_require__(108);
	
	var mutations = _interopRequireWildcard(_mutationTypes);
	
	var _api = __webpack_require__(31);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LOCAL_STORAGE_PREFIX = 'ui';
	var LOCAL_STORAGE_VERSION = 5;
	
	var loadExecuteProject = exports.loadExecuteProject = function () {
	  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(_ref2, _ref3) {
	    var state = _ref2.state,
	        commit = _ref2.commit;
	    var id = _ref3.id;
	
	    var project, resources, program, _resources$filter, _resources$filter2;
	
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return _api2.default.getProject(id, state.token);
	
	          case 2:
	            project = _context.sent;
	            _context.next = 5;
	            return _api2.default.getAllProjectResources(project.id);
	
	          case 5:
	            resources = _context.sent;
	            program = null;
	
	            if (project.mainProgramId) {
	              _resources$filter = resources.filter(function (resource) {
	                return resource.id === project.mainProgramId;
	              });
	              _resources$filter2 = (0, _slicedToArray3.default)(_resources$filter, 1);
	              program = _resources$filter2[0].file_name;
	            }
	            commit('setExecuteProject', {
	              sceneHeight: project.sceneHeight,
	              sceneWidth: project.sceneWidth,
	              mainProgram: program,
	              id: project.id,
	              name: project.name
	            });
	
	          case 9:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function loadExecuteProject(_x, _x2) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var register = exports.register = function () {
	  var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(_ref5, _ref6) {
	    var dispatch = _ref5.dispatch;
	    var username = _ref6.username,
	        email = _ref6.email,
	        password = _ref6.password;
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            _context2.next = 2;
	            return _api2.default.createUser({ username: username, email: email, password: password });
	
	          case 2:
	            _context2.next = 4;
	            return dispatch('logIn', { username: username, password: password });
	
	          case 4:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, undefined);
	  }));
	
	  return function register(_x3, _x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	
	var autoLogIn = exports.autoLogIn = function () {
	  var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(_ref8) {
	    var dispatch = _ref8.dispatch;
	    var version, token;
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            version = getLocalItem('version');
	
	            if (version === null || parseInt(version) !== LOCAL_STORAGE_VERSION) {
	              clearLocalItems();
	            } else {
	              token = getLocalItem('token');
	
	              dispatch('logIn', { token: token });
	            }
	
	          case 2:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, undefined);
	  }));
	
	  return function autoLogIn(_x5) {
	    return _ref7.apply(this, arguments);
	  };
	}();
	
	var logIn = exports.logIn = function () {
	  var _ref9 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(_ref10, _ref11) {
	    var commit = _ref10.commit,
	        dispatch = _ref10.dispatch;
	    var username = _ref11.username,
	        password = _ref11.password,
	        token = _ref11.token;
	    var user, projectId, project;
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            if (token) {
	              _context4.next = 4;
	              break;
	            }
	
	            _context4.next = 3;
	            return _api2.default.createToken(username, password);
	
	          case 3:
	            token = _context4.sent;
	
	          case 4:
	            _context4.next = 6;
	            return _api2.default.getUserByToken(token);
	
	          case 6:
	            user = _context4.sent;
	
	            commit(mutations.LOG_IN, { token: token, user: user });
	            setLocalItem('version', LOCAL_STORAGE_VERSION);
	            setLocalItem('token', token);
	            projectId = user.currentProjectId || user.defaultProjectId;
	            _context4.next = 13;
	            return _api2.default.getProject(projectId, token);
	
	          case 13:
	            project = _context4.sent;
	
	            commit(mutations.PROJECT_SELECTION, { project: project });
	            dispatch('loadCurrentCourseResults');
	
	          case 16:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, undefined);
	  }));
	
	  return function logIn(_x6, _x7) {
	    return _ref9.apply(this, arguments);
	  };
	}();
	
	var logOut = exports.logOut = function () {
	  var _ref12 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5(_ref13, _ref14) {
	    var commit = _ref13.commit,
	        dispatch = _ref13.dispatch,
	        state = _ref13.state;
	    var token = _ref14.token;
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            clearLocalItems();
	            _api2.default.destroyToken(state.token);
	            commit(mutations.LOG_OUT);
	            dispatch('loadCurrentCourseResults');
	
	          case 4:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, undefined);
	  }));
	
	  return function logOut(_x8, _x9) {
	    return _ref12.apply(this, arguments);
	  };
	}();
	
	var getAllCourses = exports.getAllCourses = function () {
	  var _ref15 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            _context6.next = 2;
	            return _api2.default.getAllCourses();
	
	          case 2:
	            return _context6.abrupt('return', _context6.sent);
	
	          case 3:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, undefined);
	  }));
	
	  return function getAllCourses() {
	    return _ref15.apply(this, arguments);
	  };
	}();
	
	var registerCurrentAssessmentResult = exports.registerCurrentAssessmentResult = function () {
	  var _ref16 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7(_ref17, data) {
	    var commit = _ref17.commit,
	        _ref17$state = _ref17.state,
	        token = _ref17$state.token,
	        user = _ref17$state.user,
	        currentAssessment = _ref17$state.currentAssessment;
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            if (!user) {
	              _context7.next = 3;
	              break;
	            }
	
	            _context7.next = 3;
	            return _api2.default.registerUserResult(user.id, currentAssessment.id, data, token);
	
	          case 3:
	            commit(mutations.ASSESSMENT_RESULT, {
	              id: currentAssessment.id,
	              result: data
	            });
	
	          case 4:
	          case 'end':
	            return _context7.stop();
	        }
	      }
	    }, _callee7, undefined);
	  }));
	
	  return function registerCurrentAssessmentResult(_x10, _x11) {
	    return _ref16.apply(this, arguments);
	  };
	}();
	
	var selectCourse = exports.selectCourse = function () {
	  var _ref18 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8(_ref19, _ref20) {
	    var commit = _ref19.commit,
	        dispatch = _ref19.dispatch,
	        state = _ref19.state;
	    var id = _ref20.id;
	    var token, assessments;
	    return _regenerator2.default.wrap(function _callee8$(_context8) {
	      while (1) {
	        switch (_context8.prev = _context8.next) {
	          case 0:
	            token = state.token;
	
	            if (!(state.currentCourseId === parseInt(id))) {
	              _context8.next = 3;
	              break;
	            }
	
	            return _context8.abrupt('return');
	
	          case 3:
	            _context8.next = 5;
	            return _api2.default.getAllCourseAssessments(id);
	
	          case 5:
	            assessments = _context8.sent;
	
	            if (state.currentCourseId !== parseInt(id)) {
	              commit(mutations.COURSE_SELECTION, { id: parseInt(id), course: assessments });
	              if (token === state.token) {
	                dispatch('loadCurrentCourseResults');
	              }
	            }
	
	          case 7:
	          case 'end':
	            return _context8.stop();
	        }
	      }
	    }, _callee8, undefined);
	  }));
	
	  return function selectCourse(_x12, _x13) {
	    return _ref18.apply(this, arguments);
	  };
	}();
	
	var loadCurrentCourseResults = exports.loadCurrentCourseResults = function () {
	  var _ref21 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee9(_ref22) {
	    var commit = _ref22.commit,
	        state = _ref22.state;
	    var user, token, results, filteredResults;
	    return _regenerator2.default.wrap(function _callee9$(_context9) {
	      while (1) {
	        switch (_context9.prev = _context9.next) {
	          case 0:
	            user = state.user, token = state.token;
	
	            if (!state.currentCourse) {
	              _context9.next = 10;
	              break;
	            }
	
	            if (!user) {
	              _context9.next = 9;
	              break;
	            }
	
	            _context9.next = 5;
	            return _api2.default.getAllUserResults(user.id, token);
	
	          case 5:
	            results = _context9.sent;
	
	            if (token === state.token) {
	              filteredResults = [];
	
	              state.currentCourse.forEach(function (assessment) {
	                var result = results.reduce(function (selectedResult, currentResult) {
	                  if (currentResult.assessmentId === assessment.id) {
	                    if (!selectedResult) {
	                      return currentResult;
	                    } else if (selectedResult.passed && !currentResult.passed) {
	                      return selectedResult;
	                    } else {
	                      return currentResult;
	                    }
	                  }
	                  return selectedResult;
	                }, null);
	                if (result) {
	                  filteredResults.push(result);
	                }
	              });
	              commit(mutations.RECEIVE_RESULTS, { results: filteredResults });
	            }
	            _context9.next = 10;
	            break;
	
	          case 9:
	            commit(mutations.RECEIVE_RESULTS, { results: [] });
	
	          case 10:
	          case 'end':
	            return _context9.stop();
	        }
	      }
	    }, _callee9, undefined);
	  }));
	
	  return function loadCurrentCourseResults(_x14) {
	    return _ref21.apply(this, arguments);
	  };
	}();
	
	var selectAssessment = exports.selectAssessment = function () {
	  var _ref23 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee10(_ref24, _ref25) {
	    var dispatch = _ref24.dispatch,
	        commit = _ref24.commit,
	        state = _ref24.state;
	    var id = _ref25.id;
	    return _regenerator2.default.wrap(function _callee10$(_context10) {
	      while (1) {
	        switch (_context10.prev = _context10.next) {
	          case 0:
	            commit(mutations.ASSESSMENT_SELECTION, { id: id });
	            _context10.next = 3;
	            return dispatch('registerCurrentAssessmentResult', {});
	
	          case 3:
	          case 'end':
	            return _context10.stop();
	        }
	      }
	    }, _callee10, undefined);
	  }));
	
	  return function selectAssessment(_x15, _x16) {
	    return _ref23.apply(this, arguments);
	  };
	}();
	
	var selectPreviousAssessment = exports.selectPreviousAssessment = function selectPreviousAssessment(_ref26) {
	  var dispatch = _ref26.dispatch,
	      state = _ref26.state;
	
	  var currentPosition = null;
	  for (var index = 0; index < state.currentCourse.length; index++) {
	    var currentItem = state.currentCourse[index];
	    if (currentItem.id === state.currentAssessment.id) {
	      currentPosition = index;
	      break;
	    }
	  }
	  if (currentPosition !== null && state.currentCourse[currentPosition - 1]) {
	    dispatch('selectAssessment', {
	      id: state.currentCourse[currentPosition - 1].id
	    });
	  }
	  return currentPosition;
	};
	
	var selectNextAssessment = exports.selectNextAssessment = function selectNextAssessment(_ref27) {
	  var dispatch = _ref27.dispatch,
	      state = _ref27.state;
	
	  var currentPosition = null;
	  for (var index = 0; index < state.currentCourse.length; index++) {
	    var currentItem = state.currentCourse[index];
	    if (currentItem.id === state.currentAssessment.id) {
	      currentPosition = index;
	      break;
	    }
	  }
	  if (currentPosition !== null && state.currentCourse[currentPosition + 1]) {
	    dispatch('selectAssessment', {
	      id: state.currentCourse[currentPosition + 1].id
	    });
	  }
	};
	
	var createProject = exports.createProject = function () {
	  var _ref28 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee11(_ref29, _ref30) {
	    var commit = _ref29.commit,
	        state = _ref29.state;
	    var data = _ref30.data;
	    var project;
	    return _regenerator2.default.wrap(function _callee11$(_context11) {
	      while (1) {
	        switch (_context11.prev = _context11.next) {
	          case 0:
	            _context11.next = 2;
	            return _api2.default.createProject(data, state.token);
	
	          case 2:
	            project = _context11.sent;
	            _context11.next = 5;
	            return _api2.default.updateUser(state.user.id, {
	              currentProjectId: project.id
	            }, state.token);
	
	          case 5:
	            commit(mutations.PROJECT_SELECTION, { project: project });
	
	          case 6:
	          case 'end':
	            return _context11.stop();
	        }
	      }
	    }, _callee11, undefined);
	  }));
	
	  return function createProject(_x17, _x18) {
	    return _ref28.apply(this, arguments);
	  };
	}();
	
	var selectProject = exports.selectProject = function () {
	  var _ref31 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee12(_ref32, _ref33) {
	    var commit = _ref32.commit,
	        state = _ref32.state;
	    var id = _ref33.id;
	    var project;
	    return _regenerator2.default.wrap(function _callee12$(_context12) {
	      while (1) {
	        switch (_context12.prev = _context12.next) {
	          case 0:
	            _context12.next = 2;
	            return _api2.default.updateUser(state.user.id, {
	              currentProjectId: id
	            }, state.token);
	
	          case 2:
	            _context12.next = 4;
	            return _api2.default.getProject(id, state.token);
	
	          case 4:
	            project = _context12.sent;
	
	            commit(mutations.PROJECT_SELECTION, { project: project });
	
	          case 6:
	          case 'end':
	            return _context12.stop();
	        }
	      }
	    }, _callee12, undefined);
	  }));
	
	  return function selectProject(_x19, _x20) {
	    return _ref31.apply(this, arguments);
	  };
	}();
	
	var updateProject = exports.updateProject = function () {
	  var _ref34 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee13(_ref35, _ref36) {
	    var state = _ref35.state;
	    var id = _ref36.id,
	        data = _ref36.data;
	    return _regenerator2.default.wrap(function _callee13$(_context13) {
	      while (1) {
	        switch (_context13.prev = _context13.next) {
	          case 0:
	            _context13.next = 2;
	            return _api2.default.updateProject(id, data, state.token);
	
	          case 2:
	            return _context13.abrupt('return', _context13.sent);
	
	          case 3:
	          case 'end':
	            return _context13.stop();
	        }
	      }
	    }, _callee13, undefined);
	  }));
	
	  return function updateProject(_x21, _x22) {
	    return _ref34.apply(this, arguments);
	  };
	}();
	
	var getAllUserProjects = exports.getAllUserProjects = function () {
	  var _ref37 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee14(_ref38) {
	    var state = _ref38.state;
	    return _regenerator2.default.wrap(function _callee14$(_context14) {
	      while (1) {
	        switch (_context14.prev = _context14.next) {
	          case 0:
	            _context14.next = 2;
	            return _api2.default.getAllUserProjects(state.user.id, state.token);
	
	          case 2:
	            return _context14.abrupt('return', _context14.sent);
	
	          case 3:
	          case 'end':
	            return _context14.stop();
	        }
	      }
	    }, _callee14, undefined);
	  }));
	
	  return function getAllUserProjects(_x23) {
	    return _ref37.apply(this, arguments);
	  };
	}();
	
	function getLocalItem(key) {
	  return localStorage.getItem(LOCAL_STORAGE_PREFIX + '.' + key);
	}
	
	function setLocalItem(key, value) {
	  return localStorage.setItem(LOCAL_STORAGE_PREFIX + '.' + key, value);
	}
	
	function clearLocalItems() {
	  var keys = [];
	  for (var index = 0; index < localStorage.length; index++) {
	    keys.push(localStorage.key(index));
	  }
	  var prefixLength = LOCAL_STORAGE_PREFIX.length;
	  keys.forEach(function (key) {
	    if (key.substr(0, prefixLength + 1) === LOCAL_STORAGE_PREFIX + '.') {
	      localStorage.removeItem(key);
	    }
	  });
	}

/***/ }),
/* 195 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getUser = exports.getUser = function getUser(state) {
	  return state.user;
	};

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(236);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _slicedToArray2 = __webpack_require__(76);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _setExecuteProject$mu;
	
	var _vue = __webpack_require__(21);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _mutationTypes = __webpack_require__(108);
	
	var mutations = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (_setExecuteProject$mu = {
	  setExecuteProject: function setExecuteProject(state, project) {
	    state.executeProject = project;
	  }
	}, (0, _defineProperty3.default)(_setExecuteProject$mu, mutations.LOG_IN, function (state, _ref) {
	  var token = _ref.token,
	      user = _ref.user;
	
	  state.token = token;
	  state.user = user;
	}), (0, _defineProperty3.default)(_setExecuteProject$mu, mutations.LOG_OUT, function (state) {
	  state.token = null;
	  state.user = null;
	  state.currentProject = null;
	}), (0, _defineProperty3.default)(_setExecuteProject$mu, mutations.PROJECT_SELECTION, function (state, _ref2) {
	  var project = _ref2.project;
	
	  state.currentProject = project;
	}), (0, _defineProperty3.default)(_setExecuteProject$mu, mutations.COURSE_SELECTION, function (state, _ref3) {
	  var id = _ref3.id,
	      course = _ref3.course;
	
	  state.currentAssessment = null;
	  state.currentCourseId = id;
	  state.currentCourse = course;
	  state.currentCourseResults = [];
	}), (0, _defineProperty3.default)(_setExecuteProject$mu, mutations.ASSESSMENT_SELECTION, function (state, _ref4) {
	  var id = _ref4.id;
	
	  var _state$currentCourse$ = state.currentCourse.filter(function (assessment) {
	    return assessment.id === id;
	  }),
	      _state$currentCourse$2 = (0, _slicedToArray3.default)(_state$currentCourse$, 1),
	      assessment = _state$currentCourse$2[0];
	
	  if (assessment) {
	    state.currentAssessment = assessment;
	  } else {
	    state.currentAssessment = null;
	  }
	}), (0, _defineProperty3.default)(_setExecuteProject$mu, mutations.RECEIVE_RESULTS, function (state, _ref5) {
	  var results = _ref5.results;
	
	  state.currentCourseResults = results;
	}), (0, _defineProperty3.default)(_setExecuteProject$mu, mutations.ASSESSMENT_RESULT, function (state, _ref6) {
	  var id = _ref6.id,
	      result = _ref6.result;
	
	  var _state$currentCourseR = state.currentCourseResults.filter(function (resultItem) {
	    return resultItem.assessmentId === id;
	  }),
	      _state$currentCourseR2 = (0, _slicedToArray3.default)(_state$currentCourseR, 1),
	      resultEntry = _state$currentCourseR2[0];
	
	  if (resultEntry) {
	    if (resultEntry.passed && !result.passed) {
	      return;
	    }
	    _vue2.default.set(resultEntry, 'visited', true);
	    _vue2.default.set(resultEntry, 'passed', result.passed);
	    resultEntry.solution = result.solution;
	  } else {
	    state.currentCourseResults.push({
	      assessmentId: id,
	      visited: true,
	      passed: result.passed,
	      solution: result.solution
	    });
	  }
	}), _setExecuteProject$mu);

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ramda = __webpack_require__(328);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _CourseRun = __webpack_require__(566);
	
	var _CourseRun2 = _interopRequireDefault(_CourseRun);
	
	var _CreateView = __webpack_require__(557);
	
	var _CreateView2 = _interopRequireDefault(_CreateView);
	
	var _FooterBar = __webpack_require__(571);
	
	var _FooterBar2 = _interopRequireDefault(_FooterBar);
	
	var _HeaderBar = __webpack_require__(572);
	
	var _HeaderBar2 = _interopRequireDefault(_HeaderBar);
	
	var _MainMenu = __webpack_require__(573);
	
	var _MainMenu2 = _interopRequireDefault(_MainMenu);
	
	var _Execute = __webpack_require__(562);
	
	var _Execute2 = _interopRequireDefault(_Execute);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  computed: {
	    viewId: function viewId() {
	      if (this.$route.matched) {
	        var last = _ramda2.default.last(this.$route.matched);
	        if (last && last.meta && last.meta.id) {
	          return last.meta.id;
	        }
	      }
	      return null;
	    },
	    viewUseFullscreen: function viewUseFullscreen() {
	      return this.$route.matched.some(function (match) {
	        return match.meta.useFullscreen;
	      });
	    }
	  },
	  components: {
	    courseRun: _CourseRun2.default,
	    CreateView: _CreateView2.default,
	    FooterBar: _FooterBar2.default,
	    HeaderBar: _HeaderBar2.default,
	    MainMenu: _MainMenu2.default,
	    Execute: _Execute2.default
	  }
	};

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _declick = __webpack_require__(26);
	
	var _declick2 = _interopRequireDefault(_declick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['id'],
	  created: function created() {
	    var router = this.$router;
	    window.goTo = function (event, location) {
	      router.push(location);
	      event.preventDefault();
	    };
	    var url = _declick2.default.cmsUrl + 'api/1/tables/pages/rows/' + this.id + '?access_token=jWNoVhWCng6odNLK';
	    this.$http.get(url).then(function (response) {
	      $('#onLoadGif').fadeOut();
	      $('#content').append($.parseHTML(response.body.content, document, true)).fadeIn();
	    });
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 199 */
/***/ (function(module, exports) {

	"use strict";

/***/ }),
/* 200 */
/***/ (function(module, exports) {

	"use strict";

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(14);
	
	var _api = __webpack_require__(31);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['editor'],
	  methods: {
	    importExamplePrograms: function importExamplePrograms(id) {
	
	      if (confirm("Attention, l'import va ajouter plusieurs programmes et médias dans le projet :" + this.currentProject.name)) {
	        _api2.default.importProject(id, this.token);
	      }
	    },
	    toggleMode: function toggleMode() {
	      this.$emit('toggleEditor');
	    }
	  },
	  computed: (0, _vuex.mapState)(['token', 'user', 'currentProject'])
	};

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(27);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	__webpack_require__(28);
	
	var _vuex = __webpack_require__(14);
	
	var _CreateHeaderBar = __webpack_require__(555);
	
	var _CreateHeaderBar2 = _interopRequireDefault(_CreateHeaderBar);
	
	var _CreateMenuBar = __webpack_require__(556);
	
	var _CreateMenuBar2 = _interopRequireDefault(_CreateMenuBar);
	
	var _ProjectCreator = __webpack_require__(558);
	
	var _ProjectCreator2 = _interopRequireDefault(_ProjectCreator);
	
	var _ProjectDetails = __webpack_require__(559);
	
	var _ProjectDetails2 = _interopRequireDefault(_ProjectDetails);
	
	var _ProjectEditor = __webpack_require__(560);
	
	var _ProjectEditor2 = _interopRequireDefault(_ProjectEditor);
	
	var _ProjectList = __webpack_require__(561);
	
	var _ProjectList2 = _interopRequireDefault(_ProjectList);
	
	var _declick = __webpack_require__(26);
	
	var _declick2 = _interopRequireDefault(_declick);
	
	var _eventBus = __webpack_require__(188);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      view: null,
	      params: null,
	      editor: true,
	      wikiUrl: _declick2.default.wikiUrl,
	      wiki: false
	    };
	  },
	
	  computed: (0, _extends3.default)({
	    frameUrl: function frameUrl() {
	      return _declick2.default.clientUrl + 'index.html' + ('#editor=' + this.editor) + ('&token=' + this.token) + (this.currentProject ? '&id=' + this.currentProject.id : '') + ('&wiki=' + this.wiki);
	    }
	  }, (0, _vuex.mapState)(['currentProject', 'token'])),
	  mounted: function mounted() {
	    var _this = this;
	
	    window.addEventListener('message', function (_ref) {
	      var data = _ref.data;
	
	      switch (data) {
	        case 'switchEditor':
	          _this.editor = true;
	          break;
	        case 'switchView':
	          _this.editor = false;
	          break;
	        case 'toggleWiki':
	          _this.toggleWiki();
	          break;
	      }
	    }, false);
	    var createFrame = this.$refs.createFrame;
	    _eventBus.EventBus.$on('initCreate', function () {
	      createFrame.contentWindow.postMessage('init', '*');
	    });
	  },
	
	  methods: {
	    showView: function showView(payload) {
	      if (typeof payload === 'string') {
	        this.view = payload;
	      } else {
	        this.view = payload.view;
	        this.params = payload.params;
	      }
	    },
	    beforeEnter: function beforeEnter(element) {
	      $(element).hide();
	    },
	    onEnter: function onEnter(element, done) {
	      $(element).slideDown(1000, done);
	    },
	    onLeave: function onLeave(element, done) {
	      $(element).slideUp(1000, done);
	    },
	    toggleWiki: function toggleWiki() {
	      var wikiFrame = $(this.$refs.wikiFrame);
	      var createFrame = $(this.$refs.createFrame);
	      wikiFrame.stop();
	      createFrame.stop();
	      this.wiki = !this.wiki;
	      if (this.wiki) {
	        wikiFrame.css("left", "-365px").show().animate({ left: "0" }, 500);
	        createFrame.animate({ "padding-left": "365px" }, 500);
	      } else {
	        wikiFrame.animate({ left: "-365px" }, 500, function () {
	          $(this).hide();
	        });
	        createFrame.animate({ "padding-left": "8px" }, 500, function () {
	          $(this).css("padding-left", "");
	        });
	      }
	    }
	  },
	  components: {
	    CreateHeaderBar: _CreateHeaderBar2.default,
	    CreateMenuBar: _CreateMenuBar2.default,
	    ProjectCreator: _ProjectCreator2.default,
	    ProjectDetails: _ProjectDetails2.default,
	    ProjectEditor: _ProjectEditor2.default,
	    ProjectList: _ProjectList2.default
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(9);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(8);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      name: '',
	      isPublic: false,
	      sceneWidth: '',
	      sceneHeight: '',
	      description: '',
	      instructions: ''
	    };
	  },
	
	  methods: {
	    createProject: function createProject() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var data;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                data = {
	                  name: _this.name,
	                  isPublic: _this.isPublic,
	                  sceneWidth: _this.sceneWidth,
	                  sceneHeight: _this.sceneHeight,
	                  description: _this.description,
	                  instructions: _this.instructions
	                };
	                _context.next = 3;
	                return _this.$store.dispatch('createProject', { data: data });
	
	              case 3:
	                _this.$emit('close');
	
	              case 4:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    }
	  }
	};

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(9);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(8);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(27);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(14);
	
	var _api = __webpack_require__(31);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['params'],
	  computed: (0, _extends3.default)({
	    project: function project() {
	      return this.params.project;
	    }
	  }, (0, _vuex.mapState)(['currentProject', 'user'])),
	  methods: (0, _extends3.default)({
	    selectAsCurrentProject: function selectAsCurrentProject() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _this.selectProject({ id: _this.project.id });
	
	              case 2:
	                _this.$emit('close');
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    },
	    deleteProject: function deleteProject() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return _api2.default.deleteProject(_this2.project.id, _this2.$store.state.token);
	
	              case 2:
	                if (_this2.currentProject.id === _this2.project.id) {
	                  _this2.selectProject({ id: _this2.user.defaultProjectId });
	                }
	                _this2.$emit('showView', { view: 'ProjectList' });
	
	              case 4:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }))();
	    }
	  }, (0, _vuex.mapActions)(['selectProject']))
	};

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(9);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(8);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _api = __webpack_require__(31);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['params'],
	  data: function data() {
	    return {
	      name: '',
	      isPublic: false,
	      sceneWidth: '',
	      sceneHeight: '',
	      description: '',
	      instructions: '',
	      mainProgramId: null,
	      resources: null
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      var resources;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this.name = _this.params.project.name;
	              _this.isPublic = _this.params.project.isPublic;
	              _this.sceneWidth = _this.params.project.sceneWidth;
	              _this.sceneHeight = _this.params.project.sceneHeight;
	              _this.description = _this.params.project.description;
	              _this.instructions = _this.params.project.instructions;
	              _this.mainProgramId = _this.params.project.mainProgramId;
	              _context.next = 9;
	              return _api2.default.getAllProjectResources(_this.params.project.id);
	
	            case 9:
	              resources = _context.sent;
	
	              resources.unshift({
	                file_name: '<aucun>',
	                id: null,
	                media_type: 'text/vnd.colombbus.declick.script'
	              });
	              _this.resources = resources;
	
	            case 12:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	
	  methods: {
	    updateProject: function updateProject() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        var data, truc;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                data = {
	                  name: _this2.name,
	                  isPublic: _this2.isPublic,
	                  sceneWidth: _this2.sceneWidth,
	                  sceneHeight: _this2.sceneHeight,
	                  description: _this2.description,
	                  instructions: _this2.instructions,
	                  mainProgramId: _this2.mainProgramId
	                };
	                _context2.next = 3;
	                return _this2.$store.dispatch('updateProject', {
	                  id: _this2.params.project.id,
	                  data: data
	                });
	
	              case 3:
	                truc = _context2.sent;
	
	                console.debug(truc);
	                _this2.params.project.name = _this2.name;
	                _this2.params.project.isPublic = _this2.isPublic;
	                _this2.params.project.sceneWidth = _this2.sceneWidth;
	                _this2.params.project.sceneHeight = _this2.sceneHeight;
	                _this2.params.project.description = _this2.description;
	                _this2.params.project.instructions = _this2.instructions;
	                _this2.params.project.mainProgramId = _this2.mainProgramId;
	                _this2.showProjectDetails();
	
	              case 13:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }))();
	    },
	    showProjectDetails: function showProjectDetails() {
	      this.$emit('showView', {
	        view: 'ProjectDetails',
	        params: { project: this.params.project }
	      });
	    }
	  }
	};

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(9);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(8);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _vuex = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      projects: []
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return _this.getAllUserProjects();
	
	            case 2:
	              _this.projects = _context.sent;
	
	            case 3:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	
	  methods: (0, _vuex.mapActions)(['getAllUserProjects'])
	};

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(9);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(8);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(27);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(14);
	
	var _declick = __webpack_require__(26);
	
	var _declick2 = _interopRequireDefault(_declick);
	
	var _ExecuteHeaderBar = __webpack_require__(563);
	
	var _ExecuteHeaderBar2 = _interopRequireDefault(_ExecuteHeaderBar);
	
	var _store = __webpack_require__(107);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _vue = __webpack_require__(21);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(184);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	
	var viewPortTag = void 0;
	var currentId = -1;
	
	exports.default = {
	  data: function data() {
	    return {
	      count: 0,
	      hidden: true
	    };
	  },
	
	  computed: (0, _extends3.default)({
	    iframeStyle: function iframeStyle() {
	      var content = "width:";
	      if (this.project && this.project.sceneWidth) {
	        content += this.project.sceneWidth + "px;";
	      } else {
	        content += "100%;";
	      }
	      content += "height:";
	      if (this.project && this.project.sceneHeight) {
	        content += this.project.sceneHeight + "px;";
	      } else {
	        content += "100%;";
	      }
	      return content;
	    },
	    iframeUrl: function iframeUrl() {
	      return _declick2.default.clientUrl + 'execute.html#id=' + this.project.id + '&init=' + encodeURI(this.project.mainProgram) + "&count=" + this.count;
	    }
	  }, (0, _vuex.mapState)({ project: 'executeProject' }), {
	    projectReady: function projectReady() {
	      if (this.project !== null) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }),
	  mounted: function mounted() {
	    if (this.project === null && this.$route.path.indexOf('execute') >= 0) {
	      this.publicUserNeedIfram();
	      this.startConfig();
	    } else {
	      this.startConfig();
	    }
	    if (this.$route.name === 'execute') {
	      this.checkId();
	    }
	  },
	
	  watch: {
	    project: function project() {
	      if (this.project.sceneWidth) {
	        viewPortTag.content = "width=" + this.project.sceneWidth + ", user-scalable=no";
	      } else {
	        viewPortTag.content = "width=device-width, user-scalable=no";
	      }
	    },
	    $route: function $route(to, from) {
	      if (to.name === 'execute') {
	        this.hidden = false;
	        this.checkId();
	      } else if (!this.hidden) {
	        this.hidden = true;
	      }
	    }
	  },
	  components: {
	    ExecuteHeaderBar: _ExecuteHeaderBar2.default
	  },
	  methods: {
	    startConfig: function startConfig() {
	      viewPortTag = document.createElement('meta');
	      viewPortTag.id = "viewport";
	      viewPortTag.name = "viewport";
	      viewPortTag.content = "width=device-width, user-scalable=no";
	      document.getElementsByTagName('head')[0].appendChild(viewPortTag);
	    },
	    publicUserNeedIfram: function publicUserNeedIfram() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var _ref, body;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _vue2.default.http.get(_declick2.default.apiUrl + 'v1/projects/' + _this.$route.path.split('/')[2]);
	
	              case 2:
	                _ref = _context.sent;
	                body = _ref.body;
	                return _context.abrupt('return', body);
	
	              case 5:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    },
	    checkId: function checkId() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        var newId;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                if (!_this2.$route.params.projectId) {
	                  _context2.next = 12;
	                  break;
	                }
	
	                newId = parseInt(_this2.$route.params.projectId);
	
	                if (!(newId !== currentId)) {
	                  _context2.next = 11;
	                  break;
	                }
	
	                _this2.$refs.loading.style.display = "flex";
	                _context2.next = 6;
	                return _store2.default.dispatch('loadExecuteProject', { id: newId });
	
	              case 6:
	                _this2.$refs.loading.style.display = "none";
	                currentId = newId;
	                _this2.count = 0;
	                _context2.next = 12;
	                break;
	
	              case 11:
	                _this2.count++;
	
	              case 12:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }))();
	    }
	  }
	};

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(14);
	
	var previousRoute = void 0;
	
	exports.default = {
	  methods: {
	    goBack: function goBack() {
	      if (previousRoute) {
	        this.$router.push(previousRoute);
	      } else {
	        this.$router.push("/");
	      }
	    }
	  },
	  computed: (0, _vuex.mapState)({ project: 'executeProject' }),
	  watch: {
	    $route: function $route(to, from) {
	      if (to.name === 'execute') {
	        if (from.name !== 'execute') {
	          previousRoute = from.path;
	        }
	      }
	    }
	  }
	};

/***/ }),
/* 209 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(9);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(8);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(27);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  metaInfo: {
	    title: 'Apprendre',
	
	    titleTemplate: '%s - Colombbus',
	
	    meta: [{ 'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8' }, { name: 'viewport', content: 'width=device-width, initial-scale=1' }, { vmid: 'description', name: 'description', content: 'Apprend a utilisé declick grace au parcourt' }]
	  },
	  data: function data() {
	    return {
	      courses: []
	    };
	  },
	
	  methods: (0, _extends3.default)({
	    getImg: function getImg(course) {
	      return "//v2.declick.net/images/" + course.id + ".png";
	    }
	  }, (0, _vuex.mapActions)(['getAllCourses'])),
	  created: function created() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      var courses;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return _this.getAllCourses();
	
	            case 2:
	              courses = _context.sent;
	
	              courses.forEach(function (course) {
	                course.showDetails = false;
	              });
	              _this.courses = courses;
	              console.log(_this.courses[0]);
	
	            case 6:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  }
	};

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(27);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _declick = __webpack_require__(26);
	
	var _declick2 = _interopRequireDefault(_declick);
	
	var _jschannel = __webpack_require__(293);
	
	var _jschannel2 = _interopRequireDefault(_jschannel);
	
	var _vuex = __webpack_require__(14);
	
	var _ProgressHeaderBar = __webpack_require__(569);
	
	var _ProgressHeaderBar2 = _interopRequireDefault(_ProgressHeaderBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	window.Channel = _jschannel2.default;
	exports.default = {
	  data: function data() {
	    return {
	      storeReady: false,
	      componentReady: false,
	      initialized: false
	    };
	  },
	
	  methods: (0, _extends3.default)({
	    init: function init() {
	      var _this = this;
	
	      if (this.initialized || !this.storeReady || !this.componentReady) {
	        return;
	      }
	
	      this.initialized = true;
	
	      if (this.$route.name === 'step') {
	        this.selectAssessment({ id: parseInt(this.$route.params.assessmentId) });
	      }
	
	      window.addEventListener('message', function (event) {
	        if (event.data === "checkLocationBeforGoToCreate") {
	          _this.$router.push("/create");
	        }
	      });
	
	      window.addEventListener('message', function (event) {
	        if (event.data === "validateExercise") {
	          _this.selectNextAssessment();
	        }
	      }, false);
	    }
	  }, (0, _vuex.mapActions)(['currentAssessment', 'selectCourse', 'selectAssessment', 'selectNextAssessment', 'registerCurrentAssessmentResult'])),
	  computed: (0, _extends3.default)({
	    urlLearn: function urlLearn() {
	      var lastParams = "";
	      if (this.$route.path.split("/")[4] === "run") {
	        if (this.currentCourse !== null) {
	          for (var index = 0; index < this.currentCourse.length; index++) {
	            var currentItem = this.currentCourse[index];
	            if (currentItem.id === this.currentAssessment.id) {
	              lastParams = "&project-id=" + this.currentAssessment.id;
	            }
	          }
	        }
	      }
	      if (this.currentAssessment) {
	        if (this.currentAssessment.url) {
	          var regx = /[a-z]*\.html#[a-z]*=(\d{1,})($|&ok=false)/g;
	          var urlMatch = this.currentAssessment.url.match(regx);
	          return _declick2.default.clientUrl + urlMatch + '&token=' + this.token + lastParams;
	        } else {
	          this.$router.push({ name: 'map', params: { id: this.$route.params.id } });
	
	          return _declick2.default.clientUrl + 'learn.html#token=' + this.token + lastParams;
	        }
	      } else {
	        return _declick2.default.clientUrl + 'learn.html#token=' + this.token + lastParams;
	      }
	    }
	  }, (0, _vuex.mapState)(['currentAssessment', 'currentCourse', 'currentCourseResults', 'token'])),
	  mounted: function mounted() {
	    this.componentReady = true;
	    this.init();
	  },
	
	  watch: {
	    currentCourseResults: {
	      handler: function handler(value) {
	        if (value) {
	          this.storeReady = true;
	          this.init();
	        }
	      },
	      immediate: true
	    }
	  },
	  components: {
	    ProgressHeaderBar: _ProgressHeaderBar2.default
	  }
	};

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(9);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(8);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(27);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _map = __webpack_require__(224);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _vuex = __webpack_require__(14);
	
	var _api = __webpack_require__(31);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _mapConfig = __webpack_require__(186);
	
	var _mapConfig2 = _interopRequireDefault(_mapConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var map = new _map2.default();
	
	exports.default = {
	  data: function data() {
	    return {
	      showRest: false
	    };
	  },
	
	  computed: (0, _vuex.mapState)(['currentAssessment', 'currentCourse', 'currentCourseResults', 'user', 'token']),
	  mounted: function mounted() {
	    var _this = this;
	
	    var robotPath = __webpack_require__.p + 'static/map-robot.svg';
	    map.init('map', robotPath, function (step) {
	      _this.selectAssessment({ id: step.id });
	      _this.$router.push({
	        name: 'step',
	        params: {
	          id: _this.$route.params.id,
	          assessmentId: step.id
	        }
	      });
	    }, function () {
	      map.loadPathFromUI(_mapConfig2.default, function () {
	        _this.loadSteps();
	      });
	    });
	  },
	  activated: function activated() {
	    if (this.currentAssessment) {
	      map.setCurrentStep(this.currentAssessment.id, false);
	    }
	  },
	
	  watch: {
	    '$route': function $route() {
	      this.initMap();
	    },
	    'currentAssessment.id': function currentAssessmentId() {
	      var _this2 = this;
	
	      this.$router.push({
	        name: 'step',
	        params: {
	          id: this.$route.params.id,
	          assessmentId: this.currentAssessment.id
	        }
	      });
	      this.$store.dispatch("loadCurrentCourseResults").then(function () {
	        setTimeout(function () {
	          _this2.initMap();
	        }, 100);
	      });
	    },
	
	    currentCourseResults: {
	      handler: function handler(value) {
	        if (value) {
	          map.setResults(value);
	        }
	      },
	      deep: true,
	      immediate: true
	    },
	    user: function user() {
	      this.loadSteps();
	    }
	  },
	  methods: (0, _extends3.default)({
	    initMap: function initMap() {
	      var _this3 = this;
	
	      map.loadPathFromUI(_mapConfig2.default, function () {
	        _this3.loadSteps();
	      });
	    },
	    resetCircuitResult: function resetCircuitResult() {
	      var _this4 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _api2.default.resetCircuitNodes(_this4.token, _this4.$route.params.id, _this4.user.id).then(function (r) {
	                  _this4.showRest = false;
	                  _this4.$store.dispatch("loadCurrentCourseResults");
	                  setTimeout(function () {
	                    _this4.initMap();
	                  }, 250);
	                });
	
	              case 2:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this4);
	      }))();
	    },
	    centeringMap: function centeringMap() {
	      this.initMap();
	    },
	    loadSteps: function loadSteps() {
	      var _this5 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return _this5.selectCourse({ id: _this5.$route.params.id });
	
	              case 2:
	                map.loadStepsFromUI(_this5.currentCourse);
	                if (_this5.currentCourseResults) {
	                  map.setResults(_this5.currentCourseResults);
	                }
	
	              case 4:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this5);
	      }))();
	    }
	  }, (0, _vuex.mapActions)(['selectCourse', 'selectAssessment']))
	};

/***/ }),
/* 213 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var activePath = null;
	
	exports.default = {
	  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
	    if (activePath && activePath !== to.path) {
	      next(activePath);
	    } else {
	      next();
	    }
	  },
	  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
	    activePath = from.path;
	    next();
	  }
	};

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(9);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(8);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(27);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {};
	  },
	
	  computed: (0, _extends3.default)({
	    assessmentName: function assessmentName() {
	      if (this.currentAssessment) {
	        return this.currentAssessment.name;
	      } else {
	        return '';
	      }
	    }
	  }, (0, _vuex.mapState)(['currentAssessment', 'updateMap'])),
	  updated: function updated() {},
	
	  methods: (0, _extends3.default)({
	    previous: function previous() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this.$router.push({
	                  name: 'step',
	                  params: {
	                    id: _this.$route.params.id,
	                    assessmentId: _this.$route.params.assessmentId - 1
	                  }
	                });
	
	                _this.selectPreviousAssessment();
	
	              case 2:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    },
	    next: function next() {
	      this.$router.push({
	        name: 'step',
	        params: {
	          id: this.$route.params.id,
	          assessmentId: this.$route.params.assessmentId + 1
	        }
	      });
	      this.selectNextAssessment();
	    },
	    toggleMapIframe: function toggleMapIframe() {
	      $('#declick-client-learn').css('display', 'none');
	      $('#map').css('display', 'block');
	    }
	  }, (0, _vuex.mapActions)(['selectPreviousAssessment', 'selectNextAssessment']))
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(77);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _stringify = __webpack_require__(229);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _matrix = __webpack_require__(225);
	
	var Matrix = _interopRequireWildcard(_matrix);
	
	var _maze = __webpack_require__(226);
	
	var Maze = _interopRequireWildcard(_maze);
	
	var _vue = __webpack_require__(21);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _easystarjs = __webpack_require__(289);
	
	var _easystarjs2 = _interopRequireDefault(_easystarjs);
	
	var _brace = __webpack_require__(239);
	
	var ace = _interopRequireWildcard(_brace);
	
	var _vueJsToggleButton = __webpack_require__(551);
	
	__webpack_require__(294);
	
	__webpack_require__(240);
	
	__webpack_require__(241);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.component('toggle-button', _vueJsToggleButton.ToggleButton);
	
	exports.default = {
	  name: 'mapGenerator',
	  data: function data() {
	    return {
	      showReset: false,
	      showRemoveAll: false,
	      builderAction: 'poserLigne',
	      builder: 'max',
	      currentView: 'drawer',
	      toBuild: 1,
	      rows: 1,
	      columns: 1,
	      help: false,
	      isMouseDown: false,
	      needReverse: false,
	      tiles: [],
	      mapCode: '',
	      editSession: null,
	      editor: null,
	      selection: null,
	      undoManager: null,
	      isPathToggled: false
	    };
	  },
	  created: function created() {
	    this.$nextTick(this.createEditor);
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    window.addEventListener('mouseup', function () {
	      _this.isMouseDown = false;
	    });
	    this.init();
	  },
	  destroyed: function destroyed() {
	    this.editor.destroy();
	    this.editor.container.remove();
	  },
	
	  computed: {
	    isDrawer: {
	      get: function get() {
	        return this.currentView === 'drawer';
	      },
	      set: function set(isDrawerDisplayed) {
	        this.help = false;
	        this.currentView = isDrawerDisplayed ? 'drawer' : 'code';
	        if (!isDrawerDisplayed) {
	          this.updateTextEditor();
	        }
	        return this.currentView === 'drawer';
	      }
	    }
	  },
	  methods: {
	    clearTextEditor: function clearTextEditor() {
	      this.mapCode = '';
	      this.editSession.setValue(this.mapCode);
	    },
	    createEditor: function createEditor() {
	      this.editor = ace.edit(this.$refs.editor);
	      this.editSession = this.editor.getSession();
	      this.selection = this.editSession.getSelection();
	      this.undoManager = this.editSession.getUndoManager();
	
	      this.editor.setTheme('ace/theme/twilight');
	      this.editor.$blockScrolling = Infinity;
	      this.editor.setShowPrintMargin(false);
	      this.editor.setShowFoldWidgets(false);
	      this.editor.setBehavioursEnabled(false);
	
	      this.editSession.setMode('ace/mode/javascript');
	      this.editSession.setUseWrapMode(true);
	      this.editSession.setOption('useWorker', false);
	
	      this.editSession.setValue(this.mapCode);
	      this.editor.focus();
	    },
	    editorEvent: function editorEvent() {},
	    updateCode: function updateCode() {
	      var tiles = this.mapCode.match(/([0-9,]*)\)$/gm);
	      var rows = tiles.length;
	      var columns = 0;
	      for (var anArray in tiles) {
	        tiles[anArray] = tiles[anArray].replace(')', '').split(',');
	        columns = tiles[anArray].length;
	      }
	      this.setLocalStorage({ rows: rows, columns: columns, tiles: tiles });
	
	      this.tiles = tiles;
	
	      this.init();
	    },
	    setLocalStorage: function setLocalStorage(target) {
	      if (target === null) {
	        window.localStorage.setItem('declick-maze', (0, _stringify2.default)({
	          rows: this.rows,
	          columns: this.columns,
	          tiles: this.tiles
	        }));
	      } else {
	        window.localStorage.setItem('declick-maze', (0, _stringify2.default)(target));
	      }
	    },
	    filterTilesArray: function filterTilesArray(toDeletes, anArray) {
	      anArray.map(function (row) {
	        row.map(function (col, index) {
	          if (toDeletes.indexOf(parseInt(col)) > -1) {
	            row[index] = 0;
	          }
	        });
	      });
	    },
	    clearPath: function clearPath() {
	      console.log("clear path");
	
	      this.filterTilesArray([5], this.tiles);
	      this.$nextTick(this.updateTiles);
	    },
	    findTile: function findTile(anArray, tile) {
	      var pos = void 0;
	      anArray.map(function (row, rowIndex) {
	        var col = row.indexOf(tile);
	        if (col > -1) {
	          pos = { x: col, y: rowIndex };
	        }
	      });
	
	      if (typeof pos === 'undefined') {
	
	        pos = -1;
	      }
	      return pos;
	    },
	    toggleFindPath: function toggleFindPath() {
	      this.isPathToggled = !this.isPathToggled;
	      if (this.isPathToggled) {
	        this.findPath();
	      } else {
	        this.clearPath();
	      }
	    },
	    findPath: function findPath() {
	      var _this2 = this;
	
	      this.filterTilesArray([5], this.tiles);
	      var easystar = new _easystarjs2.default.js();
	      var start = this.findTile(this.tiles, 3);
	      var end = this.findTile(this.tiles, 4);
	      var startX = start.x;
	      var startY = start.y;
	      var endX = end.x;
	      var endY = end.y;
	
	      easystar.setGrid(this.tiles);
	      easystar.setAcceptableTiles([0, 3, 4]);
	
	      easystar.findPath(startX, startY, endX, endY, function (path) {
	        if (path !== null) {
	          path.map(function (pos) {
	            var lastTile = _this2.tiles[pos.y][pos.x];
	            var skip = false;
	
	            if (lastTile === 3) {
	              skip = true;
	            }
	            if (lastTile === 4) {
	              skip = true;
	            }
	            if (!skip) {
	              _this2.tiles[pos.y][pos.x] = 5;
	            }
	          });
	          _this2.updateTiles();
	        }
	      });
	      easystar.calculate();
	    },
	    swapDimensions: function swapDimensions() {
	      this.tiles = Matrix.transpose(this.tiles);
	      this.columns = this.tiles[0].length;
	      this.rows = this.tiles.length;
	
	      this.$nextTick(this.updateTiles);
	    },
	    importCodeFromTextarea: function importCodeFromTextarea() {
	      var selection = this.editor.getSelection();
	
	      selection.selectAll();
	      var range = selection.getRange();
	      var text = this.editSession.getTextRange(range);
	
	      var fuzzyContent = text.trim();
	      var content = fuzzyContent.replace(/[\n]+/g, '\n').trim().replace(/.*\(/g, '').replace(/\)/g, '');
	      var lines = content.split('\n').map(function (line) {
	        return line.split(',').map(function (number) {
	          return parseInt(number);
	        });
	      });
	      this.tiles = lines;
	      this.rows = lines.length;
	      this.columns = lines[0].length;
	      this.$nextTick(this.updateTiles);
	      this.currentView = 'drawer';
	
	      if (this.isPathToggled) {
	        this.findPath();
	      }
	    },
	    increaseBuildingMaterial: function increaseBuildingMaterial() {
	      return this.toBuild < 5 ? this.toBuild++ : this.toBuild = 0;
	    },
	    decreaseBuildingMaterial: function decreaseBuildingMaterial() {
	      return this.toBuild > 0 ? this.toBuild-- : this.toBuild = 5;
	    },
	    copyToClipboard: function copyToClipboard() {
	      var selection = this.editor.getSelection();
	
	      var _selection$getSelecti = selection.getSelectionAnchor(),
	          row = _selection$getSelecti.row,
	          column = _selection$getSelecti.column;
	
	      var text = void 0;
	      var needClearSelection = false;
	      if (selection.isEmpty()) {
	        selection.selectAll();
	        needClearSelection = true;
	      }
	      var range = selection.getRange();
	      text = this.editSession.getTextRange(range);
	
	      var textarea = document.createElement('textarea');
	      textarea.innerHTML = text.trim();
	      document.body.appendChild(textarea);
	      textarea.select();
	      document.execCommand('copy');
	      document.body.removeChild(textarea);
	
	      if (needClearSelection) {
	        selection.clearSelection();
	        this.editor.moveCursorTo(row, column);
	      }
	      this.editor.focus();
	    },
	    updateTextEditor: function updateTextEditor() {
	      var _this3 = this;
	
	      var tiles = this.tiles;
	      var code = tiles.map(function (item) {
	        if (item.length > 0) {
	          return _this3.builder + '.' + _this3.builderAction + '(' + item.join(',') + ')';
	        }
	      });
	      this.mapCode = code.join('\n');
	      this.editSession.setValue(this.mapCode);
	
	      var selection = this.editor.getSelection();
	      selection.selectAll();
	
	      var _selection$getRange = this.selection.getRange(),
	          end = _selection$getRange.end;
	
	      var row = end.row,
	          column = end.column;
	
	      this.editor.moveCursorTo(row, column);
	      selection.clearSelection();
	    },
	    generateMaze: function generateMaze(columns, rows) {
	      var height = parseInt(rows);
	      var width = parseInt(columns);
	      var rowExitStep = width % 2 ? 1 : 2;
	      var columnExitStep = height % 2 ? 2 : 3;
	      var empty2DArray = Array(height).fill(1).map(function () {
	        return Array(width).fill(1);
	      });
	      this.tiles = Maze.generateMaze(empty2DArray);
	      this.tiles[0][1] = 3;
	      this.tiles[this.tiles.length - columnExitStep][this.tiles[0].length - rowExitStep] = 4;
	      this.$nextTick(this.updateTiles);
	
	      if (this.isPathToggled) {
	        this.findPath();
	      }
	    },
	    updateTiles: function updateTiles() {
	      var _this4 = this;
	
	      var cells = [].concat((0, _toConsumableArray3.default)(document.querySelectorAll('table#grid td')));
	      cells.map(function (cell) {
	        cell.className = cell.className.split(' ').filter(function (aClass) {
	          return !aClass.startsWith('to-build-') ? aClass : null;
	        }).join(' ');
	
	        var x = parseInt(cell.dataset['x']);
	        var y = parseInt(cell.dataset['y']);
	        cell.classList.add('to-build-' + _this4.tiles[x][y]);
	      });
	    },
	    clearMap: function clearMap() {
	      this.tiles = Matrix.fillArray2D(this.tiles);
	      this.updateTiles();
	      this.showRemoveAll = false;
	    },
	    clearAll: function clearAll() {
	      this.setLocalStorage({
	        rows: 5,
	        columns: 7,
	        tiles: Matrix.createArray2D(5, 7)
	      });
	      this.init();
	      this.clearMap();
	      this.showReset = false;
	    },
	    drawBorders: function drawBorders() {
	      for (var col = 0; col < this.columns; col++) {
	        this.tiles[0][col] = 1;
	        this.tiles[this.rows - 1][col] = 1;
	      }
	      for (var row = 0; row < this.rows; row++) {
	        this.tiles[row][0] = 1;
	        this.tiles[row][this.columns - 1] = 1;
	      }
	      this.updateTiles();
	    },
	    mouseManager: function mouseManager(e) {
	      var event = e;
	      event.preventDefault();
	      this.isMouseDown = true;
	      var x = event.target.dataset['x'];
	      var y = event.target.dataset['y'];
	      var domCell = event.target;
	
	      var oldMaterialFound = null;
	      var last = null;
	
	      domCell.className.split(' ').filter(function (aClass) {
	        oldMaterialFound = aClass.match(/^to-build-(\d+)/);
	        if (Array.isArray(oldMaterialFound)) {
	          last = parseInt(oldMaterialFound[1]);
	          domCell.classList.remove('to-build-' + last);
	        }
	      }).join(' ');
	
	      if (this.toBuild === last) {
	        domCell.classList.remove('to-build-' + this.toBuild);
	        this.tiles[x][y] = 0;
	      } else {
	        if (this.toBuild > 0) {
	          domCell.classList.add('to-build-' + this.toBuild);
	        }
	        this.tiles[x][y] = this.toBuild;
	      }
	      this.setLocalStorage(null);
	    },
	    cellHightlighter: function cellHightlighter(e) {
	      var event = e;
	      event.preventDefault();
	      var x = event.target.dataset['x'];
	      var y = event.target.dataset['y'];
	      var domCell = event.target;
	      if (this.isMouseDown) {
	        var oldMaterialFound = null;
	        var last = null;
	
	        domCell.className.split(' ').filter(function (aClass) {
	          oldMaterialFound = aClass.match(/^to-build-(\d+)/);
	          if (Array.isArray(oldMaterialFound)) {
	            last = parseInt(oldMaterialFound[1]);
	          }
	        }).join(' ');
	
	        domCell.classList.remove('to-build-' + last);
	
	        if (this.toBuild === 0) {
	          domCell.classList.remove('to-build-' + this.toBuild);
	          this.tiles[x][y] = 0;
	        } else {
	          if (this.toBuild > 0) {
	            domCell.classList.add('to-build-' + this.toBuild);
	          }
	          this.tiles[x][y] = this.toBuild;
	        }
	      }
	      this.setLocalStorage(null);
	    },
	    init: function init() {
	      var backup = JSON.parse(window.localStorage.getItem('declick-maze'));
	
	      this.toBuild = 1;
	      if (backup === null) {
	        this.rows = 5;
	        this.columns = 7;
	        this.tiles = Matrix.createArray2D(5, 7);
	      } else {
	        this.rows = parseInt(backup.rows);
	        this.columns = parseInt(backup.columns);
	        this.tiles = backup.tiles;
	
	        this.tiles.map(function (row) {
	          row.map(function (col, index) {
	            return row[index] = parseInt(col);
	          });
	        });
	        this.$nextTick(this.updateTiles);
	      }
	    }
	  },
	  watch: {
	    rows: function rows() {
	      this.tiles = Matrix.resize(this.tiles, this.columns, this.rows, 0);
	      return this.tiles.length;
	    },
	    columns: function columns() {
	      this.tiles = Matrix.resize(this.tiles, this.columns, this.rows, 0);
	      return this.tiles[0].length;
	    },
	    mapCode: function mapCode() {
	      return this.updateCode();
	    }
	  }
	};

/***/ }),
/* 216 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  methods: {
	    testRoute: function testRoute() {
	      if (this.$route.name === 'create' || this.$route.path.indexOf('execute') >= 0 || this.$route.path.indexOf('draw') >= 0 || this.$route.path.indexOf('run') >= 0) return 0;else return 1;
	    }
	  }
	};

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(27);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _AuthenticationModal = __webpack_require__(575);
	
	var _AuthenticationModal2 = _interopRequireDefault(_AuthenticationModal);
	
	var _vuex = __webpack_require__(14);
	
	var _config = __webpack_require__(187);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      userID: this.$store.state.user ? this.$store.state.user.id : false,
	
	      isAuthenticationModalVisible: false,
	      opened: false,
	      sticky: false,
	      onScroll: null
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var menuY = this.$refs.menu.offsetTop;
	    this.onScroll = function () {
	      if (document.body.scrollTop > menuY) {
	        _this.sticky = true;
	      } else {
	        _this.sticky = false;
	      }
	    };
	    this.onScroll();
	    document.body.addEventListener("scroll", this.onScroll);
	  },
	
	  computed: (0, _extends3.default)({
	    getUserIDLink: function getUserIDLink() {
	      return '/users/' + this.$store.state.user.id;
	    },
	    user_id: function user_id() {
	      return this.userID;
	    },
	    forumLink: function forumLink() {
	      return _config2.default.forumUrl;
	    },
	    stateClass: function stateClass() {
	      return {
	        "main-menu--opened": this.opened,
	        "main-menu--closed": !this.opened,
	        "main-menu--sticky": this.sticky
	      };
	    }
	  }, (0, _vuex.mapState)(["user"])),
	  methods: (0, _extends3.default)({
	    open: function open() {
	      this.opened = true;
	    },
	    close: function close() {
	      this.opened = false;
	    }
	  }, (0, _vuex.mapActions)(["logOut"])),
	  components: {
	    AuthenticationModal: _AuthenticationModal2.default
	  }
	};

/***/ }),
/* 218 */
/***/ (function(module, exports) {

	"use strict";

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(9);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(8);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	__webpack_require__(295);
	
	__webpack_require__(297);
	
	var _RegistrationForm = __webpack_require__(576);
	
	var _RegistrationForm2 = _interopRequireDefault(_RegistrationForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      mode: 'connection',
	      isLogingIn: false,
	      username: '',
	      password: '',
	      error: null
	    };
	  },
	
	  methods: {
	    logIn: function logIn() {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this.isLogingIn = true;
	                _context.prev = 1;
	                _context.next = 4;
	                return _this.$store.dispatch('logIn', {
	                  username: _this.username,
	                  password: _this.password
	                });
	
	              case 4:
	                _this.$emit('close');
	                _context.next = 10;
	                break;
	
	              case 7:
	                _context.prev = 7;
	                _context.t0 = _context['catch'](1);
	
	                _this.error = _context.t0.body.errors;
	
	              case 10:
	                _context.prev = 10;
	
	                _this.isLogingIn = false;
	                return _context.finish(10);
	
	              case 13:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this, [[1, 7, 10, 13]]);
	      }))();
	    }
	  },
	  components: {
	    RegistrationForm: _RegistrationForm2.default
	  }
	};

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(9);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(8);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _vue = __webpack_require__(21);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _declick = __webpack_require__(26);
	
	var _declick2 = _interopRequireDefault(_declick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      username: '',
	      email: '',
	      password: '',
	      errors: {
	        username: null,
	        email: null,
	        password: null,
	        passwordConfirmation: null
	      },
	      passwordConfirmation: '',
	      lastUsernameTest: 0
	    };
	  },
	
	  watch: {
	    username: function username(value) {
	      var _this = this;
	
	      this.errors.username = null;
	      if (this.checkTimeout) {
	        window.clearTimeout(this.checkTimeout);
	      }
	      this.checkTimeout = window.setTimeout((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var endpoint, _ref2, response;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                endpoint = _declick2.default.apiUrl + 'v1/test/username';
	                _context.next = 3;
	                return _vue2.default.http.post(endpoint, { username: _this.username });
	
	              case 3:
	                _ref2 = _context.sent;
	                response = _ref2.body;
	
	                if (response.result === false) {
	                  _this.errors.username = ["Ce nom d'utilisateur est déjà pris."];
	                }
	
	              case 6:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      })), 500);
	    },
	    password: function password() {
	      this.errors.password = null;
	      this.comparePasswords();
	    },
	    passwordConfirmation: function passwordConfirmation() {
	      this.errors.passwordConfirmation = null;
	      this.comparePasswords();
	    },
	    email: function email() {
	      this.errors.email = null;
	    }
	  },
	  methods: {
	    register: function register() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        var error, data, field;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this2.errors.server = null;
	                _context2.prev = 1;
	
	                if (!(!_this2.password || _this2.password.trim().length === 0)) {
	                  _context2.next = 5;
	                  break;
	                }
	
	                error = { body: { password: ["Mot de passe vide"] } };
	                throw error;
	
	              case 5:
	                if (!(!_this2.errors.username && !_this2.errors.password && !_this2.errors.passwordConfirmation && !_this2.errors.email)) {
	                  _context2.next = 13;
	                  break;
	                }
	
	                data = {
	                  username: _this2.username,
	                  password: _this2.password
	                };
	
	                if (_this2.email.trim().length > 0) {
	                  data.email = _this2.email;
	                }
	                _context2.next = 10;
	                return _this2.$store.dispatch('register', data);
	
	              case 10:
	                _context2.next = 12;
	                return _this2.$store.dispatch('logIn', {
	                  username: _this2.username,
	                  password: _this2.password
	                });
	
	              case 12:
	                _this2.$emit('close');
	
	              case 13:
	                _context2.next = 18;
	                break;
	
	              case 15:
	                _context2.prev = 15;
	                _context2.t0 = _context2['catch'](1);
	
	                if (_context2.t0.body) {
	                  for (field in _context2.t0.body) {
	                    _this2.errors[field] = _context2.t0.body[field];
	                  }
	                } else {
	                  _this2.errors.server = ["Erreur du serveur"];
	                }
	
	              case 18:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2, [[1, 15]]);
	      }))();
	    },
	    comparePasswords: function comparePasswords() {
	      if (this.password && this.password.trim().length > 0 || this.passwordConfirmation && this.passwordConfirmation.trim().length > 0) {
	        if (this.password === this.passwordConfirmation) {
	          return true;
	        } else {
	          this.errors.passwordConfirmation = ["Les mots de passe ne correspondent pas"];
	        }
	      }
	      return false;
	    }
	  },
	  checkTimeout: false
	};

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(9);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(8);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _api = __webpack_require__(31);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['id'],
	  data: function data() {
	    return {
	      user: null
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return _api2.default.getUser(_this.id);
	
	            case 2:
	              _this.user = _context.sent;
	
	            case 3:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	
	  methods: {
	    updateUser: function updateUser() {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return _api2.default.updateUser(_this2.user.id, { email: _this2.user.email }, _this2.$store.state.token);
	
	              case 2:
	                _this2.showUserProfile();
	
	              case 3:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }))();
	    },
	    showUserProfile: function showUserProfile() {
	      this.$router.push({ path: '/users/' + this.user.id });
	    }
	  }
	};

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(9);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(8);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _api = __webpack_require__(31);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['id'],
	  data: function data() {
	    return {
	      user: null
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return _api2.default.getUser(_this.id);
	
	            case 2:
	              _this.user = _context.sent;
	
	            case 3:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	
	  methods: {
	    editUser: function editUser() {
	      this.$router.push({ path: '/users/' + this.user.id + '/edit' });
	    }
	  }
	};

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(237);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	!function (a) {
	   true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(28)], __WEBPACK_AMD_DEFINE_FACTORY__ = (a), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof exports === "undefined" ? "undefined" : (0, _typeof3.default)(exports)) ? module.exports = a : a(jQuery);
	}(function (a) {
	  function b(b) {
	    var g = b || window.event,
	        h = i.call(arguments, 1),
	        j = 0,
	        l = 0,
	        m = 0,
	        n = 0,
	        o = 0,
	        p = 0;if (b = a.event.fix(g), b.type = "mousewheel", "detail" in g && (m = -1 * g.detail), "wheelDelta" in g && (m = g.wheelDelta), "wheelDeltaY" in g && (m = g.wheelDeltaY), "wheelDeltaX" in g && (l = -1 * g.wheelDeltaX), "axis" in g && g.axis === g.HORIZONTAL_AXIS && (l = -1 * m, m = 0), j = 0 === m ? l : m, "deltaY" in g && (m = -1 * g.deltaY, j = m), "deltaX" in g && (l = g.deltaX, 0 === m && (j = -1 * l)), 0 !== m || 0 !== l) {
	      if (1 === g.deltaMode) {
	        var q = a.data(this, "mousewheel-line-height");j *= q, m *= q, l *= q;
	      } else if (2 === g.deltaMode) {
	        var r = a.data(this, "mousewheel-page-height");j *= r, m *= r, l *= r;
	      }if (n = Math.max(Math.abs(m), Math.abs(l)), (!f || f > n) && (f = n, d(g, n) && (f /= 40)), d(g, n) && (j /= 40, l /= 40, m /= 40), j = Math[j >= 1 ? "floor" : "ceil"](j / f), l = Math[l >= 1 ? "floor" : "ceil"](l / f), m = Math[m >= 1 ? "floor" : "ceil"](m / f), k.settings.normalizeOffset && this.getBoundingClientRect) {
	        var s = this.getBoundingClientRect();o = b.clientX - s.left, p = b.clientY - s.top;
	      }return b.deltaX = l, b.deltaY = m, b.deltaFactor = f, b.offsetX = o, b.offsetY = p, b.deltaMode = 0, h.unshift(b, j, l, m), e && clearTimeout(e), e = setTimeout(c, 200), (a.event.dispatch || a.event.handle).apply(this, h);
	    }
	  }function c() {
	    f = null;
	  }function d(a, b) {
	    return k.settings.adjustOldDeltas && "mousewheel" === a.type && b % 120 === 0;
	  }var e,
	      f,
	      g = ["wheel", "mousewheel", "DOMMouseScroll", "MozMousePixelScroll"],
	      h = "onwheel" in document || document.documentMode >= 9 ? ["wheel"] : ["mousewheel", "DomMouseScroll", "MozMousePixelScroll"],
	      i = Array.prototype.slice;if (a.event.fixHooks) for (var j = g.length; j;) {
	    a.event.fixHooks[g[--j]] = a.event.mouseHooks;
	  }var k = a.event.special.mousewheel = { version: "3.1.12", setup: function setup() {
	      if (this.addEventListener) for (var c = h.length; c;) {
	        this.addEventListener(h[--c], b, !1);
	      } else this.onmousewheel = b;a.data(this, "mousewheel-line-height", k.getLineHeight(this)), a.data(this, "mousewheel-page-height", k.getPageHeight(this));
	    }, teardown: function teardown() {
	      if (this.removeEventListener) for (var c = h.length; c;) {
	        this.removeEventListener(h[--c], b, !1);
	      } else this.onmousewheel = null;a.removeData(this, "mousewheel-line-height"), a.removeData(this, "mousewheel-page-height");
	    }, getLineHeight: function getLineHeight(b) {
	      var c = a(b),
	          d = c["offsetParent" in a.fn ? "offsetParent" : "parent"]();return d.length || (d = a("body")), parseInt(d.css("fontSize"), 10) || parseInt(c.css("fontSize"), 10) || 16;
	    }, getPageHeight: function getPageHeight(b) {
	      return a(b).height();
	    }, settings: { adjustOldDeltas: !0, normalizeOffset: !0 } };a.fn.extend({ mousewheel: function mousewheel(a) {
	      return a ? this.bind("mousewheel", a) : this.trigger("mousewheel");
	    }, unmousewheel: function unmousewheel(a) {
	      return this.unbind("mousewheel", a);
	    } });
	});

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray2 = __webpack_require__(76);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _paper = __webpack_require__(292);
	
	var _paper2 = _interopRequireDefault(_paper);
	
	__webpack_require__(223);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DeclickMap() {
	    var path;
	
	    var $canvas;
	    var everything;
	
	    var chapters = [];
	    var sChapter, sChapterValidated;
	    var currentChapterLabels;
	    var chapterPaths = [];
	    var chapterLabels = [];
	    var chapterOpen = false;
	
	    var steps = [];
	    var sStep, sStepValidated, sStepVisited;
	    var displayedSteps = [];
	    var stepCallback;
	    var stepsDisplayed = false;
	
	    var current;
	    var currentIndex = -1;
	    var currentCallback = false;
	
	    var labels = [];
	    var labelsVisible = false;
	
	    var initCenter;
	    var targetZoom, targetCenter, targetCurrent;
	    var changeZoom = false,
	        changeCenter = false,
	        changeCurrent = false;
	    var movementSpeed, zoomSpeed, currentSpeed;
	
	    var clickCaptured = false;
	
	    var margin = 40;
	
	    var animationDuration = 0.8;
	
	    var zoomFactor = 200;
	
	    var zoomDisplayLabels = 1.5;
	
	    var maxZoom = 3.5;
	
	    var reset = function reset() {
	        initCenter = new _paper2.default.Point(_paper2.default.view.center);
	        targetCenter = new _paper2.default.Point(initCenter);
	        targetZoom = 1;
	    };
	
	    var initView = function initView(canvasId) {
	        var canvas = document.getElementById(canvasId);
	        $canvas = $(canvas);
	        $canvas.attr("resize", "1");
	        $canvas.css("cursor", "pointer");
	
	        _paper2.default.setup(canvas);
	
	        reset();
	
	        _paper2.default.view.onResize = function (event) {
	            reset();
	            if (stepsDisplayed) {
	                resize();
	            }
	        };
	
	        var scrollTimeout = -1;
	        var endScrollTimeout = -1;
	        var scrollAmount = 0;
	        var scrollPoint = false;
	
	        var handleScroll = function handleScroll() {
	            var newZoom = targetZoom + scrollAmount / zoomFactor;
	            newZoom = Math.min(newZoom, maxZoom);
	            if (newZoom < 1) {
	                setTarget(initCenter, 1, true);
	            } else {
	                var newCenter = scrollPoint.add(targetCenter.subtract(scrollPoint).divide(newZoom / targetZoom));
	                setTarget(newCenter, newZoom, true);
	            }
	            scrollAmount = 0;
	        };
	
	        $canvas.mousewheel(function (event) {
	            event.preventDefault();
	            if (scrollPoint === false) {
	                scrollPoint = _paper2.default.view.getEventPoint(event);
	            }
	            if (endScrollTimeout !== -1) {
	                clearTimeout(endScrollTimeout);
	            }
	            scrollAmount = event.deltaY * event.deltaFactor;
	            if (scrollTimeout === -1 && !(targetZoom < 1 && scrollAmount < 0) && !(targetZoom == maxZoom && scrollAmount > 0)) {
	                handleScroll();
	                scrollTimeout = setTimeout(function () {
	                    handleScroll();
	                    scrollTimeout = -1;
	                }, 200);
	            }
	            endScrollTimeout = setTimeout(function () {
	                if (targetZoom < 1) {
	                    setTarget(initCenter, 1, true);
	                    endScrollTimeout = -1;
	                }
	                scrollPoint = false;
	            }, 250);
	        });
	
	        var tool = new _paper2.default.Tool();
	        tool.onKeyDown = function (event) {
	            if (event.key === 'space') {
	                console.log(initCenter);
	
	                setTarget(initCenter, 1);
	            }
	        };
	
	        var dragStartPoint;
	
	        _paper2.default.view.onMouseDown = function (e) {
	            dragStartPoint = e.point;
	        };
	
	        _paper2.default.view.onMouseDrag = function (e) {
	            var delta = e.point.subtract(dragStartPoint);
	            _paper2.default.view.center = _paper2.default.view.center.subtract(delta);
	            targetCenter = _paper2.default.view.center;
	        };
	
	        _paper2.default.view.onFrame = function (event) {
	            var vector, step;
	            var view = _paper2.default.view;
	            var center = view.center;
	            if (changeCenter) {
	                step = event.delta * movementSpeed;
	                vector = targetCenter.subtract(center);
	                if (vector.length > step) {
	                    step = vector.normalize(step);
	                    view.center = center.add(step);
	                } else {
	                    view.center = new _paper2.default.Point(targetCenter);
	                    changeCenter = false;
	                }
	            }
	            if (changeZoom) {
	                step = event.delta * zoomSpeed;
	                if (view.zoom < targetZoom) {
	                    view.zoom = Math.min(view.zoom + step, targetZoom);
	                } else {
	                    view.zoom = Math.max(view.zoom - step, targetZoom);
	                }
	                if (view.zoom === targetZoom) {
	                    changeZoom = false;
	                }
	                checkLabelsVisibility();
	            }
	            if (changeCurrent) {
	                step = event.delta * currentSpeed;
	                vector = targetCurrent.subtract(current.position);
	                if (vector.length > step) {
	                    step = vector.normalize(step);
	                    current.position = current.position.add(step);
	                } else {
	                    current.position = new _paper2.default.Point(targetCurrent);
	                    changeCurrent = false;
	                    if (currentCallback) {
	                        currentCallback();
	                    }
	                }
	            }
	        };
	    };
	
	    var initSymbols = function initSymbols(currentSVG, callback) {
	        var pChapter = new _paper2.default.Path.Circle(new _paper2.default.Point(0, 0), 12);
	        pChapter.strokeColor = "#E01980";
	        pChapter.strokeWidth = 2;
	        pChapter.fillColor = "#46102A";
	        sChapter = new _paper2.default.Symbol(pChapter);
	
	        var pStep = new _paper2.default.Path.Circle(new _paper2.default.Point(0, 0), 8);
	        pStep.strokeColor = "#E33022";
	        pStep.strokeWidth = 1;
	        pStep.fillColor = "#46102A";
	        sStep = new _paper2.default.Symbol(pStep);
	
	        var pStepValidated = new _paper2.default.Group();
	        var pStepValidatedOuter = new _paper2.default.Path.Circle(new _paper2.default.Point(0, 0), 8);
	        pStepValidatedOuter.strokeColor = "#E33022";
	        pStepValidatedOuter.strokeWidth = 1;
	        pStepValidatedOuter.fillColor = "#46102A";
	        var pStepValidatedInner = new _paper2.default.Path.Circle(new _paper2.default.Point(0, 0), 6);
	        pStepValidatedInner.fillColor = "#0FAC8D";
	        pStepValidated.addChild(pStepValidatedOuter);
	        pStepValidated.addChild(pStepValidatedInner);
	        sStepValidated = new _paper2.default.Symbol(pStepValidated);
	        var pChapterValidated = new _paper2.default.Group();
	        var pChapterValidatedOuter = new _paper2.default.Path.Circle(new _paper2.default.Point(0, 0), 12);
	        pChapterValidatedOuter.strokeColor = "#E01980";
	        pChapterValidatedOuter.strokeWidth = 2;
	        pChapterValidatedOuter.fillColor = "#46102A";
	        var pChapterValidatedInner = new _paper2.default.Path.Circle(new _paper2.default.Point(0, 0), 10);
	        pChapterValidatedInner.fillColor = "#0FAC8D";
	        pChapterValidated.addChild(pChapterValidatedOuter);
	        pChapterValidated.addChild(pChapterValidatedInner);
	        sChapterValidated = new _paper2.default.Symbol(pChapterValidated);
	
	        var pStepVisited = new _paper2.default.Path.Circle(new _paper2.default.Point(0, 0), 6);
	        pStepVisited.fillColor = "#E33022";
	        sStepVisited = new _paper2.default.Symbol(pStepVisited);
	
	        var activeLayer = _paper2.default.project.activeLayer;
	        var currentLayer = new _paper2.default.Layer();
	
	        _paper2.default.project.importSVG(currentSVG, function (item) {
	            current = item;
	            current.visible = false;
	            activeLayer.activate();
	            if (callback) {
	                callback();
	            }
	        });
	    };
	
	    var checkLabelsVisibility = function checkLabelsVisibility() {
	        if (labelsVisible) {
	            if (_paper2.default.view.zoom < zoomDisplayLabels) {
	                for (var i = 0; i < chapterLabels.length; i++) {
	                    chapterLabels[i].visible = false;
	                }
	                labelsVisible = false;
	            }
	        } else {
	            if (_paper2.default.view.zoom >= zoomDisplayLabels) {
	                for (var i = 0; i < chapterLabels.length; i++) {
	                    chapterLabels[i].visible = true;
	                }
	                labelsVisible = true;
	            }
	        }
	    };
	
	    var centerEverything = function centerEverything() {
	        everything.position = new _paper2.default.Point(_paper2.default.view.center);
	    };
	
	    var initSteps = function initSteps(data) {
	        steps = [];
	        var currentPosition = 0;
	        function getObject(value, chapter) {
	            var _steps$filter = steps.filter(function (step) {
	                return step.id === value.parentId;
	            }),
	                _steps$filter2 = (0, _slicedToArray3.default)(_steps$filter, 1),
	                parent = _steps$filter2[0];
	
	            if (parent) {
	                parent.chapter = true;
	            }
	            var object = { chapter: chapter, name: value.name };
	            object.position = value.position;
	            if (value.passed) {
	                object.passed = value.passed;
	            }
	            if (value.visited) {
	                object.visited = value.visited;
	            }
	            if (value.url) {
	                object.url = value.url;
	            }
	            if (value.id) {
	                object.id = value.id;
	            }
	            return object;
	        }
	        $.each(data, function (key, value) {
	            steps.push(getObject(value));
	        });
	    };
	
	    var openChapter = function openChapter(index, animate) {
	        if (typeof animate === 'undefined') {
	            animate = false;
	        }
	        if (index < chapterPaths.length) {
	            var currentChapterPath = chapterPaths[index];
	            var bounds = currentChapterPath.bounds;
	            bounds = bounds.expand(2 * margin);
	            var zHeight = _paper2.default.view.bounds.height / bounds.height;
	            var zWidth = _paper2.default.view.bounds.width / bounds.width;
	            var newZoom = _paper2.default.view.zoom * Math.min(zHeight, zWidth);
	            var newCenter = bounds.center;
	            console.debug(newCenter);
	            if (newZoom < zoomDisplayLabels) {
	                var cPosition = chapters[index].bounds.point.subtract(margin);
	                var delta = cPosition.subtract(newCenter).normalize((1 - newZoom / zoomDisplayLabels) * bounds.width / 2);
	                newCenter = newCenter.add(delta);
	                console.debug(newCenter);
	                newZoom = zoomDisplayLabels;
	            }
	            if (animate) {
	                setTarget(newCenter, newZoom);
	            } else {
	                _paper2.default.view.center = new _paper2.default.Point(newCenter);
	                targetCenter = new _paper2.default.Point(newCenter);
	                _paper2.default.view.zoom = newZoom;
	                targetZoom = _paper2.default.view.zoom;
	                checkLabelsVisibility();
	            }
	            chapterOpen = true;
	        } else {
	            chapterOpen = false;
	        }
	    };
	
	    var setTargetZoom = function setTargetZoom(zoom, fast) {
	        targetZoom = zoom;
	        changeZoom = true;
	        zoomSpeed = Math.abs(zoom - _paper2.default.view.zoom) / animationDuration;
	        if (fast) {
	            zoomSpeed = zoomSpeed * 2;
	        }
	    };
	
	    var setTargetCenter = function setTargetCenter(center, fast) {
	        targetCenter = new _paper2.default.Point(center);
	        changeCenter = true;
	        movementSpeed = _paper2.default.view.center.getDistance(targetCenter) / animationDuration;
	        if (fast) {
	            movementSpeed = movementSpeed * 2;
	        }
	    };
	
	    var setTargetCurrent = function setTargetCurrent(position, factor) {
	        targetCurrent = new _paper2.default.Point(position);
	        changeCurrent = true;
	        currentSpeed = current.position.getDistance(targetCurrent) * factor / animationDuration;
	    };
	
	    var setTarget = function setTarget(center, zoom, fast) {
	        setTargetZoom(zoom, fast);
	        setTargetCenter(center, fast);
	    };
	
	    var wordwrap = function wordwrap(txt, max) {
	        var lines = [];
	        var space = -1;
	        var times = 0;
	        function cut() {
	            for (var i = 0; i < txt.length; i++) {
	                if (txt[i] == ' ') {
	                    space = i;
	                }
	                if (i >= max) {
	                    if (space == -1 || txt[i] == ' ') {
	                        space = i;
	                    }
	                    if (space > 0) {
	                        lines.push(txt.slice(txt[0] === ' ' ? 1 : 0, space));
	                    }
	                    txt = txt.slice(txt[0] === ' ' ? space + 1 : space);
	                    space = -1;
	                    break;
	                }
	            }
	            check();
	        }
	
	        function check() {
	            if (txt.length <= max) {
	                lines.push(txt[0] === ' ' ? txt.slice(1) : txt);txt = '';
	            } else if (txt.length) {
	                cut();
	            }
	            return;
	        }
	        check();
	        return lines.join('\n');
	    };
	
	    var getSymbol = function getSymbol(step) {
	        if (step.chapter) {
	            if (step.passed) {
	                return sChapterValidated;
	            } else {
	                return sChapter;
	            }
	        } else {
	            if (step.passed) {
	                return sStepValidated;
	            } else if (step.visited) {
	                return sStepVisited;
	            } else {
	                return sStep;
	            }
	        }
	    };
	
	    var removeSteps = function removeSteps() {
	        _paper2.default.project.activeLayer.removeChildren();
	
	        displayedSteps = [];
	        chapterPaths = [];
	        chapterLabels = [];
	        chapters = [];
	        labels = [];
	        currentIndex = -1;
	        chapterOpen = false;
	        changeCenter = false;
	        changeZoom = false;
	        changeCurrent = false;
	        labelsVisible = false;
	        stepsDisplayed = true;
	
	        if (initCenter) {
	            _paper2.default.view.center = new _paper2.default.Point(initCenter);
	            targetCenter = new _paper2.default.Point(initCenter);
	        }
	        _paper2.default.view.zoom = 1;
	        targetZoom = 1;
	
	        everything = new _paper2.default.Group();
	
	        if (path) {
	            path.fitBounds(_paper2.default.view.bounds.expand(-margin));
	
	            everything.addChild(path);
	
	            centerEverything();
	        }
	    };
	
	    var resize = function resize() {
	        var savedCurrentIndex = currentIndex;
	        var savedChapterOpen = chapterOpen;
	        removeSteps();
	
	        displaySteps();
	
	        if (savedCurrentIndex > -1 && savedChapterOpen) {
	            setCurrentStep(steps[savedCurrentIndex].position, false);
	        }
	    };
	
	    var displaySteps = function displaySteps() {
	        var previousChapter = false;
	        var previousLabel;
	        var currentLabels;
	        if (!path) {
	            return;
	        }
	        var basePath = path.clone();
	
	        var placeSymbol = function placeSymbol(index, curve, length, last) {
	            var chapter = steps[index].chapter;
	            var symbol = getSymbol(steps[index]);
	            var point = curve.getPointAt(length, false);
	            var placed = symbol.place(point);
	            var hasSubItems = false;
	            var offset, newPath, chapterPath;
	            displayedSteps.push(placed);
	            everything.addChild(placed);
	            if (chapter) {
	                if (previousChapter) {
	                    offset = basePath.getOffsetOf(placed.position);
	                    newPath = basePath.split(offset);
	                    chapterPath = basePath;
	                    chapterPath.visible = false;
	                    chapterPaths.push(chapterPath);
	                    basePath = newPath;
	                    everything.addChild(currentLabels);
	                    chapterLabels.push(currentLabels);
	                }
	                previousChapter = true;
	                chapters.push(placed);
	                currentLabels = new _paper2.default.Group();
	                currentLabels.visible = false;
	                if (typeof steps[index + 1] !== 'undefined' && !steps[index + 1].chapter) {
	                    hasSubItems = true;
	                }
	                if (hasSubItems) {
	                    placed.onMouseDown = getChapterMouseHandler(chapters.length - 1);
	                } else {
	                    placed.onMouseDown = getStepMouseHandler(index);
	                }
	
	                var textNumber = new _paper2.default.PointText({
	                    point: point,
	                    justification: 'center',
	                    fontSize: 15,
	                    fillColor: "#FFFFFF",
	                    content: chapters.length
	                });
	                textNumber.bounds.center = point;
	                if (hasSubItems) {
	                    placed.onMouseDown = getChapterMouseHandler(chapters.length - 1);
	                    textNumber.onMouseDown = getChapterMouseHandler(chapters.length - 1);
	                } else {
	                    placed.onMouseDown = getStepMouseHandler(index);
	                    textNumber.onMouseDown = getStepMouseHandler(index);
	                }
	                everything.addChild(textNumber);
	            } else {
	                placed.onMouseDown = getStepMouseHandler(index);
	                if (last) {
	                    offset = basePath.getOffsetOf(placed.position);
	                    newPath = basePath.split(offset);
	                    chapterPath = basePath;
	                    chapterPath.visible = false;
	                    chapterPaths.push(chapterPath);
	                    basePath = newPath;
	                    everything.addChild(currentLabels);
	                    chapterLabels.push(currentLabels);
	                }
	            }
	
	            var textColor, textSize, textShift;
	            if (chapter) {
	                textColor = "#E01980";
	                textSize = 15;
	                textShift = 20;
	            } else {
	                textColor = "#FFFFFF";
	                textSize = 8;
	                textShift = 15;
	            }
	            var normal = curve.getNormalAt(length, false);
	            normal.length = textShift;
	            var text = new _paper2.default.PointText({
	                point: point.add(normal),
	                justification: 'left',
	                fontSize: textSize,
	                fillColor: textColor,
	                content: steps[i].name
	            });
	            if (!chapter) {
	                if (previousLabel && previousLabel.bounds.intersects(text.bounds)) {
	                    normal = normal.multiply(-2);
	                    text.point = text.point.add(normal);
	                }
	                previousLabel = text;
	                currentLabels.addChild(text);
	                text.onMouseDown = getStepMouseHandler(index);
	            } else {
	                text.content = wordwrap(steps[i].name, 12);
	                if (text.intersects(path)) {
	                    normal = normal.multiply(-2);
	                    text.point = text.point.add(normal);
	                }
	                everything.addChild(text);
	                if (hasSubItems) {
	                    text.onMouseDown = getChapterMouseHandler(chapters.length - 1);
	                } else {
	                    text.onMouseDown = getStepMouseHandler(index);
	                }
	                previousLabel = null;
	            }
	            labels.push(text);
	            return placed;
	        };
	
	        var stepLength = path.length / (steps.length - 1);
	        var curves = path.curves;
	        var currIndex = 0;
	        var currentCurve = curves[0];
	        var currentLength = 0;
	        for (var i = 0; i < steps.length - 1; i++) {
	            while (currentLength > currentCurve.length) {
	                currentLength -= currentCurve.length;
	                currIndex++;
	                currentCurve = curves[currIndex];
	            }
	            placeSymbol(i, currentCurve, currentLength);
	            currentLength += stepLength;
	        }
	        currentCurve = curves[curves.length - 1];
	
	        placeSymbol(i, currentCurve, currentCurve.length, true);
	
	        var startIndex;
	        if (currentIndex === -1) {
	            startIndex = 0;
	            current.visible = false;
	        } else {
	            startIndex = currentIndex;
	        }
	        current.position = displayedSteps[startIndex].position;
	        targetCurrent = current.position;
	        current.fitBounds(displayedSteps[startIndex].bounds);
	        current.scale(1.5);
	        current.onMouseDown = function (event) {
	            event.preventDefault();
	            setCurrentStep(steps[currentIndex].position, false, true, function () {
	                if (stepCallback) {
	                    stepCallback(steps[currentIndex]);
	                }
	            });
	        };
	
	        everything.addChild(current);
	        stepsDisplayed = true;
	    };
	
	    var getStepMouseHandler = function getStepMouseHandler(i) {
	        return function (event) {
	            event.preventDefault();
	            setCurrentStep(steps[i].position, true, true, function () {
	                if (stepCallback) {
	                    stepCallback(steps[i]);
	                }
	            });
	        };
	    };
	
	    var getChapterMouseHandler = function getChapterMouseHandler(i) {
	        return function (event) {
	            event.preventDefault();
	            openChapter(i, true);
	        };
	    };
	
	    var setCurrentStep = function setCurrentStep(position, animate, skipChapter, callback) {
	        var stepIndex = -1,
	            chapterIndex = -1;
	
	        for (var i = 0; i < steps.length; i++) {
	            if (steps[i].position && steps[i].position === position) {
	                stepIndex = i;
	                break;
	            }
	        }
	        if (stepIndex > -1) {
	            var step = displayedSteps[stepIndex];
	            if (!skipChapter) {
	                for (var j = stepIndex; j >= 0; j--) {
	                    if (steps[j].chapter) {
	                        for (var k = 0; k < chapters.length; k++) {
	                            if (chapters[k] === displayedSteps[j]) {
	                                chapterIndex = k;
	                                break;
	                            }
	                        }
	                        break;
	                    }
	                }
	                if (chapterIndex > -1) {
	                    openChapter(chapterIndex, animate);
	                }
	            }
	            if (animate && current.visible === true) {
	                var delta, factor;
	                if (stepIndex < currentIndex) {
	                    delta = -1;
	                    factor = currentIndex - stepIndex;
	                } else {
	                    delta = +1;
	                    factor = stepIndex - currentIndex;
	                }
	                currentCallback = function currentCallback() {
	                    currentIndex += delta;
	                    if (currentIndex === stepIndex) {
	                        if (callback) {
	                            callback();
	                        }
	                    } else {
	                        step = displayedSteps[currentIndex + delta];
	                        if (step && step.position) {
	                            setTargetCurrent(step.position, factor);
	                        }
	                    }
	                };
	                step = displayedSteps[currentIndex + delta];
	                if (step && step.position) {
	                    setTargetCurrent(step.position, factor);
	                }
	            } else {
	                current.visible = true;
	                currentIndex = stepIndex;
	                current.position = new _paper2.default.Point(step.position);
	                targetCurrent = new _paper2.default.Point(current.position);
	
	                if (!_paper2.default.view.bounds.contains(current.bounds)) {
	                    var deltaX = 0;
	                    var deltaY = 0;
	                    if (current.bounds.left < _paper2.default.view.bounds.left) {
	                        deltaX = current.bounds.left - _paper2.default.view.bounds.left - margin;
	                    } else if (current.bounds.right > _paper2.default.view.bounds.right) {
	                        deltaX = current.bounds.right - _paper2.default.view.bounds.right + margin;
	                    }
	                    if (current.bounds.top < _paper2.default.view.bounds.top) {
	                        deltaY = current.bounds.top - _paper2.default.view.bounds.top - margin;
	                    } else if (current.bounds.bottom > _paper2.default.view.bounds.bottom) {
	                        deltaY = current.bounds.bottom - _paper2.default.view.bounds.bottom + margin;
	                    }
	                    _paper2.default.view.center = _paper2.default.view.center.add(new _paper2.default.Point(deltaX, deltaY));
	                    targetCenter = new _paper2.default.Point(_paper2.default.view.center);
	                }
	                if (callback) {
	                    callback();
	                }
	            }
	        } else {
	            console.error("Step with position " + position + " not found");
	        }
	    };
	
	    this.init = function (canvasId, currentImage, newStepCallback, callback) {
	        initView(canvasId);
	        if (newStepCallback) {
	            stepCallback = newStepCallback;
	        }
	        initSymbols(currentImage, callback);
	    };
	
	    this.loadPath = function (data) {
	        path = new _paper2.default.Path(data.data);
	        path.fitBounds(_paper2.default.view.bounds.expand(-margin));
	        if (data.color) {
	            path.strokeColor = data.color;
	        }
	        if (data.opacity) {
	            path.opacity = data.opacity;
	        }
	
	        if (data.width) {
	            path.strokeWidth = data.width;
	        }
	
	        everything = new _paper2.default.Group();
	        everything.addChild(path);
	        centerEverything();
	    };
	
	    this.loadPathFromJSON = function (file, callback) {
	        var self = this;
	        $.getJSON(file, function (pathData) {
	            self.loadPath(pathData);
	            if (callback) {
	                callback();
	            }
	        }).fail(function () {
	            console.error("Could not load JSON file: " + file);
	        });
	    };
	
	    this.loadSteps = function (data) {
	        if (stepsDisplayed) {
	            removeSteps();
	        }
	        initSteps(data);
	        displaySteps();
	        _paper2.default.view.draw();
	    };
	
	    this.loadPathFromUI = function (file, callback) {
	        this.loadPath(file);
	        if (callback) {
	            callback();
	        }
	    };
	
	    this.loadStepsFromUI = function (file, callback) {
	        this.loadSteps(file);
	        if (callback) {
	            callback();
	        }
	    };
	
	    this.loadStepsFromJSON = function (file, callback) {
	        var self = this;
	        $.getJSON(file, function (stepsData) {
	            self.loadSteps(stepsData);
	            if (callback) {
	                callback();
	            }
	        }).fail(function () {
	            console.error("Could not load JSON file: " + file);
	        });
	    };
	
	    this.setResults = function (results) {
	
	        results.forEach(function (result) {
	            for (var i = 0; i < steps.length; i++) {
	                if (steps[i].id && steps[i].id === result.assessmentId && !steps[i].chapter) {
	                    steps[i].visited = false;
	                    steps[i].passed = false;
	                    if (result) {
	                        steps[i].visited = true;
	                    }
	                    if (result && result.passed || result.solution !== "") {
	                        steps[i].passed = result.passed;
	                    }
	
	                    var old = displayedSteps[i];
	                    var point = old.position;
	                    var symbol = getSymbol(steps[i]);
	                    var placed = symbol.place(point);
	                    placed.insertBelow(old);
	                    old.remove();
	                    displayedSteps[i] = placed;
	                    placed.onMouseDown = getStepMouseHandler(i);
	                    break;
	                }
	            }
	        });
	    };
	
	    this.setCurrentStep = function (id, animate) {
	        if (typeof animate === 'undefined') {
	            animate = false;
	        }
	
	        var _steps$filter3 = steps.filter(function (step) {
	            return step.id === id;
	        }),
	            _steps$filter4 = (0, _slicedToArray3.default)(_steps$filter3, 1),
	            step = _steps$filter4[0];
	
	        if (step) {
	            setCurrentStep(step.position, animate);
	        }
	    };
	
	    this.removeSteps = function () {
	        removeSteps();
	    };
	
	    this.update = function () {
	        var cSize = new _paper2.default.Size($canvas.width(), $canvas.height());
	        if (!cSize.equals(_paper2.default.view.size)) {
	            try {
	                window.dispatchEvent(new Event('resize'));
	            } catch (e) {
	                var evt = window.document.createEvent('UIEvents');
	                evt.initUIEvent('resize', true, false, window, 0);
	                window.dispatchEvent(evt);
	            }
	        }
	
	        $canvas.off("mousemove");
	    };
	}
	
	exports.default = DeclickMap;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(77);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _from = __webpack_require__(109);
	
	var _from2 = _interopRequireDefault(_from);
	
	exports.transpose = transpose;
	exports.resize = resize;
	exports.createArray2D = createArray2D;
	exports.fillArray2D = fillArray2D;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transpose(matrix) {
	  return matrix[0].map(function (_, c) {
	    return matrix.map(function (r) {
	      return r[c];
	    });
	  });
	}
	
	function resize(arr, width, height) {
	  var val = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	
	  var newRow = function newRow(row) {
	    return (0, _from2.default)({ length: width }, function (_, i) {
	      return i < row.length ? row[i] : val;
	    });
	  };
	  return (0, _from2.default)({ length: height }, function (_, i) {
	    return i < arr.length ? newRow(arr[i]) : (0, _from2.default)({ length: width }, function () {
	      return val;
	    });
	  });
	}
	
	function createArray2D(rows, columns) {
	  return [].concat((0, _toConsumableArray3.default)(Array(rows).keys())).map(function () {
	    return Array(columns);
	  });
	}
	
	function fillArray2D(anArray) {
	  return anArray.map(function (row) {
	    return row.fill(0);
	  });
	}

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.generateMaze = generateMaze;
	exports.recursion = recursion;
	exports.generateRandomDirections = generateRandomDirections;
	
	var _lodash = __webpack_require__(325);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UP = 1;
	var RIGHT = 2;
	var DOWN = 3;
	var LEFT = 4;
	
	function getRandomInt(max) {
	    return Math.floor(Math.random() * Math.floor(max));
	}
	
	function generateMaze(maze) {
	    var height = maze.length;
	    var width = maze[0].length;
	
	    var row = getRandomInt(height);
	    while (row % 2 === 0) {
	        row = getRandomInt(height);
	    }
	
	    var col = getRandomInt(width);
	    while (col % 2 == 0) {
	        col = getRandomInt(width);
	    }
	
	    maze[row][col] = 0;
	
	    recursion(maze, row, col);
	
	    return maze;
	}
	
	function recursion(maze, row, col) {
	    var height = maze.length;
	    var width = maze[0].length;
	
	    var randDirs = generateRandomDirections();
	
	    randDirs.map(function (dir) {
	        switch (dir) {
	            case UP:
	                if (row - 2 <= 0) {} else {
	                    if (maze[row - 2][col] != 0) {
	                        maze[row - 2][col] = 0;
	                        maze[row - 1][col] = 0;
	                        recursion(maze, row - 2, col);
	                    }
	                }
	                break;
	            case RIGHT:
	                if (col + 2 >= width - 1) {} else {
	                    if (maze[row][col + 2] != 0) {
	                        maze[row][col + 2] = 0;
	                        maze[row][col + 1] = 0;
	                        recursion(maze, row, col + 2);
	                    }
	                }
	                break;
	            case DOWN:
	                if (row + 2 >= height - 1) {} else {
	                    if (maze[row + 2][col] != 0) {
	                        maze[row + 2][col] = 0;
	                        maze[row + 1][col] = 0;
	                        recursion(maze, row + 2, col);
	                    }
	                }
	                break;
	            case LEFT:
	                if (col - 2 <= 0) {} else {
	                    if (maze[row][col - 2] != 0) {
	                        maze[row][col - 2] = 0;
	                        maze[row][col - 1] = 0;
	                        recursion(maze, row, col - 2);
	                    }
	                }
	                break;
	        }
	    });
	}
	
	function generateRandomDirections() {
	    return (0, _lodash2.default)([UP, RIGHT, DOWN, LEFT]);
	}

/***/ }),
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * Paper.js v0.10.2 - The Swiss Army Knife of Vector Graphics Scripting.
	 * http://paperjs.org/
	 *
	 * Copyright (c) 2011 - 2016, Juerg Lehni & Jonathan Puckey
	 * http://scratchdisk.com/ & http://jonathanpuckey.com/
	 *
	 * Distributed under the MIT license. See LICENSE file for details.
	 *
	 * All rights reserved.
	 *
	 * Date: Sat Jul 9 20:56:58 2016 +0200
	 *
	 ***
	 *
	 * Straps.js - Class inheritance library with support for bean-style accessors
	 *
	 * Copyright (c) 2006 - 2016 Juerg Lehni
	 * http://scratchdisk.com/
	 *
	 * Distributed under the MIT license.
	 *
	 ***
	 *
	 * Acorn.js
	 * http://marijnhaverbeke.nl/acorn/
	 *
	 * Acorn is a tiny, fast JavaScript parser written in JavaScript,
	 * created by Marijn Haverbeke and released under an MIT license.
	 *
	 */
	var paper=function(t,e){var i=t?t.window:__webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"./node/window\""); e.code = 'MODULE_NOT_FOUND'; throw e; }())),n=i&&i.document;t=t||i;var r=new function(){function t(t,e,i,n,a){function o(s,o){o=o||(o=u(e,s))&&(o.get?o:o.value),"string"==typeof o&&"#"===o[0]&&(o=t[o.substring(1)]||o);var l,d="function"==typeof o,f=o,_=a||d&&!o.base?o&&o.get?s in t:t[s]:null;a&&_||(d&&_&&(o.base=_),d&&n!==!1&&(l=s.match(/^([gs]et|is)(([A-Z])(.*))$/))&&(h[l[3].toLowerCase()+l[4]]=l[2]),f&&!d&&f.get&&"function"==typeof f.get&&r.isPlainObject(f)||(f={value:f,writable:!0}),(u(t,s)||{configurable:!0}).configurable&&(f.configurable=!0,f.enumerable=i),c(t,s,f))}var h={};if(e){for(var l in e)e.hasOwnProperty(l)&&!s.test(l)&&o(l);for(var l in h){var d=h[l],f=t["set"+d],_=t["get"+d]||f&&t["is"+d];!_||n!==!0&&0!==_.length||o(l,{get:_,set:f})}}return t}function i(t,e,i){return t&&("length"in t&&!t.getLength&&"number"==typeof t.length?a:o).call(t,e,i=i||t),i}function n(t,e,i){for(var n=i,r=e.length;n<r;n++){var s=e[n];for(var a in s)s.hasOwnProperty(a)&&(t[a]=s[a])}return t}var s=/^(statics|enumerable|beans|preserve)$/,a=[].forEach||function(t,e){for(var i=0,n=this.length;i<n;i++)t.call(e,this[i],i,this)},o=function(t,e){for(var i in this)this.hasOwnProperty(i)&&t.call(e,this[i],i,this)},h=Object.create||function(t){return{__proto__:t}},u=Object.getOwnPropertyDescriptor||function(t,e){var i=t.__lookupGetter__&&t.__lookupGetter__(e);return i?{get:i,set:t.__lookupSetter__(e),enumerable:!0,configurable:!0}:t.hasOwnProperty(e)?{value:t[e],enumerable:!0,configurable:!0,writable:!0}:null},l=Object.defineProperty||function(t,e,i){return(i.get||i.set)&&t.__defineGetter__?(i.get&&t.__defineGetter__(e,i.get),i.set&&t.__defineSetter__(e,i.set)):t[e]=i.value,t},c=function(t,e,i){return delete t[e],l(t,e,i)};return t(function(){n(this,arguments,0)},{inject:function(e){if(e){var i=e.statics===!0?e:e.statics,n=e.beans,r=e.preserve;i!==e&&t(this.prototype,e,e.enumerable,n,r),t(this,i,!0,n,r)}for(var s=1,a=arguments.length;s<a;s++)this.inject(arguments[s]);return this},extend:function(){for(var e,i,n,r=this,s=0,a=arguments.length;s<a&&(!e||!i);s++)n=arguments[s],e=e||n.initialize,i=i||n.prototype;return e=e||function(){r.apply(this,arguments)},i=e.prototype=i||h(this.prototype),c(i,"constructor",{value:e,writable:!0,configurable:!0}),t(e,this,!0),arguments.length&&this.inject.apply(e,arguments),e.base=r,e}},!0).inject({inject:function(){for(var e=0,i=arguments.length;e<i;e++){var n=arguments[e];n&&t(this,n,n.enumerable,n.beans,n.preserve)}return this},extend:function(){var t=h(this);return t.inject.apply(t,arguments)},each:function(t,e){return i(this,t,e)},set:function(){return n(this,arguments,0)},clone:function(){return new this.constructor(this)},statics:{each:i,create:h,define:c,describe:u,set:function(t){return n(t,arguments,1)},clone:function(t){return n(new t.constructor,arguments,0)},isPlainObject:function(t){var e=null!=t&&t.constructor;return e&&(e===Object||e===r||"Object"===e.name)},pick:function(t,i){return t!==e?t:i}}})};"undefined"!=typeof module&&(module.exports=r),r.inject({toString:function(){return null!=this._id?(this._class||"Object")+(this._name?" '"+this._name+"'":" @"+this._id):"{ "+r.each(this,function(t,e){if(!/^_/.test(e)){var i=typeof t;this.push(e+": "+("number"===i?h.instance.number(t):"string"===i?"'"+t+"'":t))}},[]).join(", ")+" }"},getClassName:function(){return this._class||""},importJSON:function(t){return r.importJSON(t,this)},exportJSON:function(t){return r.exportJSON(this,t)},toJSON:function(){return r.serialize(this)},_set:function(t){if(t&&r.isPlainObject(t))return r.filter(this,t)},statics:{exports:{enumerable:!0},extend:function nt(){var t=nt.base.apply(this,arguments),e=t.prototype._class;return e&&!r.exports[e]&&(r.exports[e]=t),t},equals:function(t,e){if(t===e)return!0;if(t&&t.equals)return t.equals(e);if(e&&e.equals)return e.equals(t);if(t&&e&&"object"==typeof t&&"object"==typeof e){if(Array.isArray(t)&&Array.isArray(e)){var i=t.length;if(i!==e.length)return!1;for(;i--;)if(!r.equals(t[i],e[i]))return!1}else{var n=Object.keys(t),i=n.length;if(i!==Object.keys(e).length)return!1;for(;i--;){var s=n[i];if(!e.hasOwnProperty(s)||!r.equals(t[s],e[s]))return!1}}return!0}return!1},read:function(t,i,n,s){if(this===r){var a=this.peek(t,i);return t.__index++,a}var o=this.prototype,h=o._readIndex,u=i||h&&t.__index||0;s||(s=t.length-u);var l=t[u];return l instanceof this||n&&n.readNull&&null==l&&s<=1?(h&&(t.__index=u+1),l&&n&&n.clone?l.clone():l):(l=r.create(this.prototype),h&&(l.__read=!0),l=l.initialize.apply(l,u>0||s<t.length?Array.prototype.slice.call(t,u,u+s):t)||l,h&&(t.__index=u+l.__read,l.__read=e),l)},peek:function(t,e){return t[t.__index=e||t.__index||0]},remain:function(t){return t.length-(t.__index||0)},readAll:function(t,e,i){for(var n,r=[],s=e||0,a=t.length;s<a;s++)r.push(Array.isArray(n=t[s])?this.read(n,0,i):this.read(t,s,i,1));return r},readNamed:function(t,i,n,s,a){var o=this.getNamed(t,i),h=o!==e;if(h){var u=t._filtered;u||(u=t._filtered=r.create(t[0]),u._filtering=t[0]),u[i]=e}return this.read(h?[o]:t,n,s,a)},getNamed:function(t,i){var n=t[0];if(t._hasObject===e&&(t._hasObject=1===t.length&&r.isPlainObject(n)),t._hasObject)return i?n[i]:t._filtered||n},hasNamed:function(t,e){return!!this.getNamed(t,e)},filter:function(t,i,n){for(var r=Object.keys(i._filtering||i),s=0,a=r.length;s<a;s++){var o=r[s];if(!n||!n[o]){var h=i[o];h!==e&&(t[o]=h)}}return t},isPlainValue:function(t,e){return this.isPlainObject(t)||Array.isArray(t)||e&&"string"==typeof t},serialize:function(t,e,i,n){e=e||{};var s,a=!n;if(a&&(e.formatter=new h(e.precision),n={length:0,definitions:{},references:{},add:function(t,e){var i="#"+t._id,n=this.references[i];if(!n){this.length++;var r=e.call(t),s=t._class;s&&r[0]!==s&&r.unshift(s),this.definitions[i]=r,n=this.references[i]=[i]}return n}}),t&&t._serialize){s=t._serialize(e,n);var o=t._class;!o||t._compactSerialize||!a&&i||s[0]===o||s.unshift(o)}else if(Array.isArray(t)){s=[];for(var u=0,l=t.length;u<l;u++)s[u]=r.serialize(t[u],e,i,n)}else if(r.isPlainObject(t)){s={};for(var c=Object.keys(t),u=0,l=c.length;u<l;u++){var d=c[u];s[d]=r.serialize(t[d],e,i,n)}}else s="number"==typeof t?e.formatter.number(t,e.precision):t;return a&&n.length>0?[["dictionary",n.definitions],s]:s},deserialize:function(t,e,i,n,s){var a=t,o=!i,h=o&&t&&t.length&&"dictionary"===t[0][0];if(i=i||{},Array.isArray(t)){var u=t[0],l="dictionary"===u;if(1==t.length&&/^#/.test(u))return i.dictionary[u];u=r.exports[u],a=[];for(var c=u?1:0,d=t.length;c<d;c++)a.push(r.deserialize(t[c],e,i,l,h));if(u){var f=a;e?a=e(u,f,o||s):(a=r.create(u.prototype),u.apply(a,f))}}else if(r.isPlainObject(t)){a={},n&&(i.dictionary=a);for(var _ in t)a[_]=r.deserialize(t[_],e,i)}return h?a[1]:a},exportJSON:function(t,e){var i=r.serialize(t,e);return e&&e.asString===!1?i:JSON.stringify(i)},importJSON:function(t,e){return r.deserialize("string"==typeof t?JSON.parse(t):t,function(t,i,n){var s=n&&e&&e.constructor===t,a=s?e:r.create(t.prototype);if(1===i.length&&a instanceof w&&(s||!(a instanceof b))){var o=i[0];r.isPlainObject(o)&&(o.insert=!1)}return(s?a._set:t).apply(a,i),s&&(e=null),a})},splice:function(t,i,n,r){var s=i&&i.length,a=n===e;n=a?t.length:n,n>t.length&&(n=t.length);for(var o=0;o<s;o++)i[o]._index=n+o;if(a)return t.push.apply(t,i),[];var h=[n,r];i&&h.push.apply(h,i);for(var u=t.splice.apply(t,h),o=0,l=u.length;o<l;o++)u[o]._index=e;for(var o=n+s,l=t.length;o<l;o++)t[o]._index=o;return u},capitalize:function(t){return t.replace(/\b[a-z]/g,function(t){return t.toUpperCase()})},camelize:function(t){return t.replace(/-(.)/g,function(t,e){return e.toUpperCase()})},hyphenate:function(t){return t.replace(/([a-z])([A-Z])/g,"$1-$2").toLowerCase()}}});var s={on:function(t,e){if("string"!=typeof t)r.each(t,function(t,e){this.on(e,t)},this);else{var i=this._eventTypes,n=i&&i[t],s=this._callbacks=this._callbacks||{};s=s[t]=s[t]||[],s.indexOf(e)===-1&&(s.push(e),n&&n.install&&1===s.length&&n.install.call(this,t))}return this},off:function(t,e){if("string"!=typeof t)return void r.each(t,function(t,e){this.off(e,t)},this);var i,n=this._eventTypes,s=n&&n[t],a=this._callbacks&&this._callbacks[t];return a&&(!e||(i=a.indexOf(e))!==-1&&1===a.length?(s&&s.uninstall&&s.uninstall.call(this,t),delete this._callbacks[t]):i!==-1&&a.splice(i,1)),this},once:function(t,e){return this.on(t,function(){e.apply(this,arguments),this.off(t,e)})},emit:function(t,e){var i=this._callbacks&&this._callbacks[t];if(!i)return!1;var n=[].slice.call(arguments,1),r=e&&e.target&&!e.currentTarget;i=i.slice(),r&&(e.currentTarget=this);for(var s=0,a=i.length;s<a;s++)if(i[s].apply(this,n)===!1){e&&e.stop&&e.stop();break}return r&&delete e.currentTarget,!0},responds:function(t){return!(!this._callbacks||!this._callbacks[t])},attach:"#on",detach:"#off",fire:"#emit",_installEvents:function(t){var e=this._eventTypes,i=this._callbacks,n=t?"install":"uninstall";if(e)for(var r in i)if(i[r].length>0){var s=e[r],a=s&&s[n];a&&a.call(this,r)}},statics:{inject:function rt(t){var e=t._events;if(e){var i={};r.each(e,function(e,n){var s="string"==typeof e,a=s?e:n,o=r.capitalize(a),h=a.substring(2).toLowerCase();i[h]=s?{}:e,a="_"+a,t["get"+o]=function(){return this[a]},t["set"+o]=function(t){var e=this[a];e&&this.off(h,e),t&&this.on(h,t),this[a]=t}}),t._eventTypes=i}return rt.base.apply(this,arguments)}}},a=r.extend({_class:"PaperScope",initialize:function st(){paper=this,this.settings=new r({applyMatrix:!0,insertItems:!0,handleSize:4,hitTolerance:0}),this.project=null,this.projects=[],this.tools=[],this.palettes=[],this._id=st._id++,st._scopes[this._id]=this;var e=st.prototype;if(!this.support){var i=Q.getContext(1,1)||{};e.support={nativeDash:"setLineDash"in i||"mozDash"in i,nativeBlendModes:tt.nativeModes},Q.release(i)}if(!this.agent){var n=t.navigator.userAgent.toLowerCase(),s=(/(darwin|win|mac|linux|freebsd|sunos)/.exec(n)||[])[0],a="darwin"===s?"mac":s,o=e.agent=e.browser={platform:a};a&&(o[a]=!0),n.replace(/(opera|chrome|safari|webkit|firefox|msie|trident|atom|node)\/?\s*([.\d]+)(?:.*version\/([.\d]+))?(?:.*rv\:v?([.\d]+))?/g,function(t,e,i,n,r){if(!o.chrome){var s="opera"===e?n:/^(node|trident)$/.test(e)?r:i;o.version=s,o.versionNumber=parseFloat(s),e="trident"===e?"msie":e,o.name=e,o[e]=!0}}),o.chrome&&delete o.webkit,o.atom&&delete o.chrome}},version:"0.10.2",getView:function(){var t=this.project;return t&&t._view},getPaper:function(){return this},execute:function(t,e){paper.PaperScript.execute(t,this,e),U.updateFocus()},install:function(t){var e=this;r.each(["project","view","tool"],function(i){r.define(t,i,{configurable:!0,get:function(){return e[i]}})});for(var i in this)!/^_/.test(i)&&this[i]&&(t[i]=this[i])},setup:function(t){return paper=this,this.project=new y(t),this},createCanvas:function(t,e){return Q.getCanvas(t,e)},activate:function(){paper=this},clear:function(){for(var t=this.projects,e=this.tools,i=this.palettes,n=t.length-1;n>=0;n--)t[n].remove();for(var n=e.length-1;n>=0;n--)e[n].remove();for(var n=i.length-1;n>=0;n--)i[n].remove()},remove:function(){this.clear(),delete a._scopes[this._id]},statics:new function(){function t(t){return t+="Attribute",function(e,i){return e[t](i)||e[t]("data-paper-"+i)}}return{_scopes:{},_id:0,get:function(t){return this._scopes[t]||null},getAttribute:t("get"),hasAttribute:t("has")}}}),o=r.extend(s,{initialize:function(t){this._scope=paper,this._index=this._scope[this._list].push(this)-1,!t&&this._scope[this._reference]||this.activate()},activate:function(){if(!this._scope)return!1;var t=this._scope[this._reference];return t&&t!==this&&t.emit("deactivate"),this._scope[this._reference]=this,this.emit("activate",t),!0},isActive:function(){return this._scope[this._reference]===this},remove:function(){return null!=this._index&&(r.splice(this._scope[this._list],null,this._index,1),this._scope[this._reference]==this&&(this._scope[this._reference]=null),this._scope=null,!0)},getView:function(){return this._scope.getView()}}),h=r.extend({initialize:function(t){this.precision=r.pick(t,5),this.multiplier=Math.pow(10,this.precision)},number:function(t){return this.precision<16?Math.round(t*this.multiplier)/this.multiplier:t},pair:function(t,e,i){return this.number(t)+(i||",")+this.number(e)},point:function(t,e){return this.number(t.x)+(e||",")+this.number(t.y)},size:function(t,e){return this.number(t.width)+(e||",")+this.number(t.height)},rectangle:function(t,e){return this.point(t,e)+(e||",")+this.size(t,e)}});h.instance=new h;var u=new function(){function t(t,e,i){return t<e?e:t>i?i:t}function e(t,e,i){function n(t){var e=134217729*t,i=t-e,n=i+e,r=t-n;return[n,r]}var r=e*e-t*i,a=e*e+t*i;if(3*s(r)<a){var o=n(t),h=n(e),u=n(i),l=e*e,c=h[0]*h[0]-l+2*h[0]*h[1]+h[1]*h[1],d=t*i,f=o[0]*u[0]-d+o[0]*u[1]+o[1]*u[0]+o[1]*u[1];r=l-d+(c-f)}return r}function i(){var t=Math.max.apply(Math,arguments);return t&&(t<1e-8||t>1e8)?o(2,-Math.round(h(t))):0}var n=[[.5773502691896257],[0,.7745966692414834],[.33998104358485626,.8611363115940526],[0,.5384693101056831,.906179845938664],[.2386191860831969,.6612093864662645,.932469514203152],[0,.4058451513773972,.7415311855993945,.9491079123427585],[.1834346424956498,.525532409916329,.7966664774136267,.9602898564975363],[0,.3242534234038089,.6133714327005904,.8360311073266358,.9681602395076261],[.14887433898163122,.4333953941292472,.6794095682990244,.8650633666889845,.9739065285171717],[0,.26954315595234496,.5190961292068118,.7301520055740494,.8870625997680953,.978228658146057],[.1252334085114689,.3678314989981802,.5873179542866175,.7699026741943047,.9041172563704749,.9815606342467192],[0,.2304583159551348,.44849275103644687,.6423493394403402,.8015780907333099,.9175983992229779,.9841830547185881],[.10805494870734367,.31911236892788974,.5152486363581541,.6872929048116855,.827201315069765,.9284348836635735,.9862838086968123],[0,.20119409399743451,.3941513470775634,.5709721726085388,.7244177313601701,.8482065834104272,.937273392400706,.9879925180204854],[.09501250983763744,.2816035507792589,.45801677765722737,.6178762444026438,.755404408355003,.8656312023878318,.9445750230732326,.9894009349916499]],r=[[1],[.8888888888888888,.5555555555555556],[.6521451548625461,.34785484513745385],[.5688888888888889,.47862867049936647,.23692688505618908],[.46791393457269104,.3607615730481386,.17132449237917036],[.4179591836734694,.3818300505051189,.27970539148927664,.1294849661688697],[.362683783378362,.31370664587788727,.22238103445337448,.10122853629037626],[.3302393550012598,.31234707704000286,.26061069640293544,.1806481606948574,.08127438836157441],[.29552422471475287,.26926671930999635,.21908636251598204,.1494513491505806,.06667134430868814],[.2729250867779006,.26280454451024665,.23319376459199048,.18629021092773426,.1255803694649046,.05566856711617366],[.24914704581340277,.2334925365383548,.20316742672306592,.16007832854334622,.10693932599531843,.04717533638651183],[.2325515532308739,.22628318026289723,.2078160475368885,.17814598076194574,.13887351021978725,.09212149983772845,.04048400476531588],[.2152638534631578,.2051984637212956,.18553839747793782,.15720316715819355,.12151857068790319,.08015808715976021,.03511946033175186],[.2025782419255613,.19843148532711158,.1861610000155622,.16626920581699392,.13957067792615432,.10715922046717194,.07036604748810812,.03075324199611727],[.1894506104550685,.18260341504492358,.16915651939500254,.14959598881657674,.12462897125553388,.09515851168249279,.062253523938647894,.027152459411754096]],s=Math.abs,a=Math.sqrt,o=Math.pow,h=Math.log2||function(t){return Math.log(t)*Math.LOG2E},l=1e-12,c=1.12e-16;return{TOLERANCE:1e-6,EPSILON:l,MACHINE_EPSILON:c,CURVETIME_EPSILON:4e-7,GEOMETRIC_EPSILON:2e-7,WINDING_EPSILON:2e-7,TRIGONOMETRIC_EPSILON:1e-7,CLIPPING_EPSILON:1e-9,KAPPA:4*(a(2)-1)/3,isZero:function(t){return t>=-l&&t<=l},clamp:t,integrate:function(t,e,i,s){for(var a=n[s-2],o=r[s-2],h=.5*(i-e),u=h+e,l=0,c=s+1>>1,d=1&s?o[l++]*t(u):0;l<c;){var f=h*a[l];d+=o[l++]*(t(u+f)+t(u-f))}return h*d},findRoot:function(t,e,i,n,r,a,o){for(var h=0;h<a;h++){var u=t(i),l=u/e(i),c=i-l;if(s(l)<o)return c;u>0?(r=i,i=c<=n?.5*(n+r):c):(n=i,i=c>=r?.5*(n+r):c)}return i},solveQuadratic:function(n,r,o,h,u,d){var f,_=1/0;if(s(n)<l){if(s(r)<l)return s(o)<l?-1:0;f=-o/r}else{r*=-.5;var g=e(n,r,o);if(g&&s(g)<c){var v=i(s(n),s(r),s(o));v&&(n*=v,r*=v,o*=v,g=e(n,r,o))}if(g>=-c){var p=g<0?0:a(g),m=r+(r<0?-p:p);0===m?(f=o/n,_=-f):(f=m/n,_=o/m)}}var y=0,w=null==u,x=u-l,b=d+l;return isFinite(f)&&(w||f>x&&f<b)&&(h[y++]=w?f:t(f,u,d)),_!==f&&isFinite(_)&&(w||_>x&&_<b)&&(h[y++]=w?_:t(_,u,d)),y},solveCubic:function(e,n,r,h,d,f,_){function g(t){v=t;var i=e*v;p=i+n,m=p*v+r,y=(i+p)*v+m,w=m*v+h}var v,p,m,y,w,x=i(s(e),s(n),s(r),s(h));if(x&&(e*=x,n*=x,r*=x,h*=x),s(e)<l)e=n,p=r,m=h,v=1/0;else if(s(h)<l)p=n,m=r,v=0;else{g(-(n/e)/3);var b=w/e,C=o(s(b),1/3),S=b<0?-1:1,P=-y/e,I=P>0?1.324717957244746*Math.max(C,a(P)):C,M=v-S*I;if(M!==v){do g(M),M=0===y?v:v-w/y/(1+c);while(S*M>S*v);s(e)*v*v>s(h/v)&&(m=-h/v,p=(m-r)/v)}}var T=u.solveQuadratic(e,p,m,d,f,_),k=null==f;return isFinite(v)&&(0===T||T>0&&v!==d[0]&&v!==d[1])&&(k||v>f-l&&v<_+l)&&(d[T++]=k?v:t(v,f,_)),T}}},l={_id:1,_pools:{},get:function(t){if(t){var e=this._pools[t];return e||(e=this._pools[t]={_id:1}),e._id++}return this._id++}},c=r.extend({_class:"Point",_readIndex:!0,initialize:function(t,e){var i=typeof t;if("number"===i){var n="number"==typeof e;this.x=t,this.y=n?e:t,this.__read&&(this.__read=n?2:1)}else if("undefined"===i||null===t)this.x=this.y=0,this.__read&&(this.__read=null===t?1:0);else{var r="string"===i?t.split(/[\s,]+/)||[]:t;Array.isArray(r)?(this.x=r[0],this.y=r.length>1?r[1]:r[0]):"x"in r?(this.x=r.x,this.y=r.y):"width"in r?(this.x=r.width,this.y=r.height):"angle"in r?(this.x=r.length,this.y=0,this.setAngle(r.angle)):(this.x=this.y=0,this.__read&&(this.__read=0)),this.__read&&(this.__read=1)}},set:function(t,e){return this.x=t,this.y=e,this},equals:function(t){return this===t||t&&(this.x===t.x&&this.y===t.y||Array.isArray(t)&&this.x===t[0]&&this.y===t[1])||!1},clone:function(){return new c(this.x,this.y)},toString:function(){var t=h.instance;return"{ x: "+t.number(this.x)+", y: "+t.number(this.y)+" }"},_serialize:function(t){var e=t.formatter;return[e.number(this.x),e.number(this.y)]},getLength:function(){return Math.sqrt(this.x*this.x+this.y*this.y)},setLength:function(t){if(this.isZero()){var e=this._angle||0;this.set(Math.cos(e)*t,Math.sin(e)*t)}else{var i=t/this.getLength();u.isZero(i)&&this.getAngle(),this.set(this.x*i,this.y*i)}},getAngle:function(){return 180*this.getAngleInRadians.apply(this,arguments)/Math.PI},setAngle:function(t){this.setAngleInRadians.call(this,t*Math.PI/180)},getAngleInDegrees:"#getAngle",setAngleInDegrees:"#setAngle",getAngleInRadians:function(){if(arguments.length){var t=c.read(arguments),e=this.getLength()*t.getLength();if(u.isZero(e))return NaN;var i=this.dot(t)/e;return Math.acos(i<-1?-1:i>1?1:i)}return this.isZero()?this._angle||0:this._angle=Math.atan2(this.y,this.x)},setAngleInRadians:function(t){if(this._angle=t,!this.isZero()){var e=this.getLength();this.set(Math.cos(t)*e,Math.sin(t)*e)}},getQuadrant:function(){return this.x>=0?this.y>=0?1:4:this.y>=0?2:3}},{beans:!1,getDirectedAngle:function(){var t=c.read(arguments);return 180*Math.atan2(this.cross(t),this.dot(t))/Math.PI},getDistance:function(){var t=c.read(arguments),e=t.x-this.x,i=t.y-this.y,n=e*e+i*i,s=r.read(arguments);return s?n:Math.sqrt(n)},normalize:function(t){t===e&&(t=1);var i=this.getLength(),n=0!==i?t/i:0,r=new c(this.x*n,this.y*n);return n>=0&&(r._angle=this._angle),r},rotate:function(t,e){if(0===t)return this.clone();t=t*Math.PI/180;var i=e?this.subtract(e):this,n=Math.sin(t),r=Math.cos(t);return i=new c(i.x*r-i.y*n,i.x*n+i.y*r),e?i.add(e):i},transform:function(t){return t?t._transformPoint(this):this},add:function(){var t=c.read(arguments);return new c(this.x+t.x,this.y+t.y)},subtract:function(){var t=c.read(arguments);return new c(this.x-t.x,this.y-t.y)},multiply:function(){var t=c.read(arguments);return new c(this.x*t.x,this.y*t.y)},divide:function(){var t=c.read(arguments);return new c(this.x/t.x,this.y/t.y)},modulo:function(){var t=c.read(arguments);return new c(this.x%t.x,this.y%t.y)},negate:function(){return new c((-this.x),(-this.y))},isInside:function(){return g.read(arguments).contains(this)},isClose:function(){var t=c.read(arguments),e=r.read(arguments);return this.getDistance(t)<=e},isCollinear:function(){var t=c.read(arguments);return c.isCollinear(this.x,this.y,t.x,t.y)},isColinear:"#isCollinear",isOrthogonal:function(){var t=c.read(arguments);return c.isOrthogonal(this.x,this.y,t.x,t.y)},isZero:function(){return u.isZero(this.x)&&u.isZero(this.y)},isNaN:function(){return isNaN(this.x)||isNaN(this.y)},dot:function(){var t=c.read(arguments);return this.x*t.x+this.y*t.y},cross:function(){var t=c.read(arguments);return this.x*t.y-this.y*t.x},project:function(){var t=c.read(arguments),e=t.isZero()?0:this.dot(t)/t.dot(t);return new c(t.x*e,t.y*e)},statics:{min:function(){var t=c.read(arguments),e=c.read(arguments);return new c(Math.min(t.x,e.x),Math.min(t.y,e.y))},max:function(){var t=c.read(arguments),e=c.read(arguments);return new c(Math.max(t.x,e.x),Math.max(t.y,e.y))},random:function(){return new c(Math.random(),Math.random())},isCollinear:function(t,e,i,n){return Math.abs(t*n-e*i)<=1e-7*Math.sqrt((t*t+e*e)*(i*i+n*n))},isOrthogonal:function(t,e,i,n){return Math.abs(t*i+e*n)<=1e-7*Math.sqrt((t*t+e*e)*(i*i+n*n))}}},r.each(["round","ceil","floor","abs"],function(t){var e=Math[t];this[t]=function(){return new c(e(this.x),e(this.y))}},{})),d=c.extend({initialize:function(t,e,i,n){this._x=t,this._y=e,this._owner=i,this._setter=n},set:function(t,e,i){return this._x=t,this._y=e,i||this._owner[this._setter](this),this},getX:function(){return this._x},setX:function(t){this._x=t,this._owner[this._setter](this)},getY:function(){return this._y},setY:function(t){this._y=t,this._owner[this._setter](this)},isSelected:function(){return!!(this._owner._selection&this._getSelection())},setSelected:function(t){this._owner.changeSelection(this._getSelection(),t)},_getSelection:function(){return"setPosition"===this._setter?4:0}}),f=r.extend({_class:"Size",_readIndex:!0,initialize:function(t,e){var i=typeof t;if("number"===i){var n="number"==typeof e;this.width=t,this.height=n?e:t,this.__read&&(this.__read=n?2:1)}else if("undefined"===i||null===t)this.width=this.height=0,this.__read&&(this.__read=null===t?1:0);else{var r="string"===i?t.split(/[\s,]+/)||[]:t;Array.isArray(r)?(this.width=r[0],this.height=r.length>1?r[1]:r[0]):"width"in r?(this.width=r.width,this.height=r.height):"x"in r?(this.width=r.x,this.height=r.y):(this.width=this.height=0,this.__read&&(this.__read=0)),this.__read&&(this.__read=1)}},set:function(t,e){return this.width=t,this.height=e,this},equals:function(t){return t===this||t&&(this.width===t.width&&this.height===t.height||Array.isArray(t)&&this.width===t[0]&&this.height===t[1])||!1},clone:function(){return new f(this.width,this.height)},toString:function(){var t=h.instance;return"{ width: "+t.number(this.width)+", height: "+t.number(this.height)+" }"},_serialize:function(t){var e=t.formatter;return[e.number(this.width),e.number(this.height)]},add:function(){var t=f.read(arguments);return new f(this.width+t.width,this.height+t.height)},subtract:function(){var t=f.read(arguments);return new f(this.width-t.width,this.height-t.height)},multiply:function(){var t=f.read(arguments);return new f(this.width*t.width,this.height*t.height)},divide:function(){var t=f.read(arguments);return new f(this.width/t.width,this.height/t.height)},modulo:function(){var t=f.read(arguments);return new f(this.width%t.width,this.height%t.height)},negate:function(){return new f((-this.width),(-this.height))},isZero:function(){return u.isZero(this.width)&&u.isZero(this.height)},isNaN:function(){return isNaN(this.width)||isNaN(this.height)},statics:{min:function(t,e){return new f(Math.min(t.width,e.width),Math.min(t.height,e.height))},max:function(t,e){return new f(Math.max(t.width,e.width),Math.max(t.height,e.height))},random:function(){return new f(Math.random(),Math.random())}}},r.each(["round","ceil","floor","abs"],function(t){var e=Math[t];this[t]=function(){return new f(e(this.width),e(this.height))}},{})),_=f.extend({initialize:function(t,e,i,n){this._width=t,this._height=e,this._owner=i,this._setter=n},set:function(t,e,i){return this._width=t,this._height=e,i||this._owner[this._setter](this),this},getWidth:function(){return this._width},setWidth:function(t){this._width=t,this._owner[this._setter](this)},getHeight:function(){return this._height},setHeight:function(t){this._height=t,this._owner[this._setter](this)}}),g=r.extend({_class:"Rectangle",_readIndex:!0,beans:!0,initialize:function(t,i,n,s){var a=typeof t,o=0;if("number"===a?(this.x=t,this.y=i,this.width=n,this.height=s,o=4):"undefined"===a||null===t?(this.x=this.y=this.width=this.height=0,o=null===t?1:0):1===arguments.length&&(Array.isArray(t)?(this.x=t[0],this.y=t[1],this.width=t[2],this.height=t[3],o=1):t.x!==e||t.width!==e?(this.x=t.x||0,this.y=t.y||0,this.width=t.width||0,this.height=t.height||0,o=1):t.from===e&&t.to===e&&(this.x=this.y=this.width=this.height=0,this._set(t),o=1)),!o){var h=c.readNamed(arguments,"from"),u=r.peek(arguments);if(this.x=h.x,this.y=h.y,u&&u.x!==e||r.hasNamed(arguments,"to")){var l=c.readNamed(arguments,"to");this.width=l.x-h.x,this.height=l.y-h.y,this.width<0&&(this.x=l.x,this.width=-this.width),this.height<0&&(this.y=l.y,this.height=-this.height)}else{var d=f.read(arguments);this.width=d.width,this.height=d.height}o=arguments.__index}this.__read&&(this.__read=o)},set:function(t,e,i,n){return this.x=t,this.y=e,this.width=i,this.height=n,this},clone:function(){return new g(this.x,this.y,this.width,this.height)},equals:function(t){var e=r.isPlainValue(t)?g.read(arguments):t;return e===this||e&&this.x===e.x&&this.y===e.y&&this.width===e.width&&this.height===e.height||!1},toString:function(){var t=h.instance;return"{ x: "+t.number(this.x)+", y: "+t.number(this.y)+", width: "+t.number(this.width)+", height: "+t.number(this.height)+" }"},_serialize:function(t){var e=t.formatter;return[e.number(this.x),e.number(this.y),e.number(this.width),e.number(this.height)]},getPoint:function(t){var e=t?c:d;return new e(this.x,this.y,this,"setPoint")},setPoint:function(){var t=c.read(arguments);this.x=t.x,this.y=t.y},getSize:function(t){var e=t?f:_;return new e(this.width,this.height,this,"setSize")},setSize:function(){var t=f.read(arguments);this._fixX&&(this.x+=(this.width-t.width)*this._fixX),this._fixY&&(this.y+=(this.height-t.height)*this._fixY),this.width=t.width,this.height=t.height,this._fixW=1,this._fixH=1},getLeft:function(){return this.x},setLeft:function(t){this._fixW||(this.width-=t-this.x),this.x=t,this._fixX=0},getTop:function(){return this.y},setTop:function(t){this._fixH||(this.height-=t-this.y),this.y=t,this._fixY=0},getRight:function(){return this.x+this.width},setRight:function(t){this._fixX!==e&&1!==this._fixX&&(this._fixW=0),this._fixW?this.x=t-this.width:this.width=t-this.x,this._fixX=1},getBottom:function(){return this.y+this.height},setBottom:function(t){this._fixY!==e&&1!==this._fixY&&(this._fixH=0),this._fixH?this.y=t-this.height:this.height=t-this.y,this._fixY=1},getCenterX:function(){return this.x+.5*this.width},setCenterX:function(t){this.x=t-.5*this.width,this._fixX=.5},getCenterY:function(){return this.y+.5*this.height},setCenterY:function(t){this.y=t-.5*this.height,this._fixY=.5},getCenter:function(t){var e=t?c:d;return new e(this.getCenterX(),this.getCenterY(),this,"setCenter")},setCenter:function(){var t=c.read(arguments);return this.setCenterX(t.x),this.setCenterY(t.y),this},getArea:function(){return this.width*this.height},isEmpty:function(){return 0===this.width||0===this.height},contains:function(t){return t&&t.width!==e||4===(Array.isArray(t)?t:arguments).length?this._containsRectangle(g.read(arguments)):this._containsPoint(c.read(arguments))},_containsPoint:function(t){var e=t.x,i=t.y;return e>=this.x&&i>=this.y&&e<=this.x+this.width&&i<=this.y+this.height},_containsRectangle:function(t){var e=t.x,i=t.y;return e>=this.x&&i>=this.y&&e+t.width<=this.x+this.width&&i+t.height<=this.y+this.height},intersects:function(){var t=g.read(arguments);return t.x+t.width>this.x&&t.y+t.height>this.y&&t.x<this.x+this.width&&t.y<this.y+this.height},touches:function(){var t=g.read(arguments);return t.x+t.width>=this.x&&t.y+t.height>=this.y&&t.x<=this.x+this.width&&t.y<=this.y+this.height},intersect:function(){var t=g.read(arguments),e=Math.max(this.x,t.x),i=Math.max(this.y,t.y),n=Math.min(this.x+this.width,t.x+t.width),r=Math.min(this.y+this.height,t.y+t.height);return new g(e,i,n-e,r-i)},unite:function(){var t=g.read(arguments),e=Math.min(this.x,t.x),i=Math.min(this.y,t.y),n=Math.max(this.x+this.width,t.x+t.width),r=Math.max(this.y+this.height,t.y+t.height);return new g(e,i,n-e,r-i)},include:function(){var t=c.read(arguments),e=Math.min(this.x,t.x),i=Math.min(this.y,t.y),n=Math.max(this.x+this.width,t.x),r=Math.max(this.y+this.height,t.y);return new g(e,i,n-e,r-i)},expand:function(){var t=f.read(arguments),e=t.width,i=t.height;return new g(this.x-e/2,this.y-i/2,this.width+e,this.height+i)},scale:function(t,i){return this.expand(this.width*t-this.width,this.height*(i===e?t:i)-this.height)}},r.each([["Top","Left"],["Top","Right"],["Bottom","Left"],["Bottom","Right"],["Left","Center"],["Top","Center"],["Right","Center"],["Bottom","Center"]],function(t,e){var i=t.join(""),n=/^[RL]/.test(i);e>=4&&(t[1]+=n?"Y":"X");var r=t[n?0:1],s=t[n?1:0],a="get"+r,o="get"+s,h="set"+r,u="set"+s,l="get"+i,f="set"+i;this[l]=function(t){var e=t?c:d;return new e(this[a](),this[o](),this,f)},this[f]=function(){var t=c.read(arguments);this[h](t.x),this[u](t.y)}},{beans:!0})),v=g.extend({initialize:function(t,e,i,n,r,s){this.set(t,e,i,n,!0),this._owner=r,this._setter=s},set:function(t,e,i,n,r){return this._x=t,this._y=e,this._width=i,this._height=n,r||this._owner[this._setter](this),this}},new function(){var t=g.prototype;return r.each(["x","y","width","height"],function(t){var e=r.capitalize(t),i="_"+t;this["get"+e]=function(){return this[i]},this["set"+e]=function(t){this[i]=t,this._dontNotify||this._owner[this._setter](this)}},r.each(["Point","Size","Center","Left","Top","Right","Bottom","CenterX","CenterY","TopLeft","TopRight","BottomLeft","BottomRight","LeftCenter","TopCenter","RightCenter","BottomCenter"],function(e){var i="set"+e;this[i]=function(){this._dontNotify=!0,t[i].apply(this,arguments),this._dontNotify=!1,this._owner[this._setter](this)}},{isSelected:function(){return!!(2&this._owner._selection)},setSelected:function(t){var e=this._owner;e.changeSelection&&e.changeSelection(2,t)}}))}),p=r.extend({_class:"Matrix",initialize:function at(t){var e=arguments.length,i=!0;if(6===e?this.set.apply(this,arguments):1===e?t instanceof at?this.set(t._a,t._b,t._c,t._d,t._tx,t._ty):Array.isArray(t)?this.set.apply(this,t):i=!1:0===e?this.reset():i=!1,!i)throw new Error("Unsupported matrix parameters")},set:function(t,e,i,n,r,s,a){return this._a=t,this._b=e,this._c=i,this._d=n,this._tx=r,this._ty=s,a||this._changed(),this},_serialize:function(t,e){return r.serialize(this.getValues(),t,!0,e)},_changed:function(){var t=this._owner;t&&(t._applyMatrix?t.transform(null,!0):t._changed(9))},clone:function(){return new p(this._a,this._b,this._c,this._d,this._tx,this._ty)},equals:function(t){return t===this||t&&this._a===t._a&&this._b===t._b&&this._c===t._c&&this._d===t._d&&this._tx===t._tx&&this._ty===t._ty},toString:function(){var t=h.instance;return"[["+[t.number(this._a),t.number(this._c),t.number(this._tx)].join(", ")+"], ["+[t.number(this._b),t.number(this._d),t.number(this._ty)].join(", ")+"]]"},reset:function(t){return this._a=this._d=1,this._b=this._c=this._tx=this._ty=0,t||this._changed(),this},apply:function(t,e){var i=this._owner;return!!i&&(i.transform(null,!0,r.pick(t,!0),e),this.isIdentity())},translate:function(){var t=c.read(arguments),e=t.x,i=t.y;return this._tx+=e*this._a+i*this._c,
	this._ty+=e*this._b+i*this._d,this._changed(),this},scale:function(){var t=c.read(arguments),e=c.read(arguments,0,{readNull:!0});return e&&this.translate(e),this._a*=t.x,this._b*=t.x,this._c*=t.y,this._d*=t.y,e&&this.translate(e.negate()),this._changed(),this},rotate:function(t){t*=Math.PI/180;var e=c.read(arguments,1),i=e.x,n=e.y,r=Math.cos(t),s=Math.sin(t),a=i-i*r+n*s,o=n-i*s-n*r,h=this._a,u=this._b,l=this._c,d=this._d;return this._a=r*h+s*l,this._b=r*u+s*d,this._c=-s*h+r*l,this._d=-s*u+r*d,this._tx+=a*h+o*l,this._ty+=a*u+o*d,this._changed(),this},shear:function(){var t=c.read(arguments),e=c.read(arguments,0,{readNull:!0});e&&this.translate(e);var i=this._a,n=this._b;return this._a+=t.y*this._c,this._b+=t.y*this._d,this._c+=t.x*i,this._d+=t.x*n,e&&this.translate(e.negate()),this._changed(),this},skew:function(){var t=c.read(arguments),e=c.read(arguments,0,{readNull:!0}),i=Math.PI/180,n=new c(Math.tan(t.x*i),Math.tan(t.y*i));return this.shear(n,e)},append:function(t){if(t){var e=this._a,i=this._b,n=this._c,r=this._d,s=t._a,a=t._c,o=t._b,h=t._d,u=t._tx,l=t._ty;this._a=s*e+o*n,this._c=a*e+h*n,this._b=s*i+o*r,this._d=a*i+h*r,this._tx+=u*e+l*n,this._ty+=u*i+l*r,this._changed()}return this},prepend:function(t){if(t){var e=this._a,i=this._b,n=this._c,r=this._d,s=this._tx,a=this._ty,o=t._a,h=t._c,u=t._b,l=t._d,c=t._tx,d=t._ty;this._a=o*e+h*i,this._c=o*n+h*r,this._b=u*e+l*i,this._d=u*n+l*r,this._tx=o*s+h*a+c,this._ty=u*s+l*a+d,this._changed()}return this},appended:function(t){return this.clone().append(t)},prepended:function(t){return this.clone().prepend(t)},invert:function(){var t=this._a,e=this._b,i=this._c,n=this._d,r=this._tx,s=this._ty,a=t*n-e*i,o=null;return a&&!isNaN(a)&&isFinite(r)&&isFinite(s)&&(this._a=n/a,this._b=-e/a,this._c=-i/a,this._d=t/a,this._tx=(i*s-n*r)/a,this._ty=(e*r-t*s)/a,o=this),o},inverted:function(){return this.clone().invert()},concatenate:"#append",preConcatenate:"#prepend",chain:"#appended",_shiftless:function(){return new p(this._a,this._b,this._c,this._d,0,0)},_orNullIfIdentity:function(){return this.isIdentity()?null:this},isIdentity:function(){return 1===this._a&&0===this._b&&0===this._c&&1===this._d&&0===this._tx&&0===this._ty},isInvertible:function(){var t=this._a*this._d-this._c*this._b;return t&&!isNaN(t)&&isFinite(this._tx)&&isFinite(this._ty)},isSingular:function(){return!this.isInvertible()},transform:function(t,e,i){return arguments.length<3?this._transformPoint(c.read(arguments)):this._transformCoordinates(t,e,i)},_transformPoint:function(t,e,i){var n=t.x,r=t.y;return e||(e=new c),e.set(n*this._a+r*this._c+this._tx,n*this._b+r*this._d+this._ty,i)},_transformCoordinates:function(t,e,i){for(var n=0,r=2*i;n<r;n+=2){var s=t[n],a=t[n+1];e[n]=s*this._a+a*this._c+this._tx,e[n+1]=s*this._b+a*this._d+this._ty}return e},_transformCorners:function(t){var e=t.x,i=t.y,n=e+t.width,r=i+t.height,s=[e,i,n,i,n,r,e,r];return this._transformCoordinates(s,s,4)},_transformBounds:function(t,e,i){for(var n=this._transformCorners(t),r=n.slice(0,2),s=r.slice(),a=2;a<8;a++){var o=n[a],h=1&a;o<r[h]?r[h]=o:o>s[h]&&(s[h]=o)}return e||(e=new g),e.set(r[0],r[1],s[0]-r[0],s[1]-r[1],i)},inverseTransform:function(){return this._inverseTransform(c.read(arguments))},_inverseTransform:function(t,e,i){var n=this._a,r=this._b,s=this._c,a=this._d,o=this._tx,h=this._ty,u=n*a-r*s,l=null;if(u&&!isNaN(u)&&isFinite(o)&&isFinite(h)){var d=t.x-this._tx,f=t.y-this._ty;e||(e=new c),l=e.set((d*a-f*s)/u,(f*n-d*r)/u,i)}return l},decompose:function(){var t,e,i,n=this._a,r=this._b,s=this._c,a=this._d,o=n*a-r*s,h=Math.sqrt,u=Math.atan2,l=180/Math.PI;if(0!==n||0!==r){var d=h(n*n+r*r);t=Math.acos(n/d)*(r>0?1:-1),e=[d,o/d],i=[u(n*s+r*a,d*d),0]}else if(0!==s||0!==a){var f=h(s*s+a*a);t=Math.asin(s/f)*(a>0?1:-1),e=[o/f,f],i=[0,u(n*s+r*a,f*f)]}else t=0,i=e=[0,0];return{translation:this.getTranslation(),rotation:t*l,scaling:new c(e),skewing:new c(i[0]*l,i[1]*l)}},getValues:function(){return[this._a,this._b,this._c,this._d,this._tx,this._ty]},getTranslation:function(){return new c(this._tx,this._ty)},getScaling:function(){return(this.decompose()||{}).scaling},getRotation:function(){return(this.decompose()||{}).rotation},applyToContext:function(t){this.isIdentity()||t.transform(this._a,this._b,this._c,this._d,this._tx,this._ty)}},r.each(["a","b","c","d","tx","ty"],function(t){var e=r.capitalize(t),i="_"+t;this["get"+e]=function(){return this[i]},this["set"+e]=function(t){this[i]=t,this._changed()}},{})),m=r.extend({_class:"Line",initialize:function(t,e,i,n,r){var s=!1;arguments.length>=4?(this._px=t,this._py=e,this._vx=i,this._vy=n,s=r):(this._px=t.x,this._py=t.y,this._vx=e.x,this._vy=e.y,s=i),s||(this._vx-=this._px,this._vy-=this._py)},getPoint:function(){return new c(this._px,this._py)},getVector:function(){return new c(this._vx,this._vy)},getLength:function(){return this.getVector().getLength()},intersect:function(t,e){return m.intersect(this._px,this._py,this._vx,this._vy,t._px,t._py,t._vx,t._vy,!0,e)},getSide:function(t,e){return m.getSide(this._px,this._py,this._vx,this._vy,t.x,t.y,!0,e)},getDistance:function(t){return Math.abs(m.getSignedDistance(this._px,this._py,this._vx,this._vy,t.x,t.y,!0))},isCollinear:function(t){return c.isCollinear(this._vx,this._vy,t._vx,t._vy)},isOrthogonal:function(t){return c.isOrthogonal(this._vx,this._vy,t._vx,t._vy)},statics:{intersect:function(t,e,i,n,r,s,a,o,h,l){h||(i-=t,n-=e,a-=r,o-=s);var d=i*o-n*a;if(!u.isZero(d)){var f=t-r,_=e-s,g=(a*_-o*f)/d,v=(i*_-n*f)/d,p=1e-12,m=-p,y=1+p;if(l||m<g&&g<y&&m<v&&v<y)return l||(g=g<=0?0:g>=1?1:g),new c(t+g*i,e+g*n)}},getSide:function(t,e,i,n,r,s,a,o){a||(i-=t,n-=e);var h=r-t,u=s-e,l=h*n-u*i;return 0!==l||o||(l=(h*i+h*i)/(i*i+n*n),l>=0&&l<=1&&(l=0)),l<0?-1:l>0?1:0},getSignedDistance:function(t,e,i,n,r,s,a){return a||(i-=t,n-=e),0===i?n>0?r-t:t-r:0===n?i<0?s-e:e-s:((r-t)*n-(s-e)*i)/Math.sqrt(i*i+n*n)}}}),y=o.extend({_class:"Project",_list:"projects",_reference:"project",_compactSerialize:!0,initialize:function(t){o.call(this,!0),this._children=[],this._namedChildren={},this._activeLayer=null,this._currentStyle=new V(null,null,this),this._view=U.create(this,t||Q.getCanvas(1,1)),this._selectionItems={},this._selectionCount=0,this._updateVersion=0},_serialize:function(t,e){return r.serialize(this._children,t,!0,e)},_changed:function(t,e){if(1&t){var i=this._view;i&&(i._needsUpdate=!0,!i._requested&&i._autoUpdate&&i.requestUpdate())}var n=this._changes;if(n&&e){var r=this._changesById,s=e._id,a=r[s];a?a.flags|=t:n.push(r[s]={item:e,flags:t})}},clear:function(){for(var t=this._children,e=t.length-1;e>=0;e--)t[e].remove()},isEmpty:function(){return 0===this._children.length},remove:function ot(){return!!ot.base.call(this)&&(this._view&&this._view.remove(),!0)},getView:function(){return this._view},getCurrentStyle:function(){return this._currentStyle},setCurrentStyle:function(t){this._currentStyle.initialize(t)},getIndex:function(){return this._index},getOptions:function(){return this._scope.settings},getLayers:function(){return this._children},getActiveLayer:function(){return this._activeLayer||new b({project:this,insert:!0})},getSymbolDefinitions:function(){var t=[],e={};return this.getItems({"class":P,match:function(i){var n=i._definition,r=n._id;return e[r]||(e[r]=!0,t.push(n)),!1}}),t},getSymbols:"getSymbolDefinitions",getSelectedItems:function(){var t=this._selectionItems,e=[];for(var i in t){var n=t[i],r=n._selection;1&r&&n.isInserted()?e.push(n):r||this._updateSelection(n)}return e},_updateSelection:function(t){var e=t._id,i=this._selectionItems;t._selection?i[e]!==t&&(this._selectionCount++,i[e]=t):i[e]===t&&(this._selectionCount--,delete i[e])},selectAll:function(){for(var t=this._children,e=0,i=t.length;e<i;e++)t[e].setFullySelected(!0)},deselectAll:function(){var t=this._selectionItems;for(var e in t)t[e].setFullySelected(!1)},addLayer:function(t){return this.insertLayer(e,t)},insertLayer:function(t,e){if(e instanceof b){e._remove(!1,!0),r.splice(this._children,[e],t,0),e._setProject(this,!0);var i=e._name;i&&e.setName(i),this._changes&&e._changed(5),this._activeLayer||(this._activeLayer=e)}else e=null;return e},_insertItem:function(t,i,n,r){return i=this.insertLayer(t,i)||(this._activeLayer||this._insertItem(e,new b(w.NO_INSERT),!0,!0)).insertChild(t,i,n),r&&i.activate&&i.activate(),i},getItems:function(t){return w._getItems(this,t)},getItem:function(t){return w._getItems(this,t,null,null,!0)[0]||null},importJSON:function(t){this.activate();var e=this._activeLayer;return r.importJSON(t,e&&e.isEmpty()&&e)},removeOn:function(t){var e=this._removeSets;if(e){"mouseup"===t&&(e.mousedrag=null);var i=e[t];if(i){for(var n in i){var r=i[n];for(var s in e){var a=e[s];a&&a!=i&&delete a[r._id]}r.remove()}e[t]=null}}},draw:function(t,e,i){this._updateVersion++,t.save(),e.applyToContext(t);for(var n=this._children,s=new r({offset:new c(0,0),pixelRatio:i,viewMatrix:e.isIdentity()?null:e,matrices:[new p],updateMatrix:!0}),a=0,o=n.length;a<o;a++)n[a].draw(t,s);if(t.restore(),this._selectionCount>0){t.save(),t.strokeWidth=1;var h=this._selectionItems,u=this._scope.settings.handleSize,l=this._updateVersion;for(var d in h)h[d]._drawSelection(t,e,u,h,l);t.restore()}}}),w=r.extend(s,{statics:{extend:function ht(t){return t._serializeFields&&(t._serializeFields=r.set({},this.prototype._serializeFields,t._serializeFields)),ht.base.apply(this,arguments)},NO_INSERT:{insert:!1}},_class:"Item",_name:null,_applyMatrix:!0,_canApplyMatrix:!0,_canScaleStroke:!1,_pivot:null,_visible:!0,_blendMode:"normal",_opacity:1,_locked:!1,_guide:!1,_clipMask:!1,_selection:0,_selectBounds:!0,_selectChildren:!1,_serializeFields:{name:null,applyMatrix:null,matrix:new p,pivot:null,visible:!0,blendMode:"normal",opacity:1,locked:!1,guide:!1,clipMask:!1,selected:!1,data:{}}},new function(){var t=["onMouseDown","onMouseUp","onMouseDrag","onClick","onDoubleClick","onMouseMove","onMouseEnter","onMouseLeave"];return r.each(t,function(t){this._events[t]={install:function(t){this.getView()._countItemEvent(t,1)},uninstall:function(t){this.getView()._countItemEvent(t,-1)}}},{_events:{onFrame:{install:function(){this.getView()._animateItem(this,!0)},uninstall:function(){this.getView()._animateItem(this,!1)}},onLoad:{},onError:{}},statics:{_itemHandlers:t}})},{initialize:function(){},_initialize:function(t,i){var n=t&&r.isPlainObject(t),s=n&&t.internal===!0,a=this._matrix=new p,o=n&&t.project||paper.project,h=paper.settings;return this._id=s?null:l.get(),this._parent=this._index=null,this._applyMatrix=this._canApplyMatrix&&h.applyMatrix,i&&a.translate(i),a._owner=this,this._style=new V(o._currentStyle,this,o),s||n&&t.insert===!1||!h.insertItems&&(!n||t.insert!==!0)?this._setProject(o):(n&&t.parent||o)._insertItem(e,this,!0,!0),n&&t!==w.NO_INSERT&&r.filter(this,t,{internal:!0,insert:!0,project:!0,parent:!0}),n},_serialize:function(t,e){function i(i){for(var a in i){var o=s[a];r.equals(o,"leading"===a?1.2*i.fontSize:i[a])||(n[a]=r.serialize(o,t,"data"!==a,e))}}var n={},s=this;return i(this._serializeFields),this instanceof x||i(this._style._defaults),[this._class,n]},_changed:function(t){var i=this._symbol,n=this._parent||i,r=this._project;8&t&&(this._bounds=this._position=this._decomposed=this._globalMatrix=e),n&&40&t&&w._clearBoundsCache(n),2&t&&w._clearBoundsCache(this),r&&r._changed(t,this),i&&i._changed(t)},set:function(t){return t&&this._set(t),this},getId:function(){return this._id},getName:function(){return this._name},setName:function(t){if(this._name&&this._removeNamed(),t===+t+"")throw new Error("Names consisting only of numbers are not supported.");var i=this._getOwner();if(t&&i){var n=i._children,r=i._namedChildren;(r[t]=r[t]||[]).push(this),t in n||(n[t]=this)}this._name=t||e,this._changed(128)},getStyle:function(){return this._style},setStyle:function(t){this.getStyle().set(t)}},r.each(["locked","visible","blendMode","opacity","guide"],function(t){var e=r.capitalize(t),t="_"+t;this["get"+e]=function(){return this[t]},this["set"+e]=function(e){e!=this[t]&&(this[t]=e,this._changed("_locked"===t?128:129))}},{}),{beans:!0,getSelection:function(){return this._selection},setSelection:function(t){if(t!==this._selection){this._selection=t;var e=this._project;e&&(e._updateSelection(this),this._changed(129))}},changeSelection:function(t,e){var i=this._selection;this.setSelection(e?i|t:i&~t)},isSelected:function(){if(this._selectChildren)for(var t=this._children,e=0,i=t.length;e<i;e++)if(t[e].isSelected())return!0;return!!(1&this._selection)},setSelected:function(t){if(this._selectChildren)for(var e=this._children,i=0,n=e.length;i<n;i++)e[i].setSelected(t);this.changeSelection(1,t)},isFullySelected:function(){var t=this._children,e=!!(1&this._selection);if(t&&e){for(var i=0,n=t.length;i<n;i++)if(!t[i].isFullySelected())return!1;return!0}return e},setFullySelected:function(t){var e=this._children;if(e)for(var i=0,n=e.length;i<n;i++)e[i].setFullySelected(t);this.changeSelection(1,t)},isClipMask:function(){return this._clipMask},setClipMask:function(t){this._clipMask!=(t=!!t)&&(this._clipMask=t,t&&(this.setFillColor(null),this.setStrokeColor(null)),this._changed(129),this._parent&&this._parent._changed(1024))},getData:function(){return this._data||(this._data={}),this._data},setData:function(t){this._data=t},getPosition:function(t){var e=this._position,i=t?c:d;if(!e){var n=this._pivot;e=this._position=n?this._matrix._transformPoint(n):this.getBounds().getCenter(!0)}return new i(e.x,e.y,this,"setPosition")},setPosition:function(){this.translate(c.read(arguments).subtract(this.getPosition(!0)))},getPivot:function(t){var e=this._pivot;if(e){var i=t?c:d;e=new i(e.x,e.y,this,"setPivot")}return e},setPivot:function(){this._pivot=c.read(arguments,0,{clone:!0,readNull:!0}),this._position=e}},r.each({getStrokeBounds:{stroke:!0},getHandleBounds:{handle:!0},getInternalBounds:{internal:!0}},function(t,e){this[e]=function(e){return this.getBounds(e,t)}},{beans:!0,getBounds:function(t,e){var i=e||t instanceof p,n=r.set({},i?e:t,this._boundsOptions);n.stroke&&!this.getStrokeScaling()||(n.cacheItem=this);var s=this._getCachedBounds(i&&t,n);return 0===arguments.length?new v(s.x,s.y,s.width,s.height,this,"setBounds"):s},setBounds:function(){var t=g.read(arguments),e=this.getBounds(),i=this._matrix,n=new p,r=t.getCenter();n.translate(r),t.width==e.width&&t.height==e.height||(i.isInvertible()||(i.initialize(i._backup||(new p).translate(i.getTranslation())),e=this.getBounds()),n.scale(0!==e.width?t.width/e.width:0,0!==e.height?t.height/e.height:0)),r=e.getCenter(),n.translate(-r.x,-r.y),this.transform(n)},_getBounds:function(t,e){var i=this._children;return i&&0!==i.length?(w._updateBoundsCache(this,e.cacheItem),w._getBounds(i,t,e)):new g},_getCachedBounds:function(t,e){t=t&&t._orNullIfIdentity();var i=e.internal,n=e.cacheItem,r=i?null:this._matrix._orNullIfIdentity(),s=n&&(!t||t.equals(r))&&[e.stroke?1:0,e.handle?1:0,i?1:0].join("");if(w._updateBoundsCache(this._parent||this._symbol,n),s&&this._bounds&&s in this._bounds)return this._bounds[s].rect.clone();var a=this._getBounds(t||r,e);if(s){this._bounds||(this._bounds={});this._bounds[s]={rect:a.clone(),internal:e.internal}}return a},_getStrokeMatrix:function(t,e){var i=this.getStrokeScaling()?null:e&&e.internal?this:this._parent||this._symbol&&this._symbol._item,n=i?i.getViewMatrix().invert():t;return n&&n._shiftless()},statics:{_updateBoundsCache:function(t,e){if(t&&e){var i=e._id,n=t._boundsCache=t._boundsCache||{ids:{},list:[]};n.ids[i]||(n.list.push(e),n.ids[i]=e)}},_clearBoundsCache:function(t){var i=t._boundsCache;if(i){t._bounds=t._position=t._boundsCache=e;for(var n=0,r=i.list,s=r.length;n<s;n++){var a=r[n];a!==t&&(a._bounds=a._position=e,a._boundsCache&&w._clearBoundsCache(a))}}},_getBounds:function(t,e,i){var n=1/0,r=-n,s=n,a=r;i=i||{};for(var o=0,h=t.length;o<h;o++){var u=t[o];if(u._visible&&!u.isEmpty()){var l=u._getCachedBounds(e&&e.appended(u._matrix),i);n=Math.min(l.x,n),s=Math.min(l.y,s),r=Math.max(l.x+l.width,r),a=Math.max(l.y+l.height,a)}}return isFinite(n)?new g(n,s,r-n,a-s):new g}}}),{beans:!0,_decompose:function(){return this._decomposed||(this._decomposed=this._matrix.decompose())},getRotation:function(){var t=this._decompose();return t&&t.rotation},setRotation:function(t){var e=this.getRotation();null!=e&&null!=t&&this.rotate(t-e)},getScaling:function(t){var e=this._decompose(),i=e&&e.scaling,n=t?c:d;return i&&new n(i.x,i.y,this,"setScaling")},setScaling:function(){var t=this.getScaling(),e=c.read(arguments,0,{clone:!0,readNull:!0});t&&e&&this.scale(e.x/t.x,e.y/t.y)},getMatrix:function(){return this._matrix},setMatrix:function(){var t=this._matrix;t.initialize.apply(t,arguments)},getGlobalMatrix:function(t){var e=this._globalMatrix,i=this._project._updateVersion;if(e&&e._updateVersion!==i&&(e=null),!e){e=this._globalMatrix=this._matrix.clone();var n=this._parent;n&&e.prepend(n.getGlobalMatrix(!0)),e._updateVersion=i}return t?e:e.clone()},getViewMatrix:function(){return this.getGlobalMatrix().prepend(this.getView()._matrix)},getApplyMatrix:function(){return this._applyMatrix},setApplyMatrix:function(t){(this._applyMatrix=this._canApplyMatrix&&!!t)&&this.transform(null,!0)},getTransformContent:"#getApplyMatrix",setTransformContent:"#setApplyMatrix"},{getProject:function(){return this._project},_setProject:function(t,e){if(this._project!==t){this._project&&this._installEvents(!1),this._project=t;for(var i=this._children,n=0,r=i&&i.length;n<r;n++)i[n]._setProject(t);e=!0}e&&this._installEvents(!0)},getView:function(){return this._project._view},_installEvents:function ut(t){ut.base.call(this,t);for(var e=this._children,i=0,n=e&&e.length;i<n;i++)e[i]._installEvents(t)},getLayer:function(){for(var t=this;t=t._parent;)if(t instanceof b)return t;return null},getParent:function(){return this._parent},setParent:function(t){return t.addChild(this)},_getOwner:"#getParent",getChildren:function(){return this._children},setChildren:function(t,e){this.removeChildren(),this.addChildren(t,e)},getFirstChild:function(){return this._children&&this._children[0]||null},getLastChild:function(){return this._children&&this._children[this._children.length-1]||null},getNextSibling:function(){var t=this._getOwner();return t&&t._children[this._index+1]||null},getPreviousSibling:function(){var t=this._getOwner();return t&&t._children[this._index-1]||null},getIndex:function(){return this._index},equals:function(t){return t===this||t&&this._class===t._class&&this._style.equals(t._style)&&this._matrix.equals(t._matrix)&&this._locked===t._locked&&this._visible===t._visible&&this._blendMode===t._blendMode&&this._opacity===t._opacity&&this._clipMask===t._clipMask&&this._guide===t._guide&&this._equals(t)||!1},_equals:function(t){return r.equals(this._children,t._children)},clone:function(t){var i=new this.constructor(w.NO_INSERT),n=this._children,s=r.pick(t?t.insert:e,t===e||t===!0),a=r.pick(t?t.deep:e,!0);n&&i.copyAttributes(this),n&&!a||i.copyContent(this),n||i.copyAttributes(this),s&&i.insertAbove(this);var o=this._name,h=this._parent;if(o&&h){for(var n=h._children,u=o,l=1;n[o];)o=u+" "+l++;o!==u&&i.setName(o)}return i},copyContent:function(t){for(var e=t._children,i=0,n=e&&e.length;i<n;i++)this.addChild(e[i].clone(!1),!0)},copyAttributes:function(t,e){this.setStyle(t._style);for(var i=["_locked","_visible","_blendMode","_opacity","_clipMask","_guide"],n=0,s=i.length;n<s;n++){var a=i[n];t.hasOwnProperty(a)&&(this[a]=t[a])}e||this._matrix.initialize(t._matrix),this.setApplyMatrix(t._applyMatrix),this.setPivot(t._pivot),this.setSelection(t._selection);var o=t._data,h=t._name;this._data=o?r.clone(o):null,h&&this.setName(h)},rasterize:function(t,i){var n=this.getStrokeBounds(),s=(t||this.getView().getResolution())/72,a=n.getTopLeft().floor(),o=n.getBottomRight().ceil(),h=new f(o.subtract(a)),u=new S(w.NO_INSERT);if(!h.isZero()){var l=Q.getCanvas(h.multiply(s)),c=l.getContext("2d"),d=(new p).scale(s).translate(a.negate());c.save(),d.applyToContext(c),this.draw(c,new r({matrices:[d]})),c.restore(),u.setCanvas(l)}return u.transform((new p).translate(a.add(h.divide(2))).scale(1/s)),(i===e||i)&&u.insertAbove(this),u},contains:function(){return!!this._contains(this._matrix._inverseTransform(c.read(arguments)))},_contains:function(t){var e=this._children;if(e){for(var i=e.length-1;i>=0;i--)if(e[i].contains(t))return!0;return!1}return t.isInside(this.getInternalBounds())},isInside:function(){return g.read(arguments).contains(this.getBounds())},_asPathItem:function(){return new L.Rectangle({rectangle:this.getInternalBounds(),matrix:this._matrix,insert:!1})},intersects:function(t,e){return t instanceof w&&this._asPathItem().getIntersections(t._asPathItem(),null,e,!0).length>0}},new function(){function t(){return this._hitTest(c.read(arguments),M.getOptions(arguments))}function e(){var t=c.read(arguments),e=M.getOptions(arguments),i=e.match,n=[];return e=r.set({},e,{match:function(t){i&&!i(t)||n.push(t)}}),this._hitTest(t,e),n}function i(t,e,i,n){var r=this._children;if(r)for(var s=r.length-1;s>=0;s--){var a=r[s],o=a!==n&&a._hitTest(t,e,i);if(o)return o}return null}return y.inject({hitTest:t,hitTestAll:e,_hitTest:i}),{hitTest:t,hitTestAll:e,_hitTestChildren:i}},{_hitTest:function(t,e,i){function n(t){return!g||t&&g(t)?t:null}function s(e,i){var n=c["get"+i]();if(t.subtract(n).divide(l).length<=1)return new M(e,v,{name:r.hyphenate(i),point:n})}if(this._locked||!this._visible||this._guide&&!e.guides||this.isEmpty())return null;var a=this._matrix,o=i?i.appended(a):this.getGlobalMatrix().prepend(this.getView()._matrix),h=this.getStrokeScaling()?null:o.inverted()._shiftless(),u=Math.max(e.tolerance,1e-6),l=e._tolerancePadding=new f(L._getStrokePadding(u,h));if(t=a._inverseTransform(t),!t||!this._children&&!this.getBounds({internal:!0,stroke:!0,handle:!0}).expand(l.multiply(2))._containsPoint(t))return null;var c,d,_=!(e.guides&&!this._guide||e.selected&&!this.isSelected()||e.type&&e.type!==r.hyphenate(this._class)||e["class"]&&!(this instanceof e["class"])),g=e.match,v=this;if(_&&(e.center||e.bounds)&&this._parent){if(c=this.getInternalBounds(),e.center&&(d=s("center","Center")),!d&&e.bounds)for(var p=["TopLeft","TopRight","BottomLeft","BottomRight","LeftCenter","TopCenter","RightCenter","BottomCenter"],m=0;m<8&&!d;m++)d=s("bounds",p[m]);d=n(d)}return d||(d=this._hitTestChildren(t,e,o)||_&&n(this._hitTestSelf(t,e,o,h))||null),d&&d.point&&(d.point=a.transform(d.point)),d},_hitTestSelf:function(t,e){if(e.fill&&this.hasFill()&&this._contains(t))return new M("fill",this)},matches:function(t,e){function i(t,e){for(var n in t)if(t.hasOwnProperty(n)){var s=t[n],a=e[n];if(r.isPlainObject(s)&&r.isPlainObject(a)){if(!i(s,a))return!1}else if(!r.equals(s,a))return!1}return!0}var n=typeof t;if("object"===n){for(var s in t)if(t.hasOwnProperty(s)&&!this.matches(s,t[s]))return!1;return!0}if("function"===n)return t(this);if("match"===t)return e(this);var a=/^(empty|editable)$/.test(t)?this["is"+r.capitalize(t)]():"type"===t?r.hyphenate(this._class):this[t];if("class"===t){if("function"==typeof e)return this instanceof e;a=this._class}if("function"==typeof e)return!!e(a);if(e){if(e.test)return e.test(a);if(r.isPlainObject(e))return i(e,a)}return r.equals(a,e)},getItems:function(t){return w._getItems(this,t,this._matrix)},getItem:function(t){return w._getItems(this,t,this._matrix,null,!0)[0]||null},statics:{_getItems:function lt(t,e,i,n,s){if(!n){var a="object"==typeof e&&e,o=a&&a.overlapping,h=a&&a.inside,u=o||h,l=u&&g.read([u]);n={items:[],recursive:a&&a.recursive!==!1,inside:!!h,overlapping:!!o,rect:l,path:o&&new L.Rectangle({rectangle:l,insert:!1})},a&&(e=r.filter({},e,{recursive:!0,inside:!0,overlapping:!0}))}var c=t._children,d=n.items,l=n.rect;i=l&&(i||new p);for(var f=0,_=c&&c.length;f<_;f++){var v=c[f],m=i&&i.appended(v._matrix),y=!0;if(l){var u=v.getBounds(m);if(!l.intersects(u))continue;l.contains(u)||n.overlapping&&(u.contains(l)||n.path.intersects(v,m))||(y=!1)}if(y&&v.matches(e)&&(d.push(v),s))break;if(n.recursive!==!1&&lt(v,e,m,n,s),s&&d.length>0)break}return d}}},{importJSON:function(t){var e=r.importJSON(t,this);return e!==this?this.addChild(e):e},addChild:function(t,i){return this.insertChild(e,t,i)},insertChild:function(t,e,i){var n=e?this.insertChildren(t,[e],i):null;return n&&n[0]},addChildren:function(t,e){return this.insertChildren(this._children.length,t,e)},insertChildren:function(t,e,i,n){var s=this._children;if(s&&e&&e.length>0){e=Array.prototype.slice.apply(e);for(var a=e.length-1;a>=0;a--){var o=e[a];o&&(!n||o instanceof n)?o._remove(!1,!0):e.splice(a,1)}r.splice(s,e,t,0);for(var h=this._project,u=h._changes,a=0,l=e.length;a<l;a++){var o=e[a],c=o._name;o._parent=this,o._setProject(h,!0),c&&o.setName(c),u&&this._changed(5)}this._changed(11)}else e=null;return e},_insertItem:"#insertChild",_insertAt:function(t,e,i){var n=this;if(n!==t){var r=t&&t._getOwner();r?(n._remove(!1,!0),r._insertItem(t._index+e,n,i)):n=null}return n},insertAbove:function(t,e){return this._insertAt(t,1,e)},insertBelow:function(t,e){return this._insertAt(t,0,e)},sendToBack:function(){var t=this._getOwner();return t?t._insertItem(0,this):null},bringToFront:function(){var t=this._getOwner();return t?t._insertItem(e,this):null},appendTop:"#addChild",appendBottom:function(t){return this.insertChild(0,t)},moveAbove:"#insertAbove",moveBelow:"#insertBelow",copyTo:function(t){return t._insertItem(e,this.clone(!1))},reduce:function(t){var e=this._children;if(e&&1===e.length){var i=e[0].reduce(t);return this._parent?(i.insertAbove(this),this.remove()):i.remove(),i}return this},_removeNamed:function(){var t=this._getOwner();if(t){var e=t._children,i=t._namedChildren,n=this._name,r=i[n],s=r?r.indexOf(this):-1;s!==-1&&(e[n]==this&&delete e[n],r.splice(s,1),r.length?e[n]=r[0]:delete i[n])}},_remove:function(t,e){var i=this._getOwner(),n=this._project,s=this._index;return!!i&&(null!=s&&(n._activeLayer===this&&(n._activeLayer=this.getNextSibling()||this.getPreviousSibling()),r.splice(i._children,null,s,1)),this._name&&this._removeNamed(),this._installEvents(!1),t&&n._changes&&this._changed(5),e&&i._changed(11,this),this._parent=null,!0)},remove:function(){return this._remove(!0,!0)},replaceWith:function(t){var e=t&&t.insertBelow(this);return e&&this.remove(),e},removeChildren:function(t,e){if(!this._children)return null;t=t||0,e=r.pick(e,this._children.length);for(var i=r.splice(this._children,null,t,e-t),n=i.length-1;n>=0;n--)i[n]._remove(!0,!1);return i.length>0&&this._changed(11),i},clear:"#removeChildren",reverseChildren:function(){if(this._children){this._children.reverse();for(var t=0,e=this._children.length;t<e;t++)this._children[t]._index=t;this._changed(11)}},isEmpty:function(){return!this._children||0===this._children.length},isEditable:function(){for(var t=this;t;){if(!t._visible||t._locked)return!1;t=t._parent}return!0},hasFill:function(){return this.getStyle().hasFill()},hasStroke:function(){return this.getStyle().hasStroke()},hasShadow:function(){return this.getStyle().hasShadow()},_getOrder:function(t){function e(t){var e=[];do e.unshift(t);while(t=t._parent);return e}for(var i=e(this),n=e(t),r=0,s=Math.min(i.length,n.length);r<s;r++)if(i[r]!=n[r])return i[r]._index<n[r]._index?1:-1;return 0},hasChildren:function(){return this._children&&this._children.length>0},isInserted:function(){return!!this._parent&&this._parent.isInserted()},isAbove:function(t){return this._getOrder(t)===-1},isBelow:function(t){return 1===this._getOrder(t)},isParent:function(t){return this._parent===t},isChild:function(t){return t&&t._parent===this},isDescendant:function(t){for(var e=this;e=e._parent;)if(e===t)return!0;return!1},isAncestor:function(t){return!!t&&t.isDescendant(this)},isSibling:function(t){return this._parent===t._parent},isGroupedWith:function(t){for(var e=this._parent;e;){if(e._parent&&/^(Group|Layer|CompoundPath)$/.test(e._class)&&t.isDescendant(e))return!0;e=e._parent}return!1}},r.each(["rotate","scale","shear","skew"],function(t){var e="rotate"===t;this[t]=function(){var i=(e?r:c).read(arguments),n=c.read(arguments,0,{readNull:!0});return this.transform((new p)[t](i,n||this.getPosition(!0)))}},{translate:function(){var t=new p;return this.transform(t.translate.apply(t,arguments))},transform:function(t,e,i,n){t&&t.isIdentity()&&(t=null);var r=this._matrix,s=(e||this._applyMatrix)&&(!r.isIdentity()||t||e&&i&&this._children);if(!t&&!s)return this;if(t&&(!t.isInvertible()&&r.isInvertible()&&(r._backup=r.getValues()),r.prepend(t)),s=s&&this._transformContent(r,i,n)){var a=this._pivot,o=this._style,h=o.getFillColor(!0),u=o.getStrokeColor(!0);a&&r._transformPoint(a,a,!0),h&&h.transform(r),u&&u.transform(r),r.reset(!0),n&&this._canApplyMatrix&&(this._applyMatrix=!0)}var l=this._bounds,c=this._position;this._changed(9);var d=l&&t&&t.decompose();if(d&&!d.shearing&&d.rotation%90===0){for(var f in l){var _=l[f];if(s||!_.internal){var g=_.rect;t._transformBounds(g,g)}}var v=this._boundsGetter,g=l[v&&v.getBounds||v||"getBounds"];g&&(this._position=g.getCenter(!0)),this._bounds=l}else t&&c&&(this._position=t._transformPoint(c,c));return this},_transformContent:function(t,e,i){var n=this._children;if(n){for(var r=0,s=n.length;r<s;r++)n[r].transform(t,!0,e,i);return!0}},globalToLocal:function(){return this.getGlobalMatrix(!0)._inverseTransform(c.read(arguments))},localToGlobal:function(){return this.getGlobalMatrix(!0)._transformPoint(c.read(arguments))},parentToLocal:function(){return this._matrix._inverseTransform(c.read(arguments))},localToParent:function(){return this._matrix._transformPoint(c.read(arguments))},fitBounds:function(t,e){t=g.read(arguments);var i=this.getBounds(),n=i.height/i.width,r=t.height/t.width,s=(e?n>r:n<r)?t.width/i.width:t.height/i.height,a=new g(new c,new f(i.width*s,i.height*s));a.setCenter(t.getCenter()),this.setBounds(a)}}),{_setStyles:function(t,e,i){var n=this._style;if(n.hasFill()&&(t.fillStyle=n.getFillColor().toCanvasStyle(t)),n.hasStroke()){t.strokeStyle=n.getStrokeColor().toCanvasStyle(t),t.lineWidth=n.getStrokeWidth();var r=n.getStrokeJoin(),s=n.getStrokeCap(),a=n.getMiterLimit();if(r&&(t.lineJoin=r),s&&(t.lineCap=s),a&&(t.miterLimit=a),paper.support.nativeDash){var o=n.getDashArray(),h=n.getDashOffset();o&&o.length&&("setLineDash"in t?(t.setLineDash(o),t.lineDashOffset=h):(t.mozDash=o,t.mozDashOffset=h))}}if(n.hasShadow()){var u=e.pixelRatio||1,l=i._shiftless().prepend((new p).scale(u,u)),d=l.transform(new c(n.getShadowBlur(),0)),f=l.transform(this.getShadowOffset());t.shadowColor=n.getShadowColor().toCanvasStyle(t),t.shadowBlur=d.getLength(),t.shadowOffsetX=f.x,t.shadowOffsetY=f.y}},draw:function(t,e,i){var n=this._updateVersion=this._project._updateVersion;if(this._visible&&0!==this._opacity){var r=e.matrices,s=e.viewMatrix,a=this._matrix,o=r[r.length-1].appended(a);if(o.isInvertible()){s=s?s.appended(o):o,r.push(o),e.updateMatrix&&(o._updateVersion=n,this._globalMatrix=o);var h,u,l,c=this._blendMode,d=this._opacity,f="normal"===c,_=tt.nativeModes[c],g=f&&1===d||e.dontStart||e.clip||(_||f&&d<1)&&this._canComposite(),v=e.pixelRatio||1;if(!g){var p=this.getStrokeBounds(s);if(!p.width||!p.height)return;l=e.offset,u=e.offset=p.getTopLeft().floor(),h=t,t=Q.getContext(p.getSize().ceil().add(1).multiply(v)),1!==v&&t.scale(v,v)}t.save();var m=i?i.appended(a):this._canScaleStroke&&!this.getStrokeScaling(!0)&&s,y=!g&&e.clipItem,w=!m||y;if(g?(t.globalAlpha=d,_&&(t.globalCompositeOperation=c)):w&&t.translate(-u.x,-u.y),w&&(g?a:s).applyToContext(t),y&&e.clipItem.draw(t,e.extend({clip:!0})),m){t.setTransform(v,0,0,v,0,0);var x=e.offset;x&&t.translate(-x.x,-x.y)}this._draw(t,e,s,m),t.restore(),r.pop(),e.clip&&!e.dontFinish&&t.clip(),g||(tt.process(c,t,h,d,u.subtract(l).multiply(v)),Q.release(t),e.offset=l)}}},_isUpdated:function(t){var e=this._parent;if(e instanceof N)return e._isUpdated(t);var i=this._updateVersion===t;return!i&&e&&e._visible&&e._isUpdated(t)&&(this._updateVersion=t,i=!0),i},_drawSelection:function(t,e,i,n,r){var s=this._selection,a=1&s,o=2&s||a&&this._selectBounds,h=4&s;if(this._drawSelected||(a=!1),
	(a||o||h)&&this._isUpdated(r)){var u,l=this.getSelectedColor(!0)||(u=this.getLayer())&&u.getSelectedColor(!0),c=e.appended(this.getGlobalMatrix(!0)),d=i/2;if(t.strokeStyle=t.fillStyle=l?l.toCanvasStyle(t):"#009dec",a&&this._drawSelected(t,c,n),h){var f=this.getPosition(!0),_=f.x,g=f.y;t.beginPath(),t.arc(_,g,d,0,2*Math.PI,!0),t.stroke();for(var v=[[0,-1],[1,0],[0,1],[-1,0]],p=d,m=i+1,y=0;y<4;y++){var w=v[y],x=w[0],b=w[1];t.moveTo(_+x*p,g+b*p),t.lineTo(_+x*m,g+b*m),t.stroke()}}if(o){var C=c._transformCorners(this.getInternalBounds());t.beginPath();for(var y=0;y<8;y++)t[0===y?"moveTo":"lineTo"](C[y],C[++y]);t.closePath(),t.stroke();for(var y=0;y<8;y++)t.fillRect(C[y]-d,C[++y]-d,i,i)}}},_canComposite:function(){return!1}},r.each(["down","drag","up","move"],function(t){this["removeOn"+r.capitalize(t)]=function(){var e={};return e[t]=!0,this.removeOn(e)}},{removeOn:function(t){for(var e in t)if(t[e]){var i="mouse"+e,n=this._project,r=n._removeSets=n._removeSets||{};r[i]=r[i]||{},r[i][this._id]=this}return this}})),x=w.extend({_class:"Group",_selectBounds:!1,_selectChildren:!0,_serializeFields:{children:[]},initialize:function(t){this._children=[],this._namedChildren={},this._initialize(t)||this.addChildren(Array.isArray(t)?t:arguments)},_changed:function ct(t){ct.base.call(this,t),1026&t&&(this._clipItem=e)},_getClipItem:function(){var t=this._clipItem;if(t===e){t=null;for(var i=this._children,n=0,r=i.length;n<r;n++)if(i[n]._clipMask){t=i[n];break}this._clipItem=t}return t},isClipped:function(){return!!this._getClipItem()},setClipped:function(t){var e=this.getFirstChild();e&&e.setClipMask(t)},_getBounds:function dt(t,e){var i=this._getClipItem();return i?i._getCachedBounds(t&&t.appended(i._matrix),r.set({},e,{stroke:!1})):dt.base.call(this,t,e)},_hitTestChildren:function ft(t,e,i){var n=this._getClipItem();return(!n||n.contains(t))&&ft.base.call(this,t,e,i,n)},_draw:function(t,e){var i=e.clip,n=!i&&this._getClipItem();e=e.extend({clipItem:n,clip:!1}),i?(t.beginPath(),e.dontStart=e.dontFinish=!0):n&&n.draw(t,e.extend({clip:!0}));for(var r=this._children,s=0,a=r.length;s<a;s++){var o=r[s];o!==n&&o.draw(t,e)}}}),b=x.extend({_class:"Layer",initialize:function(){x.apply(this,arguments)},_getOwner:function(){return this._parent||null!=this._index&&this._project},isInserted:function _t(){return this._parent?_t.base.call(this):null!=this._index},activate:function(){this._project._activeLayer=this},_hitTestSelf:function(){}}),C=w.extend({_class:"Shape",_applyMatrix:!1,_canApplyMatrix:!1,_canScaleStroke:!0,_serializeFields:{type:null,size:null,radius:null},initialize:function(t){this._initialize(t)},_equals:function(t){return this._type===t._type&&this._size.equals(t._size)&&r.equals(this._radius,t._radius)},copyContent:function(t){this.setType(t._type),this.setSize(t._size),this.setRadius(t._radius)},getType:function(){return this._type},setType:function(t){this._type=t},getShape:"#getType",setShape:"#setType",getSize:function(){var t=this._size;return new _(t.width,t.height,this,"setSize")},setSize:function(){var t=f.read(arguments);if(this._size){if(!this._size.equals(t)){var e=this._type,i=t.width,n=t.height;if("rectangle"===e){var r=f.min(this._radius,t.divide(2));this._radius.set(r.width,r.height)}else"circle"===e?(i=n=(i+n)/2,this._radius=i/2):"ellipse"===e&&this._radius.set(i/2,n/2);this._size.set(i,n),this._changed(9)}}else this._size=t.clone()},getRadius:function(){var t=this._radius;return"circle"===this._type?t:new _(t.width,t.height,this,"setRadius")},setRadius:function(t){var e=this._type;if("circle"===e){if(t===this._radius)return;var i=2*t;this._radius=t,this._size.set(i,i)}else if(t=f.read(arguments),this._radius){if(this._radius.equals(t))return;if(this._radius.set(t.width,t.height),"rectangle"===e){var i=f.max(this._size,t.multiply(2));this._size.set(i.width,i.height)}else"ellipse"===e&&this._size.set(2*t.width,2*t.height)}else this._radius=t.clone();this._changed(9)},isEmpty:function(){return!1},toPath:function(t){var i=new(L[r.capitalize(this._type)])({center:new c,size:this._size,radius:this._radius,insert:!1});return i.copyAttributes(this),paper.settings.applyMatrix&&i.setApplyMatrix(!0),(t===e||t)&&i.insertAbove(this),i},toShape:"#clone",_draw:function(t,e,i,n){var r=this._style,s=r.hasFill(),a=r.hasStroke(),o=e.dontFinish||e.clip,h=!n;if(s||a||o){var u=this._type,l=this._radius,c="circle"===u;if(e.dontStart||t.beginPath(),h&&c)t.arc(0,0,l,0,2*Math.PI,!0);else{var d=c?l:l.width,f=c?l:l.height,_=this._size,g=_.width,v=_.height;if(h&&"rectangle"===u&&0===d&&0===f)t.rect(-g/2,-v/2,g,v);else{var p=g/2,m=v/2,y=.44771525016920644,w=d*y,x=f*y,b=[-p,-m+f,-p,-m+x,-p+w,-m,-p+d,-m,p-d,-m,p-w,-m,p,-m+x,p,-m+f,p,m-f,p,m-x,p-w,m,p-d,m,-p+d,m,-p+w,m,-p,m-x,-p,m-f];n&&n.transform(b,b,32),t.moveTo(b[0],b[1]),t.bezierCurveTo(b[2],b[3],b[4],b[5],b[6],b[7]),p!==d&&t.lineTo(b[8],b[9]),t.bezierCurveTo(b[10],b[11],b[12],b[13],b[14],b[15]),m!==f&&t.lineTo(b[16],b[17]),t.bezierCurveTo(b[18],b[19],b[20],b[21],b[22],b[23]),p!==d&&t.lineTo(b[24],b[25]),t.bezierCurveTo(b[26],b[27],b[28],b[29],b[30],b[31])}}t.closePath()}o||!s&&!a||(this._setStyles(t,e,i),s&&(t.fill(r.getFillRule()),t.shadowColor="rgba(0,0,0,0)"),a&&t.stroke())},_canComposite:function(){return!(this.hasFill()&&this.hasStroke())},_getBounds:function(t,e){var i=new g(this._size).setCenter(0,0),n=this._style,r=e.stroke&&n.hasStroke()&&n.getStrokeWidth();return t&&(i=t._transformBounds(i)),r?i.expand(L._getStrokePadding(r,this._getStrokeMatrix(t,e))):i}},new function(){function t(t,e,i){var n=t._radius;if(!n.isZero())for(var r=t._size.divide(2),s=0;s<4;s++){var a=new c(1&s?1:-1,s>1?1:-1),o=a.multiply(r),h=o.subtract(a.multiply(n)),u=new g(o,h);if((i?u.expand(i):u).contains(e))return h}}function e(t,e,i,n){var r=t.divide(e);return(!n||r.quadrant===n)&&r.subtract(r.normalize()).multiply(e).divide(i).length<=1}return{_contains:function i(e){if("rectangle"===this._type){var n=t(this,e);return n?e.subtract(n).divide(this._radius).getLength()<=1:i.base.call(this,e)}return e.divide(this.size).getLength()<=.5},_hitTestSelf:function n(i,r,s,a){var o=!1,h=this._style,u=r.stroke&&h.hasStroke(),l=r.fill&&h.hasFill();if(u||l){var c=this._type,d=this._radius,f=u?h.getStrokeWidth()/2:0,_=r._tolerancePadding.add(L._getStrokePadding(f,!h.getStrokeScaling()&&a));if("rectangle"===c){var v=_.multiply(2),p=t(this,i,v);if(p)o=e(i.subtract(p),d,_,p.getQuadrant());else{var m=new g(this._size).setCenter(0,0),y=m.expand(v),w=m.expand(v.negate());o=y._containsPoint(i)&&!w._containsPoint(i)}}else o=e(i,d,_)}return o?new M(u?"stroke":"fill",this):n.base.apply(this,arguments)}}},{statics:new function(){function t(t,e,i,n,s){var a=new C(r.getNamed(s));return a._type=t,a._size=i,a._radius=n,a.translate(e)}return{Circle:function(){var e=c.readNamed(arguments,"center"),i=r.readNamed(arguments,"radius");return t("circle",e,new f(2*i),i,arguments)},Rectangle:function(){var e=g.readNamed(arguments,"rectangle"),i=f.min(f.readNamed(arguments,"radius"),e.getSize(!0).divide(2));return t("rectangle",e.getCenter(!0),e.getSize(!0),i,arguments)},Ellipse:function(){var e=C._readEllipse(arguments),i=e.radius;return t("ellipse",e.center,i.multiply(2),i,arguments)},_readEllipse:function(t){var e,i;if(r.hasNamed(t,"radius"))e=c.readNamed(t,"center"),i=f.readNamed(t,"radius");else{var n=g.readNamed(t,"rectangle");e=n.getCenter(!0),i=n.getSize(!0).divide(2)}return{center:e,radius:i}}}}}),S=w.extend({_class:"Raster",_applyMatrix:!1,_canApplyMatrix:!1,_boundsOptions:{stroke:!1,handle:!1},_serializeFields:{crossOrigin:null,source:null},initialize:function(t,i){if(!this._initialize(t,i!==e&&c.read(arguments,1))){var r="string"==typeof t?n.getElementById(t):t;r?this.setImage(r):this.setSource(t)}this._size||(this._size=new f,this._loaded=!1)},_equals:function(t){return this.getSource()===t.getSource()},copyContent:function(t){var e=t._image,i=t._canvas;if(e)this._setImage(e);else if(i){var n=Q.getCanvas(t._size);n.getContext("2d").drawImage(i,0,0),this._setImage(n)}this._crossOrigin=t._crossOrigin},getSize:function(){var t=this._size;return new _(t?t.width:0,t?t.height:0,this,"setSize")},setSize:function(){var t=f.read(arguments);if(!t.equals(this._size))if(t.width>0&&t.height>0){var e=this.getElement();this._setImage(Q.getCanvas(t)),e&&this.getContext(!0).drawImage(e,0,0,t.width,t.height)}else this._canvas&&Q.release(this._canvas),this._size=t.clone()},getWidth:function(){return this._size?this._size.width:0},setWidth:function(t){this.setSize(t,this.getHeight())},getHeight:function(){return this._size?this._size.height:0},setHeight:function(t){this.setSize(this.getWidth(),t)},getLoaded:function(){return this._loaded},isEmpty:function(){var t=this._size;return!t||0===t.width&&0===t.height},getResolution:function(){var t=this._matrix,e=new c(0,0).transform(t),i=new c(1,0).transform(t).subtract(e),n=new c(0,1).transform(t).subtract(e);return new f(72/i.getLength(),72/n.getLength())},getPpi:"#getResolution",getImage:function(){return this._image},setImage:function(t){function e(t){var e=i.getView(),n=t&&t.type||"load";e&&i.responds(n)&&(paper=e._scope,i.emit(n,new G(t)))}var i=this;this._setImage(t),this._loaded?setTimeout(e,0):t&&Z.add(t,{load:function(n){i._setImage(t),e(n)},error:e})},_setImage:function(t){this._canvas&&Q.release(this._canvas),t&&t.getContext?(this._image=null,this._canvas=t,this._loaded=!0):(this._image=t,this._canvas=null,this._loaded=!!(t&&t.src&&t.complete)),this._size=new f(t?t.naturalWidth||t.width:0,t?t.naturalHeight||t.height:0),this._context=null,this._changed(521)},getCanvas:function(){if(!this._canvas){var t=Q.getContext(this._size);try{this._image&&t.drawImage(this._image,0,0),this._canvas=t.canvas}catch(e){Q.release(t)}}return this._canvas},setCanvas:"#setImage",getContext:function(t){return this._context||(this._context=this.getCanvas().getContext("2d")),t&&(this._image=null,this._changed(513)),this._context},setContext:function(t){this._context=t},getSource:function(){var t=this._image;return t&&t.src||this.toDataURL()},setSource:function(t){var e=new i.Image,n=this._crossOrigin;n&&(e.crossOrigin=n),e.src=t,this.setImage(e)},getCrossOrigin:function(){var t=this._image;return t&&t.crossOrigin||this._crossOrigin||""},setCrossOrigin:function(t){this._crossOrigin=t;var e=this._image;e&&(e.crossOrigin=t)},getElement:function(){return this._canvas||this._loaded&&this._image}},{beans:!1,getSubCanvas:function(){var t=g.read(arguments),e=Q.getContext(t.getSize());return e.drawImage(this.getCanvas(),t.x,t.y,t.width,t.height,0,0,t.width,t.height),e.canvas},getSubRaster:function(){var t=g.read(arguments),e=new S(w.NO_INSERT);return e._setImage(this.getSubCanvas(t)),e.translate(t.getCenter().subtract(this.getSize().divide(2))),e._matrix.prepend(this._matrix),e.insertAbove(this),e},toDataURL:function(){var t=this._image,e=t&&t.src;if(/^data:/.test(e))return e;var i=this.getCanvas();return i?i.toDataURL.apply(i,arguments):null},drawImage:function(t){var e=c.read(arguments,1);this.getContext(!0).drawImage(t,e.x,e.y)},getAverageColor:function(t){var e,i;if(t?t instanceof A?(i=t,e=t.getBounds()):"object"==typeof t&&("width"in t?e=new g(t):"x"in t&&(e=new g(t.x-.5,t.y-.5,1,1))):e=this.getBounds(),!e)return null;var n=32,s=Math.min(e.width,n),a=Math.min(e.height,n),o=S._sampleContext;o?o.clearRect(0,0,n+1,n+1):o=S._sampleContext=Q.getContext(new f(n)),o.save();var h=(new p).scale(s/e.width,a/e.height).translate(-e.x,-e.y);h.applyToContext(o),i&&i.draw(o,new r({clip:!0,matrices:[h]})),this._matrix.applyToContext(o);var u=this.getElement(),l=this._size;u&&o.drawImage(u,-l.width/2,-l.height/2),o.restore();for(var c=o.getImageData(.5,.5,Math.ceil(s),Math.ceil(a)).data,d=[0,0,0],_=0,v=0,m=c.length;v<m;v+=4){var y=c[v+3];_+=y,y/=255,d[0]+=c[v]*y,d[1]+=c[v+1]*y,d[2]+=c[v+2]*y}for(var v=0;v<3;v++)d[v]/=_;return _?F.read(d):null},getPixel:function(){var t=c.read(arguments),e=this.getContext().getImageData(t.x,t.y,1,1).data;return new F("rgb",[e[0]/255,e[1]/255,e[2]/255],e[3]/255)},setPixel:function(){var t=c.read(arguments),e=F.read(arguments),i=e._convert("rgb"),n=e._alpha,r=this.getContext(!0),s=r.createImageData(1,1),a=s.data;a[0]=255*i[0],a[1]=255*i[1],a[2]=255*i[2],a[3]=null!=n?255*n:255,r.putImageData(s,t.x,t.y)},createImageData:function(){var t=f.read(arguments);return this.getContext().createImageData(t.width,t.height)},getImageData:function(){var t=g.read(arguments);return t.isEmpty()&&(t=new g(this._size)),this.getContext().getImageData(t.x,t.y,t.width,t.height)},setImageData:function(t){var e=c.read(arguments,1);this.getContext(!0).putImageData(t,e.x,e.y)},_getBounds:function(t,e){var i=new g(this._size).setCenter(0,0);return t?t._transformBounds(i):i},_hitTestSelf:function(t){if(this._contains(t)){var e=this;return new M("pixel",e,{offset:t.add(e._size.divide(2)).round(),color:{get:function(){return e.getPixel(this.offset)}}})}},_draw:function(t){var e=this.getElement();e&&(t.globalAlpha=this._opacity,t.drawImage(e,-this._size.width/2,-this._size.height/2))},_canComposite:function(){return!0}}),P=w.extend({_class:"SymbolItem",_applyMatrix:!1,_canApplyMatrix:!1,_boundsOptions:{stroke:!0},_serializeFields:{symbol:null},initialize:function(t,i){this._initialize(t,i!==e&&c.read(arguments,1))||this.setDefinition(t instanceof I?t:new I(t))},_equals:function(t){return this._definition===t._definition},copyContent:function(t){this.setDefinition(t._definition)},getDefinition:function(){return this._definition},setDefinition:function(t){this._definition=t,this._changed(9)},getSymbol:"#getDefinition",setSymbol:"#setDefinition",isEmpty:function(){return this._definition._item.isEmpty()},_getBounds:function(t,e){var i=this._definition._item;return i._getCachedBounds(i._matrix.prepended(t),e)},_hitTestSelf:function(t,e,i,n){var r=this._definition._item._hitTest(t,e,i);return r&&(r.item=this),r},_draw:function(t,e){this._definition._item.draw(t,e)}}),I=r.extend({_class:"SymbolDefinition",initialize:function(t,e){this._id=l.get(),this.project=paper.project,t&&this.setItem(t,e)},_serialize:function(t,e){return e.add(this,function(){return r.serialize([this._class,this._item],t,!1,e)})},_changed:function(t){8&t&&w._clearBoundsCache(this),1&t&&this.project._changed(t)},getItem:function(){return this._item},setItem:function(t,e){t._symbol&&(t=t.clone()),this._item&&(this._item._symbol=null),this._item=t,t.remove(),t.setSelected(!1),e||t.setPosition(new c),t._symbol=this,this._changed(9)},getDefinition:"#getItem",setDefinition:"#setItem",place:function(t){return new P(this,t)},clone:function(){return new I(this._item.clone(!1))},equals:function(t){return t===this||t&&this._item.equals(t._item)||!1}}),M=r.extend({_class:"HitResult",initialize:function(t,e,i){this.type=t,this.item=e,i&&(i.enumerable=!0,this.inject(i))},statics:{getOptions:function(t){var e=t&&r.read(t);return r.set({type:null,tolerance:paper.settings.hitTolerance,fill:!e,stroke:!e,segments:!e,handles:!1,ends:!1,center:!1,bounds:!1,guides:!1,selected:!1},e)}}}),T=r.extend({_class:"Segment",beans:!0,_selection:0,initialize:function(t,i,n,r,s,a){var o,h,u,l,c=arguments.length;0===c||(1===c?t&&"point"in t?(o=t.point,h=t.handleIn,u=t.handleOut,l=t.selection):o=t:null==t||"object"==typeof t?(o=t,h=i,u=n,l=r):(o=t!==e?[t,i]:null,h=n!==e?[n,r]:null,u=s!==e?[s,a]:null)),new k(o,this,"_point"),new k(h,this,"_handleIn"),new k(u,this,"_handleOut"),l&&this.setSelection(l)},_serialize:function(t,e){var i=this._point,n=this._selection,s=n||this.hasHandles()?[i,this._handleIn,this._handleOut]:i;return n&&s.push(n),r.serialize(s,t,!0,e)},_changed:function(t){var e=this._path;if(e){var i,n=e._curves,r=this._index;n&&(t&&t!==this._point&&t!==this._handleIn||!(i=r>0?n[r-1]:e._closed?n[n.length-1]:null)||i._changed(),t&&t!==this._point&&t!==this._handleOut||!(i=n[r])||i._changed()),e._changed(25)}},getPoint:function(){return this._point},setPoint:function(){var t=c.read(arguments);this._point.set(t.x,t.y)},getHandleIn:function(){return this._handleIn},setHandleIn:function(){var t=c.read(arguments);this._handleIn.set(t.x,t.y)},getHandleOut:function(){return this._handleOut},setHandleOut:function(){var t=c.read(arguments);this._handleOut.set(t.x,t.y)},hasHandles:function(){return!this._handleIn.isZero()||!this._handleOut.isZero()},clearHandles:function(){this._handleIn.set(0,0),this._handleOut.set(0,0)},getSelection:function(){return this._selection},setSelection:function(t){var e=this._selection,i=this._path;this._selection=t=t||0,i&&t!==e&&(i._updateSelection(this,e,t),i._changed(129))},changeSelection:function(t,e){var i=this._selection;this.setSelection(e?i|t:i&~t)},isSelected:function(){return!!(7&this._selection)},setSelected:function(t){this.changeSelection(7,t)},getIndex:function(){return this._index!==e?this._index:null},getPath:function(){return this._path||null},getCurve:function(){var t=this._path,e=this._index;return t?(e>0&&!t._closed&&e===t._segments.length-1&&e--,t.getCurves()[e]||null):null},getLocation:function(){var t=this.getCurve();return t?new O(t,this===t._segment1?0:1):null},getNext:function(){var t=this._path&&this._path._segments;return t&&(t[this._index+1]||this._path._closed&&t[0])||null},smooth:function(t,i,n){var r=t||{},s=r.type,a=r.factor,o=this.getPrevious(),h=this.getNext(),u=(o||this)._point,l=this._point,d=(h||this)._point,f=u.getDistance(l),_=l.getDistance(d);if(s&&"catmull-rom"!==s){if("geometric"!==s)throw new Error("Smoothing method '"+s+"' not supported.");if(o&&h){var g=u.subtract(d),v=a===e?.4:a,p=v*f/(f+_);i||this.setHandleIn(g.multiply(p)),n||this.setHandleOut(g.multiply(p-v))}}else{var m=a===e?.5:a,y=Math.pow(f,m),w=y*y,x=Math.pow(_,m),b=x*x;if(!i&&o){var C=2*b+3*x*y+w,S=3*x*(x+y);this.setHandleIn(0!==S?new c((b*u._x+C*l._x-w*d._x)/S-l._x,(b*u._y+C*l._y-w*d._y)/S-l._y):new c)}if(!n&&h){var C=2*w+3*y*x+b,S=3*y*(y+x);this.setHandleOut(0!==S?new c((w*d._x+C*l._x-b*u._x)/S-l._x,(w*d._y+C*l._y-b*u._y)/S-l._y):new c)}}},getPrevious:function(){var t=this._path&&this._path._segments;return t&&(t[this._index-1]||this._path._closed&&t[t.length-1])||null},isFirst:function(){return 0===this._index},isLast:function(){var t=this._path;return t&&this._index===t._segments.length-1||!1},reverse:function(){var t=this._handleIn,e=this._handleOut,i=t._x,n=t._y;t.set(e._x,e._y),e.set(i,n)},reversed:function(){return new T(this._point,this._handleOut,this._handleIn)},remove:function(){return!!this._path&&!!this._path.removeSegment(this._index)},clone:function(){return new T(this._point,this._handleIn,this._handleOut)},equals:function(t){return t===this||t&&this._class===t._class&&this._point.equals(t._point)&&this._handleIn.equals(t._handleIn)&&this._handleOut.equals(t._handleOut)||!1},toString:function(){var t=["point: "+this._point];return this._handleIn.isZero()||t.push("handleIn: "+this._handleIn),this._handleOut.isZero()||t.push("handleOut: "+this._handleOut),"{ "+t.join(", ")+" }"},transform:function(t){this._transformCoordinates(t,new Array(6),!0),this._changed()},interpolate:function(t,e,i){var n=1-i,r=i,s=t._point,a=e._point,o=t._handleIn,h=e._handleIn,u=e._handleOut,l=t._handleOut;this._point.set(n*s._x+r*a._x,n*s._y+r*a._y,!0),this._handleIn.set(n*o._x+r*h._x,n*o._y+r*h._y,!0),this._handleOut.set(n*l._x+r*u._x,n*l._y+r*u._y,!0),this._changed()},_transformCoordinates:function(t,e,i){var n=this._point,r=i&&this._handleIn.isZero()?null:this._handleIn,s=i&&this._handleOut.isZero()?null:this._handleOut,a=n._x,o=n._y,h=2;return e[0]=a,e[1]=o,r&&(e[h++]=r._x+a,e[h++]=r._y+o),s&&(e[h++]=s._x+a,e[h++]=s._y+o),t&&(t._transformCoordinates(e,e,h/2),a=e[0],o=e[1],i?(n._x=a,n._y=o,h=2,r&&(r._x=e[h++]-a,r._y=e[h++]-o),s&&(s._x=e[h++]-a,s._y=e[h++]-o)):(r||(e[h++]=a,e[h++]=o),s||(e[h++]=a,e[h++]=o))),e}}),k=c.extend({initialize:function(t,i,n){var r,s,a;if(t)if((r=t[0])!==e)s=t[1];else{var o=t;(r=o.x)===e&&(o=c.read(arguments),r=o.x),s=o.y,a=o.selected}else r=s=0;this._x=r,this._y=s,this._owner=i,i[n]=this,a&&this.setSelected(!0)},set:function(t,e){return this._x=t,this._y=e,this._owner._changed(this),this},getX:function(){return this._x},setX:function(t){this._x=t,this._owner._changed(this)},getY:function(){return this._y},setY:function(t){this._y=t,this._owner._changed(this)},isZero:function(){return u.isZero(this._x)&&u.isZero(this._y)},isSelected:function(){return!!(this._owner._selection&this._getSelection())},setSelected:function(t){this._owner.changeSelection(this._getSelection(),t)},_getSelection:function(){var t=this._owner;return this===t._point?1:this===t._handleIn?2:this===t._handleOut?4:0}}),z=r.extend({_class:"Curve",initialize:function(t,e,i,n,r,s,a,o){var h,u,l,c,d,f,_=arguments.length;3===_?(this._path=t,h=e,u=i):0===_?(h=new T,u=new T):1===_?"segment1"in t?(h=new T(t.segment1),u=new T(t.segment2)):"point1"in t?(l=t.point1,d=t.handle1,f=t.handle2,c=t.point2):Array.isArray(t)&&(l=[t[0],t[1]],c=[t[6],t[7]],d=[t[2]-t[0],t[3]-t[1]],f=[t[4]-t[6],t[5]-t[7]]):2===_?(h=new T(t),u=new T(e)):4===_?(l=t,d=e,f=i,c=n):8===_&&(l=[t,e],c=[a,o],d=[i-t,n-e],f=[r-a,s-o]),this._segment1=h||new T(l,null,d),this._segment2=u||new T(c,f,null)},_serialize:function(t,e){return r.serialize(this.hasHandles()?[this.getPoint1(),this.getHandle1(),this.getHandle2(),this.getPoint2()]:[this.getPoint1(),this.getPoint2()],t,!0,e)},_changed:function(){this._length=this._bounds=e},clone:function(){return new z(this._segment1,this._segment2)},toString:function(){var t=["point1: "+this._segment1._point];return this._segment1._handleOut.isZero()||t.push("handle1: "+this._segment1._handleOut),this._segment2._handleIn.isZero()||t.push("handle2: "+this._segment2._handleIn),t.push("point2: "+this._segment2._point),"{ "+t.join(", ")+" }"},remove:function(){var t=!1;if(this._path){var e=this._segment2,i=e._handleOut;t=e.remove(),t&&this._segment1._handleOut.set(i.x,i.y)}return t},getPoint1:function(){return this._segment1._point},setPoint1:function(){var t=c.read(arguments);this._segment1._point.set(t.x,t.y)},getPoint2:function(){return this._segment2._point},setPoint2:function(){var t=c.read(arguments);this._segment2._point.set(t.x,t.y)},getHandle1:function(){return this._segment1._handleOut},setHandle1:function(){var t=c.read(arguments);this._segment1._handleOut.set(t.x,t.y)},getHandle2:function(){return this._segment2._handleIn},setHandle2:function(){var t=c.read(arguments);this._segment2._handleIn.set(t.x,t.y)},getSegment1:function(){return this._segment1},getSegment2:function(){return this._segment2},getPath:function(){return this._path},getIndex:function(){return this._segment1._index},getNext:function(){var t=this._path&&this._path._curves;return t&&(t[this._segment1._index+1]||this._path._closed&&t[0])||null},getPrevious:function(){var t=this._path&&this._path._curves;return t&&(t[this._segment1._index-1]||this._path._closed&&t[t.length-1])||null},isFirst:function(){return 0===this._segment1._index},isLast:function(){var t=this._path;return t&&this._segment1._index===t._curves.length-1||!1},isSelected:function(){return this.getPoint1().isSelected()&&this.getHandle2().isSelected()&&this.getHandle2().isSelected()&&this.getPoint2().isSelected()},setSelected:function(t){this.getPoint1().setSelected(t),this.getHandle1().setSelected(t),this.getHandle2().setSelected(t),this.getPoint2().setSelected(t)},getValues:function(t){return z.getValues(this._segment1,this._segment2,t)},getPoints:function(){for(var t=this.getValues(),e=[],i=0;i<8;i+=2)e.push(new c(t[i],t[i+1]));return e},getLength:function(){return null==this._length&&(this._length=z.getLength(this.getValues(),0,1)),this._length},getArea:function(){return z.getArea(this.getValues())},getLine:function(){return new m(this._segment1._point,this._segment2._point)},getPart:function(t,e){return new z(z.getPart(this.getValues(),t,e))},getPartLength:function(t,e){return z.getLength(this.getValues(),t,e)},getIntersections:function(t){return z._getIntersections(this.getValues(),t&&t!==this?t.getValues():null,this,t,[],{})},divideAt:function(t){return this.divideAtTime(t&&t.curve===this?t.time:t)},divideAtTime:function(t,e){var i=4e-7,n=1-i,r=null;if(t>=i&&t<=n){var s=z.subdivide(this.getValues(),t),a=s[0],o=s[1],h=e||this.hasHandles(),u=this._segment1,l=this._segment2,d=this._path;h&&(u._handleOut.set(a[2]-a[0],a[3]-a[1]),l._handleIn.set(o[4]-o[6],o[5]-o[7]));var f=a[6],_=a[7],g=new T(new c(f,_),h&&new c(a[4]-f,a[5]-_),h&&new c(o[2]-f,o[3]-_));d?(d.insert(u._index+1,g),r=this.getNext()):(this._segment2=g,this._changed(),r=new z(g,l))}return r},splitAt:function(t){return this._path?this._path.splitAt(t):null},splitAtTime:function(t){return this.splitAt(this.getLocationAtTime(t))},divide:function(t,i){return this.divideAtTime(t===e?.5:i?t:this.getTimeAt(t))},split:function(t,i){return this.splitAtTime(t===e?.5:i?t:this.getTimeAt(t))},reversed:function(){return new z(this._segment2.reversed(),this._segment1.reversed())},clearHandles:function(){this._segment1._handleOut.set(0,0),this._segment2._handleIn.set(0,0)},statics:{getValues:function(t,e,i){var n=t._point,r=t._handleOut,s=e._handleIn,a=e._point,o=[n._x,n._y,n._x+r._x,n._y+r._y,a._x+s._x,a._y+s._y,a._x,a._y];return i&&i._transformCoordinates(o,o,4),o},subdivide:function(t,i){var n=t[0],r=t[1],s=t[2],a=t[3],o=t[4],h=t[5],u=t[6],l=t[7];i===e&&(i=.5);var c=1-i,d=c*n+i*s,f=c*r+i*a,_=c*s+i*o,g=c*a+i*h,v=c*o+i*u,p=c*h+i*l,m=c*d+i*_,y=c*f+i*g,w=c*_+i*v,x=c*g+i*p,b=c*m+i*w,C=c*y+i*x;return[[n,r,d,f,m,y,b,C],[b,C,w,x,v,p,u,l]]},solveCubic:function(t,e,i,n,r,s){var a=t[e],o=t[e+2],h=t[e+4],l=t[e+6],c=0;if(!(a<i&&l<i&&o<i&&h<i||a>i&&l>i&&o>i&&h>i)){var d=3*(o-a),f=3*(h-o)-d,_=l-a-d-f;c=u.solveCubic(_,f,d,a-i,n,r,s)}return c},getTimeOf:function(t,e){var i=new c(t[0],t[1]),n=new c(t[6],t[7]),r=1e-12,s=e.isClose(i,r)?0:e.isClose(n,r)?1:null;if(null!==s)return s;for(var a=[e.x,e.y],o=[],h=2e-7,u=0;u<2;u++)for(var l=z.solveCubic(t,u,a[u],o,0,1),d=0;d<l;d++)if(s=o[d],e.isClose(z.getPoint(t,s),h))return s;return e.isClose(i,h)?0:e.isClose(n,h)?1:null},getNearestTime:function(t,e){function i(i){if(i>=0&&i<=1){var n=e.getDistance(z.getPoint(t,i),!0);if(n<f)return f=n,_=i,!0}}if(z.isStraight(t)){var n=t[0],r=t[1],s=t[6],a=t[7],o=s-n,h=a-r,u=o*o+h*h;if(0===u)return 0;var l=((e.x-n)*o+(e.y-r)*h)/u;return l<1e-12?0:l>.999999999999?1:z.getTimeOf(t,new c(n+l*o,r+l*h))}for(var d=100,f=1/0,_=0,g=0;g<=d;g++)i(g/d);for(var v=1/(2*d);v>4e-7;)i(_-v)||i(_+v)||(v/=2);return _},getPart:function(t,e,i){var n=e>i;if(n){var r=e;e=i,i=r}return e>0&&(t=z.subdivide(t,e)[1]),i<1&&(t=z.subdivide(t,(i-e)/(1-e))[0]),n?[t[6],t[7],t[4],t[5],t[2],t[3],t[0],t[1]]:t},isFlatEnough:function(t,e){var i=t[0],n=t[1],r=t[2],s=t[3],a=t[4],o=t[5],h=t[6],u=t[7],l=3*r-2*i-h,c=3*s-2*n-u,d=3*a-2*h-i,f=3*o-2*u-n;return Math.max(l*l,d*d)+Math.max(c*c,f*f)<=16*e*e},getArea:function(t){var e=t[0],i=t[1],n=t[2],r=t[3],s=t[4],a=t[5],o=t[6],h=t[7];return 3*((h-i)*(n+s)-(o-e)*(r+a)+r*(e-s)-n*(i-a)+h*(s+e/3)-o*(a+i/3))/20},getBounds:function(t){for(var e=t.slice(0,2),i=e.slice(),n=[0,0],r=0;r<2;r++)z._addBounds(t[r],t[r+2],t[r+4],t[r+6],r,0,e,i,n);return new g(e[0],e[1],i[0]-e[0],i[1]-e[1])},_addBounds:function(t,e,i,n,r,s,a,o,h){function l(t,e){var i=t-e,n=t+e;i<a[r]&&(a[r]=i),n>o[r]&&(o[r]=n)}s/=2;var c=a[r]-s,d=o[r]+s;if(t<c||e<c||i<c||n<c||t>d||e>d||i>d||n>d)if(e<t!=e<n&&i<t!=i<n)l(t,s),l(n,s);else{var f=3*(e-i)-t+n,_=2*(t+i)-4*e,g=e-t,v=u.solveQuadratic(f,_,g,h),p=4e-7,m=1-p;l(n,0);for(var y=0;y<v;y++){var w=h[y],x=1-w;p<w&&w<m&&l(x*x*x*t+3*x*x*w*e+3*x*w*w*i+w*w*w*n,s)}}}}},r.each(["getBounds","getStrokeBounds","getHandleBounds"],function(t){this[t]=function(){this._bounds||(this._bounds={});var e=this._bounds[t];return e||(e=this._bounds[t]=L[t]([this._segment1,this._segment2],!1,this._path)),e.clone()}},{}),r.each({isStraight:function(t,e,i){if(e.isZero()&&i.isZero())return!0;var n=t.getVector(),r=2e-7;if(n.isZero())return!1;if(t.getDistance(e)<r&&t.getDistance(i)<r){var s=n.dot(n),a=n.dot(e)/s,o=n.dot(i)/s;return a>=0&&a<=1&&o<=0&&o>=-1}return!1},isLinear:function(t,e,i){var n=t.getVector().divide(3);return e.equals(n)&&i.negate().equals(n)}},function(t,e){this[e]=function(){var e=this._segment1,i=this._segment2;return t(new m(e._point,i._point),e._handleOut,i._handleIn)},this.statics[e]=function(e){var i=e[0],n=e[1],r=e[6],s=e[7];return t(new m(i,n,r,s),new c(e[2]-i,e[3]-n),new c(e[4]-r,e[5]-s))}},{statics:{},hasHandles:function(){return!this._segment1._handleOut.isZero()||!this._segment2._handleIn.isZero()},isCollinear:function(t){return t&&this.isStraight()&&t.isStraight()&&this.getLine().isCollinear(t.getLine())},isHorizontal:function(){return this.isStraight()&&Math.abs(this.getTangentAtTime(.5).y)<1e-7},isVertical:function(){return this.isStraight()&&Math.abs(this.getTangentAtTime(.5).x)<1e-7}}),{beans:!1,getLocationAt:function(t,e){return this.getLocationAtTime(e?t:this.getTimeAt(t))},getLocationAtTime:function(t){return null!=t&&t>=0&&t<=1?new O(this,t):null},getTimeAt:function(t,e){return z.getTimeAt(this.getValues(),t,e)},getParameterAt:"#getTimeAt",getOffsetAtTime:function(t){return this.getPartLength(0,t)},getLocationOf:function(){return this.getLocationAtTime(this.getTimeOf(c.read(arguments)))},getOffsetOf:function(){var t=this.getLocationOf.apply(this,arguments);return t?t.getOffset():null},getTimeOf:function(){return z.getTimeOf(this.getValues(),c.read(arguments))},getParameterOf:"#getTimeOf",getNearestLocation:function(){var t=c.read(arguments),e=this.getValues(),i=z.getNearestTime(e,t),n=z.getPoint(e,i);return new O(this,i,n,null,t.getDistance(n))},getNearestPoint:function(){var t=this.getNearestLocation.apply(this,arguments);return t?t.getPoint():t}},new function(){var t=["getPoint","getTangent","getNormal","getWeightedTangent","getWeightedNormal","getCurvature"];return r.each(t,function(t){this[t+"At"]=function(e,i){var n=this.getValues();return z[t](n,i?e:z.getTimeAt(n,e))},this[t+"AtTime"]=function(e){return z[t](this.getValues(),e)}},{statics:{_evaluateMethods:t}})},new function(){function t(t){var e=t[0],i=t[1],n=t[2],r=t[3],s=t[4],a=t[5],o=t[6],h=t[7],u=9*(n-s)+3*(o-e),l=6*(e+s)-12*n,c=3*(n-e),d=9*(r-a)+3*(h-i),f=6*(i+a)-12*r,_=3*(r-i);return function(t){var e=(u*t+l)*t+c,i=(d*t+f)*t+_;return Math.sqrt(e*e+i*i)}}function i(t,e){return Math.max(2,Math.min(16,Math.ceil(32*Math.abs(e-t))))}function n(t,e,i,n){if(null==e||e<0||e>1)return null;var r=t[0],s=t[1],a=t[2],o=t[3],h=t[4],l=t[5],d=t[6],f=t[7],_=u.isZero;_(a-r)&&_(o-s)&&(a=r,o=s),_(h-d)&&_(l-f)&&(h=d,l=f);var g,v,p=3*(a-r),m=3*(h-a)-p,y=d-r-p-m,w=3*(o-s),x=3*(l-o)-w,b=f-s-w-x;if(0===i)g=0===e?r:1===e?d:((y*e+m)*e+p)*e+r,v=0===e?s:1===e?f:((b*e+x)*e+w)*e+s;else{var C=4e-7,S=1-C;if(e<C?(g=p,v=w):e>S?(g=3*(d-h),v=3*(f-l)):(g=(3*y*e+2*m)*e+p,v=(3*b*e+2*x)*e+w),n){0===g&&0===v&&(e<C||e>S)&&(g=h-a,v=l-o);var P=Math.sqrt(g*g+v*v);P&&(g/=P,v/=P)}if(3===i){var I=6*y*e+2*m,M=6*b*e+2*x,T=Math.pow(g*g+v*v,1.5);g=0!==T?(g*M-v*I)/T:0,v=0}}return 2===i?new c(v,(-g)):new c(g,v)}return{statics:{getLength:function(n,r,s,a){if(r===e&&(r=0),s===e&&(s=1),z.isStraight(n)){var o=n;s<1&&(o=z.subdivide(o,s)[0],r/=s),r>0&&(o=z.subdivide(o,r)[1]);var h=o[6]-o[0],l=o[7]-o[1];return Math.sqrt(h*h+l*l)}return u.integrate(a||t(n),r,s,i(r,s))},getTimeAt:function(n,r,s){function a(t){return p+=u.integrate(f,s,t,i(s,t)),s=t,p-r}if(s===e&&(s=r<0?1:0),0===r)return s;var o=Math.abs,h=1e-12,l=r>0,c=l?s:0,d=l?1:s,f=t(n),_=z.getLength(n,c,d,f),g=o(r)-_;if(o(g)<h)return l?d:c;if(g>h)return null;var v=r/_,p=0;return u.findRoot(a,f,s+v,c,d,32,1e-12)},getPoint:function(t,e){return n(t,e,0,!1)},getTangent:function(t,e){return n(t,e,1,!0)},getWeightedTangent:function(t,e){return n(t,e,1,!1)},getNormal:function(t,e){return n(t,e,2,!0)},getWeightedNormal:function(t,e){return n(t,e,2,!1)},getCurvature:function(t,e){return n(t,e,3,!1).x}}}},new function(){function t(t,e,i,n,r,s,a,o,h,u,l){var c=!l&&e.excludeStart,d=!l&&e.excludeEnd,f=4e-7,_=1-f;if(null==r&&(r=z.getTimeOf(i,s)),null!==r&&r>=(c?f:0)&&r<=(d?_:1)&&(null==h&&(h=z.getTimeOf(a,u)),null!==h&&h>=(d?f:0)&&h<=(c?_:1))){var g=e.renormalize;if(g){
	var v=g(r,h);r=v[0],h=v[1]}var p=new O(n,r,s||z.getPoint(i,r),l),m=new O(o,h,u||z.getPoint(a,h),l),y=p.getPath()===m.getPath()&&p.getIndex()>m.getIndex(),w=y?m:p,x=e.include;p._intersection=m,m._intersection=p,x&&!x(w)||O.insert(t,w,!0)}}function e(r,s,a,o,h,u,l,c,d,f,_,g,v){if(++g>=48||++v>4096)return v;var p,y,w=s[0],x=s[1],b=s[6],C=s[7],S=m.getSignedDistance,P=S(w,x,b,C,s[2],s[3]),I=S(w,x,b,C,s[4],s[5]),M=P*I>0?.75:4/9,T=M*Math.min(0,P,I),k=M*Math.max(0,P,I),O=S(w,x,b,C,r[0],r[1]),A=S(w,x,b,C,r[2],r[3]),L=S(w,x,b,C,r[4],r[5]),N=S(w,x,b,C,r[6],r[7]),B=i(O,A,L,N),E=B[0],D=B[1];if(0===P&&0===I&&0===O&&0===A&&0===L&&0===N||null==(p=n(E,D,T,k))||null==(y=n(E.reverse(),D.reverse(),T,k)))return v;var j=l+(c-l)*p,F=l+(c-l)*y;if(Math.max(f-d,F-j)<1e-9){var R=(j+F)/2,q=(d+f)/2;r=a.getValues(),s=o.getValues(),t(h,u,_?s:r,_?o:a,_?q:R,null,_?r:s,_?a:o,_?R:q,null)}else if(r=z.getPart(r,p,y),y-p>.8)if(F-j>f-d){var V=z.subdivide(r,.5),R=(j+F)/2;v=e(s,V[0],o,a,h,u,d,f,j,R,!_,g,v),v=e(s,V[1],o,a,h,u,d,f,R,F,!_,g,v)}else{var V=z.subdivide(s,.5),q=(d+f)/2;v=e(V[0],r,o,a,h,u,d,q,j,F,!_,g,v),v=e(V[1],r,o,a,h,u,q,f,j,F,!_,g,v)}else v=e(s,r,o,a,h,u,d,f,j,F,!_,g,v);return v}function i(t,e,i,n){var r,s=[0,t],a=[1/3,e],o=[2/3,i],h=[1,n],u=e-(2*t+n)/3,l=i-(t+2*n)/3;if(u*l<0)r=[[s,a,h],[s,o,h]];else{var c=u/l;r=[c>=2?[s,a,h]:c<=.5?[s,o,h]:[s,a,o,h],[s,h]]}return(u||l)<0?r.reverse():r}function n(t,e,i,n){return t[0][1]<i?r(t,!0,i):e[0][1]>n?r(e,!1,n):t[0][0]}function r(t,e,i){for(var n=t[0][0],r=t[0][1],s=1,a=t.length;s<a;s++){var o=t[s][0],h=t[s][1];if(e?h>=i:h<=i)return h===i?o:n+(i-r)*(o-n)/(h-r);n=o,r=h}return null}function s(e,i,n,r,s,a){for(var o=z.isStraight(e),h=o?i:e,l=o?e:i,c=l[0],d=l[1],f=l[6],_=l[7],g=f-c,v=_-d,p=Math.atan2(-v,g),m=Math.sin(p),y=Math.cos(p),w=[],x=0;x<8;x+=2){var b=h[x]-c,C=h[x+1]-d;w.push(b*y-C*m,b*m+C*y)}for(var S=[],P=z.solveCubic(w,1,0,S,0,1),x=0;x<P;x++){var I=S[x],M=z.getPoint(h,I),T=z.getTimeOf(l,M);if(null!==T){var k=z.getPoint(l,T),O=o?T:I,A=o?I:T;(!a.excludeEnd||A>u.CURVETIME_EPSILON)&&t(s,a,e,n,O,o?k:M,i,r,A,o?M:k)}}}function a(e,i,n,r,s,a){var o=m.intersect(e[0],e[1],e[6],e[7],i[0],i[1],i[6],i[7]);o&&t(s,a,e,n,null,o,i,r,null,o)}return{statics:{_getIntersections:function(i,n,r,o,h,u){if(!n)return z._getSelfIntersection(i,r,h,u);var l=2e-7,d=i[0],f=i[1],_=i[6],g=i[7],v=n[0],p=n[1],m=n[6],y=n[7],w=(3*i[2]+d)/4,x=(3*i[3]+f)/4,b=(3*i[4]+_)/4,C=(3*i[5]+g)/4,S=(3*n[2]+v)/4,P=(3*n[3]+p)/4,I=(3*n[4]+m)/4,M=(3*n[5]+y)/4,T=Math.min,k=Math.max;if(!(k(d,w,b,_)+l>T(v,S,I,m)&&T(d,w,b,_)-l<k(v,S,I,m)&&k(f,x,C,g)+l>T(p,P,M,y)&&T(f,x,C,g)-l<k(p,P,M,y)))return h;var O=z.getOverlaps(i,n);if(O){for(var A=0;A<2;A++){var L=O[A];t(h,u,i,r,L[0],null,n,o,L[1],null,!0)}return h}var N=z.isStraight(i),B=z.isStraight(n),E=N&&B,D=h.length;if((E?a:N||B?s:e)(i,n,r,o,h,u,0,1,0,1,0,0,0),E&&h.length>D)return h;var j=new c(d,f),F=new c(_,g),R=new c(v,p),q=new c(m,y);return j.isClose(R,l)&&t(h,u,i,r,0,j,n,o,0,R),!u.excludeStart&&j.isClose(q,l)&&t(h,u,i,r,0,j,n,o,1,q),!u.excludeEnd&&F.isClose(R,l)&&t(h,u,i,r,1,F,n,o,0,R),F.isClose(q,l)&&t(h,u,i,r,1,F,n,o,1,q),h},_getSelfIntersection:function(t,e,i,n){var r=t[0],s=t[1],a=t[2],o=t[3],h=t[4],l=t[5],d=t[6],f=t[7],_=new m(r,s,d,f,(!1)),g=_.getSide(new c(a,o),!0),v=_.getSide(new c(h,l),!0);if(g===v){var p=(r-h)*(o-f)+(a-d)*(l-s);if(p*g>0)return i}var y=d-3*h+3*a-r,w=h-2*a+r,x=a-r,b=f-3*l+3*o-s,C=l-2*o+s,S=o-s,P=b*x-y*S,I=b*w-y*C,M=C*x-w*S;if(P*P-4*I*M<0){var T,k=[],O=u.solveCubic(y*y+b*b,3*(y*w+b*C),2*(w*w+C*C)+y*x+b*S,w*x+C*S,k,0,1);if(O>0){for(var A=0,L=0;A<O;A++){var N=Math.abs(e.getCurvatureAtTime(k[A]));N>L&&(L=N,T=k[A])}var B=z.subdivide(t,T);n.excludeEnd=!0,n.renormalize=function(t,e){return[t*T,e*(1-T)+T]},z._getIntersections(B[0],B[1],e,e,i,n)}}return i},getOverlaps:function(t,e){function i(t){var e=t[6]-t[0],i=t[7]-t[1];return e*e+i*i}var n=Math.abs,r=4e-7,s=2e-7,a=z.isStraight(t),o=z.isStraight(e),h=a&&o,u=i(t)<i(e),l=u?e:t,d=u?t:e,f=new m(l[0],l[1],l[6],l[7]);if(f.getDistance(new c(d[0],d[1]))<s&&f.getDistance(new c(d[6],d[7]))<s)!h&&f.getDistance(new c(l[2],l[3]))<s&&f.getDistance(new c(l[4],l[5]))<s&&f.getDistance(new c(d[2],d[3]))<s&&f.getDistance(new c(d[4],d[5]))<s&&(a=o=h=!0);else if(h)return null;if(a^o)return null;for(var _=[t,e],g=[],v=0,p=0;v<2&&g.length<2;v+=0===p?0:1,p=1^p){var y=z.getTimeOf(_[1^v],new c(_[v][0===p?0:6],_[v][0===p?1:7]));if(null!=y){var w=0===v?[p,y]:[y,p];(0===g.length||n(w[0]-g[0][0])>r&&n(w[1]-g[0][1])>r)&&g.push(w)}if(1===v&&0===g.length)break}if(2!==g.length)g=null;else if(!h){var x=z.getPart(t,g[0][0],g[1][0]),b=z.getPart(e,g[0][1],g[1][1]);(n(b[2]-x[2])>s||n(b[3]-x[3])>s||n(b[4]-x[4])>s||n(b[5]-x[5])>s)&&(g=null)}return g}}}}),O=r.extend({_class:"CurveLocation",beans:!0,initialize:function(t,e,i,n,r){if(e>.9999996){var s=t.getNext();s&&(e=0,t=s)}this._setCurve(t),this._time=e,this._point=i||t.getPointAtTime(e),this._overlap=n,this._distance=r,this._intersection=this._next=this._previous=null},_setCurve:function(t){var e=t._path;this._path=e,this._version=e?e._version:0,this._curve=t,this._segment=null,this._segment1=t._segment1,this._segment2=t._segment2},_setSegment:function(t){this._setCurve(t.getCurve()),this._segment=t,this._time=t===this._segment1?0:1,this._point=t._point.clone()},getSegment:function(){var t=this.getCurve(),e=this._segment;if(!e){var i=this.getTime();0===i?e=t._segment1:1===i?e=t._segment2:null!=i&&(e=t.getPartLength(0,i)<t.getPartLength(i,1)?t._segment1:t._segment2),this._segment=e}return e},getCurve:function(){function t(t){var e=t&&t.getCurve();if(e&&null!=(i._time=e.getTimeOf(i._point)))return i._setCurve(e),i._segment=t,e}var e=this._path,i=this;return e&&e._version!==this._version&&(this._time=this._curve=this._offset=null),this._curve||t(this._segment)||t(this._segment1)||t(this._segment2.getPrevious())},getPath:function(){var t=this.getCurve();return t&&t._path},getIndex:function(){var t=this.getCurve();return t&&t.getIndex()},getTime:function(){var t=this.getCurve(),e=this._time;return t&&null==e?this._time=t.getTimeOf(this._point):e},getParameter:"#getTime",getPoint:function(){return this._point},getOffset:function(){var t=this._offset;if(null==t){t=0;var e=this.getPath(),i=this.getIndex();if(e&&null!=i)for(var n=e.getCurves(),r=0;r<i;r++)t+=n[r].getLength();this._offset=t+=this.getCurveOffset()}return t},getCurveOffset:function(){var t=this.getCurve(),e=this.getTime();return null!=e&&t&&t.getPartLength(0,e)},getIntersection:function(){return this._intersection},getDistance:function(){return this._distance},divide:function(){var t=this.getCurve(),e=null;return t&&(e=t.divideAtTime(this.getTime()),e&&this._setSegment(e._segment1)),e},split:function(){var t=this.getCurve();return t?t.splitAtTime(this.getTime()):null},equals:function(t,e){var i=this===t,n=2e-7;if(!i&&t instanceof O&&this.getPath()===t.getPath()&&this.getPoint().isClose(t.getPoint(),n)){var r=this.getCurve(),s=t.getCurve(),a=Math.abs,o=a((r.isLast()&&s.isFirst()?-1:r.getIndex())+this.getTime()-((s.isLast()&&r.isFirst()?-1:s.getIndex())+t.getTime()));i=(o<4e-7||(o=a(this.getOffset()-t.getOffset()))<n||a(this.getPath().getLength()-o)<n)&&(e||!this._intersection&&!t._intersection||this._intersection&&this._intersection.equals(t._intersection,!0))}return i},toString:function(){var t=[],e=this.getPoint(),i=h.instance;e&&t.push("point: "+e);var n=this.getIndex();null!=n&&t.push("index: "+n);var r=this.getTime();return null!=r&&t.push("time: "+i.number(r)),null!=this._distance&&t.push("distance: "+i.number(this._distance)),"{ "+t.join(", ")+" }"},isTouching:function(){var t=this._intersection;if(t&&this.getTangent().isCollinear(t.getTangent())){var e=this.getCurve(),i=t.getCurve();return!(e.isStraight()&&i.isStraight()&&e.getLine().intersect(i.getLine()))}return!1},isCrossing:function(){function t(t,e,i){return e<i?t>e&&t<i:t>e||t<i}var e=this._intersection;if(!e)return!1;var i=this.getTime(),n=e.getTime(),r=4e-7,s=1-r,a=i>r&&i<s,o=n>r&&n<s;if(a&&o)return!this.isTouching();var h=this.getCurve(),u=i<=r?h.getPrevious():h,l=e.getCurve(),c=n<=r?l.getPrevious():l;if(i>=s&&(h=h.getNext()),n>=s&&(l=l.getNext()),!(u&&h&&c&&l))return!1;var d=[];a||d.push(u.getLength(),h.getLength()),o||d.push(c.getLength(),l.getLength());var f=this.getPoint(),_=Math.min.apply(Math,d)/64,g=a?h.getTangentAtTime(i):h.getPointAt(_).subtract(f),v=a?g.negate():u.getPointAt(-_).subtract(f),p=o?l.getTangentAtTime(n):l.getPointAt(_).subtract(f),m=o?p.negate():c.getPointAt(-_).subtract(f),y=v.getAngle(),w=g.getAngle(),x=m.getAngle(),b=p.getAngle();return!!(a?t(y,x,b)^t(w,x,b)&&t(y,b,x)^t(w,b,x):t(x,y,w)^t(b,y,w)&&t(x,w,y)^t(b,w,y))},hasOverlap:function(){return!!this._overlap}},r.each(z._evaluateMethods,function(t){var e=t+"At";this[t]=function(){var t=this.getCurve(),i=this.getTime();return null!=i&&t&&t[e](i,!0)}},{preserve:!0}),new function(){function t(t,e,i){function n(i,n){for(var s=i+n;s>=-1&&s<=r;s+=n){var a=t[(s%r+r)%r];if(!e.getPoint().isClose(a.getPoint(),2e-7))break;if(e.equals(a))return a}return null}for(var r=t.length,s=0,a=r-1;s<=a;){var o,h=s+a>>>1,u=t[h];if(i&&(o=e.equals(u)?u:n(h,-1)||n(h,1)))return e._overlap&&(o._overlap=o._intersection._overlap=!0),o;var l=e.getPath(),c=u.getPath(),d=l===c?e.getIndex()+e.getTime()-(u.getIndex()+u.getTime()):l._id-c._id;d<0?a=h-1:s=h+1}return t.splice(s,0,e),e}return{statics:{insert:t,expand:function(e){for(var i=e.slice(),n=e.length-1;n>=0;n--)t(i,e[n]._intersection,!1);return i}}}}),A=w.extend({_class:"PathItem",_selectBounds:!1,_canScaleStroke:!0,initialize:function(){},statics:{create:function(t){var e=(t&&t.match(/m/gi)||[]).length>1||/z\s*\S+/i.test(t)?N:L;return new e(t)}},_asPathItem:function(){return this},setPathData:function(t){function e(t,e){var i=+n[t];return o&&(i+=h[e]),i}function i(t){return new c(e(t,"x"),e(t+1,"y"))}var n,r,s,a=t&&t.match(/[mlhvcsqtaz][^mlhvcsqtaz]*/gi),o=!1,h=new c,u=new c;this.clear();for(var l=0,d=a&&a.length;l<d;l++){var _=a[l],g=_[0],v=g.toLowerCase();n=_.match(/[+-]?(?:\d*\.\d+|\d+\.?)(?:[eE][+-]?\d+)?/g);var p=n&&n.length;switch(o=g===v,"z"!==r||/[mz]/.test(v)||this.moveTo(h=u),v){case"m":case"l":for(var m="m"===v,y=0;y<p;y+=2)this[0===y&&m?"moveTo":"lineTo"](h=i(y));s=h,m&&(u=h);break;case"h":case"v":for(var w="h"===v?"x":"y",y=0;y<p;y++)h[w]=e(y,w),this.lineTo(h);s=h;break;case"c":for(var y=0;y<p;y+=6)this.cubicCurveTo(i(y),s=i(y+2),h=i(y+4));break;case"s":for(var y=0;y<p;y+=4)this.cubicCurveTo(/[cs]/.test(r)?h.multiply(2).subtract(s):h,s=i(y),h=i(y+2)),r=v;break;case"q":for(var y=0;y<p;y+=4)this.quadraticCurveTo(s=i(y),h=i(y+2));break;case"t":for(var y=0;y<p;y+=2)this.quadraticCurveTo(s=/[qt]/.test(r)?h.multiply(2).subtract(s):h,h=i(y)),r=v;break;case"a":for(var y=0;y<p;y+=7)this.arcTo(h=i(y+5),new f((+n[y]),(+n[y+1])),+n[y+2],+n[y+4],+n[y+3]);break;case"z":this.closePath(1e-12)}r=v}},_canComposite:function(){return!(this.hasFill()&&this.hasStroke())},_contains:function(t){var e=t.isInside(this.getBounds({internal:!0,handle:!0}))&&this._getWinding(t);return!!("evenodd"===this.getFillRule()?1&e:e)},getIntersections:function(t,e,i,n){var r=this===t||!t,s=this._matrix._orNullIfIdentity(),a=r?s:(i||t._matrix)._orNullIfIdentity();if(!r&&!this.getBounds(s).touches(t.getBounds(a)))return[];for(var o,t,h=this.getCurves(),u=r?h:t.getCurves(),l=h.length,c=r?l:u.length,d=[],f=[],_=0;_<c;_++)d[_]=u[_].getValues(a);for(var _=0;_<l;_++){var g=h[_],v=r?d[_]:g.getValues(s),p=g.getPath();p!==t&&(t=p,o=[],f.push(o)),r&&z._getSelfIntersection(v,g,o,{include:e,excludeStart:1===l&&g.getPoint1().equals(g.getPoint2())});for(var m=r?_+1:0;m<c;m++){if(n&&o.length)return o;var y=u[m];z._getIntersections(v,d[m],g,y,o,{include:e,excludeStart:r&&g.getPrevious()===y,excludeEnd:r&&g.getNext()===y})}}o=[];for(var _=0,w=f.length;_<w;_++)o.push.apply(o,f[_]);return o},getCrossings:function(t){return this.getIntersections(t,function(t){return t._overlap||t.isCrossing()})},getNearestLocation:function(){for(var t=c.read(arguments),e=this.getCurves(),i=1/0,n=null,r=0,s=e.length;r<s;r++){var a=e[r].getNearestLocation(t);a._distance<i&&(i=a._distance,n=a)}return n},getNearestPoint:function(){var t=this.getNearestLocation.apply(this,arguments);return t?t.getPoint():t},interpolate:function(t,e,i){var n=!this._children,r=n?"_segments":"_children",s=t[r],a=e[r],o=this[r];if(!s||!a||s.length!==a.length)throw new Error("Invalid operands in interpolate() call: "+t+", "+e);var h=o.length,u=a.length;if(h<u)for(var l=n?T:L,c=h;c<u;c++)this.add(new l);else h>u&&this[n?"removeSegments":"removeChildren"](u,h);for(var c=0;c<u;c++)o[c].interpolate(s[c],a[c],i);n&&(this.setClosed(t._closed),this._changed(9))}}),L=A.extend({_class:"Path",_serializeFields:{segments:[],closed:!1},initialize:function(t){this._closed=!1,this._segments=[],this._version=0;var i=Array.isArray(t)?"object"==typeof t[0]?t:arguments:!t||t.size!==e||t.x===e&&t.point===e?null:arguments;i&&i.length>0?this.setSegments(i):(this._curves=e,this._segmentSelection=0,i||"string"!=typeof t||(this.setPathData(t),t=null)),this._initialize(!i&&t)},_equals:function(t){return this._closed===t._closed&&r.equals(this._segments,t._segments)},copyContent:function(t){this.setSegments(t._segments),this._closed=t._closed;var i=t._clockwise;i!==e&&(this._clockwise=i)},_changed:function gt(t){if(gt.base.call(this,t),8&t){if(this._length=this._area=this._clockwise=this._monoCurves=e,16&t)this._version++;else if(this._curves)for(var i=0,n=this._curves.length;i<n;i++)this._curves[i]._changed()}else 32&t&&(this._bounds=e)},getStyle:function(){var t=this._parent;return(t instanceof N?t:this)._style},getSegments:function(){return this._segments},setSegments:function(t){var i=this.isFullySelected();this._segments.length=0,this._segmentSelection=0,this._curves=e,t&&t.length>0&&this._add(T.readAll(t)),i&&this.setFullySelected(!0)},getFirstSegment:function(){return this._segments[0]},getLastSegment:function(){return this._segments[this._segments.length-1]},getCurves:function(){var t=this._curves,e=this._segments;if(!t){var i=this._countCurves();t=this._curves=new Array(i);for(var n=0;n<i;n++)t[n]=new z(this,e[n],e[n+1]||e[0])}return t},getFirstCurve:function(){return this.getCurves()[0]},getLastCurve:function(){var t=this.getCurves();return t[t.length-1]},isClosed:function(){return this._closed},setClosed:function(t){if(this._closed!=(t=!!t)){if(this._closed=t,this._curves){var e=this._curves.length=this._countCurves();t&&(this._curves[e-1]=new z(this,this._segments[e-1],this._segments[0]))}this._changed(25)}}},{beans:!0,getPathData:function(t,e){function i(e,i){e._transformCoordinates(t,g),n=g[0],r=g[1],v?(p.push("M"+_.pair(n,r)),v=!1):(o=g[2],u=g[3],o===n&&u===r&&l===s&&c===a?i||p.push("l"+_.pair(n-s,r-a)):p.push("c"+_.pair(l-s,c-a)+" "+_.pair(o-s,u-a)+" "+_.pair(n-s,r-a))),s=n,a=r,l=g[4],c=g[5]}var n,r,s,a,o,u,l,c,d=this._segments,f=d.length,_=new h(e),g=new Array(6),v=!0,p=[];if(0===f)return"";for(var m=0;m<f;m++)i(d[m]);return this._closed&&f>0&&(i(d[0],!0),p.push("z")),p.join("")},isEmpty:function(){return 0===this._segments.length},_transformContent:function(t){for(var e=this._segments,i=new Array(6),n=0,r=e.length;n<r;n++)e[n]._transformCoordinates(t,i,!0);return!0},_add:function(t,e){for(var i=this._segments,n=this._curves,r=t.length,s=null==e,e=s?i.length:e,a=0;a<r;a++){var o=t[a];o._path&&(o=t[a]=o.clone()),o._path=this,o._index=e+a,o._selection&&this._updateSelection(o,0,o._selection)}if(s)i.push.apply(i,t);else{i.splice.apply(i,[e,0].concat(t));for(var a=e+r,h=i.length;a<h;a++)i[a]._index=a}if(n){var u=this._countCurves(),l=e>0&&e+r-1===u?e-1:e,c=l,d=Math.min(l+r,u);t._curves&&(n.splice.apply(n,[l,0].concat(t._curves)),c+=t._curves.length);for(var a=c;a<d;a++)n.splice(a,0,new z(this,null,null));this._adjustCurves(l,d)}return this._changed(25),t},_adjustCurves:function(t,e){for(var i,n=this._segments,r=this._curves,s=t;s<e;s++)i=r[s],i._path=this,i._segment1=n[s],i._segment2=n[s+1]||n[0],i._changed();(i=r[this._closed&&0===t?n.length-1:t-1])&&(i._segment2=n[t]||n[0],i._changed()),(i=r[e])&&(i._segment1=n[e],i._changed())},_countCurves:function(){var t=this._segments.length;return!this._closed&&t>0?t-1:t},add:function(t){return arguments.length>1&&"number"!=typeof t?this._add(T.readAll(arguments)):this._add([T.read(arguments)])[0]},insert:function(t,e){return arguments.length>2&&"number"!=typeof e?this._add(T.readAll(arguments,1),t):this._add([T.read(arguments,1)],t)[0]},addSegment:function(){return this._add([T.read(arguments)])[0]},insertSegment:function(t){return this._add([T.read(arguments,1)],t)[0]},addSegments:function(t){return this._add(T.readAll(t))},insertSegments:function(t,e){return this._add(T.readAll(e),t)},removeSegment:function(t){return this.removeSegments(t,t+1)[0]||null},removeSegments:function(t,e,i){t=t||0,e=r.pick(e,this._segments.length);var n=this._segments,s=this._curves,a=n.length,o=n.splice(t,e-t),h=o.length;if(!h)return o;for(var u=0;u<h;u++){var l=o[u];l._selection&&this._updateSelection(l,l._selection,0),l._index=l._path=null}for(var u=t,c=n.length;u<c;u++)n[u]._index=u;if(s){for(var d=t>0&&e===a+(this._closed?1:0)?t-1:t,s=s.splice(d,h),u=s.length-1;u>=0;u--)s[u]._path=null;i&&(o._curves=s.slice(1)),this._adjustCurves(d,d)}return this._changed(25),o},clear:"#removeSegments",hasHandles:function(){for(var t=this._segments,e=0,i=t.length;e<i;e++)if(t[e].hasHandles())return!0;return!1},clearHandles:function(){for(var t=this._segments,e=0,i=t.length;e<i;e++)t[e].clearHandles()},getLength:function(){if(null==this._length){for(var t=this.getCurves(),e=0,i=0,n=t.length;i<n;i++)e+=t[i].getLength();this._length=e}return this._length},getArea:function(t){var i=t===e,n=this._area;if(!i||null==n){var r=this._segments,s=r.length,a=i?this._closed:t,o=s-1;n=0;for(var h=0,u=a?s:o;h<u;h++)n+=z.getArea(z.getValues(r[h],r[h<o?h+1:0]));i&&(this._area=n)}return n},isClockwise:function(){return this._clockwise!==e?this._clockwise:this.getArea()>=0},setClockwise:function(t){this.isClockwise()!=(t=!!t)&&this.reverse(),this._clockwise=t},isFullySelected:function(){var t=this._segments.length;return this.isSelected()&&t>0&&this._segmentSelection===7*t},setFullySelected:function(t){t&&this._selectSegments(!0),this.setSelected(t)},setSelection:function vt(t){1&t||this._selectSegments(!1),vt.base.call(this,t)},_selectSegments:function(t){var e=this._segments,i=e.length,n=t?7:0;this._segmentSelection=n*i;for(var r=0;r<i;r++)e[r]._selection=n},_updateSelection:function(t,e,i){t._selection=i;var n=this._segmentSelection+=i-e;n>0&&this.setSelected(!0)},splitAt:function(t){var e="number"==typeof t?this.getLocationAt(t):t,i=e&&e.index,n=e&&e.time,r=4e-7,s=1-r;n>=s&&(i++,n=0);var a=this.getCurves();if(i>=0&&i<a.length){n>=r&&a[i++].divideAtTime(n);var o,h=this.removeSegments(i,this._segments.length,!0);return this._closed?(this.setClosed(!1),o=this):(o=new L(w.NO_INSERT),o.insertAbove(this,!0),o.copyAttributes(this)),o._add(h,0),this.addSegment(h[0]),o}return null},split:function(t,i){var n,r=i===e?t:(n=this.getCurves()[t])&&n.getLocationAtTime(i);return null!=r?this.splitAt(r):null},join:function(t,e){var i=e||0;if(t&&t!==this){var n=t._segments,r=this.getLastSegment(),s=t.getLastSegment();if(!s)return this;r&&r._point.isClose(s._point,i)&&t.reverse();var a=t.getFirstSegment();if(r&&r._point.isClose(a._point,i))r.setHandleOut(a._handleOut),this._add(n.slice(1));else{var o=this.getFirstSegment();o&&o._point.isClose(a._point,i)&&t.reverse(),s=t.getLastSegment(),o&&o._point.isClose(s._point,i)?(o.setHandleIn(s._handleIn),this._add(n.slice(0,n.length-1),0)):this._add(n.slice())}t._closed&&this._add([n[0]]),t.remove()}var h=this.getFirstSegment(),u=this.getLastSegment();return h!==u&&h._point.isClose(u._point,i)&&(h.setHandleIn(u._handleIn),u.remove(),this.setClosed(!0)),this},reduce:function(t){for(var e=this.getCurves(),i=t&&t.simplify,n=i?2e-7:0,r=e.length-1;r>=0;r--){var s=e[r];!s.hasHandles()&&(s.getLength()<n||i&&s.isCollinear(s.getNext()))&&s.remove()}return this},reverse:function(){this._segments.reverse();for(var t=0,i=this._segments.length;t<i;t++){var n=this._segments[t],r=n._handleIn;n._handleIn=n._handleOut,n._handleOut=r,n._index=t}this._curves=null,this._clockwise!==e&&(this._clockwise=!this._clockwise),this._changed(9)},flatten:function(t){for(var e=new B(this,t||.25,256,(!0)),i=e.parts,n=i.length,r=[],s=0;s<n;s++)r.push(new T(i[s].curve.slice(0,2)));!this._closed&&n>0&&r.push(new T(i[n-1].curve.slice(6))),this.setSegments(r)},simplify:function(t){var e=new E(this).fit(t||2.5);return e&&this.setSegments(e),!!e},smooth:function(t){function i(t,e){var i=t&&t.index;if(null!=i){var r=t.path;if(r&&r!==n)throw new Error(t._class+" "+i+" of "+r+" is not part of "+n);e&&t instanceof z&&i++}else i="number"==typeof t?t:e;return Math.min(i<0&&h?i%o:i<0?i+o:i,o-1)}var n=this,r=t||{},s=r.type||"asymmetric",a=this._segments,o=a.length,h=this._closed,u=h&&r.from===e&&r.to===e,l=i(r.from,0),c=i(r.to,o-1);if(l>c)if(h)l-=o;else{var d=l;l=c,c=d}if(/^(?:asymmetric|continuous)$/.test(s)){var f="asymmetric"===s,_=Math.min,g=c-l+1,v=g-1,p=u?_(g,4):1,m=p,y=p,w=[];if(h||(m=_(1,l),y=_(1,o-c-1)),v+=m+y,v<=1)return;for(var x=0,b=l-m;x<=v;x++,b++)w[x]=a[(b<0?b+o:b)%o]._point;for(var C=w[0]._x+2*w[1]._x,S=w[0]._y+2*w[1]._y,P=2,I=v-1,M=[C],T=[S],k=[P],O=[],A=[],x=1;x<v;x++){var L=x<I,N=L?1:f?1:2,B=L?4:f?2:7,E=L?4:f?3:8,D=L?2:f?0:1,j=N/P;P=k[x]=B-j,C=M[x]=E*w[x]._x+D*w[x+1]._x-j*C,S=T[x]=E*w[x]._y+D*w[x+1]._y-j*S}O[I]=M[I]/k[I],A[I]=T[I]/k[I];for(var x=v-2;x>=0;x--)O[x]=(M[x]-O[x+1])/k[x],A[x]=(T[x]-A[x+1])/k[x];O[v]=(3*w[v]._x-O[I])/2,A[v]=(3*w[v]._y-A[I])/2;for(var x=m,F=v-y,b=l;x<=F;x++,b++){var R=a[b<0?b+o:b],q=R._point,V=O[x]-q._x,H=A[x]-q._y;(u||x<F)&&R.setHandleOut(V,H),(u||x>m)&&R.setHandleIn(-V,-H)}}else for(var x=l;x<=c;x++)a[x<0?x+o:x].smooth(r,!u&&x===l,!u&&x===c)},toShape:function(t){function i(t,e){var i=c[t],n=i.getNext(),r=c[e],s=r.getNext();return i._handleOut.isZero()&&n._handleIn.isZero()&&r._handleOut.isZero()&&s._handleIn.isZero()&&n._point.subtract(i._point).isCollinear(s._point.subtract(r._point))}function n(t){var e=c[t],i=e.getPrevious(),n=e.getNext();return i._handleOut.isZero()&&e._handleIn.isZero()&&e._handleOut.isZero()&&n._handleIn.isZero()&&e._point.subtract(i._point).isOrthogonal(n._point.subtract(e._point))}function r(t){var e=c[t],i=e.getNext(),n=e._handleOut,r=i._handleIn,s=.5522847498307936;if(n.isOrthogonal(r)){var a=e._point,o=i._point,h=new m(a,n,(!0)).intersect(new m(o,r,(!0)),!0);return h&&u.isZero(n.getLength()/h.subtract(a).getLength()-s)&&u.isZero(r.getLength()/h.subtract(o).getLength()-s)}return!1}function s(t,e){return c[t]._point.getDistance(c[e]._point)}if(!this._closed)return null;var a,o,h,l,c=this._segments;if(!this.hasHandles()&&4===c.length&&i(0,2)&&i(1,3)&&n(1)?(a=C.Rectangle,o=new f(s(0,3),s(0,1)),l=c[1]._point.add(c[2]._point).divide(2)):8===c.length&&r(0)&&r(2)&&r(4)&&r(6)&&i(1,5)&&i(3,7)?(a=C.Rectangle,o=new f(s(1,6),s(0,3)),h=o.subtract(new f(s(0,7),s(1,2))).divide(2),l=c[3]._point.add(c[4]._point).divide(2)):4===c.length&&r(0)&&r(1)&&r(2)&&r(3)&&(u.isZero(s(0,2)-s(1,3))?(a=C.Circle,h=s(0,2)/2):(a=C.Ellipse,h=new f(s(2,0)/2,s(3,1)/2)),l=c[1]._point),a){var d=this.getPosition(!0),_=new a({center:d,size:o,radius:h,insert:!1});return _.copyAttributes(this,!0),_._matrix.prepend(this._matrix),_.rotate(l.subtract(d).getAngle()+90),(t===e||t)&&_.insertAbove(this),_}return null},toPath:"#clone",_hitTestSelf:function(t,e,i,n){function r(e,i){return t.subtract(e).divide(i).length<=1}function s(t,i,n){if(!e.selected||i.isSelected()){var s=t._point;if(i!==s&&(i=i.add(s)),r(i,x))return new M(n,g,{segment:t,point:i})}}function a(t,i){return(i||e.segments)&&s(t,t._point,"segment")||!i&&e.handles&&(s(t,t._handleIn,"handle-in")||s(t,t._handleOut,"handle-out"))}function o(t){d.add(t)}function h(e){if(("round"!==u||"round"!==l)&&(d=new L({internal:!0,closed:!0}),y||e._index>0&&e._index<m-1?"round"!==u&&(e._handleIn.isZero()||e._handleOut.isZero())&&L._addBevelJoin(e,u,P,c,null,n,o,!0):"round"!==l&&L._addSquareCap(e,l,P,null,n,o,!0),!d.isEmpty())){var i;return d.contains(t)||(i=d.getNearestLocation(t))&&r(i.getPoint(),w)}return r(e._point,x)}var u,l,c,d,f,_,g=this,v=this.getStyle(),p=this._segments,m=p.length,y=this._closed,w=e._tolerancePadding,x=w,b=e.stroke&&v.hasStroke(),C=e.fill&&v.hasFill(),S=e.curves,P=b?v.getStrokeWidth()/2:C&&e.tolerance>0||S?0:null;if(null!==P&&(P>0?(u=v.getStrokeJoin(),l=v.getStrokeCap(),c=P*v.getMiterLimit(),x=x.add(L._getStrokePadding(P,n))):u=l="round"),!e.ends||e.segments||y){if(e.segments||e.handles)for(var I=0;I<m;I++)if(_=a(p[I]))return _}else if(_=a(p[0],!0)||a(p[m-1],!0))return _;if(null!==P){if(f=this.getNearestLocation(t)){var T=f.getTime();0===T||1===T&&m>1?h(f.getSegment())||(f=null):r(f.getPoint(),x)||(f=null)}if(!f&&"miter"===u&&m>1)for(var I=0;I<m;I++){var k=p[I];if(t.getDistance(k._point)<=c&&h(k)){f=k.getLocation();break}}}return!f&&C&&this._contains(t)||f&&!b&&!S?new M("fill",this):f?new M(b?"stroke":"curve",this,{location:f,point:f.getPoint()}):null}},r.each(z._evaluateMethods,function(t){this[t+"At"]=function(e){var i=this.getLocationAt(e);return i&&i[t]()}},{beans:!1,getLocationOf:function(){for(var t=c.read(arguments),e=this.getCurves(),i=0,n=e.length;i<n;i++){var r=e[i].getLocationOf(t);if(r)return r}return null},getOffsetOf:function(){var t=this.getLocationOf.apply(this,arguments);return t?t.getOffset():null},getLocationAt:function(t){for(var e=this.getCurves(),i=0,n=0,r=e.length;n<r;n++){var s=i,a=e[n];if(i+=a.getLength(),i>t)return a.getLocationAt(t-s)}return e.length>0&&t<=this.getLength()?new O(e[e.length-1],1):null}}),new function(){function t(t,e,i,n){function r(e){var i=h[e],n=h[e+1];s==i&&a==n||(t.beginPath(),t.moveTo(s,a),t.lineTo(i,n),t.stroke(),t.beginPath(),t.arc(i,n,o,0,2*Math.PI,!0),t.fill())}for(var s,a,o=n/2,h=new Array(6),u=0,l=e.length;u<l;u++){var c=e[u],d=c._selection;if(c._transformCoordinates(i,h),s=h[0],a=h[1],2&d&&r(2),4&d&&r(4),t.fillRect(s-o,a-o,n,n),!(1&d)){var f=t.fillStyle;t.fillStyle="#ffffff",t.fillRect(s-o+1,a-o+1,n-2,n-2),t.fillStyle=f}}}function e(t,e,i){function n(e){if(i)e._transformCoordinates(i,_),r=_[0],s=_[1];else{var n=e._point;r=n._x,s=n._y}if(g)t.moveTo(r,s),g=!1;else{if(i)h=_[2],u=_[3];else{var d=e._handleIn;h=r+d._x,u=s+d._y}h===r&&u===s&&l===a&&c===o?t.lineTo(r,s):t.bezierCurveTo(l,c,h,u,r,s)}if(a=r,o=s,i)l=_[4],c=_[5];else{var d=e._handleOut;l=a+d._x,c=o+d._y}}for(var r,s,a,o,h,u,l,c,d=e._segments,f=d.length,_=new Array(6),g=!0,v=0;v<f;v++)n(d[v]);e._closed&&f>0&&n(d[0])}return{_draw:function(t,i,n,r){function s(t){return c[(t%d+d)%d]}var a=i.dontStart,o=i.dontFinish||i.clip,h=this.getStyle(),u=h.hasFill(),l=h.hasStroke(),c=h.getDashArray(),d=!paper.support.nativeDash&&l&&c&&c.length;if(a||t.beginPath(),(u||l&&!d||o)&&(e(t,this,r),this._closed&&t.closePath()),!o&&(u||l)&&(this._setStyles(t,i,n),u&&(t.fill(h.getFillRule()),t.shadowColor="rgba(0,0,0,0)"),l)){if(d){a||t.beginPath();var f,_=new B(this,.25,32,(!1),r),g=_.length,v=-h.getDashOffset(),p=0;for(v%=g;v>0;)v-=s(p--)+s(p--);for(;v<g;)f=v+s(p++),(v>0||f>0)&&_.drawPart(t,Math.max(v,0),Math.max(f,0)),v=f+s(p++)}t.stroke()}},_drawSelected:function(i,n){i.beginPath(),e(i,this,n),i.stroke(),t(i,this._segments,n,paper.settings.handleSize)}}},new function(){function t(t){var e=t._segments;if(0===e.length)throw new Error("Use a moveTo() command first");return e[e.length-1]}return{moveTo:function(){var t=this._segments;1===t.length&&this.removeSegment(0),t.length||this._add([new T(c.read(arguments))])},moveBy:function(){throw new Error("moveBy() is unsupported on Path items.")},lineTo:function(){this._add([new T(c.read(arguments))])},cubicCurveTo:function(){var e=c.read(arguments),i=c.read(arguments),n=c.read(arguments),r=t(this);r.setHandleOut(e.subtract(r._point)),this._add([new T(n,i.subtract(n))])},quadraticCurveTo:function(){var e=c.read(arguments),i=c.read(arguments),n=t(this)._point;this.cubicCurveTo(e.add(n.subtract(e).multiply(1/3)),e.add(i.subtract(e).multiply(1/3)),i)},curveTo:function(){var e=c.read(arguments),i=c.read(arguments),n=r.pick(r.read(arguments),.5),s=1-n,a=t(this)._point,o=e.subtract(a.multiply(s*s)).subtract(i.multiply(n*n)).divide(2*n*s);if(o.isNaN())throw new Error("Cannot put a curve through points with parameter = "+n);this.quadraticCurveTo(o,i)},arcTo:function(){var e,i,n,s,a,o=t(this),h=o._point,l=c.read(arguments),d=r.peek(arguments),_=r.pick(d,!0);if("boolean"==typeof _)var g=h.add(l).divide(2),e=g.add(g.subtract(h).rotate(_?-90:90));else if(r.remain(arguments)<=2)e=l,l=c.read(arguments);else{var v=f.read(arguments),y=u.isZero;if(y(v.width)||y(v.height))return this.lineTo(l);var w=r.read(arguments),_=!!r.read(arguments),x=!!r.read(arguments),g=h.add(l).divide(2),b=h.subtract(g).rotate(-w),C=b.x,S=b.y,P=Math.abs,I=P(v.width),M=P(v.height),k=I*I,z=M*M,O=C*C,A=S*S,L=Math.sqrt(O/k+A/z);if(L>1&&(I*=L,M*=L,k=I*I,z=M*M),L=(k*z-k*A-z*O)/(k*A+z*O),P(L)<1e-12&&(L=0),L<0)throw new Error("Cannot create an arc with the given arguments");i=new c(I*S/M,-M*C/I).multiply((x===_?-1:1)*Math.sqrt(L)).rotate(w).add(g),a=(new p).translate(i).rotate(w).scale(I,M),s=a._inverseTransform(h),n=s.getDirectedAngle(a._inverseTransform(l)),!_&&n>0?n-=360:_&&n<0&&(n+=360)}if(e){var N=new m(h.add(e).divide(2),e.subtract(h).rotate(90),(!0)),B=new m(e.add(l).divide(2),l.subtract(e).rotate(90),(!0)),E=new m(h,l),D=E.getSide(e);if(i=N.intersect(B,!0),!i){if(!D)return this.lineTo(l);throw new Error("Cannot create an arc with the given arguments")}s=h.subtract(i),n=s.getDirectedAngle(l.subtract(i));var j=E.getSide(i);0===j?n=D*Math.abs(n):D===j&&(n+=n<0?360:-360)}for(var F=Math.abs(n),R=F>=360?4:Math.ceil(F/90),q=n/R,V=q*Math.PI/360,H=4/3*Math.sin(V)/(1+Math.cos(V)),Z=[],U=0;U<=R;U++){var b=l,W=null;if(U<R&&(W=s.rotate(90).multiply(H),a?(b=a._transformPoint(s),W=a._transformPoint(s.add(W)).subtract(b)):b=i.add(s)),0===U)o.setHandleOut(W);else{var G=s.rotate(-90).multiply(H);a&&(G=a._transformPoint(s.add(G)).subtract(b)),Z.push(new T(b,G,W))}s=s.rotate(q)}this._add(Z)},lineBy:function(){var e=c.read(arguments),i=t(this)._point;this.lineTo(i.add(e))},curveBy:function(){var e=c.read(arguments),i=c.read(arguments),n=r.read(arguments),s=t(this)._point;this.curveTo(s.add(e),s.add(i),n)},cubicCurveBy:function(){var e=c.read(arguments),i=c.read(arguments),n=c.read(arguments),r=t(this)._point;this.cubicCurveTo(r.add(e),r.add(i),r.add(n))},quadraticCurveBy:function(){var e=c.read(arguments),i=c.read(arguments),n=t(this)._point;this.quadraticCurveTo(n.add(e),n.add(i))},arcBy:function(){var e=t(this)._point,i=e.add(c.read(arguments)),n=r.pick(r.peek(arguments),!0);"boolean"==typeof n?this.arcTo(i,n):this.arcTo(i,e.add(c.read(arguments)))},closePath:function(t){this.setClosed(!0),this.join(this,t)}}},{_getBounds:function(t,e){var i=e.handle?"getHandleBounds":e.stroke?"getStrokeBounds":"getBounds";return L[i](this._segments,this._closed,this,t,e)},statics:{getBounds:function(t,e,i,n,r,s){function a(t){t._transformCoordinates(n,h);for(var e=0;e<2;e++)z._addBounds(u[e],u[e+4],h[e+2],h[e],e,s?s[e]:0,l,c,d);var i=u;u=h,h=i}var o=t[0];if(!o)return new g;for(var h=new Array(6),u=o._transformCoordinates(n,new Array(6)),l=u.slice(0,2),c=l.slice(),d=new Array(2),f=1,_=t.length;f<_;f++)a(t[f]);return e&&a(o),new g(l[0],l[1],c[0]-l[0],c[1]-l[1])},getStrokeBounds:function(t,e,i,n,r){function s(t){v=v.include(t)}function a(t){v=v.unite(x.setCenter(t._point.transform(n)))}function o(t,e){var i=t._handleIn,r=t._handleOut;"round"===e||!i.isZero()&&!r.isZero()&&i.isCollinear(r)?a(t):L._addBevelJoin(t,e,p,w,n,d,s)}function h(t,e){"round"===e?a(t):L._addSquareCap(t,e,p,n,d,s)}var u=i.getStyle(),l=u.hasStroke(),c=u.getStrokeWidth(),d=l&&i._getStrokeMatrix(n,r),_=l&&L._getStrokePadding(c,d),v=L.getBounds(t,e,i,n,r,_);if(!l)return v;for(var p=c/2,m=u.getStrokeJoin(),y=u.getStrokeCap(),w=p*u.getMiterLimit(),x=new g(new f(_)),b=t.length-(e?0:1),C=1;C<b;C++)o(t[C],m);return e?o(t[0],m):b>0&&(h(t[0],y),h(t[t.length-1],y)),v},_getStrokePadding:function(t,e){if(!e)return[t,t];
	var i=new c(t,0).transform(e),n=new c(0,t).transform(e),r=i.getAngleInRadians(),s=i.getLength(),a=n.getLength(),o=Math.sin(r),h=Math.cos(r),u=Math.tan(r),l=Math.atan2(a*u,s),d=Math.atan2(a,u*s);return[Math.abs(s*Math.cos(l)*h+a*Math.sin(l)*o),Math.abs(a*Math.sin(d)*h+s*Math.cos(d)*o)]},_addBevelJoin:function(t,e,i,n,r,s,a,o){var h=t.getCurve(),u=h.getPrevious(),l=h.getPointAtTime(0),d=u.getNormalAtTime(1),f=h.getNormalAtTime(0),_=d.getDirectedAngle(f)<0?-i:i;if(d.setLength(_),f.setLength(_),r&&r._transformPoint(l,l),s&&(s._transformPoint(d,d),s._transformPoint(f,f)),o&&(a(l),a(l.add(d))),"miter"===e){var g=new m(l.add(d),new c((-d.y),d.x),(!0)).intersect(new m(l.add(f),new c((-f.y),f.x),(!0)),!0);if(g&&l.getDistance(g)<=n&&(a(g),!o))return}o||a(l.add(d)),a(l.add(f))},_addSquareCap:function(t,e,i,n,r,s,a){var o=t._point,h=t.getLocation(),u=h.getNormal().multiply(i);n&&n._transformPoint(o,o),r&&r._transformPoint(u,u),a&&(s(o.subtract(u)),s(o.add(u))),"square"===e&&(o=o.add(u.rotate(0===h.getTime()?-90:90))),s(o.add(u)),s(o.subtract(u))},getHandleBounds:function(t,e,i,n,r){var s,a,o=i.getStyle(),h=r.stroke&&o.hasStroke();if(h){var u=i._getStrokeMatrix(n,r),l=o.getStrokeWidth()/2,c=l;"miter"===o.getStrokeJoin()&&(c=l*o.getMiterLimit()),"square"===o.getStrokeCap()&&(c=Math.max(c,l*Math.sqrt(2))),s=L._getStrokePadding(l,u),a=L._getStrokePadding(c,u)}for(var d=new Array(6),f=1/0,_=-f,v=f,p=_,m=0,y=t.length;m<y;m++){var w=t[m];w._transformCoordinates(n,d);for(var x=0;x<6;x+=2){var b=0===x?a:s,C=b?b[0]:0,S=b?b[1]:0,P=d[x],I=d[x+1],M=P-C,T=P+C,k=I-S,z=I+S;M<f&&(f=M),T>_&&(_=T),k<v&&(v=k),z>p&&(p=z)}}return new g(f,v,_-f,p-v)}}});L.inject({statics:new function(){function t(t,e,i){var n=r.getNamed(i),s=new L(n&&n.insert===!1&&w.NO_INSERT);return s._add(t),s._closed=e,s.set(n)}function e(e,i,r){for(var s=new Array(4),a=0;a<4;a++){var o=n[a];s[a]=new T(o._point.multiply(i).add(e),o._handleIn.multiply(i),o._handleOut.multiply(i))}return t(s,!0,r)}var i=.5522847498307936,n=[new T([-1,0],[0,i],[0,-i]),new T([0,-1],[-i,0],[i,0]),new T([1,0],[0,-i],[0,i]),new T([0,1],[i,0],[-i,0])];return{Line:function(){return t([new T(c.readNamed(arguments,"from")),new T(c.readNamed(arguments,"to"))],!1,arguments)},Circle:function(){var t=c.readNamed(arguments,"center"),i=r.readNamed(arguments,"radius");return e(t,new f(i),arguments)},Rectangle:function(){var e,n=g.readNamed(arguments,"rectangle"),r=f.readNamed(arguments,"radius",0,{readNull:!0}),s=n.getBottomLeft(!0),a=n.getTopLeft(!0),o=n.getTopRight(!0),h=n.getBottomRight(!0);if(!r||r.isZero())e=[new T(s),new T(a),new T(o),new T(h)];else{r=f.min(r,n.getSize(!0).divide(2));var u=r.width,l=r.height,c=u*i,d=l*i;e=[new T(s.add(u,0),null,[-c,0]),new T(s.subtract(0,l),[0,d]),new T(a.add(0,l),null,[0,-d]),new T(a.add(u,0),[-c,0],null),new T(o.subtract(u,0),null,[c,0]),new T(o.add(0,l),[0,-d],null),new T(h.subtract(0,l),null,[0,d]),new T(h.subtract(u,0),[c,0])]}return t(e,!0,arguments)},RoundRectangle:"#Rectangle",Ellipse:function(){var t=C._readEllipse(arguments);return e(t.center,t.radius,arguments)},Oval:"#Ellipse",Arc:function(){var t=c.readNamed(arguments,"from"),e=c.readNamed(arguments,"through"),i=c.readNamed(arguments,"to"),n=r.getNamed(arguments),s=new L(n&&n.insert===!1&&w.NO_INSERT);return s.moveTo(t),s.arcTo(e,i),s.set(n)},RegularPolygon:function(){for(var e=c.readNamed(arguments,"center"),i=r.readNamed(arguments,"sides"),n=r.readNamed(arguments,"radius"),s=360/i,a=i%3===0,o=new c(0,a?-n:n),h=a?-1:.5,u=new Array(i),l=0;l<i;l++)u[l]=new T(e.add(o.rotate((l+h)*s)));return t(u,!0,arguments)},Star:function(){for(var e=c.readNamed(arguments,"center"),i=2*r.readNamed(arguments,"points"),n=r.readNamed(arguments,"radius1"),s=r.readNamed(arguments,"radius2"),a=360/i,o=new c(0,(-1)),h=new Array(i),u=0;u<i;u++)h[u]=new T(e.add(o.rotate(a*u).multiply(u%2?s:n)));return t(h,!0,arguments)}}}});var N=A.extend({_class:"CompoundPath",_serializeFields:{children:[]},initialize:function(t){this._children=[],this._namedChildren={},this._initialize(t)||("string"==typeof t?this.setPathData(t):this.addChildren(Array.isArray(t)?t:arguments))},insertChildren:function pt(t,i,n){for(var r=i.length-1;r>=0;r--){var s=i[r];s instanceof N&&(i=i.slice(),i.splice.apply(i,[r,1].concat(s.removeChildren())),s.remove())}i=pt.base.call(this,t,i,n,L);for(var r=0,a=!n&&i&&i.length;r<a;r++){var s=i[r];s._clockwise===e&&s.setClockwise(0===s._index)}return i},reduce:function mt(t){for(var e=this._children,i=e.length-1;i>=0;i--){var n=e[i].reduce(t);n.isEmpty()&&n.remove()}if(0===e.length){var n=new L(w.NO_INSERT);return n.copyAttributes(this),n.insertAbove(this),this.remove(),n}return mt.base.call(this)},isClockwise:function(){var t=this.getFirstChild();return t&&t.isClockwise()},setClockwise:function(t){this.isClockwise()^!!t&&this.reverse()},getFirstSegment:function(){var t=this.getFirstChild();return t&&t.getFirstSegment()},getLastSegment:function(){var t=this.getLastChild();return t&&t.getLastSegment()},getCurves:function(){for(var t=this._children,e=[],i=0,n=t.length;i<n;i++)e.push.apply(e,t[i].getCurves());return e},getFirstCurve:function(){var t=this.getFirstChild();return t&&t.getFirstCurve()},getLastCurve:function(){var t=this.getLastChild();return t&&t.getFirstCurve()},getArea:function(){for(var t=this._children,e=0,i=0,n=t.length;i<n;i++)e+=t[i].getArea();return e}},{beans:!0,getPathData:function(t,e){for(var i=this._children,n=[],r=0,s=i.length;r<s;r++){var a=i[r],o=a._matrix;n.push(a.getPathData(t&&!o.isIdentity()?t.appended(o):t,e))}return n.join(" ")}},{_hitTestChildren:function yt(t,e,i){return yt.base.call(this,t,e["class"]===L||"path"===e.type?e:r.set({},e,{fill:!1}),i)},_draw:function(t,e,i,n){var r=this._children;if(0!==r.length){e=e.extend({dontStart:!0,dontFinish:!0}),t.beginPath();for(var s=0,a=r.length;s<a;s++)r[s].draw(t,e,n);if(!e.clip){this._setStyles(t,e,i);var o=this._style;o.hasFill()&&(t.fill(o.getFillRule()),t.shadowColor="rgba(0,0,0,0)"),o.hasStroke()&&t.stroke()}}},_drawSelected:function(t,e,i){for(var n=this._children,r=0,s=n.length;r<s;r++){var a=n[r],o=a._matrix;i[a._id]||a._drawSelected(t,o.isIdentity()?e:e.appended(o))}}},new function(){function t(t,e){var i=t._children;if(e&&0===i.length)throw new Error("Use a moveTo() command first");return i[i.length-1]}return r.each(["lineTo","cubicCurveTo","quadraticCurveTo","curveTo","arcTo","lineBy","cubicCurveBy","quadraticCurveBy","curveBy","arcBy"],function(e){this[e]=function(){var i=t(this,!0);i[e].apply(i,arguments)}},{moveTo:function(){var e=t(this),i=e&&e.isEmpty()?e:new L(w.NO_INSERT);i!==e&&this.addChild(i),i.moveTo.apply(i,arguments)},moveBy:function(){var e=t(this,!0),i=e&&e.getLastSegment(),n=c.read(arguments);this.moveTo(i?n.add(i._point):n)},closePath:function(e){t(this,!0).closePath(e)}})},r.each(["reverse","flatten","simplify","smooth"],function(t){this[t]=function(e){for(var i,n=this._children,r=0,s=n.length;r<s;r++)i=n[r][t](e)||i;return i}},{}));A.inject(new function(){function t(t,e){var i=t.clone(!1).reduce({simplify:!0}).transform(null,!0,!0);return e?i.resolveCrossings():i}function e(t,e,i,n,r){var s=new t(w.NO_INSERT);return s.addChildren(e,!0),i&&(s=s.reduce({simplify:!0})),s.insertAbove(r&&n.isSibling(r)&&n.getIndex()<r.getIndex()?r:n),s.copyAttributes(n,!0),s}function i(i,r,s){function o(t){for(var e=0,i=t.length;e<i;e++){var n=t[e];g.push.apply(g,n._segments),v.push.apply(v,n._getMonoCurves()),n._overlapsOnly=n._validOverlapsOnly=!0}}var u=d[s];if(u[s]=!0,!i._children&&!i._closed)return n(i,r,u);var c=t(i,!0),f=r&&i!==r&&t(r,!0);f&&(u.subtract||u.exclude)^(f.isClockwise()^c.isClockwise())&&f.reverse();var _=a(O.expand(c.getCrossings(f))),g=[],v=[];o(c._children||[c]),f&&o(f._children||[f]);for(var p=0,m=_.length;p<m;p++)h(_[p]._segment,c,f,v,u);for(var p=0,m=g.length;p<m;p++){var y=g[p],w=y._intersection;if(null==y._winding&&h(y,c,f,v,u),!w||!w._overlap){var x=y._path;x._overlapsOnly=!1,u[y._winding]&&(x._validOverlapsOnly=!1)}}return e(N,l(g,u),!0,i,r)}function n(i,n,r){function s(t){if(o.contains(t.getPointAt(t.getLength()/2))^u)return l.unshift(t),!0}if(!n||!n._children&&!n._closed||!r.subtract&&!r.intersect)return null;for(var a=t(i,!1),o=t(n,!1),h=a.getCrossings(o),u=r.subtract,l=[],c=h.length-1;c>=0;c--){var d=h[c].split();d&&(s(d)&&d.getFirstSegment().setHandleIn(0,0),a.getLastSegment().setHandleOut(0,0))}return s(a),e(x,l,!1,i,n)}function s(t,e){for(var i=t;i;){if(i===e)return;i=i._previous}for(;t._next&&t._next!==e;)t=t._next;if(!t._next){for(;e._previous;)e=e._previous;t._next=e,e._previous=t}}function a(t,e){for(var i,n,r=e&&[],a=4e-7,o=1-a,h=!1,u=[],l=t.length-1;l>=0;l--){var c=t[l];if(e){if(!e(c))continue;r.unshift(c)}var d,f=c._curve,_=c._time,g=_;if(f!==i?h=!f.hasHandles():n>=a&&n<=o&&(_/=n),_<a)d=f._segment1;else if(_>o)d=f._segment2;else{var v=f.divideAtTime(_,!0);h&&u.push(f,v),d=v._segment1}c._setSegment(d);var p=d._intersection,m=c._intersection;if(p){s(p,m);for(var y=p;y;)s(y._intersection,p),y=y._next}else d._intersection=m;i=f,n=g}for(var l=0,w=u.length;l<w;l++)u[l].clearHandles();return r||t}function o(t,e,i){var n=2e-7,r=t.x,s=t.y,a=0,h=0,u=e.length,l=[],d=Math.abs;if(i){for(var f=-(1/0),_=1/0,g=s-n,v=s+n,p=0;p<u;p++)for(var m=e[p].values,y=z.solveCubic(m,0,r,l,0,1),w=y-1;w>=0;w--){var x=z.getPoint(m,l[w]).y;x<g&&x>f?f=x:x>v&&x<_&&(_=x)}f=(f+s)/2,_=(_+s)/2,f>-(1/0)&&(a=o(new c(r,f),e).winding),_<1/0&&(h=o(new c(r,_),e).winding)}else{for(var b,C,S=r-n,P=r+n,I=0,M=0,T=!1,p=0;p<u;p++){var k=e[p],O=k.winding,m=k.values,A=m[1],L=m[7];if(k.last&&(b=k.last.winding,C=k.last.values[6],T=!1),s>=A&&s<=L||s>=L&&s<=A)if(O){var N=s===A?m[0]:s===L?m[6]:1===z.solveCubic(m,1,s,l,0,1)?z.getPoint(m,l[0]).x:null;null!=N&&(N>=S&&N<=P?T=!0:s===A&&O===b||s===A&&(r-N)*(r-C)<0||(N<S?a+=O:N>P&&(h+=O))),b=O,C=m[6]}else(r-m[0])*(r-m[6])<=0&&(T=!0);T&&(p>=u-1||e[p+1].last)&&(I+=1,M-=1)}0===a&&0===h&&(a=I,h=M)}return{winding:Math.max(d(a),d(h)),contour:!a^!h}}function h(t,e,i,n,r){var s,a=[],h=t,u=0;do{var l=t.getCurve(),c=l.getLength();a.push({segment:t,curve:l,length:c}),u+=c,t=t.getNext()}while(t&&!t._intersection&&t!==h);for(var c=u/2,d=0,f=a.length;d<f;d++){var _=a[d],g=_.length;if(c<=g){var l=_.curve,v=l._path,p=v._parent,m=l.getTimeAt(c),y=l.getPointAtTime(m),w=Math.abs(l.getTangentAtTime(m).y)<1e-7;p instanceof N&&(v=p),s=r.subtract&&i&&(v===e&&i._getWinding(y,w)||v===i&&!e._getWinding(y,w))?{winding:0}:o(y,n,w);break}c-=g}for(var d=a.length-1;d>=0;d--){var x=a[d].segment;x._winding=s.winding,x._contour=s.contour}}function l(t,e){function i(t,i){return!(!t||t._visited||!(!e||e[t._winding]||!i&&e.unite&&t._contour))}function n(t){return t===a||t===o}function s(t,r){if(!t._next)return t;for(;t;){var s=t._segment,a=s.getNext(),o=a&&a._intersection;if(s!==r&&(n(s)||n(a)||!s._visited&&!a._visited&&(!e||i(s)&&(i(a)||o&&i(o._segment)))))return t;t=t._next}return null}for(var a,o,h=[],l=0,c=t.length;l<c;l++){var d,f=null,_=!1,g=t[l],v=g._intersection;if(!g._visited&&g._path._overlapsOnly){var p=g._path,m=v._segment._path,y=p._segments,x=m._segments;if(r.equals(y,x)){(e.unite||e.intersect)&&p.getArea()&&h.push(p.clone(!1));for(var b=0,C=y.length;b<C;b++)y[b]._visited=x[b]._visited=!0}}if(i(g,!0)&&(g._path._validOverlapsOnly||!v||!v._overlap)){for(a=o=null;;){v=v&&s(v,g)||v;var S=v&&v._segment;if(n(g)?_=!0:S&&(n(S)?(_=!0,g=S):i(S,i(g,!0))&&(e&&(e.intersect||e.subtract)&&(g._visited=!0),g=S)),_||g._visited){g._visited=!0;break}if(g._path._validOverlapsOnly&&!i(g))break;f||(f=new L(w.NO_INSERT),a=g,o=S);var P=g.getNext();f.add(new T(g._point,d,P&&g._handleOut)),g._visited=!0,g=P||g._path.getFirstSegment(),d=P&&P._handleIn,v=g._intersection}if(_)f.firstSegment.setHandleIn(d),f.setClosed(!0);else if(f){var I=f.getArea(!0);Math.abs(I)>=2e-7&&console.error("Boolean operation resulted in open path","segments =",f._segments.length,"length =",f.getLength(),"area=",I),f=null}f&&(f._segments.length>8||!u.isZero(f.getArea()))&&(h.push(f),f=null)}}return h}var d={unite:{1:!0},intersect:{2:!0},subtract:{1:!0},exclude:{1:!0}};return{_getWinding:function(t,e){return o(t,this._getMonoCurves(),e).winding},unite:function(t){return i(this,t,"unite")},intersect:function(t){return i(this,t,"intersect")},subtract:function(t){return i(this,t,"subtract")},exclude:function(t){return i(this,t,"exclude")},divide:function(t){return e(x,[this.subtract(t),this.intersect(t)],!0,this,t)},resolveCrossings:function(){function t(t){var e=t&&t._intersection;return e&&e._overlap}var e=this._children,i=e||[this],n=!1,s=!1,o=this.getIntersections(null,function(t){return t._overlap&&(n=!0)||t.isCrossing()&&(s=!0)});if(o=O.expand(o),n)for(var h=a(o,function(t){return t._overlap}),u=h.length-1;u>=0;u--){var c=h[u]._segment,d=c.getPrevious(),f=c.getNext();if(c._path&&t(d)&&t(f)){c.remove(),d._handleOut.set(0,0),f._handleIn.set(0,0);var _=d.getCurve();_.isStraight()&&0===_.getLength()&&d.remove()}}s&&(a(o,n&&function(t){var e=t.getCurve(),i=t._intersection._curve,n=t._segment;return!!(e&&i&&e._path&&i._path)||void(n&&(n._intersection=null))}),i=l(r.each(i,function(t){this.push.apply(this,t._segments)},[])));var g,v=i.length;if(v>1){i=i.slice().sort(function(t,e){return e.getBounds().getArea()-t.getBounds().getArea()});for(var p=i[0],m=[p],y={},x="nonzero"===this.getFillRule(),b=x&&r.each(i,function(t){this.push(t.isClockwise()?1:-1)},[]),u=1;u<v;u++){for(var C=i[u],S=C.getInteriorPoint(),P=!1,I=null,M=!1,T=u-1;T>=0&&!I;T--)if(i[T].contains(S)){if(x&&!P&&(b[u]+=b[T],b[u]&&b[T])){M=y[u]=!0;break}P=!0,I=!y[T]&&i[T]}M||(C.setClockwise(I?!I.isClockwise():p.isClockwise()),m.push(C))}i=m,v=m.length}return v>1&&e?(i!==e&&this.setChildren(i,!0),g=this):1!==v||e||(i[0]!==this&&this.setSegments(i[0].removeSegments()),g=this),g||(g=new N(w.NO_INSERT),g.addChildren(i,!0),g=g.reduce(),g.copyAttributes(this),this.replaceWith(g)),g}}}),L.inject({_getMonoCurves:function(){function t(t){var e=t[1],r=t[7],s=Math.abs((e-r)/(t[0]-t[6]))<2e-7?0:e>r?-1:1,a={values:t,winding:s};n.push(a),s&&(i=a)}function e(e){if(0!==z.getLength(e)){var i=e[1],n=e[3],r=e[5],s=e[7];if(z.isStraight(e)||i>=n==n>=r&&n>=r==r>=s)t(e);else{var a=3*(n-r)-i+s,o=2*(i+r)-4*n,h=n-i,l=4e-7,c=1-l,d=[],f=u.solveQuadratic(a,o,h,d,l,c);if(f<1)t(e);else{d.sort();var _=d[0],g=z.subdivide(e,_);t(g[0]),f>1&&(_=(d[1]-_)/(1-_),g=z.subdivide(g[1],_),t(g[0])),t(g[1])}}}}var i,n=this._monoCurves;if(!n){n=this._monoCurves=[];for(var r=this.getCurves(),s=this._segments,a=0,o=r.length;a<o;a++)e(r[a].getValues());if(!this._closed&&s.length>1){var h=s[s.length-1]._point,l=s[0]._point,c=h._x,d=h._y,f=l._x,_=l._y;e([c,d,c,d,f,_,f,_])}n.length>0&&(n[0].last=i)}return n},getInteriorPoint:function(){var t=this.getBounds(),e=t.getCenter(!0);if(!this.contains(e)){for(var i=this._getMonoCurves(),n=[],r=e.y,s=[],a=0,o=i.length;a<o;a++){var h=i[a].values;if(1===i[a].winding&&r>h[1]&&r<=h[7]||r>=h[7]&&r<h[1])for(var u=z.solveCubic(h,1,r,n,0,1),l=u-1;l>=0;l--)s.push(z.getPoint(h,n[l]).x)}s.sort(function(t,e){return t-e}),e.x=(s[0]+s[1])/2}return e}}),N.inject({_getMonoCurves:function(){for(var t=this._children,e=[],i=0,n=t.length;i<n;i++)e.push.apply(e,t[i]._getMonoCurves());return e}});var B=r.extend({_class:"PathIterator",initialize:function(t,e,i,n,r){function s(t,e){var i=z.getValues(t,e,r);h.push(i),a(i,t._index,0,1)}function a(t,i,r,s){if(!(s-r>c)||n&&z.isStraight(t)||z.isFlatEnough(t,e||.25)){var o=t[6]-t[0],h=t[7]-t[1],d=Math.sqrt(o*o+h*h);d>0&&(l+=d,u.push({offset:l,curve:t,index:i,time:s}))}else{var f=z.subdivide(t,.5),_=(r+s)/2;a(f[0],i,r,_),a(f[1],i,_,s)}}for(var o,h=[],u=[],l=0,c=1/(i||32),d=t._segments,f=d[0],_=1,g=d.length;_<g;_++)o=d[_],s(f,o),f=o;t._closed&&s(o,d[0]),this.curves=h,this.parts=u,this.length=l,this.index=0},_get:function(t){for(var e,i=this.index;e=i,!(0===i||this.parts[--i].offset<t););for(var n=this.parts.length;e<n;e++){var r=this.parts[e];if(r.offset>=t){this.index=e;var s=this.parts[e-1],a=s&&s.index===r.index?s.time:0,o=s?s.offset:0;return{index:r.index,time:a+(r.time-a)*(t-o)/(r.offset-o)}}}var r=this.parts[this.parts.length-1];return{index:r.index,time:1}},drawPart:function(t,e,i){for(var n=this._get(e),r=this._get(i),s=n.index,a=r.index;s<=a;s++){var o=z.getPart(this.curves[s],s===n.index?n.time:0,s===r.index?r.time:1);s===n.index&&t.moveTo(o[0],o[1]),t.bezierCurveTo.apply(t,o.slice(2))}}},r.each(z._evaluateMethods,function(t){this[t+"At"]=function(e){var i=this._get(e);return z[t](this.curves[i.index],i.time)}},{})),E=r.extend({initialize:function(t){for(var e,i=this.points=[],n=t._segments,r=t._closed,s=0,a=n.length;s<a;s++){var o=n[s].point;e&&e.equals(o)||i.push(e=o.clone())}r&&(i.unshift(i[i.length-1]),i.push(i[1])),this.closed=r},fit:function(t){var e=this.points,i=e.length,n=null;return i>0&&(n=[new T(e[0])],i>1&&(this.fitCubic(n,t,0,i-1,e[1].subtract(e[0]),e[i-2].subtract(e[i-1])),this.closed&&(n.shift(),n.pop()))),n},fitCubic:function(t,e,i,n,r,s){var a=this.points;if(n-i===1){var o=a[i],h=a[n],u=o.getDistance(h)/3;return void this.addCurve(t,[o,o.add(r.normalize(u)),h.add(s.normalize(u)),h])}for(var l,c=this.chordLengthParameterize(i,n),d=Math.max(e,e*e),f=!0,_=0;_<=4;_++){var g=this.generateBezier(i,n,c,r,s),v=this.findMaxError(i,n,g,c);if(v.error<e&&f)return void this.addCurve(t,g);if(l=v.index,v.error>=d)break;f=this.reparameterize(i,n,c,g),d=v.error}var p=a[l-1].subtract(a[l+1]);this.fitCubic(t,e,i,l,r,p),this.fitCubic(t,e,l,n,p.negate(),s)},addCurve:function(t,e){var i=t[t.length-1];i.setHandleOut(e[1].subtract(e[0])),t.push(new T(e[3],e[2].subtract(e[3])))},generateBezier:function(t,e,i,n,r){for(var s=1e-12,a=Math.abs,o=this.points,h=o[t],u=o[e],l=[[0,0],[0,0]],c=[0,0],d=0,f=e-t+1;d<f;d++){var _=i[d],g=1-_,v=3*_*g,p=g*g*g,m=v*g,y=v*_,w=_*_*_,x=n.normalize(m),b=r.normalize(y),C=o[t+d].subtract(h.multiply(p+m)).subtract(u.multiply(y+w));l[0][0]+=x.dot(x),l[0][1]+=x.dot(b),l[1][0]=l[0][1],l[1][1]+=b.dot(b),c[0]+=x.dot(C),c[1]+=b.dot(C)}var S,P,I=l[0][0]*l[1][1]-l[1][0]*l[0][1];if(a(I)>s){var M=l[0][0]*c[1]-l[1][0]*c[0],T=c[0]*l[1][1]-c[1]*l[0][1];S=T/I,P=M/I}else{var k=l[0][0]+l[0][1],z=l[1][0]+l[1][1];S=P=a(k)>s?c[0]/k:a(z)>s?c[1]/z:0}var O,A,L=u.getDistance(h),N=s*L;if(S<N||P<N)S=P=L/3;else{var B=u.subtract(h);O=n.normalize(S),A=r.normalize(P),O.dot(B)-A.dot(B)>L*L&&(S=P=L/3,O=A=null)}return[h,h.add(O||n.normalize(S)),u.add(A||r.normalize(P)),u]},reparameterize:function(t,e,i,n){for(var r=t;r<=e;r++)i[r-t]=this.findRoot(n,this.points[r],i[r-t]);for(var r=1,s=i.length;r<s;r++)if(i[r]<=i[r-1])return!1;return!0},findRoot:function(t,e,i){for(var n=[],r=[],s=0;s<=2;s++)n[s]=t[s+1].subtract(t[s]).multiply(3);for(var s=0;s<=1;s++)r[s]=n[s+1].subtract(n[s]).multiply(2);var a=this.evaluate(3,t,i),o=this.evaluate(2,n,i),h=this.evaluate(1,r,i),u=a.subtract(e),l=o.dot(o)+u.dot(h);return Math.abs(l)<1e-6?i:i-u.dot(o)/l},evaluate:function(t,e,i){for(var n=e.slice(),r=1;r<=t;r++)for(var s=0;s<=t-r;s++)n[s]=n[s].multiply(1-i).add(n[s+1].multiply(i));return n[0]},chordLengthParameterize:function(t,e){for(var i=[0],n=t+1;n<=e;n++)i[n-t]=i[n-t-1]+this.points[n].getDistance(this.points[n-1]);for(var n=1,r=e-t;n<=r;n++)i[n]/=i[r];return i},findMaxError:function(t,e,i,n){for(var r=Math.floor((e-t+1)/2),s=0,a=t+1;a<e;a++){var o=this.evaluate(3,i,n[a-t]),h=o.subtract(this.points[a]),u=h.x*h.x+h.y*h.y;u>=s&&(s=u,r=a)}return{error:s,index:r}}}),D=w.extend({_class:"TextItem",_applyMatrix:!1,_canApplyMatrix:!1,_serializeFields:{content:null},_boundsOptions:{stroke:!1,handle:!1},initialize:function(t){this._content="",this._lines=[];var i=t&&r.isPlainObject(t)&&t.x===e&&t.y===e;this._initialize(i&&t,!i&&c.read(arguments))},_equals:function(t){return this._content===t._content},copyContent:function(t){this.setContent(t._content)},getContent:function(){return this._content},setContent:function(t){this._content=""+t,this._lines=this._content.split(/\r\n|\n|\r/gm),this._changed(265)},isEmpty:function(){return!this._content},getCharacterStyle:"#getStyle",setCharacterStyle:"#setStyle",getParagraphStyle:"#getStyle",setParagraphStyle:"#setStyle"}),j=D.extend({_class:"PointText",initialize:function(){D.apply(this,arguments)},getPoint:function(){var t=this._matrix.getTranslation();return new d(t.x,t.y,this,"setPoint")},setPoint:function(){var t=c.read(arguments);this.translate(t.subtract(this._matrix.getTranslation()))},_draw:function(t,e,i){if(this._content){this._setStyles(t,e,i);var n=this._lines,r=this._style,s=r.hasFill(),a=r.hasStroke(),o=r.getLeading(),h=t.shadowColor;t.font=r.getFontStyle(),t.textAlign=r.getJustification();for(var u=0,l=n.length;u<l;u++){t.shadowColor=h;var c=n[u];s&&(t.fillText(c,0,0),t.shadowColor="rgba(0,0,0,0)"),a&&t.strokeText(c,0,0),t.translate(0,o)}}},_getBounds:function(t,e){var i=this._style,n=this._lines,r=n.length,s=i.getJustification(),a=i.getLeading(),o=this.getView().getTextWidth(i.getFontStyle(),n),h=0;"left"!==s&&(h-=o/("center"===s?2:1));var u=new g(h,r?-.75*a:0,o,r*a);return t?t._transformBounds(u,u):u}}),F=r.extend(new function(){function t(t){var n,r=t.match(/^#(\w{1,2})(\w{1,2})(\w{1,2})$/);if(r){n=[0,0,0];for(var s=0;s<3;s++){var o=r[s+1];n[s]=parseInt(1==o.length?o+o:o,16)/255}}else if(r=t.match(/^rgba?\((.*)\)$/)){n=r[1].split(",");for(var s=0,h=n.length;s<h;s++){var o=+n[s];n[s]=s<3?o/255:o}}else if(i){var u=a[t];if(!u){e||(e=Q.getContext(1,1),e.globalCompositeOperation="copy"),e.fillStyle="rgba(0,0,0,0)",e.fillStyle=t,e.fillRect(0,0,1,1);var l=e.getImageData(0,0,1,1).data;u=a[t]=[l[0]/255,l[1]/255,l[2]/255]}n=u.slice()}else n=[0,0,0];return n}var e,n={gray:["gray"],rgb:["red","green","blue"],hsb:["hue","saturation","brightness"],hsl:["hue","saturation","lightness"],gradient:["gradient","origin","destination","highlight"]},s={},a={},o=[[0,3,1],[2,0,1],[1,0,3],[1,2,0],[3,1,0],[0,1,2]],u={"rgb-hsb":function(t,e,i){var n=Math.max(t,e,i),r=Math.min(t,e,i),s=n-r,a=0===s?0:60*(n==t?(e-i)/s+(e<i?6:0):n==e?(i-t)/s+2:(t-e)/s+4);return[a,0===n?0:s/n,n]},"hsb-rgb":function(t,e,i){t=(t/60%6+6)%6;var n=Math.floor(t),r=t-n,n=o[n],s=[i,i*(1-e),i*(1-e*r),i*(1-e*(1-r))];return[s[n[0]],s[n[1]],s[n[2]]]},"rgb-hsl":function(t,e,i){var n=Math.max(t,e,i),r=Math.min(t,e,i),s=n-r,a=0===s,o=a?0:60*(n==t?(e-i)/s+(e<i?6:0):n==e?(i-t)/s+2:(t-e)/s+4),h=(n+r)/2,u=a?0:h<.5?s/(n+r):s/(2-n-r);return[o,u,h]},"hsl-rgb":function(t,e,i){if(t=(t/360%1+1)%1,0===e)return[i,i,i];for(var n=[t+1/3,t,t-1/3],r=i<.5?i*(1+e):i+e-i*e,s=2*i-r,a=[],o=0;o<3;o++){var h=n[o];h<0&&(h+=1),h>1&&(h-=1),a[o]=6*h<1?s+6*(r-s)*h:2*h<1?r:3*h<2?s+(r-s)*(2/3-h)*6:s}return a},"rgb-gray":function(t,e,i){return[.2989*t+.587*e+.114*i]},"gray-rgb":function(t){return[t,t,t]},"gray-hsb":function(t){return[0,0,t]},"gray-hsl":function(t){return[0,0,t]},"gradient-rgb":function(){return[]},"rgb-gradient":function(){return[]}};return r.each(n,function(t,e){s[e]=[],r.each(t,function(t,i){var a=r.capitalize(t),o=/^(hue|saturation)$/.test(t),h=s[e][i]="gradient"===t?function(t){var e=this._components[0];return t=R.read(Array.isArray(t)?t:arguments,0,{readNull:!0}),e!==t&&(e&&e._removeOwner(this),t&&t._addOwner(this)),t}:"gradient"===e?function(){return c.read(arguments,0,{readNull:"highlight"===t,clone:!0})}:function(t){return null==t||isNaN(t)?0:t};this["get"+a]=function(){return this._type===e||o&&/^hs[bl]$/.test(this._type)?this._components[i]:this._convert(e)[i]},this["set"+a]=function(t){this._type===e||o&&/^hs[bl]$/.test(this._type)||(this._components=this._convert(e),this._properties=n[e],this._type=e),this._components[i]=h.call(this,t),this._changed()}},this)},{_class:"Color",_readIndex:!0,initialize:function l(e){var i,r,a,o,h=Array.prototype.slice,u=arguments,c=this.__read,d=0;Array.isArray(e)&&(u=e,e=u[0]);var f=null!=e&&typeof e;if("string"===f&&e in n&&(i=e,e=u[1],Array.isArray(e)?(r=e,a=u[2]):(c&&(d=1),u=h.call(u,1),f=typeof e)),!r){if(o="number"===f?u:"object"===f&&null!=e.length?e:null){i||(i=o.length>=3?"rgb":"gray");var _=n[i].length;a=o[_],c&&(d+=o===arguments?_+(null!=a?1:0):1),o.length>_&&(o=h.call(o,0,_))}else if("string"===f)i="rgb",r=t(e),4===r.length&&(a=r[3],r.length--);else if("object"===f)if(e.constructor===l){if(i=e._type,r=e._components.slice(),a=e._alpha,"gradient"===i)for(var g=1,v=r.length;g<v;g++){var p=r[g];p&&(r[g]=p.clone())}}else if(e.constructor===R)i="gradient",o=u;else{i="hue"in e?"lightness"in e?"hsl":"hsb":"gradient"in e||"stops"in e||"radial"in e?"gradient":"gray"in e?"gray":"rgb";var m=n[i],y=s[i];this._components=r=[];for(var g=0,v=m.length;g<v;g++){var w=e[m[g]];null==w&&0===g&&"gradient"===i&&"stops"in e&&(w={stops:e.stops,radial:e.radial}),w=y[g].call(this,w),null!=w&&(r[g]=w)}a=e.alpha}c&&i&&(d=1)}if(this._type=i||"rgb",!r){this._components=r=[];for(var y=s[this._type],g=0,v=y.length;g<v;g++){var w=y[g].call(this,o&&o[g]);null!=w&&(r[g]=w)}}this._components=r,this._properties=n[this._type],this._alpha=a,c&&(this.__read=d)},_set:"#initialize",_serialize:function(t,e){var i=this.getComponents();return r.serialize(/^(gray|rgb)$/.test(this._type)?i:[this._type].concat(i),t,!0,e)},_changed:function(){this._canvasStyle=null,this._owner&&this._owner._changed(65)},_convert:function(t){var e;return this._type===t?this._components.slice():(e=u[this._type+"-"+t])?e.apply(this,this._components):u["rgb-"+t].apply(this,u[this._type+"-rgb"].apply(this,this._components))},convert:function(t){return new F(t,this._convert(t),this._alpha)},getType:function(){return this._type},setType:function(t){this._components=this._convert(t),this._properties=n[t],this._type=t},getComponents:function(){var t=this._components.slice();return null!=this._alpha&&t.push(this._alpha),t},getAlpha:function(){return null!=this._alpha?this._alpha:1},setAlpha:function(t){this._alpha=null==t?null:Math.min(Math.max(t,0),1),this._changed()},hasAlpha:function(){return null!=this._alpha},equals:function(t){var e=r.isPlainValue(t,!0)?F.read(arguments):t;return e===this||e&&this._class===e._class&&this._type===e._type&&this._alpha===e._alpha&&r.equals(this._components,e._components)||!1},toString:function(){for(var t=this._properties,e=[],i="gradient"===this._type,n=h.instance,r=0,s=t.length;r<s;r++){var a=this._components[r];null!=a&&e.push(t[r]+": "+(i?a:n.number(a)))}return null!=this._alpha&&e.push("alpha: "+n.number(this._alpha)),"{ "+e.join(", ")+" }"},toCSS:function(t){function e(t){return Math.round(255*(t<0?0:t>1?1:t))}var i=this._convert("rgb"),n=t||null==this._alpha?1:this._alpha;return i=[e(i[0]),e(i[1]),e(i[2])],n<1&&i.push(n<0?0:n),t?"#"+((1<<24)+(i[0]<<16)+(i[1]<<8)+i[2]).toString(16).slice(1):(4==i.length?"rgba(":"rgb(")+i.join(",")+")"},toCanvasStyle:function(t){if(this._canvasStyle)return this._canvasStyle;if("gradient"!==this._type)return this._canvasStyle=this.toCSS();var e,i=this._components,n=i[0],r=n._stops,s=i[1],a=i[2];if(n._radial){var o=a.getDistance(s),h=i[3];if(h){var u=h.subtract(s);u.getLength()>o&&(h=s.add(u.normalize(o-.1)))}var l=h||s;e=t.createRadialGradient(l.x,l.y,0,s.x,s.y,o)}else e=t.createLinearGradient(s.x,s.y,a.x,a.y);for(var c=0,d=r.length;c<d;c++){var f=r[c];e.addColorStop(f._offset||c/(d-1),f._color.toCanvasStyle())}return this._canvasStyle=e},transform:function(t){if("gradient"===this._type){for(var e=this._components,i=1,n=e.length;i<n;i++){var r=e[i];t._transformPoint(r,r,!0)}this._changed()}},statics:{_types:n,random:function(){var t=Math.random;return new F(t(),t(),t())}}})},new function(){var t={add:function(t,e){return t+e},subtract:function(t,e){return t-e},multiply:function(t,e){return t*e},divide:function(t,e){return t/e}};return r.each(t,function(t,e){this[e]=function(e){e=F.read(arguments);for(var i=this._type,n=this._components,r=e._convert(i),s=0,a=n.length;s<a;s++)r[s]=t(n[s],r[s]);return new F(i,r,null!=this._alpha?t(this._alpha,e.getAlpha()):null)}},{})}),R=r.extend({_class:"Gradient",initialize:function(t,e){this._id=l.get(),t&&this._set(t)&&(t=e=null),this._stops||this.setStops(t||["white","black"]),null==this._radial&&this.setRadial("string"==typeof e&&"radial"===e||e||!1)},_serialize:function(t,e){return e.add(this,function(){return r.serialize([this._stops,this._radial],t,!0,e)})},_changed:function(){for(var t=0,e=this._owners&&this._owners.length;t<e;t++)this._owners[t]._changed()},_addOwner:function(t){this._owners||(this._owners=[]),this._owners.push(t)},_removeOwner:function(t){var i=this._owners?this._owners.indexOf(t):-1;i!=-1&&(this._owners.splice(i,1),0===this._owners.length&&(this._owners=e))},clone:function(){for(var t=[],e=0,i=this._stops.length;e<i;e++)t[e]=this._stops[e].clone();return new R(t,this._radial)},getStops:function(){return this._stops},setStops:function(t){if(t.length<2)throw new Error("Gradient stop list needs to contain at least two stops.");var i=this._stops;if(i)for(var n=0,r=i.length;n<r;n++)i[n]._owner=e;i=this._stops=q.readAll(t,0,{clone:!0});for(var n=0,r=i.length;n<r;n++)i[n]._owner=this;this._changed()},getRadial:function(){return this._radial},setRadial:function(t){this._radial=t,this._changed()},equals:function(t){if(t===this)return!0;if(t&&this._class===t._class){var e=this._stops,i=t._stops,n=e.length;if(n===i.length){for(var r=0;r<n;r++)if(!e[r].equals(i[r]))return!1;return!0}}return!1}}),q=r.extend({_class:"GradientStop",initialize:function(t,i){var n=t,r=i;"object"==typeof t&&i===e&&(Array.isArray(t)&&"number"!=typeof t[0]?(n=t[0],r=t[1]):("color"in t||"offset"in t||"rampPoint"in t)&&(n=t.color,r=t.offset||t.rampPoint||0)),this.setColor(n),this.setOffset(r)},clone:function(){return new q(this._color.clone(),this._offset)},_serialize:function(t,e){var i=this._color,n=this._offset;return r.serialize(null==n?[i]:[i,n],t,!0,e)},_changed:function(){this._owner&&this._owner._changed(65)},getOffset:function(){return this._offset},setOffset:function(t){this._offset=t,this._changed()},getRampPoint:"#getOffset",setRampPoint:"#setOffset",getColor:function(){return this._color},setColor:function(){var t=F.read(arguments,0,{clone:!0});t&&(t._owner=this),this._color=t,this._changed()},equals:function(t){return t===this||t&&this._class===t._class&&this._color.equals(t._color)&&this._offset==t._offset||!1}}),V=r.extend(new function(){var t={fillColor:null,fillRule:"nonzero",strokeColor:null,strokeWidth:1,strokeCap:"butt",strokeJoin:"miter",strokeScaling:!0,miterLimit:10,dashOffset:0,dashArray:[],shadowColor:null,shadowBlur:0,shadowOffset:new c,selectedColor:null},i=r.set({},t,{fontFamily:"sans-serif",fontWeight:"normal",fontSize:12,leading:null,justification:"left"}),n=r.set({},i,{fillColor:new F}),s={strokeWidth:97,strokeCap:97,strokeJoin:97,strokeScaling:105,miterLimit:97,fontFamily:9,fontWeight:9,fontSize:9,font:9,leading:9,justification:9},a={beans:!0},o={_class:"Style",beans:!0,initialize:function(e,r,s){this._values={},this._owner=r,this._project=r&&r._project||s||paper.project,this._defaults=!r||r instanceof x?i:r instanceof D?n:t,e&&this.set(e)}};return r.each(i,function(t,i){var n=/Color$/.test(i),h="shadowOffset"===i,u=r.capitalize(i),l=s[i],d="set"+u,f="get"+u;o[d]=function(t){var r=this._owner,s=r&&r._children;if(s&&s.length>0&&!(r instanceof N))for(var a=0,o=s.length;a<o;a++)s[a]._style[d](t);else if(i in this._defaults){var h=this._values[i];h!==t&&(n&&(h&&h._owner!==e&&(h._owner=e),t&&t.constructor===F&&(t._owner&&(t=t.clone()),t._owner=r)),this._values[i]=t,r&&r._changed(l||65))}},o[f]=function(t){var s,a=this._owner,o=a&&a._children;if(i in this._defaults&&(!o||0===o.length||t||a instanceof N)){var s=this._values[i];if(s===e)s=this._defaults[i],s&&s.clone&&(s=s.clone());else{var u=n?F:h?c:null;!u||s&&s.constructor===u||(this._values[i]=s=u.read([s],0,{readNull:!0,clone:!0}),s&&n&&(s._owner=a))}}else if(o)for(var l=0,d=o.length;l<d;l++){var _=o[l]._style[f]();if(0===l)s=_;else if(!r.equals(s,_))return e}return s},a[f]=function(t){return this._style[f](t)},a[d]=function(t){this._style[d](t)}}),r.each({Font:"FontFamily",WindingRule:"FillRule"},function(t,e){var i="get"+e,n="set"+e;o[i]=a[i]="#get"+t,o[n]=a[n]="#set"+t}),w.inject(a),o},{set:function(t){var e=t instanceof V,i=e?t._values:t;if(i)for(var n in i)if(n in this._defaults){var r=i[n];
	this[n]=r&&e&&r.clone?r.clone():r}},equals:function(t){return t===this||t&&this._class===t._class&&r.equals(this._values,t._values)||!1},hasFill:function(){var t=this.getFillColor();return!!t&&t.alpha>0},hasStroke:function(){var t=this.getStrokeColor();return!!t&&t.alpha>0&&this.getStrokeWidth()>0},hasShadow:function(){var t=this.getShadowColor();return!!t&&t.alpha>0&&(this.getShadowBlur()>0||!this.getShadowOffset().isZero())},getView:function(){return this._project._view},getFontStyle:function(){var t=this.getFontSize();return this.getFontWeight()+" "+t+(/[a-z]/i.test(t+"")?" ":"px ")+this.getFontFamily()},getFont:"#getFontFamily",setFont:"#setFontFamily",getLeading:function wt(){var t=wt.base.call(this),e=this.getFontSize();return/pt|em|%|px/.test(e)&&(e=this.getView().getPixelSize(e)),null!=t?t:1.2*e}}),H=new function(){function t(t,e,i,n){for(var r=["","webkit","moz","Moz","ms","o"],s=e[0].toUpperCase()+e.substring(1),a=0;a<6;a++){var o=r[a],h=o?o+s:e;if(h in t){if(!i)return t[h];t[h]=n;break}}}return{getStyles:function(t){var e=t&&9!==t.nodeType?t.ownerDocument:t,i=e&&e.defaultView;return i&&i.getComputedStyle(t,"")},getBounds:function(t,e){var i,n=t.ownerDocument,r=n.body,s=n.documentElement;try{i=t.getBoundingClientRect()}catch(a){i={left:0,top:0,width:0,height:0}}var o=i.left-(s.clientLeft||r.clientLeft||0),h=i.top-(s.clientTop||r.clientTop||0);if(!e){var u=n.defaultView;o+=u.pageXOffset||s.scrollLeft||r.scrollLeft,h+=u.pageYOffset||s.scrollTop||r.scrollTop}return new g(o,h,i.width,i.height)},getViewportBounds:function(t){var e=t.ownerDocument,i=e.defaultView,n=e.documentElement;return new g(0,0,i.innerWidth||n.clientWidth,i.innerHeight||n.clientHeight)},getOffset:function(t,e){return H.getBounds(t,e).getPoint()},getSize:function(t){return H.getBounds(t,!0).getSize()},isInvisible:function(t){return H.getSize(t).equals(new f(0,0))},isInView:function(t){return!H.isInvisible(t)&&H.getViewportBounds(t).intersects(H.getBounds(t,!0))},isInserted:function(t){return n.body.contains(t)},getPrefixed:function(e,i){return e&&t(e,i)},setPrefixed:function(e,i,n){if("object"==typeof i)for(var r in i)t(e,r,!0,i[r]);else t(e,i,!0,n)}}},Z={add:function(t,e){if(t)for(var i in e)for(var n=e[i],r=i.split(/[\s,]+/g),s=0,a=r.length;s<a;s++)t.addEventListener(r[s],n,!1)},remove:function(t,e){if(t)for(var i in e)for(var n=e[i],r=i.split(/[\s,]+/g),s=0,a=r.length;s<a;s++)t.removeEventListener(r[s],n,!1)},getPoint:function(t){var e=t.targetTouches?t.targetTouches.length?t.targetTouches[0]:t.changedTouches[0]:t;return new c(e.pageX||e.clientX+n.documentElement.scrollLeft,e.pageY||e.clientY+n.documentElement.scrollTop)},getTarget:function(t){return t.target||t.srcElement},getRelatedTarget:function(t){return t.relatedTarget||t.toElement},getOffset:function(t,e){return Z.getPoint(t).subtract(H.getOffset(e||Z.getTarget(t)))}};Z.requestAnimationFrame=new function(){function t(){var e=s;s=[];for(var i=0,a=e.length;i<a;i++)e[i]();r=n&&s.length,r&&n(t)}var e,n=H.getPrefixed(i,"requestAnimationFrame"),r=!1,s=[];return function(i){s.push(i),n?r||(n(t),r=!0):e||(e=setInterval(t,1e3/60))}};var U=r.extend(s,{_class:"View",initialize:function xt(t,e){function r(t){return e[t]||parseInt(e.getAttribute(t),10)}function s(){var t=H.getSize(e);return t.isNaN()||t.isZero()?new f(r("width"),r("height")):t}var o;if(i&&e){this._id=e.getAttribute("id"),null==this._id&&e.setAttribute("id",this._id="view-"+xt._id++),Z.add(e,this._viewEvents);var h="none";if(H.setPrefixed(e.style,{userDrag:h,userSelect:h,touchCallout:h,contentZooming:h,tapHighlightColor:"rgba(0,0,0,0)"}),a.hasAttribute(e,"resize")){var u=this;Z.add(i,this._windowEvents={resize:function(){u.setViewSize(s())}})}if(o=s(),a.hasAttribute(e,"stats")&&"undefined"!=typeof Stats){this._stats=new Stats;var l=this._stats.domElement,c=l.style,d=H.getOffset(e);c.position="absolute",c.left=d.x+"px",c.top=d.y+"px",n.body.appendChild(l)}}else o=new f(e),e=null;this._project=t,this._scope=t._scope,this._element=e,this._pixelRatio||(this._pixelRatio=i&&i.devicePixelRatio||1),this._setElementSize(o.width,o.height),this._viewSize=o,xt._views.push(this),xt._viewsById[this._id]=this,(this._matrix=new p)._owner=this,this._zoom=1,xt._focused||(xt._focused=this),this._frameItems={},this._frameItemCount=0,this._itemEvents={"native":{},virtual:{}},this._autoUpdate=!paper.agent.node,this._needsUpdate=!1},remove:function(){if(!this._project)return!1;U._focused===this&&(U._focused=null),U._views.splice(U._views.indexOf(this),1),delete U._viewsById[this._id];var t=this._project;return t._view===this&&(t._view=null),Z.remove(this._element,this._viewEvents),Z.remove(i,this._windowEvents),this._element=this._project=null,this.off("frame"),this._animate=!1,this._frameItems={},!0},_events:r.each(w._itemHandlers.concat(["onResize","onKeyDown","onKeyUp"]),function(t){this[t]={}},{onFrame:{install:function(){this.play()},uninstall:function(){this.pause()}}}),_animate:!1,_time:0,_count:0,getAutoUpdate:function(){return this._autoUpdate},setAutoUpdate:function(t){this._autoUpdate=t,t&&this.requestUpdate()},update:function(){},draw:function(){this.update()},requestUpdate:function(){if(!this._requested){var t=this;Z.requestAnimationFrame(function(){if(t._requested=!1,t._animate){t.requestUpdate();var e=t._element;H.getPrefixed(n,"hidden")&&"true"!==a.getAttribute(e,"keepalive")||!H.isInView(e)||t._handleFrame()}t._autoUpdate&&t.update()}),this._requested=!0}},play:function(){this._animate=!0,this.requestUpdate()},pause:function(){this._animate=!1},_handleFrame:function(){paper=this._scope;var t=Date.now()/1e3,e=this._last?t-this._last:0;this._last=t,this.emit("frame",new r({delta:e,time:this._time+=e,count:this._count++})),this._stats&&this._stats.update()},_animateItem:function(t,e){var i=this._frameItems;e?(i[t._id]={item:t,time:0,count:0},1===++this._frameItemCount&&this.on("frame",this._handleFrameItems)):(delete i[t._id],0===--this._frameItemCount&&this.off("frame",this._handleFrameItems))},_handleFrameItems:function(t){for(var e in this._frameItems){var i=this._frameItems[e];i.item.emit("frame",new r(t,{time:i.time+=t.delta,count:i.count++}))}},_changed:function(){this._project._changed(2049),this._bounds=null},getElement:function(){return this._element},getPixelRatio:function(){return this._pixelRatio},getResolution:function(){return 72*this._pixelRatio},getViewSize:function(){var t=this._viewSize;return new _(t.width,t.height,this,"setViewSize")},setViewSize:function(){var t=f.read(arguments),e=t.width,i=t.height,n=t.subtract(this._viewSize);n.isZero()||(this._setElementSize(e,i),this._viewSize.set(e,i),this.emit("resize",{size:t,delta:n}),this._changed(),this._autoUpdate&&this.requestUpdate())},_setElementSize:function(t,e){var i=this._element;i&&(i.width!==t&&(i.width=t),i.height!==e&&(i.height=e))},getBounds:function(){return this._bounds||(this._bounds=this._matrix.inverted()._transformBounds(new g(new c,this._viewSize))),this._bounds},getSize:function(){return this.getBounds().getSize()},getCenter:function(){return this.getBounds().getCenter()},setCenter:function(){var t=c.read(arguments);this.translate(this.getCenter().subtract(t))},getZoom:function(){return this._zoom},setZoom:function(t){this.transform((new p).scale(t/this._zoom,this.getCenter())),this._zoom=t},getMatrix:function(){return this._matrix},setMatrix:function(){var t=this._matrix;t.initialize.apply(t,arguments)},isVisible:function(){return H.isInView(this._element)},isInserted:function(){return H.isInserted(this._element)},getPixelSize:function(t){var e,i=this._element;if(i){var r=i.parentNode,s=n.createElement("div");s.style.fontSize=t,r.appendChild(s),e=parseFloat(H.getStyles(s).fontSize),r.removeChild(s)}else e=parseFloat(e);return e},getTextWidth:function(t,e){return 0}},r.each(["rotate","scale","shear","skew"],function(t){var e="rotate"===t;this[t]=function(){var i=(e?r:c).read(arguments),n=c.read(arguments,0,{readNull:!0});return this.transform((new p)[t](i,n||this.getCenter(!0)))}},{translate:function(){var t=new p;return this.transform(t.translate.apply(t,arguments))},transform:function(t){this._matrix.append(t)},scrollBy:function(){this.translate(c.read(arguments).negate())}}),{projectToView:function(){return this._matrix._transformPoint(c.read(arguments))},viewToProject:function(){return this._matrix._inverseTransform(c.read(arguments))},getEventPoint:function(t){return this.viewToProject(Z.getOffset(t,this._element))}},{statics:{_views:[],_viewsById:{},_id:0,create:function(t,e){n&&"string"==typeof e&&(e=n.getElementById(e));var r=i?W:U;return new r(t,e)}}},new function(){function t(t){var e=Z.getTarget(t);return e.getAttribute&&U._viewsById[e.getAttribute("id")]}function e(){var t=U._focused;if(!t||!t.isVisible())for(var e=0,i=U._views.length;e<i;e++)if((t=U._views[e]).isVisible()){U._focused=h=t;break}}function r(t,e,i){t._handleMouseEvent("mousemove",e,i)}function s(t,e,i,n,r,s,a){function o(t,i){if(t.responds(i)){if(h||(h=new Y(i,n,r,e||t,s?r.subtract(s):null)),t.emit(i,h)&&(I=!0,h.prevented&&(M=!0),h.stopped))return u=!0}else{var a=T[i];if(a)return o(t,a)}}for(var h,u=!1;t&&t!==a&&!o(t,i);)t=t._parent;return u}function a(t,e,i,n,r,a){return t._project.removeOn(i),M=I=!1,b&&s(b,null,i,n,r,a)||e&&e!==b&&!e.isDescendant(b)&&s(e,null,T[i]||i,n,r,a,b)||s(t,b||e||t,i,n,r,a)}if(i){var o,h,u,l,c,d=!1,f=!1,_=i.navigator;_.pointerEnabled||_.msPointerEnabled?(u="pointerdown MSPointerDown",l="pointermove MSPointerMove",c="pointerup pointercancel MSPointerUp MSPointerCancel"):(u="touchstart",l="touchmove",c="touchend touchcancel","ontouchstart"in i&&_.userAgent.match(/mobile|tablet|ip(ad|hone|od)|android|silk/i)||(u+=" mousedown",l+=" mousemove",c+=" mouseup"));var g={},v={mouseout:function(t){var e=U._focused,i=Z.getRelatedTarget(t);if(e&&(!i||"HTML"===i.nodeName)){var n=Z.getOffset(t,e._element),s=n.x,a=Math.abs,o=a(s),h=1<<25,u=o-h;n.x=a(u)<o?u*(s<0?-1:1):s,r(e,t,e.viewToProject(n))}},scroll:e};g[u]=function(e){var i=U._focused=t(e);d||(d=!0,i._handleMouseEvent("mousedown",e))},v[l]=function(i){var n=U._focused;if(!f){var s=t(i);s?n!==s&&(n&&r(n,i),o||(o=n),n=U._focused=h=s):h&&h===n&&(o&&!o.isInserted()&&(o=null),n=U._focused=o,o=null,e())}n&&r(n,i)},v[u]=function(){f=!0},v[c]=function(t){var e=U._focused;e&&d&&e._handleMouseEvent("mouseup",t),f=d=!1},Z.add(n,v),Z.add(i,{load:e});var p,m,y,w,x,b,C,S,P,I=!1,M=!1,T={doubleclick:"click",mousedrag:"mousemove"},k=!1,z={mousedown:{mousedown:1,mousedrag:1,click:1,doubleclick:1},mouseup:{mouseup:1,mousedrag:1,click:1,doubleclick:1},mousemove:{mousedrag:1,mousemove:1,mouseenter:1,mouseleave:1}};return{_viewEvents:g,_handleMouseEvent:function(t,e,i){function n(t){return r.virtual[t]||l.responds(t)||u&&u.responds(t)}var r=this._itemEvents,o=r["native"][t],h="mousemove"===t,u=this._scope.tool,l=this;h&&d&&n("mousedrag")&&(t="mousedrag"),i||(i=this.getEventPoint(e));var c=this.getBounds().contains(i),f=o&&c&&l._project.hitTest(i,{tolerance:0,fill:!0,stroke:!0}),_=f&&f.item||null,g=!1,v={};v[t.substr(5)]=!0,o&&_!==x&&(x&&s(x,null,"mouseleave",e,i),_&&s(_,null,"mouseenter",e,i),x=_),k^c&&(s(this,null,c?"mouseenter":"mouseleave",e,i),p=c?this:null,g=!0),!c&&!v.drag||i.equals(y)||(a(this,_,h?t:"mousemove",e,i,y),g=!0),k=c,(v.down&&c||v.up&&m)&&(a(this,_,t,e,i,m),v.down?(P=_===C&&Date.now()-S<300,w=C=_,b=!M&&_,m=i):v.up&&(M||_!==w||(S=Date.now(),a(this,_,P?"doubleclick":"click",e,i,m),P=!1),w=b=null),k=!1,g=!0),y=i,g&&u&&(I=u._handleMouseEvent(t,e,i,v)||I),(I&&!v.move||v.down&&n("mouseup"))&&e.preventDefault()},_handleKeyEvent:function(t,e,i,n){function r(r){r.responds(t)&&(paper=a,r.emit(t,s=s||new J(t,e,i,n)))}var s,a=this._scope,o=a.tool;this.isVisible()&&(r(this),o&&o.responds(t)&&r(o))},_countItemEvent:function(t,e){var i=this._itemEvents,n=i["native"],r=i.virtual;for(var s in z)n[s]=(n[s]||0)+(z[s][t]||0)*e;r[t]=(r[t]||0)+e},statics:{updateFocus:e}}}}),W=U.extend({_class:"CanvasView",initialize:function(t,e){if(!(e instanceof i.HTMLCanvasElement)){var n=f.read(arguments,1);if(n.isZero())throw new Error("Cannot create CanvasView with the provided argument: "+[].slice.call(arguments,1));e=Q.getCanvas(n)}var r=this._context=e.getContext("2d");if(r.save(),this._pixelRatio=1,!/^off|false$/.test(a.getAttribute(e,"hidpi"))){var s=i.devicePixelRatio||1,o=H.getPrefixed(r,"backingStorePixelRatio")||1;this._pixelRatio=s/o}U.call(this,t,e),this._needsUpdate=!0},remove:function bt(){return this._context.restore(),bt.base.call(this)},_setElementSize:function Ct(t,e){var i=this._pixelRatio;if(Ct.base.call(this,t*i,e*i),1!==i){var n=this._element,r=this._context;if(!a.hasAttribute(n,"resize")){var s=n.style;s.width=t+"px",s.height=e+"px"}r.restore(),r.save(),r.scale(i,i)}},getPixelSize:function St(t){var e,i=paper.agent;if(i&&i.firefox)e=St.base.call(this,t);else{var n=this._context,r=n.font;n.font=t+" serif",e=parseFloat(n.font),n.font=r}return e},getTextWidth:function(t,e){var i=this._context,n=i.font,r=0;i.font=t;for(var s=0,a=e.length;s<a;s++)r=Math.max(r,i.measureText(e[s]).width);return i.font=n,r},update:function(){if(!this._needsUpdate)return!1;var t=this._project,e=this._context,i=this._viewSize;return e.clearRect(0,0,i.width+1,i.height+1),t&&t.draw(e,this._matrix,this._pixelRatio),this._needsUpdate=!1,!0}}),G=r.extend({_class:"Event",initialize:function(t){this.event=t,this.type=t&&t.type},prevented:!1,stopped:!1,preventDefault:function(){this.prevented=!0,this.event.preventDefault()},stopPropagation:function(){this.stopped=!0,this.event.stopPropagation()},stop:function(){this.stopPropagation(),this.preventDefault()},getTimeStamp:function(){return this.event.timeStamp},getModifiers:function(){return X.modifiers}}),J=G.extend({_class:"KeyEvent",initialize:function(t,e,i,n){this.type=t,this.event=e,this.key=i,this.character=n},toString:function(){return"{ type: '"+this.type+"', key: '"+this.key+"', character: '"+this.character+"', modifiers: "+this.getModifiers()+" }"}}),X=new function(){function t(t){var e=t.key||t.keyIdentifier;return e=/^U\+/.test(e)?String.fromCharCode(parseInt(e.substr(2),16)):/^Arrow[A-Z]/.test(e)?e.substr(5):"Unidentified"===e?String.fromCharCode(t.keyCode):e,o[e]||(e.length>1?r.hyphenate(e):e.toLowerCase())}function e(t,i,n,a){var o,h=U._focused;if(u[i]=t,t?l[i]=n:delete l[i],i.length>1&&(o=r.camelize(i))in c){c[o]=t;var d=paper&&paper.agent;if("meta"===o&&d&&d.mac)if(t)s={};else{for(var f in s)f in l&&e(!1,f,s[f],a);s=null}}else t&&s&&(s[i]=n);h&&h._handleKeyEvent(t?"keydown":"keyup",a,i,n)}var s,a,o={"\t":"tab"," ":"space","\b":"backspace","\x7f":"delete",Spacebar:"space",Del:"delete",Win:"meta",Esc:"escape"},h={tab:"\t",space:" ",enter:"\r"},u={},l={},c=new r({shift:!1,control:!1,alt:!1,meta:!1,capsLock:!1,space:!1}).inject({option:{get:function(){return this.alt}},command:{get:function(){var t=paper&&paper.agent;return t&&t.mac?this.meta:this.control}}});return Z.add(n,{keydown:function(i){var n=t(i),r=paper&&paper.agent;n.length>1||r&&r.chrome&&(i.altKey||r.mac&&i.metaKey||!r.mac&&i.ctrlKey)?e(!0,n,h[n]||(n.length>1?"":n),i):a=n},keypress:function(i){if(a){var n=t(i),r=i.charCode,s=r>=32?String.fromCharCode(r):n.length>1?"":n;n!==a&&(n=s.toLowerCase()),e(!0,n,s,i),a=null}},keyup:function(i){var n=t(i);n in l&&e(!1,n,l[n],i)}}),Z.add(i,{blur:function(t){for(var i in l)e(!1,i,l[i],t)}}),{modifiers:c,isDown:function(t){return!!u[t]}}},Y=G.extend({_class:"MouseEvent",initialize:function(t,e,i,n,r){this.type=t,this.event=e,this.point=i,this.target=n,this.delta=r},toString:function(){return"{ type: '"+this.type+"', point: "+this.point+", target: "+this.target+(this.delta?", delta: "+this.delta:"")+", modifiers: "+this.getModifiers()+" }"}}),$=G.extend({_class:"ToolEvent",_item:null,initialize:function(t,e,i){this.tool=t,this.type=e,this.event=i},_choosePoint:function(t,e){return t?t:e?e.clone():null},getPoint:function(){return this._choosePoint(this._point,this.tool._point)},setPoint:function(t){this._point=t},getLastPoint:function(){return this._choosePoint(this._lastPoint,this.tool._lastPoint)},setLastPoint:function(t){this._lastPoint=t},getDownPoint:function(){return this._choosePoint(this._downPoint,this.tool._downPoint)},setDownPoint:function(t){this._downPoint=t},getMiddlePoint:function(){return!this._middlePoint&&this.tool._lastPoint?this.tool._point.add(this.tool._lastPoint).divide(2):this._middlePoint},setMiddlePoint:function(t){this._middlePoint=t},getDelta:function(){return!this._delta&&this.tool._lastPoint?this.tool._point.subtract(this.tool._lastPoint):this._delta},setDelta:function(t){this._delta=t},getCount:function(){return this.tool[/^mouse(down|up)$/.test(this.type)?"_downCount":"_moveCount"]},setCount:function(t){this.tool[/^mouse(down|up)$/.test(this.type)?"downCount":"count"]=t},getItem:function(){if(!this._item){var t=this.tool._scope.project.hitTest(this.getPoint());if(t){for(var e=t.item,i=e._parent;/^(Group|CompoundPath)$/.test(i._class);)e=i,i=i._parent;this._item=e}}return this._item},setItem:function(t){this._item=t},toString:function(){return"{ type: "+this.type+", point: "+this.getPoint()+", count: "+this.getCount()+", modifiers: "+this.getModifiers()+" }"}}),K=(o.extend({_class:"Tool",_list:"tools",_reference:"tool",_events:["onMouseDown","onMouseUp","onMouseDrag","onMouseMove","onActivate","onDeactivate","onEditOptions","onKeyDown","onKeyUp"],initialize:function(t){o.call(this),this._moveCount=-1,this._downCount=-1,this._set(t)},getMinDistance:function(){return this._minDistance},setMinDistance:function(t){this._minDistance=t,null!=t&&null!=this._maxDistance&&t>this._maxDistance&&(this._maxDistance=t)},getMaxDistance:function(){return this._maxDistance},setMaxDistance:function(t){this._maxDistance=t,null!=this._minDistance&&null!=t&&t<this._minDistance&&(this._minDistance=t)},getFixedDistance:function(){return this._minDistance==this._maxDistance?this._minDistance:null},setFixedDistance:function(t){this._minDistance=this._maxDistance=t},_handleMouseEvent:function(t,e,i,n){function r(t,e){var r=i,s=a?c._point:c._downPoint||r;if(a){if(c._moveCount&&r.equals(s))return!1;if(s&&(null!=t||null!=e)){var o=r.subtract(s),h=o.getLength();if(h<(t||0))return!1;e&&(r=s.add(o.normalize(Math.min(h,e))))}c._moveCount++}return c._point=r,c._lastPoint=s||r,n.down&&(c._moveCount=-1,c._downPoint=r,c._downCount++),!0}function s(){o&&(l=c.emit(t,new $(c,t,e))||l)}paper=this._scope,n.drag&&!this.responds(t)&&(t="mousemove");var a=n.move||n.drag,o=this.responds(t),h=this.minDistance,u=this.maxDistance,l=!1,c=this;if(n.down)r(),s();else if(n.up)r(null,u),s();else if(o)for(;r(h,u);)s();return l}}),{request:function(t){var e=new i.XMLHttpRequest;return e.open((t.method||"get").toUpperCase(),t.url,r.pick(t.async,!0)),t.mimeType&&e.overrideMimeType(t.mimeType),e.onload=function(){var i=e.status;0===i||200===i?t.onLoad&&t.onLoad.call(e,e.responseText):e.onerror()},e.onerror=function(){var i=e.status,n='Could not load "'+t.url+'" (Status: '+i+")";if(!t.onError)throw new Error(n);t.onError(n,i)},e.send(null)}}),Q={canvases:[],getCanvas:function(t,e){if(!i)return null;var r,s=!0;"object"==typeof t&&(e=t.height,t=t.width),this.canvases.length?r=this.canvases.pop():(r=n.createElement("canvas"),s=!1);var a=r.getContext("2d");if(!a)throw new Error("Canvas "+r+" is unable toprovide a 2D context.");return r.width===t&&r.height===e?s&&a.clearRect(0,0,t+1,e+1):(r.width=t,r.height=e),a.save(),r},getContext:function(t,e){var i=this.getCanvas(t,e);return i?i.getContext("2d"):null},release:function(t){var e=t&&t.canvas?t.canvas:t;e&&e.getContext&&(e.getContext("2d").restore(),this.canvases.push(e))}},tt=new function(){function t(t,e,i){return.2989*t+.587*e+.114*i}function e(e,i,n,r){var s=r-t(e,i,n);f=e+s,_=i+s,g=n+s;var r=t(f,_,g),a=v(f,_,g),o=p(f,_,g);if(a<0){var h=r-a;f=r+(f-r)*r/h,_=r+(_-r)*r/h,g=r+(g-r)*r/h}if(o>255){var u=255-r,l=o-r;f=r+(f-r)*u/l,_=r+(_-r)*u/l,g=r+(g-r)*u/l}}function i(t,e,i){return p(t,e,i)-v(t,e,i)}function n(t,e,i,n){var r,s=[t,e,i],a=p(t,e,i),o=v(t,e,i);o=o===t?0:o===e?1:2,a=a===t?0:a===e?1:2,r=0===v(o,a)?1===p(o,a)?2:1:0,s[a]>s[o]?(s[r]=(s[r]-s[o])*n/(s[a]-s[o]),s[a]=n):s[r]=s[a]=0,s[o]=0,f=s[0],_=s[1],g=s[2]}var s,a,o,h,u,l,c,d,f,_,g,v=Math.min,p=Math.max,m=Math.abs,y={multiply:function(){f=u*s/255,_=l*a/255,g=c*o/255},screen:function(){f=u+s-u*s/255,_=l+a-l*a/255,g=c+o-c*o/255},overlay:function(){f=u<128?2*u*s/255:255-2*(255-u)*(255-s)/255,_=l<128?2*l*a/255:255-2*(255-l)*(255-a)/255,g=c<128?2*c*o/255:255-2*(255-c)*(255-o)/255},"soft-light":function(){var t=s*u/255;f=t+u*(255-(255-u)*(255-s)/255-t)/255,t=a*l/255,_=t+l*(255-(255-l)*(255-a)/255-t)/255,t=o*c/255,g=t+c*(255-(255-c)*(255-o)/255-t)/255},"hard-light":function(){f=s<128?2*s*u/255:255-2*(255-s)*(255-u)/255,_=a<128?2*a*l/255:255-2*(255-a)*(255-l)/255,g=o<128?2*o*c/255:255-2*(255-o)*(255-c)/255},"color-dodge":function(){f=0===u?0:255===s?255:v(255,255*u/(255-s)),_=0===l?0:255===a?255:v(255,255*l/(255-a)),g=0===c?0:255===o?255:v(255,255*c/(255-o))},"color-burn":function(){f=255===u?255:0===s?0:p(0,255-255*(255-u)/s),_=255===l?255:0===a?0:p(0,255-255*(255-l)/a),g=255===c?255:0===o?0:p(0,255-255*(255-c)/o)},darken:function(){f=u<s?u:s,_=l<a?l:a,g=c<o?c:o},lighten:function(){f=u>s?u:s,_=l>a?l:a,g=c>o?c:o},difference:function(){f=u-s,f<0&&(f=-f),_=l-a,_<0&&(_=-_),g=c-o,g<0&&(g=-g)},exclusion:function(){f=u+s*(255-u-u)/255,_=l+a*(255-l-l)/255,g=c+o*(255-c-c)/255},hue:function(){n(s,a,o,i(u,l,c)),e(f,_,g,t(u,l,c))},saturation:function(){n(u,l,c,i(s,a,o)),e(f,_,g,t(u,l,c))},luminosity:function(){e(u,l,c,t(s,a,o))},color:function(){e(s,a,o,t(u,l,c))},add:function(){f=v(u+s,255),_=v(l+a,255),g=v(c+o,255)},subtract:function(){f=p(u-s,0),_=p(l-a,0),g=p(c-o,0)},average:function(){f=(u+s)/2,_=(l+a)/2,g=(c+o)/2},negation:function(){f=255-m(255-s-u),_=255-m(255-a-l),g=255-m(255-o-c)}},w=this.nativeModes=r.each(["source-over","source-in","source-out","source-atop","destination-over","destination-in","destination-out","destination-atop","lighter","darker","copy","xor"],function(t){this[t]=!0},{}),x=Q.getContext(1,1);x&&(r.each(y,function(t,e){var i="darken"===e,n=!1;x.save();try{x.fillStyle=i?"#300":"#a00",x.fillRect(0,0,1,1),x.globalCompositeOperation=e,x.globalCompositeOperation===e&&(x.fillStyle=i?"#a00":"#300",x.fillRect(0,0,1,1),n=x.getImageData(0,0,1,1).data[0]!==i?170:51)}catch(r){}x.restore(),w[e]=n}),Q.release(x)),this.process=function(t,e,i,n,r){var v=e.canvas,p="normal"===t;if(p||w[t])i.save(),i.setTransform(1,0,0,1,0,0),i.globalAlpha=n,p||(i.globalCompositeOperation=t),i.drawImage(v,r.x,r.y),i.restore();else{var m=y[t];if(!m)return;for(var x=i.getImageData(r.x,r.y,v.width,v.height),b=x.data,C=e.getImageData(0,0,v.width,v.height).data,S=0,P=b.length;S<P;S+=4){s=C[S],u=b[S],a=C[S+1],l=b[S+1],o=C[S+2],c=b[S+2],h=C[S+3],d=b[S+3],m();var I=h*n/255,M=1-I;b[S]=I*f+M*u,b[S+1]=I*_+M*l,b[S+2]=I*g+M*c,b[S+3]=h*n+M*d}i.putImageData(x,r.x,r.y)}}},et=new function(){function t(t,e,s){return i(n.createElementNS(r,t),e,s)}function e(t,e){var i=o[e],n=i?t.getAttributeNS(i,e):t.getAttribute(e);return"null"===n?null:n}function i(t,e,i){for(var n in e){var r=e[n],s=o[n];"number"==typeof r&&i&&(r=i.number(r)),s?t.setAttributeNS(s,n,r):t.setAttribute(n,r)}return t}var r="http://www.w3.org/2000/svg",s="http://www.w3.org/2000/xmlns",a="http://www.w3.org/1999/xlink",o={href:a,xlink:s,xmlns:s+"/","xmlns:xlink":s+"/"};return{svg:r,xmlns:s,xlink:a,create:t,get:e,set:i}},it=r.each({fillColor:["fill","color"],fillRule:["fill-rule","string"],strokeColor:["stroke","color"],strokeWidth:["stroke-width","number"],strokeCap:["stroke-linecap","string"],strokeJoin:["stroke-linejoin","string"],strokeScaling:["vector-effect","lookup",{"true":"none","false":"non-scaling-stroke"},function(t,e){return!e&&(t instanceof A||t instanceof C||t instanceof D)}],miterLimit:["stroke-miterlimit","number"],dashArray:["stroke-dasharray","array"],dashOffset:["stroke-dashoffset","number"],fontFamily:["font-family","string"],fontWeight:["font-weight","string"],fontSize:["font-size","number"],justification:["text-anchor","lookup",{left:"start",center:"middle",right:"end"}],opacity:["opacity","number"],blendMode:["mix-blend-mode","style"]},function(t,e){var i=r.capitalize(e),n=t[2];this[e]={type:t[1],property:e,attribute:t[0],toSVG:n,fromSVG:n&&r.each(n,function(t,e){this[t]=e},{}),exportFilter:t[3],get:"get"+i,set:"set"+i}},{});return new function(){function t(t,e,i){var n=new r,s=t.getTranslation();if(e){t=t._shiftless();var a=t._inverseTransform(s);n[i?"cx":"x"]=a.x,n[i?"cy":"y"]=a.y,s=null}if(!t.isIdentity()){var o=t.decompose();if(o){var h=[],l=o.rotation,c=o.scaling,d=o.skewing;s&&!s.isZero()&&h.push("translate("+S.point(s)+")"),l&&h.push("rotate("+S.number(l)+")"),u.isZero(c.x-1)&&u.isZero(c.y-1)||h.push("scale("+S.point(c)+")"),d&&d.x&&h.push("skewX("+S.number(d.x)+")"),d&&d.y&&h.push("skewY("+S.number(d.y)+")"),n.transform=h.join(" ")}else n.transform="matrix("+t.getValues().join(",")+")"}return n}function e(e,i){for(var n=t(e._matrix),r=e._children,s=et.create("g",n,S),a=0,o=r.length;a<o;a++){var h=r[a],u=b(h,i);if(u)if(h.isClipMask()){var l=et.create("clipPath");l.appendChild(u),m(h,l,"clip"),et.set(s,{"clip-path":"url(#"+l.id+")"})}else s.appendChild(u)}return s}function n(e,i){var n=t(e._matrix,!0),r=e.getSize(),s=e.getImage();return n.x-=r.width/2,n.y-=r.height/2,n.width=r.width,n.height=r.height,n.href=i.embedImages===!1&&s&&s.src||e.toDataURL(),et.create("image",n,S)}function s(e,i){var n=i.matchShapes;if(n){var r=e.toShape(!1);if(r)return a(r,i)}var s,o=e._segments,h=o.length,u=t(e._matrix);if(n&&h>=2&&!e.hasHandles())if(h>2){s=e._closed?"polygon":"polyline";for(var l=[],c=0;c<h;c++)l.push(S.point(o[c]._point));u.points=l.join(" ")}else{s="line";var d=o[0]._point,f=o[1]._point;u.set({x1:d.x,y1:d.y,x2:f.x,y2:f.y})}else s="path",u.d=e.getPathData(null,i.precision);return et.create(s,u,S)}function a(e){var i=e._type,n=e._radius,r=t(e._matrix,!0,"rectangle"!==i);if("rectangle"===i){i="rect";var s=e._size,a=s.width,o=s.height;r.x-=a/2,r.y-=o/2,r.width=a,r.height=o,n.isZero()&&(n=null)}return n&&("circle"===i?r.r=n:(r.rx=n.width,r.ry=n.height)),et.create(i,r,S)}function o(e,i){var n=t(e._matrix),r=e.getPathData(null,i.precision);return r&&(n.d=r),et.create("path",n,S)}function c(e,i){var n=t(e._matrix,!0),r=e._definition,s=v(r,"symbol"),a=r._item,o=a.getBounds();return s||(s=et.create("symbol",{viewBox:S.rectangle(o)}),s.appendChild(b(a,i)),m(r,s,"symbol")),n.href="#"+s.id,n.x+=o.x,n.y+=o.y,n.width=o.width,n.height=o.height,n.overflow="visible",et.create("use",n,S)}function d(t){var e=v(t,"color");if(!e){var i,n=t.getGradient(),r=n._radial,s=t.getOrigin(),a=t.getDestination();if(r){i={cx:s.x,cy:s.y,r:s.getDistance(a)};var o=t.getHighlight();o&&(i.fx=o.x,i.fy=o.y)}else i={x1:s.x,y1:s.y,x2:a.x,y2:a.y};i.gradientUnits="userSpaceOnUse",e=et.create((r?"radial":"linear")+"Gradient",i,S);for(var h=n._stops,u=0,l=h.length;u<l;u++){var c=h[u],d=c._color,f=d.getAlpha();i={offset:c._offset||u/(l-1)},d&&(i["stop-color"]=d.toCSS(!0)),f<1&&(i["stop-opacity"]=f),e.appendChild(et.create("stop",i,S))}m(t,e,"color")}return"url(#"+e.id+")"}function f(e){var i=et.create("text",t(e._matrix,!0),S);return i.textContent=e._content,i}function _(t,e,i){var n={},s=!i&&t.getParent(),a=[];return null!=t._name&&(n.id=t._name),r.each(it,function(e){var i=e.get,o=e.type,h=t[i]();if(e.exportFilter?e.exportFilter(t,h):!s||!r.equals(s[i](),h)){if("color"===o&&null!=h){var u=h.getAlpha();u<1&&(n[e.attribute+"-opacity"]=u)}"style"===o?a.push(e.attribute+": "+h):n[e.attribute]=null==h?"none":"color"===o?h.gradient?d(h,t):h.toCSS(!0):"array"===o?h.join(","):"lookup"===o?e.toSVG[h]:h}}),a.length&&(n.style=a.join(";")),1===n.opacity&&delete n.opacity,t._visible||(n.visibility="hidden"),et.set(e,n,S)}function v(t,e){P||(P={ids:{},svgs:{}});var i=t._id||t.__id||(t.__id=l.get("svg"));return t&&P.svgs[e+"-"+i]}function m(t,e,i){P||v();var n=P.ids[i]=(P.ids[i]||0)+1;e.id=i+"-"+n,P.svgs[i+"-"+(t._id||t.__id)]=e}function x(t,e){var n=t,r=null;if(P){n="svg"===t.nodeName.toLowerCase()&&t;for(var s in P.svgs)r||(n||(n=et.create("svg"),n.appendChild(t)),r=n.insertBefore(et.create("defs"),n.firstChild)),r.appendChild(P.svgs[s]);P=null}return e.asString?(new i.XMLSerializer).serializeToString(n):n}function b(t,e,i){var n=I[t._class],r=n&&n(t,e);if(r){var s=e.onExport;s&&(r=s(t,r,e)||r);var a=JSON.stringify(t._data);a&&"{}"!==a&&"null"!==a&&r.setAttribute("data-paper-data",a)}return r&&_(t,r,i)}function C(t){return t||(t={}),S=new h(t.precision),t}var S,P,I={Group:e,Layer:e,Raster:n,Path:s,Shape:a,CompoundPath:o,SymbolItem:c,PointText:f};w.inject({exportSVG:function(t){return t=C(t),x(b(this,t,!0),t)}}),y.inject({exportSVG:function(e){e=C(e);var i=this._children,n=this.getView(),s=r.pick(e.bounds,"view"),a=e.matrix||"view"===s&&n._matrix,o=a&&p.read([a]),h="view"===s?new g([0,0],n.getViewSize()):"content"===s?w._getBounds(i,o,{stroke:!0}):g.read([s],0,{readNull:!0}),u={version:"1.1",xmlns:et.svg,"xmlns:xlink":et.xlink};h&&(u.width=h.width,u.height=h.height,(h.x||h.y)&&(u.viewBox=S.rectangle(h)));var l=et.create("svg",u,S),c=l;o&&!o.isIdentity()&&(c=l.appendChild(et.create("g",t(o),S)));for(var d=0,f=i.length;d<f;d++)c.appendChild(b(i[d],e,!0));return x(l,e)}})},new function(){function t(t,e,i,n,r){var s=et.get(t,e),a=null==s?n?null:i?"":0:i?s:parseFloat(s);return/%\s*$/.test(s)?a/100*(r?1:k[/x|^width/.test(e)?"width":"height"]):a}function s(e,i,n,r,s){return i=t(e,i||"x",!1,r,s),n=t(e,n||"y",!1,r,s),!r||null!=i&&null!=n?new c(i,n):null}function a(e,i,n,r,s){return i=t(e,i||"width",!1,r,s),n=t(e,n||"height",!1,r,s),!r||null!=i&&null!=n?new f(i,n):null}function o(t,e,i){return"none"===t?null:"number"===e?parseFloat(t):"array"===e?t?t.split(/[\s,]+/g).map(parseFloat):[]:"color"===e?P(t)||t:"lookup"===e?i[t]:t}function h(t,e,i,n){var r=t.childNodes,s="clippath"===e,a="defs"===e,o=new x,h=o._project,u=h._currentStyle,l=[];if(s||a||(o=b(o,t,n),h._currentStyle=o._style.clone()),n)for(var c=t.querySelectorAll("defs"),d=0,f=c.length;d<f;d++)M(c[d],i,!1);for(var d=0,f=r.length;d<f;d++){var _,g=r[d];1!==g.nodeType||/^defs$/i.test(g.nodeName)||!(_=M(g,i,!1))||_ instanceof I||l.push(_)}return o.addChildren(l),s&&(o=b(o.reduce(),t,n)),h._currentStyle=u,(s||a)&&(o.remove(),o=null),o}function u(t,e){for(var i=t.getAttribute("points").match(/[+-]?(?:\d*\.\d+|\d+\.?)(?:[eE][+-]?\d+)?/g),n=[],r=0,s=i.length;r<s;r+=2)n.push(new c(parseFloat(i[r]),parseFloat(i[r+1])));var a=new L(n);return"polygon"===e&&a.closePath(),a}function l(t){return A.create(t.getAttribute("d"))}function d(e,i){var n,r=(t(e,"href",!0)||"").substring(1),a="radialgradient"===i;if(r)n=z[r].getGradient(),n._radial^a&&(n=n.clone(),n._radial=a);else{for(var o=e.childNodes,h=[],u=0,l=o.length;u<l;u++){var c=o[u];1===c.nodeType&&h.push(b(new q,c))}n=new R(h,a)}var d,f,_,g="userSpaceOnUse"!==t(e,"gradientUnits",!0);a?(d=s(e,"cx","cy",!1,g),f=d.add(t(e,"r",!1,!1,g),0),_=s(e,"fx","fy",!0,g)):(d=s(e,"x1","y1",!1,g),f=s(e,"x2","y2",!1,g));var v=b(new F(n,d,f,_),e);return v._scaleToBounds=g,null}function _(t,e,i,n){if(t.transform){for(var r=(n.getAttribute(i)||"").split(/\)\s*/g),s=new p,a=0,o=r.length;a<o;a++){var h=r[a];if(!h)break;for(var u=h.split(/\(\s*/),l=u[0],c=u[1].split(/[\s,]+/g),d=0,f=c.length;d<f;d++)c[d]=parseFloat(c[d]);switch(l){case"matrix":s.append(new p(c[0],c[1],c[2],c[3],c[4],c[5]));break;case"rotate":s.rotate(c[0],c[1],c[2]);break;case"translate":s.translate(c[0],c[1]);break;case"scale":s.scale(c);break;case"skewX":s.skew(c[0],0);break;case"skewY":s.skew(0,c[0])}}t.transform(s)}}function v(t,e,i){var n="fill-opacity"===i?"getFillColor":"getStrokeColor",r=t[n]&&t[n]();r&&r.setAlpha(parseFloat(e))}function m(t,i,n){var s=t.attributes[i],a=s&&s.value;if(!a){var o=r.camelize(i);a=t.style[o],a||n.node[o]===n.parent[o]||(a=n.node[o])}return a?"none"===a?null:a:e}function b(t,i,n){var s=i.parentNode,a={node:H.getStyles(i)||{},parent:!n&&!/^defs$/i.test(s.tagName)&&H.getStyles(s)||{}};return r.each(N,function(n,r){var s=m(i,r,a);t=s!==e&&n(t,s,r,i,a)||t;
	}),t}function P(t){var e=t&&t.match(/\((?:["'#]*)([^"')]+)/),n=e&&z[e[1].replace(i.location.href.split("#")[0]+"#","")];return n&&n._scaleToBounds&&(n=n.clone(),n._scaleToBounds=!0),n}function M(t,e,i){var s,o,h,u=t.nodeName.toLowerCase(),l="#document"!==u,c=n.body;i&&l&&(k=a(t,null,null,!0)||paper.getView().getSize(),s=et.create("svg",{style:"stroke-width: 1px; stroke-miterlimit: 10"}),o=t.parentNode,h=t.nextSibling,s.appendChild(t),c.appendChild(s));var d=paper.settings,f=d.applyMatrix,_=d.insertItems;d.applyMatrix=!1,d.insertItems=!1;var g=O[u],v=g&&g(t,u,e,i)||null;if(d.insertItems=_,d.applyMatrix=f,v){!l||v instanceof x||(v=b(v,t,i));var p=e.onImport,m=l&&t.getAttribute("data-paper-data");p&&(v=p(t,v,e)||v),e.expandShapes&&v instanceof C&&(v.remove(),v=v.toPath()),m&&(v._data=JSON.parse(m))}return s&&(c.removeChild(s),o&&(h?o.insertBefore(t,h):o.appendChild(t))),i&&(z={},v&&r.pick(e.applyMatrix,f)&&v.matrix.apply(!0,!0)),v}function T(t,r,s){function a(n){try{var a="object"==typeof n?n:(new i.DOMParser).parseFromString(n,"image/svg+xml");if(!a.nodeName)throw a=null,new Error("Unsupported SVG source: "+t);paper=h,u=M(a,r,!0),r&&r.insert===!1||s._insertItem(e,u);var l=r.onLoad;l&&l(u,n)}catch(c){o(c)}}function o(t,e){var i=r.onError;if(!i)throw new Error(t);i(t,e)}if(!t)return null;r="function"==typeof r?{onLoad:r}:r||{};var h=paper,u=null;if("string"!=typeof t||/^.*</.test(t)){if("undefined"!=typeof File&&t instanceof File){var l=new FileReader;return l.onload=function(){a(l.result)},l.onerror=function(){o(l.error)},l.readAsText(t)}a(t)}else{var c=n.getElementById(t);c?a(c):K.request({url:t,async:!0,onLoad:a,onError:o})}return u}var k,z={},O={"#document":function(t,e,i,n){for(var r=t.childNodes,s=0,a=r.length;s<a;s++){var o=r[s];if(1===o.nodeType)return M(o,i,n)}},g:h,svg:h,clippath:h,polygon:u,polyline:u,path:l,lineargradient:d,radialgradient:d,image:function(e){var i=new S(t(e,"href",!0));return i.on("load",function(){var t=a(e);this.setSize(t);var i=this._matrix._transformPoint(s(e).add(t.divide(2)));this.translate(i)}),i},symbol:function(t,e,i,n){return new I(h(t,e,i,n),(!0))},defs:h,use:function(e){var i=(t(e,"href",!0)||"").substring(1),n=z[i],r=s(e);return n?n instanceof I?n.place(r):n.clone().translate(r):null},circle:function(e){return new C.Circle(s(e,"cx","cy"),t(e,"r"))},ellipse:function(t){return new C.Ellipse({center:s(t,"cx","cy"),radius:a(t,"rx","ry")})},rect:function(t){return new C.Rectangle(new g(s(t),a(t)),a(t,"rx","ry"))},line:function(t){return new L.Line(s(t,"x1","y1"),s(t,"x2","y2"))},text:function(t){var e=new j(s(t).add(s(t,"dx","dy")));return e.setContent(t.textContent.trim()||""),e}},N=r.set(r.each(it,function(t){this[t.attribute]=function(e,i){if(e[t.set]&&(e[t.set](o(i,t.type,t.fromSVG)),"color"===t.type)){var n=e[t.get]();if(n){if(n._scaleToBounds){var r=e.getBounds();n.transform((new p).translate(r.getPoint()).scale(r.getSize()))}e instanceof C&&n.transform((new p).translate(e.getPosition(!0).negate()))}}}},{}),{id:function(t,e){z[e]=t,t.setName&&t.setName(e)},"clip-path":function(t,e){var i=P(e);if(i){if(i=i.clone(),i.setClipMask(!0),!(t instanceof x))return new x(i,t);t.insertChild(0,i)}},gradientTransform:_,transform:_,"fill-opacity":v,"stroke-opacity":v,visibility:function(t,e){t.setVisible&&t.setVisible("visible"===e)},display:function(t,e){t.setVisible&&t.setVisible(null!==e)},"stop-color":function(t,e){t.setColor&&t.setColor(e)},"stop-opacity":function(t,e){t._color&&t._color.setAlpha(parseFloat(e))},offset:function(t,e){if(t.setOffset){var i=e.match(/(.*)%$/);t.setOffset(i?i[1]/100:parseFloat(e))}},viewBox:function(t,e,i,n,r){var s,h,u=new g(o(e,"array")),l=a(n,null,null,!0);if(t instanceof x){var c=l?l.divide(u.getSize()):1,h=(new p).scale(c).translate(u.getPoint().negate());s=t}else t instanceof I&&(l&&u.setSize(l),s=t._item);if(s){if("visible"!==m(n,"overflow",r)){var d=new C.Rectangle(u);d.setClipMask(!0),s.addChild(d)}h&&s.transform(h)}}});w.inject({importSVG:function(t,e){return T(t,e,this)}}),y.inject({importSVG:function(t,e){return this.activate(),T(t,e,this)}})},paper=new(a.inject(r.exports,{enumerable:!0,Base:r,Numerical:u,Key:X,DomEvent:Z,DomElement:H,document:n,window:i,Symbol:I,PlacedSymbol:P})),paper.agent.node&&__webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"./node/extend\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()))(paper), true?!(__WEBPACK_AMD_DEFINE_FACTORY__ = (paper), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof module&&module&&(module.exports=paper),paper}.call(this,"object"==typeof self?self:null);

/***/ }),
/* 293 */
/***/ (function(module, exports) {

	/*
	 * js_channel is a very lightweight abstraction on top of
	 * postMessage which defines message formats and semantics
	 * to support interactions more rich than just message passing
	 * js_channel supports:
	 *  + query/response - traditional rpc
	 *  + query/update/response - incremental async return of results
	 *    to a query
	 *  + notifications - fire and forget
	 *  + error handling
	 *
	 * js_channel is based heavily on json-rpc, but is focused at the
	 * problem of inter-iframe RPC.
	 *
	 * Message types:
	 *  There are 5 types of messages that can flow over this channel,
	 *  and you may determine what type of message an object is by
	 *  examining its parameters:
	 *  1. Requests
	 *    + integer id
	 *    + string method
	 *    + (optional) any params
	 *  2. Callback Invocations (or just "Callbacks")
	 *    + integer id
	 *    + string callback
	 *    + (optional) params
	 *  3. Error Responses (or just "Errors)
	 *    + integer id
	 *    + string error
	 *    + (optional) string message
	 *  4. Responses
	 *    + integer id
	 *    + (optional) any result
	 *  5. Notifications
	 *    + string method
	 *    + (optional) any params
	 */
	
	;var Channel = (function() {
	    "use strict";
	
	    // current transaction id, start out at a random *odd* number between 1 and a million
	    // There is one current transaction counter id per page, and it's shared between
	    // channel instances.  That means of all messages posted from a single javascript
	    // evaluation context, we'll never have two with the same id.
	    var s_curTranId = Math.floor(Math.random()*1000001);
	
	    // no two bound channels in the same javascript evaluation context may have the same origin, scope, and window.
	    // futher if two bound channels have the same window and scope, they may not have *overlapping* origins
	    // (either one or both support '*').  This restriction allows a single onMessage handler to efficiently
	    // route messages based on origin and scope.  The s_boundChans maps origins to scopes, to message
	    // handlers.  Request and Notification messages are routed using this table.
	    // Finally, channels are inserted into this table when built, and removed when destroyed.
	    var s_boundChans = { };
	
	    // add a channel to s_boundChans, throwing if a dup exists
	    function s_addBoundChan(win, origin, scope, handler) {
	        function hasWin(arr) {
	            for (var i = 0; i < arr.length; i++) if (arr[i].win === win) return true;
	            return false;
	        }
	
	        // does she exist?
	        var exists = false;
	
	
	        if (origin === '*') {
	            // we must check all other origins, sadly.
	            for (var k in s_boundChans) {
	                if (!s_boundChans.hasOwnProperty(k)) continue;
	                if (k === '*') continue;
	                if (typeof s_boundChans[k][scope] === 'object') {
	                    exists = hasWin(s_boundChans[k][scope]);
	                    if (exists) break;
	                }
	            }
	        } else {
	            // we must check only '*'
	            if ((s_boundChans['*'] && s_boundChans['*'][scope])) {
	                exists = hasWin(s_boundChans['*'][scope]);
	            }
	            if (!exists && s_boundChans[origin] && s_boundChans[origin][scope])
	            {
	                exists = hasWin(s_boundChans[origin][scope]);
	            }
	        }
	        if (exists) throw "A channel is already bound to the same window which overlaps with origin '"+ origin +"' and has scope '"+scope+"'";
	
	        if (typeof s_boundChans[origin] != 'object') s_boundChans[origin] = { };
	        if (typeof s_boundChans[origin][scope] != 'object') s_boundChans[origin][scope] = [ ];
	        s_boundChans[origin][scope].push({win: win, handler: handler});
	    }
	
	    function s_removeBoundChan(win, origin, scope) {
	        var arr = s_boundChans[origin][scope];
	        for (var i = 0; i < arr.length; i++) {
	            if (arr[i].win === win) {
	                arr.splice(i,1);
	            }
	        }
	        if (s_boundChans[origin][scope].length === 0) {
	            delete s_boundChans[origin][scope];
	        }
	    }
	
	    function s_isArray(obj) {
	        if (Array.isArray) return Array.isArray(obj);
	        else {
	            return (obj.constructor.toString().indexOf("Array") != -1);
	        }
	    }
	
	    // No two outstanding outbound messages may have the same id, period.  Given that, a single table
	    // mapping "transaction ids" to message handlers, allows efficient routing of Callback, Error, and
	    // Response messages.  Entries are added to this table when requests are sent, and removed when
	    // responses are received.
	    var s_transIds = { };
	
	    // class singleton onMessage handler
	    // this function is registered once and all incoming messages route through here.  This
	    // arrangement allows certain efficiencies, message data is only parsed once and dispatch
	    // is more efficient, especially for large numbers of simultaneous channels.
	    var s_onMessage = function(e) {
	        try {
	          var m = JSON.parse(e.data);
	          if (typeof m !== 'object' || m === null) throw "malformed";
	        } catch(e) {
	          // just ignore any posted messages that do not consist of valid JSON
	          return;
	        }
	
	        var w = e.source;
	        var o = e.origin;
	        var s, i, meth;
	
	        if (typeof m.method === 'string') {
	            var ar = m.method.split('::');
	            if (ar.length == 2) {
	                s = ar[0];
	                meth = ar[1];
	            } else {
	                meth = m.method;
	            }
	        }
	
	        if (typeof m.id !== 'undefined') i = m.id;
	
	        // w is message source window
	        // o is message origin
	        // m is parsed message
	        // s is message scope
	        // i is message id (or undefined)
	        // meth is unscoped method name
	        // ^^ based on these factors we can route the message
	
	        // if it has a method it's either a notification or a request,
	        // route using s_boundChans
	        if (typeof meth === 'string') {
	            var delivered = false;
	            if (s_boundChans[o] && s_boundChans[o][s]) {
	                for (var j = 0; j < s_boundChans[o][s].length; j++) {
	                    if (s_boundChans[o][s][j].win === w) {
	                        s_boundChans[o][s][j].handler(o, meth, m);
	                        delivered = true;
	                        break;
	                    }
	                }
	            }
	
	            if (!delivered && s_boundChans['*'] && s_boundChans['*'][s]) {
	                for (var j = 0; j < s_boundChans['*'][s].length; j++) {
	                    if (s_boundChans['*'][s][j].win === w) {
	                        s_boundChans['*'][s][j].handler(o, meth, m);
	                        break;
	                    }
	                }
	            }
	        }
	        // otherwise it must have an id (or be poorly formed
	        else if (typeof i != 'undefined') {
	            if (s_transIds[i]) s_transIds[i](o, meth, m);
	        }
	    };
	
	    // Setup postMessage event listeners
	    if (window.addEventListener) window.addEventListener('message', s_onMessage, false);
	    else if(window.attachEvent) window.attachEvent('onmessage', s_onMessage);
	
	    /* a messaging channel is constructed from a window and an origin.
	     * the channel will assert that all messages received over the
	     * channel match the origin
	     *
	     * Arguments to Channel.build(cfg):
	     *
	     *   cfg.window - the remote window with which we'll communicate
	     *   cfg.origin - the expected origin of the remote window, may be '*'
	     *                which matches any origin
	     *   cfg.scope  - the 'scope' of messages.  a scope string that is
	     *                prepended to message names.  local and remote endpoints
	     *                of a single channel must agree upon scope. Scope may
	     *                not contain double colons ('::').
	     *   cfg.debugOutput - A boolean value.  If true and window.console.log is
	     *                a function, then debug strings will be emitted to that
	     *                function.
	     *   cfg.debugOutput - A boolean value.  If true and window.console.log is
	     *                a function, then debug strings will be emitted to that
	     *                function.
	     *   cfg.postMessageObserver - A function that will be passed two arguments,
	     *                an origin and a message.  It will be passed these immediately
	     *                before messages are posted.
	     *   cfg.gotMessageObserver - A function that will be passed two arguments,
	     *                an origin and a message.  It will be passed these arguments
	     *                immediately after they pass scope and origin checks, but before
	     *                they are processed.
	     *   cfg.onReady - A function that will be invoked when a channel becomes "ready",
	     *                this occurs once both sides of the channel have been
	     *                instantiated and an application level handshake is exchanged.
	     *                the onReady function will be passed a single argument which is
	     *                the channel object that was returned from build().
	     */
	    return {
	        build: function(cfg) {
	            var debug = function(m) {
	                if (cfg.debugOutput && window.console && window.console.log) {
	                    // try to stringify, if it doesn't work we'll let javascript's built in toString do its magic
	                    try { if (typeof m !== 'string') m = JSON.stringify(m); } catch(e) { }
	                    console.log("["+chanId+"] " + m);
	                }
	            };
	
	            /* browser capabilities check */
	            if (!window.postMessage) throw("jschannel cannot run this browser, no postMessage");
	            if (!window.JSON || !window.JSON.stringify || ! window.JSON.parse) {
	                throw("jschannel cannot run this browser, no JSON parsing/serialization");
	            }
	
	            /* basic argument validation */
	            if (typeof cfg != 'object') throw("Channel build invoked without a proper object argument");
	
	            if (!cfg.window || !cfg.window.postMessage) throw("Channel.build() called without a valid window argument");
	
	            /* we'd have to do a little more work to be able to run multiple channels that intercommunicate the same
	             * window...  Not sure if we care to support that */
	            if (window === cfg.window) throw("target window is same as present window -- not allowed");
	
	            // let's require that the client specify an origin.  if we just assume '*' we'll be
	            // propagating unsafe practices.  that would be lame.
	            var validOrigin = false;
	            if (typeof cfg.origin === 'string') {
	                var oMatch;
	                if (cfg.origin === "*") validOrigin = true;
	                // allow valid domains under http and https.  Also, trim paths off otherwise valid origins.
	                else if (null !== (oMatch = cfg.origin.match(/^https?:\/\/(?:[-a-zA-Z0-9_\.])+(?::\d+)?/))) {
	                    cfg.origin = oMatch[0].toLowerCase();
	                    validOrigin = true;
	                }
	            }
	
	            if (!validOrigin) throw ("Channel.build() called with an invalid origin");
	
	            if (typeof cfg.scope !== 'undefined') {
	                if (typeof cfg.scope !== 'string') throw 'scope, when specified, must be a string';
	                if (cfg.scope.split('::').length > 1) throw "scope may not contain double colons: '::'";
	            }
	
	            /* private variables */
	            // generate a random and psuedo unique id for this channel
	            var chanId = (function () {
	                var text = "";
	                var alpha = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
	                for(var i=0; i < 5; i++) text += alpha.charAt(Math.floor(Math.random() * alpha.length));
	                return text;
	            })();
	
	            // registrations: mapping method names to call objects
	            var regTbl = { };
	            // current oustanding sent requests
	            var outTbl = { };
	            // current oustanding received requests
	            var inTbl = { };
	            // are we ready yet?  when false we will block outbound messages.
	            var ready = false;
	            var pendingQueue = [ ];
	
	            var createTransaction = function(id,origin,callbacks) {
	                var shouldDelayReturn = false;
	                var completed = false;
	
	                return {
	                    origin: origin,
	                    invoke: function(cbName, v) {
	                        // verify in table
	                        if (!inTbl[id]) throw "attempting to invoke a callback of a nonexistent transaction: " + id;
	                        // verify that the callback name is valid
	                        var valid = false;
	                        for (var i = 0; i < callbacks.length; i++) if (cbName === callbacks[i]) { valid = true; break; }
	                        if (!valid) throw "request supports no such callback '" + cbName + "'";
	
	                        // send callback invocation
	                        postMessage({ id: id, callback: cbName, params: v});
	                    },
	                    error: function(error, message) {
	                        completed = true;
	                        // verify in table
	                        if (!inTbl[id]) throw "error called for nonexistent message: " + id;
	
	                        // remove transaction from table
	                        delete inTbl[id];
	
	                        // send error
	                        postMessage({ id: id, error: error, message: message });
	                    },
	                    complete: function(v) {
	                        completed = true;
	                        // verify in table
	                        if (!inTbl[id]) throw "complete called for nonexistent message: " + id;
	                        // remove transaction from table
	                        delete inTbl[id];
	                        // send complete
	                        postMessage({ id: id, result: v });
	                    },
	                    delayReturn: function(delay) {
	                        if (typeof delay === 'boolean') {
	                            shouldDelayReturn = (delay === true);
	                        }
	                        return shouldDelayReturn;
	                    },
	                    completed: function() {
	                        return completed;
	                    }
	                };
	            };
	
	            var setTransactionTimeout = function(transId, timeout, method) {
	              return window.setTimeout(function() {
	                if (outTbl[transId]) {
	                  // XXX: what if client code raises an exception here?
	                  var msg = "timeout (" + timeout + "ms) exceeded on method '" + method + "'";
	                  (1,outTbl[transId].error)("timeout_error", msg);
	                  delete outTbl[transId];
	                  delete s_transIds[transId];
	                }
	              }, timeout);
	            };
	
	            var onMessage = function(origin, method, m) {
	                // if an observer was specified at allocation time, invoke it
	                if (typeof cfg.gotMessageObserver === 'function') {
	                    // pass observer a clone of the object so that our
	                    // manipulations are not visible (i.e. method unscoping).
	                    // This is not particularly efficient, but then we expect
	                    // that message observers are primarily for debugging anyway.
	                    try {
	                        cfg.gotMessageObserver(origin, m);
	                    } catch (e) {
	                        debug("gotMessageObserver() raised an exception: " + e.toString());
	                    }
	                }
	
	                // now, what type of message is this?
	                if (m.id && method) {
	                    // a request!  do we have a registered handler for this request?
	                    if (regTbl[method]) {
	                        var trans = createTransaction(m.id, origin, m.callbacks ? m.callbacks : [ ]);
	                        inTbl[m.id] = { };
	                        try {
	                            // callback handling.  we'll magically create functions inside the parameter list for each
	                            // callback
	                            if (m.callbacks && s_isArray(m.callbacks) && m.callbacks.length > 0) {
	                                for (var i = 0; i < m.callbacks.length; i++) {
	                                    var path = m.callbacks[i];
	                                    var obj = m.params;
	                                    var pathItems = path.split('/');
	                                    for (var j = 0; j < pathItems.length - 1; j++) {
	                                        var cp = pathItems[j];
	                                        if (typeof obj[cp] !== 'object') obj[cp] = { };
	                                        obj = obj[cp];
	                                    }
	                                    obj[pathItems[pathItems.length - 1]] = (function() {
	                                        var cbName = path;
	                                        return function(params) {
	                                            return trans.invoke(cbName, params);
	                                        };
	                                    })();
	                                }
	                            }
	                            var resp = regTbl[method](trans, m.params);
	                            if (!trans.delayReturn() && !trans.completed()) trans.complete(resp);
	                        } catch(e) {
	                            // automagic handling of exceptions:
	                            var error = "runtime_error";
	                            var message = null;
	                            // * if it's a string then it gets an error code of 'runtime_error' and string is the message
	                            if (typeof e === 'string') {
	                                message = e;
	                            } else if (typeof e === 'object') {
	                                // either an array or an object
	                                // * if it's an array of length two, then  array[0] is the code, array[1] is the error message
	                                if (e && s_isArray(e) && e.length == 2) {
	                                    error = e[0];
	                                    message = e[1];
	                                }
	                                // * if it's an object then we'll look form error and message parameters
	                                else if (typeof e.error === 'string') {
	                                    error = e.error;
	                                    if (!e.message) message = "";
	                                    else if (typeof e.message === 'string') message = e.message;
	                                    else e = e.message; // let the stringify/toString message give us a reasonable verbose error string
	                                }
	                            }
	
	                            // message is *still* null, let's try harder
	                            if (message === null) {
	                                try {
	                                    message = JSON.stringify(e);
	                                    /* On MSIE8, this can result in 'out of memory', which
	                                     * leaves message undefined. */
	                                    if (typeof(message) == 'undefined')
	                                      message = e.toString();
	                                } catch (e2) {
	                                    message = e.toString();
	                                }
	                            }
	
	                            trans.error(error,message);
	                        }
	                    }
	                } else if (m.id && m.callback) {
	                    if (!outTbl[m.id] ||!outTbl[m.id].callbacks || !outTbl[m.id].callbacks[m.callback])
	                    {
	                        debug("ignoring invalid callback, id:"+m.id+ " (" + m.callback +")");
	                    } else {
	                        // XXX: what if client code raises an exception here?
	                        outTbl[m.id].callbacks[m.callback](m.params);
	                    }
	                } else if (m.id) {
	                    if (!outTbl[m.id]) {
	                        debug("ignoring invalid response: " + m.id);
	                    } else {
	                        // XXX: what if client code raises an exception here?
	                        if (m.error) {
	                            (1,outTbl[m.id].error)(m.error, m.message);
	                        } else {
	                            if (m.result !== undefined) (1,outTbl[m.id].success)(m.result);
	                            else (1,outTbl[m.id].success)();
	                        }
	                        delete outTbl[m.id];
	                        delete s_transIds[m.id];
	                    }
	                } else if (method) {
	                    // tis a notification.
	                    if (regTbl[method]) {
	                        // yep, there's a handler for that.
	                        // transaction has only origin for notifications.
	                        regTbl[method]({ origin: origin }, m.params);
	                        // if the client throws, we'll just let it bubble out
	                        // what can we do?  Also, here we'll ignore return values
	                    }
	                }
	            };
	
	            // now register our bound channel for msg routing
	            s_addBoundChan(cfg.window, cfg.origin, ((typeof cfg.scope === 'string') ? cfg.scope : ''), onMessage);
	
	            // scope method names based on cfg.scope specified when the Channel was instantiated
	            var scopeMethod = function(m) {
	                if (typeof cfg.scope === 'string' && cfg.scope.length) m = [cfg.scope, m].join("::");
	                return m;
	            };
	
	            // a small wrapper around postmessage whose primary function is to handle the
	            // case that clients start sending messages before the other end is "ready"
	            var postMessage = function(msg, force) {
	                if (!msg) throw "postMessage called with null message";
	
	                // delay posting if we're not ready yet.
	                var verb = (ready ? "post  " : "queue ");
	                debug(verb + " message: " + JSON.stringify(msg));
	                if (!force && !ready) {
	                    pendingQueue.push(msg);
	                } else {
	                    if (typeof cfg.postMessageObserver === 'function') {
	                        try {
	                            cfg.postMessageObserver(cfg.origin, msg);
	                        } catch (e) {
	                            debug("postMessageObserver() raised an exception: " + e.toString());
	                        }
	                    }
	
	                    cfg.window.postMessage(JSON.stringify(msg), cfg.origin);
	                }
	            };
	
	            var onReady = function(trans, type) {
	                debug('ready msg received');
	                if (ready) throw "received ready message while in ready state.  help!";
	
	                if (type === 'ping') {
	                    chanId += '-R';
	                } else {
	                    chanId += '-L';
	                }
	
	                obj.unbind('__ready'); // now this handler isn't needed any more.
	                ready = true;
	                debug('ready msg accepted.');
	
	                if (type === 'ping') {
	                    obj.notify({ method: '__ready', params: 'pong' });
	                }
	
	                // flush queue
	                while (pendingQueue.length) {
	                    postMessage(pendingQueue.pop());
	                }
	
	                // invoke onReady observer if provided
	                if (typeof cfg.onReady === 'function') cfg.onReady(obj);
	            };
	
	            var obj = {
	                // tries to unbind a bound message handler.  returns false if not possible
	                unbind: function (method) {
	                    if (regTbl[method]) {
	                        if (!(delete regTbl[method])) throw ("can't delete method: " + method);
	                        return true;
	                    }
	                    return false;
	                },
	                bind: function (method, cb) {
	                    if (!method || typeof method !== 'string') throw "'method' argument to bind must be string";
	                    if (!cb || typeof cb !== 'function') throw "callback missing from bind params";
	
	                    if (regTbl[method]) throw "method '"+method+"' is already bound!";
	                    regTbl[method] = cb;
	                    return this;
	                },
	                call: function(m) {
	                    if (!m) throw 'missing arguments to call function';
	                    if (!m.method || typeof m.method !== 'string') throw "'method' argument to call must be string";
	                    if (!m.success || typeof m.success !== 'function') throw "'success' callback missing from call";
	
	                    // now it's time to support the 'callback' feature of jschannel.  We'll traverse the argument
	                    // object and pick out all of the functions that were passed as arguments.
	                    var callbacks = { };
	                    var callbackNames = [ ];
	                    var seen = [ ];
	
	                    var pruneFunctions = function (path, obj) {
	                        if (seen.indexOf(obj) >= 0) {
	                            throw "params cannot be a recursive data structure"
	                        }
	                        seen.push(obj);
	                       
	                        if (typeof obj === 'object') {
	                            for (var k in obj) {
	                                if (!obj.hasOwnProperty(k)) continue;
	                                var np = path + (path.length ? '/' : '') + k;
	                                if (typeof obj[k] === 'function') {
	                                    callbacks[np] = obj[k];
	                                    callbackNames.push(np);
	                                    delete obj[k];
	                                } else if (typeof obj[k] === 'object') {
	                                    pruneFunctions(np, obj[k]);
	                                }
	                            }
	                        }
	                    };
	                    pruneFunctions("", m.params);
	
	                    // build a 'request' message and send it
	                    var msg = { id: s_curTranId, method: scopeMethod(m.method), params: m.params };
	                    if (callbackNames.length) msg.callbacks = callbackNames;
	
	                    if (m.timeout)
	                      // XXX: This function returns a timeout ID, but we don't do anything with it.
	                      // We might want to keep track of it so we can cancel it using clearTimeout()
	                      // when the transaction completes.
	                      setTransactionTimeout(s_curTranId, m.timeout, scopeMethod(m.method));
	
	                    // insert into the transaction table
	                    outTbl[s_curTranId] = { callbacks: callbacks, error: m.error, success: m.success };
	                    s_transIds[s_curTranId] = onMessage;
	
	                    // increment current id
	                    s_curTranId++;
	
	                    postMessage(msg);
	                },
	                notify: function(m) {
	                    if (!m) throw 'missing arguments to notify function';
	                    if (!m.method || typeof m.method !== 'string') throw "'method' argument to notify must be string";
	
	                    // no need to go into any transaction table
	                    postMessage({ method: scopeMethod(m.method), params: m.params });
	                },
	                destroy: function () {
	                    s_removeBoundChan(cfg.window, cfg.origin, ((typeof cfg.scope === 'string') ? cfg.scope : ''));
	                    if (window.removeEventListener) window.removeEventListener('message', onMessage, false);
	                    else if(window.detachEvent) window.detachEvent('onmessage', onMessage);
	                    ready = false;
	                    regTbl = { };
	                    inTbl = { };
	                    outTbl = { };
	                    cfg.origin = null;
	                    pendingQueue = [ ];
	                    debug("channel destroyed");
	                    chanId = "";
	                }
	            };
	
	            obj.bind('__ready', onReady);
	            setTimeout(function() {
	                postMessage({ method: scopeMethod('__ready'), params: "ping" }, true);
	            }, 0);
	
	            return obj;
	        }
	    };
	})();
	
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = Channel;

/***/ }),
/* 294 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 295 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 296 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 297 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 298 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 299 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 300 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 301 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 302 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 303 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 304 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 305 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 306 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 307 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 308 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 309 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 310 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 311 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 312 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 313 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 314 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 315 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 316 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 317 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 318 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 319 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 320 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 321 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 322 */,
/* 323 */,
/* 324 */
/***/ (function(module, exports) {

	module.exports = {"en":"english","fr":"français"}

/***/ }),
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/404.ce4cd11.png";

/***/ }),
/* 528 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0Ni43NSA0NS4zOSI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNlMjJjMjA7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5jaGFydDwvdGl0bGU+PGcgaWQ9IkNhbHF1ZV8yIiBkYXRhLW5hbWU9IkNhbHF1ZSAyIj48ZyBpZD0iQ2FscXVlXzEtMiIgZGF0YS1uYW1lPSJDYWxxdWUgMSI+PHJlY3QgY2xhc3M9ImNscy0xIiB4PSIxMy4wMSIgeT0iMTguMTYiIHdpZHRoPSI3LjcyIiBoZWlnaHQ9IjI3LjIzIi8+PHJlY3QgY2xhc3M9ImNscy0xIiB4PSIyNi4wMiIgeT0iOS4wOCIgd2lkdGg9IjcuNzIiIGhlaWdodD0iMzYuMzEiLz48cmVjdCBjbGFzcz0iY2xzLTEiIHg9IjM5LjA0IiB3aWR0aD0iNy43MSIgaGVpZ2h0PSI0NS4zOSIvPjxyZWN0IGNsYXNzPSJjbHMtMSIgeT0iMjcuMjMiIHdpZHRoPSI3LjcxIiBoZWlnaHQ9IjE4LjE2Ii8+PC9nPjwvZz48L3N2Zz4="

/***/ }),
/* 529 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 530 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 531 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 532 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 533 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0NC45NiA0NC45NSI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNlMjJjMjA7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT50YXJnZXQ8L3RpdGxlPjxnIGlkPSJDYWxxdWVfMiIgZGF0YS1uYW1lPSJDYWxxdWUgMiI+PGcgaWQ9IkNhbHF1ZV8xLTIiIGRhdGEtbmFtZT0iQ2FscXVlIDEiPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTI1Ljc5LDEzLjRBMS4wNiwxLjA2LDAsMCwwLDI1LjIsMTJhMTMuNzUsMTMuNzUsMCwxLDAsNy43Myw3Ljc0LDEuMDYsMS4wNiwwLDEsMC0yLC43OEExMS42NSwxMS42NSwwLDEsMSwyNC40MSwxNCwxLjA2LDEuMDYsMCwwLDAsMjUuNzksMTMuNFoiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0zOC4xNiwxOC41NWExLjA2LDEuMDYsMCwwLDAtLjczLDEuMzFBMTgsMTgsMCwxLDEsMjUuMDksNy41MmExLjA2LDEuMDYsMCwxLDAsLjU5LTIsMjAuMSwyMC4xLDAsMSwwLDEzLjc5LDEzLjhBMS4wNiwxLjA2LDAsMCwwLDM4LjE2LDE4LjU1WiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTIwLjEyLDE5LjUzbC40NywwYTEuMDYsMS4wNiwwLDEsMCwuMTktMi4xMWMtLjIyLDAtLjQ0LDAtLjY3LDBhNy40MSw3LjQxLDAsMSwwLDcuNDEsNy40MmMwLS4yMiwwLS40MywwLS42NWExLjA2LDEuMDYsMCwxLDAtMi4xMS4xOWMwLC4xNSwwLC4zMSwwLC40NmE1LjI5LDUuMjksMCwxLDEtNS4yOS01LjI5WiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTQ0LjgsNy4xM2EyLjEyLDIuMTIsMCwwLDAtMi0xLjMxaC0zLjdWMi4xMkEyLjEyLDIuMTIsMCwwLDAsMzUuNTIuNjJMMjkuMzQsNi44YTMuMTYsMy4xNiwwLDAsMC0uOTMsMi4yNXY2bC04LjYyLDguNjJhMS4wNiwxLjA2LDAsMSwwLDEuNSwxLjVsOC42Mi04LjYyaDZhMy4xNiwzLjE2LDAsMCwwLDIuMjUtLjkzbDYuMTgtNi4xOEEyLjExLDIuMTEsMCwwLDAsNDQuOCw3LjEzWm0tMTQsMS4xN0wzNywyLjEyVjYuNDRsLTYuNDksNi40OVY5LjA1QTEuMDUsMS4wNSwwLDAsMSwzMC44NCw4LjNabTUuODIsNS44MmExLjA3LDEuMDcsMCwwLDEtLjc1LjMxSDMybDYuNDktNi40OWg0LjMyWiIvPjwvZz48L2c+PC9zdmc+"

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/Canope.519275e.svg";

/***/ }),
/* 535 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/D-Clics-Numeriques.2008eff.svg";

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/ENSIIE.2a5b351.svg";

/***/ }),
/* 538 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 539 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA4NS41NyA0NS4yIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZmZjtmaWxsLXJ1bGU6ZXZlbm9kZDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPkZyYW5jZS1JT0k8L3RpdGxlPjxnIGlkPSJDYWxxdWVfMiIgZGF0YS1uYW1lPSJDYWxxdWUgMiI+PGcgaWQ9IkNhbHF1ZV8xLTIiIGRhdGEtbmFtZT0iQ2FscXVlIDEiPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTUyLDI1LjM1Yy4xNi4zMi4zMS42NS40OCwxYTUuMjMsNS4yMywwLDAsMCwyLjE1LDIuMDguNDUuNDUsMCwwLDEsLjI4LjUzYy0uMTUuNzEtLjI3LDEuNDMtLjQ4LDIuMTJhMTguMywxOC4zLDAsMCwxLS44NiwyLjM3LDE4Ljg0LDE4Ljg0LDAsMCwxLTMsNC45NCwxNS4zOCwxNS4zOCwwLDAsMS0yLjU5LDIuNCwxMiwxMiwwLDAsMS0zLjExLDEuNTYsMTAuMzYsMTAuMzYsMCwwLDEtMy42NC41MSwxMCwxMCwwLDAsMS0zLjUtLjgsMTMuNzQsMTMuNzQsMCwwLDEtNi01LDE2LjYzLDE2LjYzLDAsMCwxLTItMy44NywzNC43OCwzNC43OCwwLDAsMS0xLjE4LTMuNjUsMjEuNTUsMjEuNTUsMCwwLDEtLjUyLTMuNWMtLjEtMS4zMy0uMDYtMi42Ny0uMDYtNCwwLS40NC4xLS41My40OS0uNTIuNTcsMCwuNjQuMDguNjQuNTRzMCwuNjUsMCwxLC4xMy40OS40OC41MmMuNjIuMDYsMS4yNC4xNSwxLjg2LjIzLjI4LDAsLjI2LjI0LjI2LjQ0LDAsLjgyLDAsMS42NC4wNiwyLjQ1QTQsNCwwLDAsMCwzMi4wOCwyOGExLjYyLDEuNjIsMCwwLDAsMS4zMy44NGMuMzgsMCwuNTQuMjYuNjQuNjIuMjksMSwuNjIsMiwuOTMsM2ExMC45MiwxMC45MiwwLDAsMCwxLjY4LDMuMTQsNy4xNyw3LjE3LDAsMCwwLDMuNTEsMi43OSw0LjUzLDQuNTMsMCwwLDAsMy4yLS4xMyw4LjY1LDguNjUsMCwwLDAsNC4yLTQuMTUsMTYuODEsMTYuODEsMCwwLDAsMS42OC00LjYyYy4xMS0uNS4yNy0uNjMuNzctLjYzaDEuMjFjLjQ2LDAsLjU3LS4xMi41Ny0uNTgsMC0uODgsMC0xLjc3LDAtMi42NSwwLS4wOSwwLS4xNywwLS4yNloiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik01MS44NywyMS45NGMwLS41MS0uMDktMS0uMDctMS41NGEyLjEsMi4xLDAsMCwwLTEuODgtMS45Yy0uMzksMC0uNTYtLjItLjY1LS41My0uMjYtLjg5LS40Ni0xLjgxLS44LTIuNjdhMjAuNDksMjAuNDksMCwwLDAtMS4zNS0yLjc4LDguMzksOC4zOSwwLDAsMC0yLjcxLTIuOUE0Ljc5LDQuNzksMCwwLDAsNDAuMTgsOWE3LDcsMCwwLDAtMy43NSwzLjExLDIwLjQ1LDIwLjQ1LDAsMCwwLTEuNiwzLjA5LDE4Ljc5LDE4Ljc5LDAsMCwwLS43NywyLjY0Yy0uMTIuNDgtLjI3LjYzLS43Ny42M0gyOC44NWMtLjQ2LDAtLjU3LS4xMy0uNDQtLjU2LjMxLTEsLjU3LTIuMSwxLTMuMTFhMTcuNjcsMTcuNjcsMCwwLDEsNS43OS04LjA3LDExLjY2LDExLjY2LDAsMCwxLDMuNjMtMS44LDkuOTQsOS45NCwwLDAsMSw0LjgxLS4yMywxMi4yNiwxMi4yNiwwLDAsMSwyLjQ1Ljg1QTExLjk0LDExLjk0LDAsMCwxLDUwLjQ5LDksMTkuNDYsMTkuNDYsMCwwLDEsNTMsMTIuNzhhMTYuNjUsMTYuNjUsMCwwLDEsMS4yNiwzLjI4Yy4yLjc4LjM4LDEuNTYuNTgsMi4zMy4wOC4zMS0uMDcuNDgtLjMzLjYyYTQuOTMsNC45MywwLDAsMC0yLjI5LDIuNDlBNC4zOSw0LjM5LDAsMCwxLDUyLDIyWiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTEzLjA5LDE0LjQ4YzAtMi4zLDAtNC42LDAtNi45YTIuMjgsMi4yOCwwLDAsMC0xLjE3LTJBOC42OCw4LjY4LDAsMCwwLDcsNC4yNWMtLjM2LDAtLjQ2LS4xMS0uNDgtLjQ3QzYuNDcsMi44OSw2LjM2LDIsNi4yNiwxLjEsNi4yLjU3LDYuMjkuNTEsNi44LjY0czEuMjkuMywxLjk0LjQxYzEuNzMuMywzLjQ1LjYxLDUuMTguODYsMiwuMjgsMy45NC41Miw1LjkxLjcxLDEuNDUuMTMsMi45LjE0LDQuMzYuMjEuMzksMCwuNDYuMTMuNC41MnEtLjE5LDEuMjMtLjMzLDIuNDdjMCwuNDEtLjE4LjQ5LS41OS40NGE2LjQ1LDYuNDUsMCwwLDAtMy41Ni4yN0ExLjU1LDEuNTUsMCwwLDAsMTkuMSw4YzAsMi44NSwwLDUuNjksMCw4LjU0LDAsLjQ0LDAsLjg4LDAsMS4zMnMtLjE1LjUyLS41Mi41MmMtMS4yNywwLTIuNTQsMC0zLjgyLjA2LS41NywwLS42NC4wOS0uNjIuNjcsMCwuODgsMCwxLjc3LDAsMi42NSwwLC40My0uMzIuNC0uNjEuNDFzLS41LS4wOC0uNDktLjQ0YzAtMi40MywwLTQuODYsMC03LjI5WiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTcxLjA2LDIxLjE1YTYuMjUsNi4yNSwwLDAsMC0uNDUtLjcsNS4xLDUuMSwwLDAsMC0zLjI3LTEuOTJjLS41NS0uMDctMS4xMSwwLTEuNjYtLjA4YS41Ni41NiwwLDAsMS0uMzYtLjMsMS4yNywxLjI3LDAsMCwxLDAtLjVjMC0zLjE3LDAtNi4zNCwwLTkuNTFhMS45LDEuOSwwLDAsMC0xLjYtMkE4LjY3LDguNjcsMCwwLDAsNjEsNmMtLjUzLDAtLjYyLDAtLjY5LS41OHMtLjE5LTEuMzEtLjMtMmMtLjA4LS40OSwwLS41NS40OC0uNTgsMS44My0uMTEsMy42Ni0uMjEsNS40OC0uMzcsMS4xMi0uMSwyLjI0LS4yNywzLjM2LS40NC42Mi0uMDksMS4yMy0uMjEsMS44My0uMzYsMS4xNi0uMjcsMi4zMS0uNTcsMy40Ny0uODZDNzUuMTMuNjgsNzUuNjcuNTUsNzYuMi40YTEuMjYsMS4yNiwwLDAsMCwuNDQtLjI4Yy4yLS4xOC4zOC0uMTYuNDEuMUEzLjY5LDMuNjksMCwwLDEsNzcsMXEtLjEsMS4yLS4yMSwyLjRjMCwuNDctLjE0LjU0LS42LjU4QTYuMzksNi4zOSwwLDAsMCw3Miw1Ljg1YTIuNjQsMi42NCwwLDAsMC0uNzMsMS45NXEwLDYuMTMsMCwxMi4yNGMwLC4zNy0uMDcuNzMtLjEsMS4xWiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTE5LjExLDMyLjcyYzAsMS44NywwLDMuNzQsMCw1LjYxYTEuNDMsMS40MywwLDAsMCwxLjE5LDEuNDksMTkuODMsMTkuODMsMCwwLDAsMi4xNC4zNGMuNTIuMDYuNTkuMTIuNTYuNjVzMCwxLjE5LS4wNiwxLjc5YzAsLjQ0LS4xLjUzLS41Mi41Ni0xLjguMTEtMy42LjE4LTUuNC4zNS0xLjQxLjEzLTIuODEuMzQtNC4yMS41N3MtMi43LjUxLTQsLjc4YTUuMTYsNS4xNiwwLDAsMC0uNzQuMjRjLS40NC4xNi0uNTcuMDktLjY1LS4zNi0uMTQtLjgyLS4yNi0xLjY0LS4zOS0yLjQ2LS4wNS0uMzMuMTYtLjQzLjQzLS40N2EyMC4wOSwyMC4wOSwwLDAsMCwyLjIyLS40LDYuODUsNi44NSwwLDAsMCwzLjE0LTEuNTIsMS4xMiwxLjEyLDAsMCwwLC4zLS43MWMwLTQuNSwwLTksMC0xMy40OSwwLS4xOC4wNi0uNDkuMTQtLjUxYTEuNzgsMS43OCwwLDAsMSwuNzksMGMuMDgsMCwuMTUuMjUuMTUuMzksMCwuODksMCwxLjc3LDAsMi42NSwwLC40OS4xMS42LjU5LjZoMS43NWMuNDYsMCwuNTctLjExLjU3LS41OCwwLS44NiwwLTEuNzEsMC0yLjU3LDAtLjQ3LjEtLjU1LjU2LS41LjI3LDAsLjU0LDAsLjgxLjA2LjUyLDAsLjU2LjA1LjU3LjU2LjA1LDIuMy4wNyw0LjYuMTIsNi44OVoiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik03MS4xNiwyNi4yOWE2LDYsMCwwLDEsLjEuNzlxMCw1LjkxLDAsMTEuODFhMS4yOSwxLjI5LDAsMCwwLC42NSwxLjI4LDExLjI3LDExLjI3LDAsMCwwLDEuOTEuOTJjMSwuMzIsMi4xMS41MiwzLjE2Ljc2YS4zNy4zNywwLDAsMSwuMzQuNDZjLS4xMS44Ny0uMjEsMS43NS0uMzIsMi42MywwLC4zLS4yNS4yOS0uNDcuMjMtLjQ1LS4xMy0uODktLjI4LTEuMzQtLjM3LTEuNTEtLjMxLTMtLjY1LTQuNTUtLjg3LTEuNzctLjI1LTMuNTYtLjQyLTUuMzQtLjU4LTEuMTUtLjEtMi4zMS0uMTMtMy40Ni0uMTgtLjQ0LDAtLjU0LS4xMy0uNTUtLjU3LDAtLjYxLDAtMS4yMi0uMDctMS44M3MuMDctLjU2LjUyLS42MkEyMC40MSwyMC40MSwwLDAsMCw2NCwzOS43OGExLjQ0LDEuNDQsMCwwLDAsMS4zLTEuNjVjMC0yLjkxLDAtNS44MiwwLTguNzMsMC0uNC4wOS0uNDYuNDgtLjQ2YTEzLjU1LDEzLjU1LDAsMCwwLDEuODItLjA4LDMuNTksMy41OSwwLDAsMCwyLS45MkM3MC4xMiwyNy40Myw3MC42MSwyNi44Nyw3MS4xNiwyNi4yOVoiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik03NC4zNSwyNC4zMkg2My44N2MtLjE2LDAtLjQ0LjA2LS40Ni4xNmEuODMuODMsMCwwLDAsLjEzLjUzLDMuMTQsMy4xNCwwLDAsMCwxLjU3LDEuNUEyLjg5LDIuODksMCwwLDAsNjguMzgsMjYsMiwyLDAsMCwxLDcwLDI1LjY1Yy4yNSwwLC4yNS4yMy4xMy40MWE0LjQ4LDQuNDgsMCwwLDEtNS40OSwxLjY1QTQuMzksNC4zOSwwLDAsMSw2Mi4yMywyMmE0LjMsNC4zLDAsMCwxLDIuNTgtMi40OUE0LjQsNC40LDAsMCwxLDcwLDIxLjI3YTUuMDYsNS4wNiwwLDAsMSwuNTIsMS4yLjY3LjY3LDAsMCwwLC43NC41M0g4NC43NWMuNjcsMCwxLC40Mi43MywxYS44My44MywwLDAsMS0uNjQuMzFjLTEuMTcsMC0yLjM0LDAtMy41MSwwaC03Wk02OC44NSwyM2MuMzksMCwuNTItLjI0LjMxLS41NmE2LjYxLDYuNjEsMCwwLDAtLjUxLS43MywzLDMsMCwwLDAtMy45NC0uNiwzLjE5LDMuMTksMCwwLDAtMS4xMywxLjI1LjcuNywwLDAsMC0uMTEuNDhjMCwuMDkuMjguMTUuNDMuMTUuOCwwLDEuNjEsMCwyLjQyLDAiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik03LjUxLDI0LjMzSC42NWMtLjUzLDAtLjY0LS4wOC0uNjUtLjQ4QzAsMjMuMS4wNywyMywuNjUsMjNIMTQuNWMuNDMsMCwuNTMtLjEuNTMtLjUzLDAtLjkxLDAtMS44MiwwLTIuNzMsMC0uMzMuMDktLjQ2LjQ0LS40NSwxLjkyLDAsMy44NSwwLDUuNzcsMCwuNDcsMCwuNTEsMCwuNTEuNDksMCwuNy4xNi44Mi0uODEuODEtMS4yNywwLTIuNTUsMC0zLjgyLDAtLjY1LDAtLjgxLjE2LS44MS44LDAsLjMyLDAsLjY1LDAsMSwwLC41MS4xMS42My42MS42M2g0LjI1Yy41MywwLC41OC4wNS41OC41OCwwLC4xLDAsLjIxLDAsLjMxLDAsLjM0LS4xMy40NS0uNDYuNDUtMS40NCwwLTIuODgsMC00LjMzLDAtLjU1LDAtLjY1LjEtLjY1LjY3LDAsLjgyLDAsMS42NCwwLDIuNDYsMCwuMTgtLjEzLjQ4LS4yNC41YTMsMywwLDAsMS0uOTQsMHMtLjA5LS4yMy0uMDktLjM1YzAtLjg4LDAtMS43NywwLTIuNjUsMC0uNTQsMC0uNTktLjU3LS41OUg3LjUxWiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTM2LjIsMTkuMzFoMy40M2ExLjI4LDEuMjgsMCwwLDEsMS4zMiwxLjEyQTMuMywzLjMsMCwwLDEsNDEsMjFxMCwzLjE4LDAsNi4zNmMwLC42LS4wNy42OC0uNjcuNjhIMzQuMTdBMS41MSwxLjUxLDAsMCwxLDMzLDI3LjY5YTEuMjcsMS4yNywwLDAsMS0uNDMtMWMwLS43OCwwLTEuNTYsMC0yLjM0YTEuMTUsMS4xNSwwLDAsMSwxLTEuMmMuNTUtLjA1LDEuMTItLjA1LDEuNjctLjA2SDM5Yy42OCwwLC43OC0uMTMuNzEtLjgyYTQuMzYsNC4zNiwwLDAsMSwwLS44OWMuMDYtLjYtLjA3LS43OC0uNjktLjc4SDMyLjc4Yy0uNDYsMC0uNTMtLjA3LS41My0uNTEsMC0uNzktLjE1LS44MS43OS0uNzlzMi4xMSwwLDMuMTYsMFptLjYxLDUuMUgzNC40N2MtLjQyLDAtLjU2LjE0LS41Ny41NnMwLC43OCwwLDEuMTdhLjQ4LjQ4LDAsMCwwLC41Mi41NGg0Ljc2YS40Ny40NywwLDAsMCwuNTItLjU0YzAtLjM5LDAtLjc4LDAtMS4xN3MtLjExLS41Ny0uNTktLjU3WiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTQyLjcyLDIzLjY0YzAtMS4yOSwwLTIuNTcsMC0zLjg2LDAtLjM2LjEzLS40OS40OC0uNDlsNi40MywwQTEuMzMsMS4zMywwLDAsMSw1MSwyMC42MWMwLDIuMzQsMCw0LjY4LDAsN2EuMzMuMzMsMCwwLDEtLjM0LjM4aC0uNDNjLS40NiwwLS41Ni0uMTMtLjU2LS41OXEwLTIuODMsMC01LjY1YzAtLjg2LS4zLTEuMTctMS4xNy0xLjE3SDQ0LjdjLS41MiwwLS42NC4xMi0uNjQuNjUsMCwyLjEsMCw0LjIxLDAsNi4zMSwwLC4yNC0uMDguMzgtLjMxLjQxYTIuMzQsMi4zNCwwLDAsMS0uMzksMGMtLjYsMC0uNjYtLjA4LS42Ni0uNjYsMC0xLjIzLDAtMi40NywwLTMuN1oiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik01NywxOS4yOWE0LjIsNC4yLDAsMCwxLDIuOTMsMS4xNGMuMzMuMy4zMi40MywwLC43MWwtLjI2LjIzYS40MS40MSwwLDAsMS0uNjIsMCwzLDMsMCwwLDAtMy4zNC0uNTcsMi44MywyLjgzLDAsMCwwLTEuNDUsMS4zLDMuMDYsMy4wNiwwLDAsMCwxLDQuMTYsMi43OCwyLjc4LDAsMCwwLDIuNzUuMjcsNi40Niw2LjQ2LDAsMCwwLDEuMTUtLjc2Yy4xOS0uMTUuMzYtLjIxLjU2LS4wNi43Ny41Ni45NC41NS4xMSwxLjI2YTQuMzYsNC4zNiwwLDAsMS00LjE5LjlBNC4xOSw0LjE5LDAsMCwxLDUzLDI1LjY3YTQuMjQsNC4yNCwwLDAsMS0uMjUtMy40Myw0LjEzLDQuMTMsMCwwLDEsMi41My0yLjYzLDQuNTEsNC41MSwwLDAsMSwxLjctLjMyWiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTIzLjYsMjMuNjRWMTkuODJjMC0uNDQuMDgtLjUxLjUzLS41MSwxLjksMCwzLjgsMCw1LjY5LDBhMS4zOCwxLjM4LDAsMCwxLDEuNDUsMS4zNGMwLC41MiwwLDEsMCwxLjU2YS4zOC4zOCwwLDAsMS0uNDQuNDNjLS43MiwwLS45Mi4xNy0uODctLjgyLjA2LTEuMjEsMC0xLjIxLTEuMi0xLjIxaC0zYy0uNzMsMC0uODkuMTYtLjg5LjksMCwyLDAsNC4wNSwwLDYuMDgsMCwuMy0uMTIuNDQtLjQuNDVhMy43MywzLjczLDAsMCwxLS40NywwYy0uMzQsMC0uNDktLjE4LS40OS0uNTUsMC0xLjI3LDAtMi41NSwwLTMuODJaIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMzIuODEsMjEuMzdjLjE2LjEzLjQyLjIzLjQ2LjM5cy0uMTIuNDYtLjQ0LjQ5Yy0uMSwwLS4xOC4xMy0uMjguMThzLS4yLjExLS4yNy4wOS0uMTItLjE1LS4xNS0uMjRhLjc1Ljc1LDAsMCwxLDAtLjIzQzMyLjEyLDIxLjUxLDMyLjE4LDIxLjQ2LDMyLjgxLDIxLjM3WiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTE4LDIyLjIzYTUuODEsNS44MSwwLDAsMS0uNjgtLjMuMzQuMzQsMCwwLDEtLjA5LS4zLjMuMywwLDAsMSwuMjMtLjE2Yy40LDAsLjgsMCwxLjIsMGEuMzUuMzUsMCwwLDEsLjI0LjJjMCwuMDYtLjA3LjItLjE0LjI0QzE4LjUzLDIyLDE4LjI4LDIyLjEzLDE4LDIyLjIzWiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTY2LjM0LDI1LjMyYTIuNTEsMi41MSwwLDAsMSwuNSwwYy4wOSwwLC4yMy4xMi4yMy4ycy0uMS4yNS0uMTcuMjZhOCw4LDAsMCwxLTEuMTQsMGMtLjA3LDAtLjE2LS4xOS0uMTctLjI5cy4xNS0uMTUuMjUtLjE3YTIuNjksMi42OSwwLDAsMSwuNSwwWiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTU1LjQ1LDIzLjY2Yy0uMS4xOC0uMi41Mi0uMy41Mi0uMzcsMC0uMjctLjM1LS4yOS0uNTlhLjE1LjE1LDAsMCwxLDAtLjA4bC4yOC0uNDguMjIuNDdhLjMyLjMyLDAsMCwxLDAsLjExWiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTY3LjYsMjJhMi44MiwyLjgyLDAsMCwxLS41OC4xNyw2LjM1LDYuMzUsMCwwLDEtMS4xMiwwYy0uMTUsMC0uMjgtLjE3LS40Mi0uMjZhMS40NSwxLjQ1LDAsMCwxLC4zMi0uMjZBMS42OCwxLjY4LDAsMCwxLDY3LjYsMjJaIi8+PC9nPjwvZz48L3N2Zz4="

/***/ }),
/* 540 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/Ministere-Education-nationale.db3156f.svg";

/***/ }),
/* 542 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 543 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3MiAzNS42MiI+PGRlZnM+PHN0eWxlPi5jbHMtMSwuY2xzLTJ7ZmlsbDojZmZmO30uY2xzLTF7ZmlsbC1ydWxlOmV2ZW5vZGQ7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5TQVBfZ3JhZF9SX3ByZWY8L3RpdGxlPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTQxNi40MSwyODEuNzFoLTEuNTZ2NS43MWgxLjU2YzIuMDgsMCwzLjc0LS42OSwzLjc0LTIuODlTNDE4LjQ5LDI4MS43MSw0MTYuNDEsMjgxLjcxWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTM3My4yNiAtMjcwLjM4KSIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTM3My4yNiwyNzAuMzhWMzA2aDM2LjM5bDM1LjYxLTM1LjYyWm00My44NywyMS45MmgtMi4yOXY2LjhoLTEwLjVsLTEtMy4yNWExMS45LDExLjksMCwwLDEtMy42OS41NywxMS43NSwxMS43NSwwLDAsMS0zLjc4LS42bC0xLjA4LDMuMjloLTYuNDRsLjcxLTEuOS0uMjYuMjJhOS42OCw5LjY4LDAsMCwxLTYuMSwyaC0uMzdhMTYuMzcsMTYuMzcsMCwwLDEtOC0yLjEzbDIuMTktNC4zNWE5LjgsOS44LDAsMCwwLDUuODcsMS42NywzLjEyLDMuMTIsMCwwLDAsMi4yOC0uNzIsMS42NywxLjY3LDAsMCwwLC40Ny0xLjExYzAtMS4xMy0xLjU5LTEuNjYtMy41Ni0yLjI3YTE2LjU2LDE2LjU2LDAsMCwxLTQuODItMi4yLDUuNTUsNS41NSwwLDAsMS0yLjQzLTQuOTUsNiw2LDAsMCwxLDEuNy00LjEzLDkuNzUsOS43NSwwLDAsMSw3LjA5LTIuNTloMGExOS4xNiwxOS4xNiwwLDAsMSw4LDEuOWwtMi40Niw0LjI5YTExLjU5LDExLjU5LDAsMCwwLTUuMTktMS40Yy0yLjEyLS4xMS0zLjE5LjY1LTMuMjEsMS40NiwwLDEsMiwxLjksMy45MiwyLjUxLDIuODkuOTIsNi41NywyLjE1LDcuMTMsNS43bDUuMjktMTQuMDloNi4xNGw2LjE5LDE2Ljg1VjI3Ny4wN0g0MTZjNi43NywwLDEwLDIuNDIsMTAsNy42OEM0MjUuOTUsMjg5LjQ4LDQyMi42NywyOTIuMyw0MTcuMTQsMjkyLjNaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzczLjI2IC0yNzAuMzgpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMzk5LjU5LDI4NGwtMi4yNSw3LjA5YTYuNDcsNi40NywwLDAsMCwyLjI3LjQsNi42Niw2LjY2LDAsMCwwLDIuMjMtLjM4TDM5OS42MywyODRaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzczLjI2IC0yNzAuMzgpIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNNDE4LjI4LDMwMy42NmExLjg3LDEuODcsMCwxLDEsMS44OCwxLjkzQTEuODcsMS44NywwLDAsMSw0MTguMjgsMzAzLjY2Wm0xLjg4LDIuMzFhMi4zLDIuMywwLDEsMC0yLjM0LTIuMzFBMi4zLDIuMywwLDAsMCw0MjAuMTYsMzA2Wm0tLjQ5LTIuMTNoLjQ2bC43LDEuMTVoLjQ2bC0uNzYtMS4xN2EuNjkuNjksMCwwLDAsLjY5LS43M2MwLS41Mi0uMzEtLjc1LS45NC0uNzVoLTFWMzA1aC40Wm0wLS4zNHYtLjgyaC41NWMuMjgsMCwuNTcuMDYuNTcuMzlzLS4zLjQzLS42NC40M1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zNzMuMjYgLTI3MC4zOCkiLz48L3N2Zz4="

/***/ }),
/* 544 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/Vivendi-Create-Joy.33273e9.svg";

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/lEurope-sengage.13a4ffb.svg";

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/instaBannier.ed9ab12.png";

/***/ }),
/* 548 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(306)
	__webpack_require__(307)
	
	/* script */
	__vue_exports__ = __webpack_require__(197)
	
	/* template */
	var __vue_template__ = __webpack_require__(587)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-24d60c45"
	
	module.exports = __vue_exports__


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(311)
	
	/* script */
	__vue_exports__ = __webpack_require__(198)
	
	/* template */
	var __vue_template__ = __webpack_require__(594)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(303)
	
	/* script */
	__vue_exports__ = __webpack_require__(199)
	
	/* template */
	var __vue_template__ = __webpack_require__(584)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(313)
	
	/* script */
	__vue_exports__ = __webpack_require__(200)
	
	/* template */
	var __vue_template__ = __webpack_require__(596)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-63f17be5"
	
	module.exports = __vue_exports__


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(314)
	
	/* script */
	__vue_exports__ = __webpack_require__(201)
	
	/* template */
	var __vue_template__ = __webpack_require__(597)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-729cae93"
	
	module.exports = __vue_exports__


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(304)
	
	/* script */
	__vue_exports__ = __webpack_require__(202)
	
	/* template */
	var __vue_template__ = __webpack_require__(585)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-21a04856"
	
	module.exports = __vue_exports__


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(203)
	
	/* template */
	var __vue_template__ = __webpack_require__(590)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(317)
	
	/* script */
	__vue_exports__ = __webpack_require__(204)
	
	/* template */
	var __vue_template__ = __webpack_require__(600)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7f328604"
	
	module.exports = __vue_exports__


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(205)
	
	/* template */
	var __vue_template__ = __webpack_require__(591)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(300)
	
	/* script */
	__vue_exports__ = __webpack_require__(206)
	
	/* template */
	var __vue_template__ = __webpack_require__(580)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-02f30d92"
	
	module.exports = __vue_exports__


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(316)
	
	/* script */
	__vue_exports__ = __webpack_require__(207)
	
	/* template */
	var __vue_template__ = __webpack_require__(599)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7cf1e53d"
	
	module.exports = __vue_exports__


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(320)
	
	/* script */
	__vue_exports__ = __webpack_require__(208)
	
	/* template */
	var __vue_template__ = __webpack_require__(603)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-ca817e8e"
	
	module.exports = __vue_exports__


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(209)
	
	/* template */
	var __vue_template__ = __webpack_require__(589)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(315)
	
	/* script */
	__vue_exports__ = __webpack_require__(210)
	
	/* template */
	var __vue_template__ = __webpack_require__(598)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-77d89edc"
	
	module.exports = __vue_exports__


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(310)
	
	/* script */
	__vue_exports__ = __webpack_require__(211)
	
	/* template */
	var __vue_template__ = __webpack_require__(593)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(309)
	
	/* script */
	__vue_exports__ = __webpack_require__(212)
	
	/* template */
	var __vue_template__ = __webpack_require__(592)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(213)
	
	/* template */
	var __vue_template__ = __webpack_require__(583)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(319)
	
	/* script */
	__vue_exports__ = __webpack_require__(214)
	
	/* template */
	var __vue_template__ = __webpack_require__(602)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(298)
	__webpack_require__(299)
	
	/* script */
	__vue_exports__ = __webpack_require__(215)
	
	/* template */
	var __vue_template__ = __webpack_require__(579)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-00c51922"
	
	module.exports = __vue_exports__


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(308)
	
	/* template */
	var __vue_template__ = __webpack_require__(588)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-286a2f0b"
	
	module.exports = __vue_exports__


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(312)
	
	/* script */
	__vue_exports__ = __webpack_require__(216)
	
	/* template */
	var __vue_template__ = __webpack_require__(595)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(301)
	
	/* script */
	__vue_exports__ = __webpack_require__(217)
	
	/* template */
	var __vue_template__ = __webpack_require__(581)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(302)
	
	/* script */
	__vue_exports__ = __webpack_require__(218)
	
	/* template */
	var __vue_template__ = __webpack_require__(582)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-15ac21cb"
	
	module.exports = __vue_exports__


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(318)
	
	/* script */
	__vue_exports__ = __webpack_require__(219)
	
	/* template */
	var __vue_template__ = __webpack_require__(601)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-9790e2c2"
	
	module.exports = __vue_exports__


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(305)
	
	/* script */
	__vue_exports__ = __webpack_require__(220)
	
	/* template */
	var __vue_template__ = __webpack_require__(586)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-227bcb03"
	
	module.exports = __vue_exports__


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(221)
	
	/* template */
	var __vue_template__ = __webpack_require__(604)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(321)
	
	/* script */
	__vue_exports__ = __webpack_require__(222)
	
	/* template */
	var __vue_template__ = __webpack_require__(605)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-e0ef6730"
	
	module.exports = __vue_exports__


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "map-generator"
	  }, [_c('header', {
	    staticClass: "generator-header"
	  }, [_c('router-link', {
	    attrs: {
	      "to": "create"
	    }
	  }, [_c('img', {
	    staticClass: "site-logo",
	    attrs: {
	      "src": __webpack_require__(548),
	      "alt": "declick log"
	    }
	  })]), _c('div', {
	    staticClass: "editor-selector",
	    on: {
	      "click": function($event) {
	        if ($event.target !== $event.currentTarget) { return null; }
	        _vm.isDrawer = !_vm.isDrawer
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-paint-brush",
	    on: {
	      "click": function($event) {
	        if ($event.target !== $event.currentTarget) { return null; }
	        _vm.isDrawer = !_vm.isDrawer
	      }
	    }
	  }), _c('toggle-button', {
	    staticClass: "view-select",
	    attrs: {
	      "sync": true
	    },
	    model: {
	      value: (_vm.isDrawer),
	      callback: function($$v) {
	        _vm.isDrawer = $$v
	      },
	      expression: "isDrawer"
	    }
	  }), _c('i', {
	    staticClass: "fa fa-keyboard",
	    on: {
	      "click": function($event) {
	        if ($event.target !== $event.currentTarget) { return null; }
	        _vm.isDrawer = !_vm.isDrawer
	      }
	    }
	  })], 1), _c('span', {
	    staticClass: "separator"
	  }), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.currentView === 'drawer'),
	      expression: "currentView === 'drawer'"
	    }],
	    staticClass: "drawer-options"
	  }, [_c('label', {
	    attrs: {
	      "for": "map-height",
	      "title": _vm.$t('mapgen.height-desc')
	    }
	  }, [_vm._v(_vm._s(_vm.$t('mapgen.height')))]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.rows),
	      expression: "rows"
	    }],
	    staticClass: "generator-height",
	    attrs: {
	      "type": "number",
	      "name": "map-height",
	      "title": _vm.$t('mapgen.height-desc'),
	      "placeholder": _vm.$t('mapgen.height'),
	      "max": "150",
	      "min": "1"
	    },
	    domProps: {
	      "value": (_vm.rows)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.rows = $event.target.value
	      }
	    }
	  }), _c('i', {
	    staticClass: "button-icon fas fa-exchange-alt",
	    attrs: {
	      "title": _vm.$t('mapgen.swap-desc')
	    },
	    on: {
	      "click": _vm.swapDimensions
	    }
	  }), _c('label', {
	    attrs: {
	      "for": "map-width",
	      "title": _vm.$t('mapgen.width-desc')
	    }
	  }, [_vm._v(_vm._s(_vm.$t('mapgen.width')))]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.columns),
	      expression: "columns"
	    }],
	    staticClass: "generator-width",
	    attrs: {
	      "type": "number",
	      "name": "map-width",
	      "title": _vm.$t('mapgen.width-desc'),
	      "placeholder": _vm.$t('mapgen.width'),
	      "max": "150",
	      "min": "1"
	    },
	    domProps: {
	      "value": (_vm.columns)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.columns = $event.target.value
	      }
	    }
	  }), _c('i', {
	    staticClass: "button-icon fas fa-trash-alt warn",
	    attrs: {
	      "title": _vm.$t('mapgen.trash-desc')
	    },
	    on: {
	      "click": function($event) {
	        _vm.showReset = true
	      }
	    }
	  }), _c('span', {
	    staticClass: "separator"
	  }), _c('i', {
	    staticClass: "button-icon fas fa-eraser warn",
	    attrs: {
	      "title": _vm.$t('mapgen.eraser-desc')
	    },
	    on: {
	      "click": function($event) {
	        _vm.showRemoveAll = true
	      }
	    }
	  }), _c('i', {
	    staticClass: "button-icon far fa-square",
	    attrs: {
	      "title": _vm.$t('mapgen.draw-border')
	    },
	    on: {
	      "click": _vm.drawBorders
	    }
	  }), _c('i', {
	    staticClass: "button-icon fas fa-fingerprint",
	    attrs: {
	      "type": "button",
	      "value": "generate maze",
	      "title": _vm.$t('mapgen.maze-generator-desc')
	    },
	    on: {
	      "click": function($event) {
	        return _vm.generateMaze(_vm.columns, _vm.rows)
	      }
	    }
	  }), _c('i', {
	    staticClass: "button-icon fas fa-calculator",
	    class: _vm.isPathToggled ? 'toggled' : '',
	    attrs: {
	      "type": "button",
	      "value": "generate maze",
	      "title": _vm.$t('mapgen.maze-pathfind-desc')
	    },
	    on: {
	      "click": _vm.toggleFindPath
	    }
	  }), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.currentView === 'drawer'),
	      expression: "currentView === 'drawer'"
	    }],
	    staticClass: "icon-chooser"
	  }, [_c('i', {
	    staticClass: "fas fa-chevron-left",
	    attrs: {
	      "title": _vm.$t('mapgen.previous-tile')
	    },
	    on: {
	      "click": _vm.increaseBuildingMaterial
	    }
	  }), _c('i', {
	    class: 'icon-screen to-build-' + _vm.toBuild,
	    attrs: {
	      "title": _vm.$t('mapgen.tile')
	    }
	  }), _c('i', {
	    staticClass: "fas fa-chevron-right",
	    attrs: {
	      "title": _vm.$t('mapgen.next-tile')
	    },
	    on: {
	      "click": _vm.decreaseBuildingMaterial
	    }
	  })])]), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.currentView === 'code'),
	      expression: "currentView === 'code'"
	    }],
	    staticClass: "code-options"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.builder),
	      expression: "builder"
	    }],
	    staticClass: "settings builder-name",
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.$t('mapgen.builder-name-desc'),
	      "title": _vm.$t('mapgen.builder-name-desc')
	    },
	    domProps: {
	      "value": (_vm.builder)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.builder = $event.target.value
	      }, _vm.updateTextEditor]
	    }
	  }), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.builderAction),
	      expression: "builderAction"
	    }],
	    staticClass: "settings builder-action",
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.$t('mapgen.builder-action-desc'),
	      "title": _vm.$t('mapgen.builder-action-desc')
	    },
	    domProps: {
	      "value": (_vm.builderAction)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.builderAction = $event.target.value
	      }, _vm.updateTextEditor]
	    }
	  }), _c('i', {
	    staticClass: "button-icon fas fa-eraser",
	    attrs: {
	      "title": _vm.$t('mapgen.erase-code-desc')
	    },
	    on: {
	      "click": _vm.clearTextEditor
	    }
	  }), _c('i', {
	    staticClass: "button-icon fas fa-clipboard",
	    attrs: {
	      "title": _vm.$t('mapgen.clipboard-desc')
	    },
	    on: {
	      "click": _vm.copyToClipboard
	    }
	  }), _c('i', {
	    staticClass: "button-icon fas fa-file-export",
	    attrs: {
	      "title": _vm.$t('mapgen.export-code')
	    },
	    on: {
	      "click": _vm.importCodeFromTextarea
	    }
	  }), _c('i', {
	    staticClass: "button-icon fab fa-readme",
	    attrs: {
	      "title": _vm.$t('mapgen.info')
	    },
	    on: {
	      "click": function($event) {
	        _vm.help = !_vm.help
	      }
	    }
	  })]), _c('span', {
	    staticClass: "cells-count",
	    attrs: {
	      "title": _vm.$t('mapgen.cells-desc')
	    }
	  }, [_vm._v(_vm._s(_vm.$t('mapgen.cells')) + " " + _vm._s(_vm.rows * _vm.columns))]), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.currentView === 'drawer'),
	      expression: "currentView === 'drawer'"
	    }],
	    staticClass: "button-icon fab fa-readme",
	    attrs: {
	      "title": _vm.$t('mapgen.info')
	    },
	    on: {
	      "click": function($event) {
	        _vm.help = !_vm.help
	      }
	    }
	  })], 1), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.currentView === 'drawer'),
	      expression: "currentView === 'drawer'"
	    }],
	    staticClass: "map-drawer"
	  }, [_c('table', {
	    attrs: {
	      "id": "grid",
	      "draggable": "false"
	    }
	  }, [_c('tbody', _vm._l((_vm.tiles.length), function(row, x) {
	    return _c('tr', {
	      key: x,
	      staticClass: "row",
	      attrs: {
	        "draggable": "false"
	      }
	    }, _vm._l((_vm.tiles[x].length), function(box, y) {
	      return _c('td', {
	        key: y,
	        staticClass: "item column",
	        attrs: {
	          "draggable": "false",
	          "data-x": x,
	          "data-y": y
	        },
	        on: {
	          "mousedown": _vm.mouseManager,
	          "mouseover": _vm.cellHightlighter
	        }
	      })
	    }), 0)
	  }), 0)]), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.help === true),
	      expression: "help === true"
	    }],
	    staticClass: "dark-layer",
	    on: {
	      "click": function($event) {
	        if ($event.target !== $event.currentTarget) { return null; }
	        _vm.help = false
	      }
	    }
	  }, [_c('div', {
	    staticClass: "help-drawer"
	  }, [_c('i', {
	    staticClass: "fas fa-times-circle",
	    on: {
	      "click": function($event) {
	        _vm.help = false
	      }
	    }
	  }), _c('h2', [_vm._v(_vm._s(_vm.$t('mapgen.help-drawer')))])])])]), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.currentView === 'code'),
	      expression: "currentView === 'code'"
	    }],
	    staticClass: "generator-code"
	  }, [_c('div', {
	    ref: "editor",
	    staticClass: "editor"
	  }), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.help === true),
	      expression: "help === true"
	    }],
	    staticClass: "dark-layer",
	    on: {
	      "click": function($event) {
	        if ($event.target !== $event.currentTarget) { return null; }
	        _vm.help = false
	      }
	    }
	  }, [_c('div', {
	    staticClass: "help-drawer"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('mapgen.help-editor')))]), _c('i', {
	    staticClass: "fas fa-times-circle",
	    on: {
	      "click": function($event) {
	        _vm.help = false
	      }
	    }
	  })])])]), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showRemoveAll || _vm.showReset),
	      expression: "showRemoveAll || showReset"
	    }],
	    staticClass: "dark-layer",
	    on: {
	      "click": function($event) {
	        _vm.showRemoveAll = false;
	        _vm.showReset = false
	      }
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showRemoveAll),
	      expression: "showRemoveAll"
	    }],
	    staticClass: "remove-all"
	  }, [_vm._v(_vm._s(_vm.$t('mapgen.alert.remove-all'))), _c('div', [_c('i', {
	    staticClass: "button-icon far fa-check-circle",
	    attrs: {
	      "title": _vm.$t('mapgen.alert.accept')
	    },
	    on: {
	      "click": _vm.clearMap
	    }
	  }), _c('i', {
	    staticClass: "far fa-times-circle warn",
	    attrs: {
	      "title": _vm.$t('mapgen.alert.refuse')
	    },
	    on: {
	      "click": function($event) {
	        _vm.showRemoveAll = false
	      }
	    }
	  })])]), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showReset),
	      expression: "showReset"
	    }],
	    staticClass: "remove-all"
	  }, [_vm._v(_vm._s(_vm.$t('mapgen.alert.reset'))), _c('div', [_c('i', {
	    staticClass: "far fa-check-circle",
	    attrs: {
	      "title": _vm.$t('mapgen.alert.accept')
	    },
	    on: {
	      "click": _vm.clearAll
	    }
	  }), _c('i', {
	    staticClass: "far fa-times-circle warn",
	    attrs: {
	      "title": _vm.$t('mapgen.alert.refuse')
	    },
	    on: {
	      "click": function($event) {
	        _vm.showReset = false
	      }
	    }
	  })])])])])
	},staticRenderFns: []}

/***/ }),
/* 580 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h3', [_vm._v("Mes projets")]), _c('ul', {
	    staticClass: "list-group"
	  }, _vm._l((_vm.projects), function(project) {
	    return _c('li', {
	      staticClass: "list-group-item"
	    }, [_c('a', {
	      on: {
	        "click": function($event) {
	          return _vm.$emit('showView', {
	            view: 'ProjectDetails',
	            params: {
	              project: project
	            }
	          })
	        }
	      }
	    }, [_c('h4', {
	      staticClass: "list-group-item-heading"
	    }, [_vm._v(_vm._s(project.name))])])])
	  }), 0), _c('button', {
	    staticClass: "btn btn-default",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('showView', 'ProjectCreator')
	      }
	    }
	  }, [_vm._v("démarrer un nouveau projet")])])
	},staticRenderFns: []}

/***/ }),
/* 581 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    ref: "menu",
	    staticClass: "main-menu",
	    class: _vm.stateClass
	  }, [_c('button', {
	    staticClass: "main-menu__open",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.open
	    }
	  }), _c('button', {
	    staticClass: "main-menu__close",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.close
	    }
	  }), _c('ul', {
	    staticClass: "main-menu__list"
	  }, [_c('li', {
	    staticClass: "main-menu__item"
	  }, [_c('router-link', {
	    staticClass: "main-menu__link main-menu__home",
	    attrs: {
	      "to": "/"
	    }
	  }, [_vm._v("ACCUEIL")])], 1), _c('li', {
	    staticClass: "main-menu__item"
	  }, [_c('router-link', {
	    staticClass: "main-menu__link",
	    attrs: {
	      "to": "/progress"
	    }
	  }, [_vm._v("APPRENDRE")])], 1), _c('li', {
	    staticClass: "main-menu__item"
	  }, [_c('router-link', {
	    staticClass: "main-menu__link",
	    attrs: {
	      "to": "/create"
	    }
	  }, [_vm._v("CRÉER")])], 1), _c('li', {
	    staticClass: "main-menu__item"
	  }, [_c('router-link', {
	    staticClass: "main-menu__link",
	    attrs: {
	      "to": "/explore"
	    }
	  }, [_vm._v("JOUER")])], 1), _c('li', {
	    staticClass: "main-menu__item"
	  }, [(!_vm.user) ? _c('a', {
	    staticClass: "main-menu__link connectionLink illustrated-link log-in-link",
	    on: {
	      "click": function($event) {
	        _vm.isAuthenticationModalVisible = true
	      }
	    }
	  }, [_vm._v("SE CONNECTER")]) : _c('a', {
	    staticClass: "main-menu__link connectionLink",
	    on: {
	      "click": _vm.logOut
	    }
	  }, [_vm._v("SE DÉCONNECTER")])]), (_vm.user) ? _c('li', {
	    staticClass: "main-menu__item"
	  }, [_c('router-link', {
	    staticClass: "main-menu__link",
	    attrs: {
	      "to": _vm.getUserIDLink
	    }
	  }, [_vm._v("MON COMPTE")])], 1) : _vm._e()]), (_vm.isAuthenticationModalVisible) ? _c('authentication-modal', {
	    on: {
	      "close": function($event) {
	        _vm.isAuthenticationModalVisible = false
	      }
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(527),
	      "alt": ""
	    }
	  })])
	}]}

/***/ }),
/* 583 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('router-view')
	},staticRenderFns: []}

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "home"
	  }, [_c('div', {
	    staticClass: "home__presentation"
	  }, [_c('h1', [_vm._v("Declick est un outil clé en main !")]), _c('p', [_vm._v("En classe, en atelier ou à la maison, il permet d'aborder les bases du\ncode informatique et de les appliquer à travers des projets, individuels\nou collectifs, d'applications ou de jeux vidéo.")]), _c('a', {
	    attrs: {
	      "href": "https://www.instagram.com/associationcolombbus/",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    staticClass: "instaBannier",
	    attrs: {
	      "src": __webpack_require__(547)
	    }
	  })])]), _c('div', {
	    staticClass: "home__box"
	  }, [_c('img', {
	    staticClass: "home__robot-train",
	    attrs: {
	      "src": __webpack_require__(532),
	      "alt": "robot logo declick"
	    }
	  }), _c('h3', [_vm._v("les parcours")]), _c('p', [_vm._v("La section « APPRENDRE » regroupe des parcours qui vous permettent\nd'assimiler progressivement des notions de programmation.")])]), _c('div', {
	    staticClass: "home__box"
	  }, [_c('img', {
	    staticClass: "home__robot-idea",
	    attrs: {
	      "src": __webpack_require__(530),
	      "alt": "robot logo declick"
	    }
	  }), _c('h3', [_vm._v("l'espace créatif")]), _c('p', [_vm._v("La section « CRÉER » vous propose un environnement de travail où vous\npouvez composer avec les notions acquises pour créer vos propres jeux et\napplications.")])]), _c('div', {
	    staticClass: "home__box"
	  }, [_c('img', {
	    staticClass: "home__robot-observe",
	    attrs: {
	      "src": __webpack_require__(531),
	      "alt": "robot logo declick"
	    }
	  }), _c('h3', [_vm._v("l'espace découverte")]), _c('p', [_vm._v("Dans la section « JOUER » retrouvez et testez les jeux ou les\napplications créés par la communauté Declick.")])]), _c('h2', [_vm._v("declick en vidéo")]), _c('div', {
	    staticClass: "home__video"
	  }, [_c('iframe', {
	    attrs: {
	      "src": "https://player.vimeo.com/video/211507001?title=0&byline=0&portrait=0",
	      "frameborder": "0",
	      "webkitallowfullscreen": "webkitallowfullscreen",
	      "mozallowfullscreen": "mozallowfullscreen",
	      "allowfullscreen": "allowfullscreen",
	      "alt": "video presentation declick"
	    }
	  })]), _c('h2', [_vm._v("notre approche")]), _c('div', {
	    staticClass: "home__box"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(533)
	    }
	  }), _c('h3', [_vm._v("notre mission")]), _c('p', [_vm._v("Declick a été conçu pour initier les 8-15 ans au code et à la création\nnumérique, à travers la programmation écrite. La plateforme constitue\nainsi une étape intermédiaire entre les éditeurs visuels (type Scratch)\net les vrais environnements de programmation.")])]), _c('div', {
	    staticClass: "home__box"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(528)
	    }
	  }), _c('h3', [_vm._v("notre pédagogie")]), _c('p', [_vm._v("Declick est le fruit de plus de 10 ans d'expérience de l'enseignement de\nla programmation auprès des jeunes, notamment en zone d'éduction\nprioritaire : la plateforme est utilisée quotidiennement pour l'animation\nd'ateliers dans les collèges les écoles élémentaires et les centres\nd'animation.")])]), _c('div', {
	    staticClass: "home__box"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(542)
	    }
	  }), _c('h3', [_vm._v("un logiciel libre")]), _c('p', [_vm._v("Declick est gratuit et libre : le code source de la plateforme est\nhébergé sur GitHub et diffusé sous license GPL 3.0. Si vous voulez\ncontribuer au développement, n'hésitez pas à nous contacter !")]), _c('img', {
	    staticClass: "home__tag",
	    attrs: {
	      "src": __webpack_require__(529)
	    }
	  })]), _c('div', {
	    staticClass: "home__about-us"
	  }, [_c('h3', [_vm._v("l'association Colombbus")]), _c('p', [_vm._v("Depuis 18 ans nous agissons pour l'éducation la formation, l'insertion\nsociale et professionnelle grâce à l'informatique et à internet. À\ntravers nos activités nous facilitons l'usage et l'appropriation des\noutils numériques qui deviennent alors vecteurs d'inclusion, de\ndéveloppement personnel et de lien social.")]), _c('a', {
	    attrs: {
	      "href": "https://www.colombbus.org/",
	      "target": "_blank"
	    }
	  }, [_vm._v("en savoir plus")])]), _c('div', {
	    staticClass: "home__partners"
	  }, [_c('h3', [_vm._v("nos partenaires éducatifs")]), _c('div', {
	    staticClass: "home__logo-group"
	  }, [_c('a', {
	    attrs: {
	      "href": "https://pixees.fr/classcode-v2/",
	      "title": "Class'Code",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(535)
	    }
	  })]), _c('a', {
	    attrs: {
	      "href": "https://d-clicsnumeriques.org/",
	      "title": "D-Clics Numériques",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(536)
	    }
	  })]), _c('a', {
	    attrs: {
	      "href": "https://www.reseau-canope.fr/",
	      "title": "Réseau Canopé",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(534)
	    }
	  })]), _c('a', {
	    attrs: {
	      "href": "http://www.ensiie.fr/",
	      "title": "ENSIIE",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(537)
	    }
	  })]), _c('a', {
	    attrs: {
	      "href": "http://www.france-ioi.org/",
	      "title": "France-IOI",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(539)
	    }
	  })])]), _c('h3', [_vm._v("nos partenaires publics")]), _c('div', {
	    staticClass: "home__logo-group"
	  }, [_c('a', {
	    attrs: {
	      "href": "http://www.education.gouv.fr/",
	      "title": "Ministère de l'Éducation nationale",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(541)
	    }
	  })]), _c('a', {
	    attrs: {
	      "href": "http://www.europe-en-france.gouv.fr/",
	      "title": "L'Europe s'engage",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(546)
	    }
	  })]), _c('a', {
	    attrs: {
	      "href": "https://www.paris.fr/",
	      "title": "Mairie de Paris",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(540)
	    }
	  })])]), _c('h3', [_vm._v("nos mécènes")]), _c('div', {
	    staticClass: "home__logo-group"
	  }, [_c('a', {
	    attrs: {
	      "href": "https://www.vivendi.com/create-joy-fr/",
	      "title": "Vivendi Create Joy",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(545)
	    }
	  })]), _c('a', {
	    attrs: {
	      "href": "https://www.thalesgroup.com/fr",
	      "title": "Thales",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(544)
	    }
	  })]), _c('a', {
	    attrs: {
	      "href": "https://www.fondation-sncf.org/fr/",
	      "title": "Fondation SNCF",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(538)
	    }
	  })]), _c('a', {
	    attrs: {
	      "href": "https://www.sap.com/france/index.html",
	      "title": "SAP",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(543)
	    }
	  })])])])])
	}]}

/***/ }),
/* 585 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "create-view"
	  }, [_c('create-header-bar'), _c('create-menu-bar', {
	    attrs: {
	      "editor": _vm.editor
	    },
	    on: {
	      "showView": _vm.showView,
	      "toggleEditor": function($event) {
	        _vm.editor = !_vm.editor
	      }
	    }
	  }), _c('transition', {
	    attrs: {
	      "css": false
	    },
	    on: {
	      "before-enter": _vm.beforeEnter,
	      "enter": _vm.onEnter,
	      "leave": _vm.onLeave
	    }
	  }, [(_vm.view) ? _c('div', {
	    staticClass: "slider"
	  }, [_c('button', {
	    staticClass: "close-button",
	    on: {
	      "click": function($event) {
	        _vm.view = null
	      }
	    }
	  }), (_vm.view) ? _c(_vm.view, {
	    tag: "component",
	    attrs: {
	      "params": _vm.params
	    },
	    on: {
	      "showView": _vm.showView,
	      "close": function($event) {
	        _vm.view = null
	      }
	    }
	  }) : _vm._e()], 1) : _vm._e()]), _c('iframe', {
	    ref: "wikiFrame",
	    staticClass: "wikiFrame",
	    attrs: {
	      "src": _vm.wikiUrl
	    }
	  }), _c('iframe', {
	    ref: "createFrame",
	    staticClass: "frame",
	    attrs: {
	      "src": _vm.frameUrl
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 586 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "form-group has-feedback",
	    class: {
	      'has-error': _vm.errors.username
	    }
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_vm._m(0), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.username),
	      expression: "username"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "nom d'utilisateur"
	    },
	    domProps: {
	      "value": (_vm.username)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.logIn($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.username = $event.target.value
	      }
	    }
	  })]), (_vm.errors.username) ? _c('span', {
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.username[0]))]) : _vm._e()]), _c('div', {
	    staticClass: "form-group has-feedback",
	    class: {
	      'has-error': _vm.errors.email
	    }
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_vm._m(1), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.email),
	      expression: "email"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "email (optionnel)"
	    },
	    domProps: {
	      "value": (_vm.email)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.register($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.email = $event.target.value
	      }
	    }
	  })]), (_vm.errors.email) ? _c('span', {
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.email[0]))]) : _vm._e()]), _c('div', {
	    staticClass: "form-group has-feedback",
	    class: {
	      'has-error': _vm.errors.password
	    }
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_vm._m(2), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.password),
	      expression: "password"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "password",
	      "placeholder": "mot de passe"
	    },
	    domProps: {
	      "value": (_vm.password)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.register($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.password = $event.target.value
	      }
	    }
	  })]), (_vm.errors.password) ? _c('span', {
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.password[0]))]) : _vm._e()]), _c('div', {
	    staticClass: "form-group has-feedback",
	    class: {
	      'has-error': _vm.errors.passwordConfirmation
	    }
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_vm._m(3), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.passwordConfirmation),
	      expression: "passwordConfirmation"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "password",
	      "placeholder": "confirmation mot de passe"
	    },
	    domProps: {
	      "value": (_vm.passwordConfirmation)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.register($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.passwordConfirmation = $event.target.value
	      }
	    }
	  })]), (_vm.errors.passwordConfirmation) ? _c('span', {
	    staticClass: "help-block"
	  }, [_vm._v(" " + _vm._s(_vm.errors.passwordConfirmation[0]))]) : _vm._e()]), _c('button', {
	    staticClass: "btn btn-block btn-primary",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.register
	    }
	  }, [_vm._v("valider l'inscription")]), (_vm.errors.server) ? _c('span', {
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.server[0]))]) : _vm._e(), _c('button', {
	    staticClass: "btn btn-block btn-link",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('switch-to-connection')
	      }
	    }
	  }, [_vm._v("retourner à la connexion")])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "input-group-addon"
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-user"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "input-group-addon"
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-envelope"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "input-group-addon"
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-lock"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "input-group-addon"
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-lock"
	  })])
	}]}

/***/ }),
/* 587 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "self",
	    style: ({
	      overflow: _vm.viewUseFullscreen ? 'hidden' : null
	    })
	  }, [_c('HeaderBar', {
	    staticClass: "application__header"
	  }), _c('MainMenu', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.viewUseFullscreen),
	      expression: "!viewUseFullscreen"
	    }],
	    staticClass: "header"
	  }), _c('div', {
	    staticClass: "content"
	  }, [_c('course-run', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (this.$route.name === 'step'),
	      expression: "this.$route.name === 'step'"
	    }]
	  }), _c('create-view', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (this.$route.name === 'create'),
	      expression: "this.$route.name === 'create'"
	    }]
	  }), _c('execute', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (this.$route.name === 'execute'),
	      expression: "this.$route.name === 'execute'"
	    }]
	  }), _c('keep-alive', [(_vm.$route.meta.keepAlive === undefined || _vm.$route.meta.keepAlive) ? _c('router-view', {
	    key: _vm.viewId,
	    attrs: {
	      "id": _vm.viewId
	    }
	  }) : _vm._e()], 1), (_vm.$route.meta.keepAlive !== undefined && !_vm.$route.meta.keepAlive) ? _c('router-view', {
	    key: _vm.viewId,
	    attrs: {
	      "id": _vm.viewId
	    }
	  }) : _vm._e()], 1), _c('footer-bar', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.viewUseFullscreen),
	      expression: "!viewUseFullscreen"
	    }]
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 588 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "footer-bar"
	  }, [_vm._v("© Colombbus 2018 - "), _c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "mailto:declick@colombbus.org"
	    }
	  }, [_vm._v("contact")])])
	}]}

/***/ }),
/* 589 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('keep-alive', [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),
/* 590 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h3', [_vm._v("Nouveau projet")]), _c('form', [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": "project-creation-project-name"
	    }
	  }, [_vm._v("nom du projet")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.name),
	      expression: "name"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "project-creation-project-name",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.name = $event.target.value
	      }
	    }
	  })]), _c('div', {
	    staticClass: "checkbox"
	  }, [_c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.isPublic),
	      expression: "isPublic"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.isPublic) ? _vm._i(_vm.isPublic, null) > -1 : (_vm.isPublic)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.isPublic,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.isPublic = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.isPublic = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.isPublic = $$c
	        }
	      }
	    }
	  }), _vm._v("rendre le projet public")])]), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": "project-creation-scene-width"
	    }
	  }, [_vm._v("largeur de la scène (pixels)")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sceneWidth),
	      expression: "sceneWidth"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "project-creation-scene-width",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.sceneWidth)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.sceneWidth = $event.target.value
	      }
	    }
	  })]), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": "project-creation-scene-height"
	    }
	  }, [_vm._v("hauteur de la scène (pixels)")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sceneHeight),
	      expression: "sceneHeight"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "project-creation-scene-height",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.sceneHeight)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.sceneHeight = $event.target.value
	      }
	    }
	  })]), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": "project-creation-description"
	    }
	  }, [_vm._v("description")]), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.description),
	      expression: "description"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "project-creation-description",
	      "rows": "3"
	    },
	    domProps: {
	      "value": (_vm.description)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.description = $event.target.value
	      }
	    }
	  })]), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": "project-creation-instructions"
	    }
	  }, [_vm._v("instructions")]), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.instructions),
	      expression: "instructions"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "project-creation-instructions",
	      "rows": "3"
	    },
	    domProps: {
	      "value": (_vm.instructions)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.instructions = $event.target.value
	      }
	    }
	  })]), _c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('showView', 'ProjectList')
	      }
	    }
	  }, [_vm._v("annuler")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.createProject
	    }
	  }, [_vm._v("créer")])])])
	},staticRenderFns: []}

/***/ }),
/* 591 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h3', [_vm._v("Nouveau projet")]), _c('form', [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": "project-edition-project-name"
	    }
	  }, [_vm._v("nom du projet")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.name),
	      expression: "name"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "project-edition-project-name",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.name = $event.target.value
	      }
	    }
	  })]), _c('div', {
	    staticClass: "checkbox"
	  }, [_c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.isPublic),
	      expression: "isPublic"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.isPublic) ? _vm._i(_vm.isPublic, null) > -1 : (_vm.isPublic)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.isPublic,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.isPublic = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.isPublic = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.isPublic = $$c
	        }
	      }
	    }
	  }), _vm._v("rendre le projet public")])]), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": "project-edition-scene-width"
	    }
	  }, [_vm._v("largeur de la scène (pixels)")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sceneWidth),
	      expression: "sceneWidth"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "project-edition-scene-width",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.sceneWidth)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.sceneWidth = $event.target.value
	      }
	    }
	  })]), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": "project-edition-scene-height"
	    }
	  }, [_vm._v("hauteur de la scène (pixels)")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sceneHeight),
	      expression: "sceneHeight"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "project-edition-scene-height",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.sceneHeight)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.sceneHeight = $event.target.value
	      }
	    }
	  })]), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": "project-edition-description"
	    }
	  }, [_vm._v("description")]), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.description),
	      expression: "description"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "project-edition-description",
	      "rows": "3"
	    },
	    domProps: {
	      "value": (_vm.description)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.description = $event.target.value
	      }
	    }
	  })]), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": "project-edition-instructions"
	    }
	  }, [_vm._v("instructions")]), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.instructions),
	      expression: "instructions"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "project-edition-instructions",
	      "rows": "3"
	    },
	    domProps: {
	      "value": (_vm.instructions)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.instructions = $event.target.value
	      }
	    }
	  })]), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": "project-edition-main-program-id"
	    }
	  }, [_vm._v("programme principal")]), (_vm.resources) ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.mainProgramId),
	      expression: "mainProgramId"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "project-edition-main-program-id"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.mainProgramId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.resources), function(resource) {
	    return (resource.media_type === 'text/vnd.colombbus.declick.script') ? _c('option', {
	      class: {
	        selected: _vm.mainProgramId === resource.id
	      },
	      domProps: {
	        "value": resource.id
	      }
	    }, [_vm._v(_vm._s(resource.file_name))]) : _vm._e()
	  }), 0) : _vm._e()]), _c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.showProjectDetails
	    }
	  }, [_vm._v("annuler")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.updateProject
	    }
	  }, [_vm._v("enregistrer les modifications")])])])
	},staticRenderFns: []}

/***/ }),
/* 592 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('p', {
	    staticClass: "mapHelp"
	  }, [_c('input', {
	    attrs: {
	      "type": "button",
	      "value": "Centrer la carte"
	    },
	    on: {
	      "click": _vm.centeringMap
	    }
	  }), _vm._v(" "), (_vm.user !== null && _vm.token !== null) ? _c('input', {
	    attrs: {
	      "type": "button",
	      "value": "Réinitialiser le parcours "
	    },
	    on: {
	      "click": function($event) {
	        _vm.showRest = true;
	      }
	    }
	  }) : _vm._e()]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.showRest) ? _c('div', {
	    attrs: {
	      "id": "popinResetCircuits"
	    }
	  }, [_c('div', [_c('p', {
	    staticClass: "mapHelp alignCenter"
	  }, [_vm._v("\n        Attention ! Cette action supprimera l'ensemble des réponses du parcours"), _c('br'), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "button",
	      "id": "validation",
	      "value": "Confirmer"
	    },
	    on: {
	      "click": _vm.resetCircuitResult
	    }
	  }), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "button",
	      "id": "annullation",
	      "value": "Annuler"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showRest = false
	      }
	    }
	  })])])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "declickMap"
	    }
	  }, [_c('canvas', {
	    attrs: {
	      "id": "map"
	    }
	  })])
	}]}

/***/ }),
/* 593 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('progress-header-bar'), _vm._v(" "), _c('iframe', {
	    ref: "iframe",
	    staticClass: "fullscreen-iframe2",
	    attrs: {
	      "src": _vm.urlLearn,
	      "id": "declick-client-learn"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "error"
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "contentContainerHome"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "onLoadGif"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(183)
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("Chargement...")])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "content"
	    }
	  })])
	}]}

/***/ }),
/* 595 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.testRoute()) ? _c('div', {
	    staticClass: "slogan-bar"
	  }, [_c('router-link', {
	    staticClass: "slogan-bar__logo",
	    attrs: {
	      "to": "/",
	      "tag": "button"
	    }
	  })], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 596 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "self"
	  }, [_c('router-link', {
	    staticClass: "home-link",
	    attrs: {
	      "to": "/"
	    }
	  }), _c('span', {
	    staticClass: "title"
	  }, [_vm._v("Créer")]), _c('router-link', {
	    staticClass: "close-link",
	    attrs: {
	      "to": "/"
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 597 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "self"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.user),
	      expression: "user"
	    }],
	    staticClass: "dropdown"
	  }, [_c('a', {
	    staticClass: "dropdown-trigger",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    }
	  }), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_c('li', [_c('a', {
	    on: {
	      "click": function($event) {
	        return _vm.$emit('showView', {
	          view: 'ProjectDetails',
	          params: {
	            project: _vm.currentProject
	          }
	        })
	      }
	    }
	  }, [_vm._v("informations")])]), _c('li', {
	    staticClass: "divider",
	    attrs: {
	      "role": "separator"
	    }
	  }), _c('li', [_c('a', {
	    on: {
	      "click": function($event) {
	        return _vm.$emit('showView', 'ProjectList')
	      }
	    }
	  }, [_vm._v("projets")])]), (_vm.user) ? [_c('li', {
	    staticClass: "divider",
	    attrs: {
	      "role": "separator"
	    }
	  }), _c('li', {
	    staticClass: "styleLikeLink"
	  }, [_vm._v("Importer des exemples de programmes :")]), _c('li', [_c('a', {
	    on: {
	      "click": function($event) {
	        return _vm.importExamplePrograms(402)
	      }
	    }
	  }, [_vm._v("Les bases - inspirées de Bob&Max "), _vm._m(0)])]), _c('li', [_c('a', {
	    on: {
	      "click": function($event) {
	        return _vm.importExamplePrograms(5692)
	      }
	    }
	  }, [_vm._v("Plateforme - Level 1 2 3 "), _vm._m(1)])]), _c('li', [_c('a', {
	    on: {
	      "click": function($event) {
	        return _vm.importExamplePrograms(6959)
	      }
	    }
	  }, [_vm._v("DinoRun "), _vm._m(2)])]), _c('li', [_c('a', {
	    on: {
	      "click": function($event) {
	        return _vm.importExamplePrograms(6895)
	      }
	    }
	  }, [_vm._v("Pong "), _vm._m(3)])]), _c('li', [_c('a', {
	    on: {
	      "click": function($event) {
	        return _vm.importExamplePrograms(5833)
	      }
	    }
	  }, [_vm._v("Runner - GothicVania "), _vm._m(4)])])] : _vm._e()], 2)]), _c('span', {
	    staticClass: "project-name"
	  }, [_vm._v(_vm._s((_vm.currentProject && _vm.currentProject.name) || 'Projet'))]), _c('a', {
	    class: _vm.editor ? 'show-view-link' : 'show-editor-link',
	    on: {
	      "click": _vm.toggleMode
	    }
	  }), _c('router-link', {
	    staticClass: "show-maze-editor-link",
	    attrs: {
	      "to": "/draw",
	      "title": "designer de niveau - beta"
	    }
	  })], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "difficulty easy"
	  }, [_c('i', {
	    staticClass: "far fa-star"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "difficulty medium"
	  }, [_c('i', {
	    staticClass: "far fa-star"
	  }), _c('i', {
	    staticClass: "far fa-star"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "difficulty medium"
	  }, [_c('i', {
	    staticClass: "far fa-star"
	  }), _c('i', {
	    staticClass: "far fa-star"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "difficulty hard"
	  }, [_c('i', {
	    staticClass: "far fa-star"
	  }), _c('i', {
	    staticClass: "far fa-star"
	  }), _c('i', {
	    staticClass: "far fa-star"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "difficulty hard"
	  }, [_c('i', {
	    staticClass: "far fa-star"
	  }), _c('i', {
	    staticClass: "far fa-star"
	  }), _c('i', {
	    staticClass: "far fa-star"
	  })])
	}]}

/***/ }),
/* 598 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "self"
	  }, _vm._l((_vm.courses), function(course) {
	    return _c('div', {
	      staticClass: "course"
	    }, [_c('div', {
	      staticClass: "image-area"
	    }, [(course.imageUrl) ? _c('img', {
	      attrs: {
	        "src": _vm.getImg(course)
	      }
	    }) : _vm._e()]), _c('p', {
	      staticClass: "fields-area"
	    }, [_c('router-link', {
	      staticClass: "name",
	      attrs: {
	        "to": '/progress/course/' + course.id
	      }
	    }, [_vm._v(_vm._s(course.name))]), _c('br')], 1), _c('p', {
	      staticClass: "summary",
	      domProps: {
	        "innerHTML": _vm._s(course.summary)
	      }
	    }), _c('br'), (course.details) ? _c('div', [(!course.showDetails) ? _c('span', [_c('a', {
	      staticClass: "toggle-details-link",
	      on: {
	        "click": function($event) {
	          course.showDetails = true
	        }
	      }
	    }, [_c('span', {
	      staticClass: "glyphicon glyphicon-triangle-right"
	    }), _vm._v("\nafficher les détails")])]) : _c('span', [_c('a', {
	      staticClass: "toggle-details-link",
	      on: {
	        "click": function($event) {
	          course.showDetails = false
	        }
	      }
	    }, [_c('span', {
	      staticClass: "glyphicon glyphicon-triangle-bottom"
	    }), _vm._v("\nmasquer les détails")]), _c('br'), _c('span', {
	      staticClass: "details",
	      domProps: {
	        "innerHTML": _vm._s(course.details)
	      }
	    })])]) : _vm._e(), _c('p')])
	  }), 0)
	},staticRenderFns: []}

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main"
	  }, [_c('div', {
	    ref: "loading",
	    staticClass: "loading"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(183)
	    }
	  }), _c('p', [_vm._v("Chargement...")])]), _c('execute-header-bar'), (_vm.projectReady) ? _c('div', {
	    staticClass: "main__execute"
	  }, [_c('iframe', {
	    staticClass: "execution",
	    style: (_vm.iframeStyle),
	    attrs: {
	      "src": _vm.iframeUrl,
	      "frameborder": "0",
	      "scrolling": "no",
	      "onmousewheel": ""
	    }
	  })]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 600 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h3', [_vm._v("Mes projets > " + _vm._s(_vm.project.name))]), _c('div', {
	    staticClass: "panel panel-default"
	  }, [_c('dl', [_c('dt', [_vm._v("nom du projet")]), _c('dd', [_vm._v(_vm._s(_vm.project.name))]), _c('dt', [_vm._v("lien vers l'application")]), _c('dd', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'execute',
	        params: {
	          projectId: _vm.project.id
	        }
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.project.name))])], 1), _c('dt', [_vm._v("public")]), _c('dd', [_vm._v(_vm._s(_vm.project.isPublic ? 'oui' : 'non'))]), _c('dt', [_vm._v("largeur de la scène")]), _c('dd', [_vm._v(_vm._s(_vm.project.sceneWidth))]), _c('dt', [_vm._v("hauteur de la scène")]), _c('dd', [_vm._v(_vm._s(_vm.project.sceneHeight))]), _c('dt', [_vm._v("description")]), _c('dd', [_vm._v(_vm._s(_vm.project.description))]), _c('dt', [_vm._v("instructions")]), _c('dd', [_vm._v(_vm._s(_vm.project.instructions))])])]), _c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$emit('showView', {
	          view: 'ProjectEditor',
	          params: {
	            project: _vm.project
	          }
	        })
	      }
	    }
	  }, [_vm._v("modifier les informations")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.selectAsCurrentProject
	    }
	  }, [_vm._v("travailler sur ce projet")]), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.project.isDefault),
	      expression: "!project.isDefault"
	    }],
	    staticClass: "btn btn-danger",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.deleteProject
	    }
	  }, [_vm._v("supprimer")])])
	},staticRenderFns: []}

/***/ }),
/* 601 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "modal"
	    }
	  }, [_c('div', {
	    staticClass: "mask",
	    on: {
	      "click": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "wrapper"
	  }, [_c('div', {
	    staticClass: "container",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.mode === 'connection'),
	      expression: "mode === 'connection'"
	    }]
	  }, [(_vm.error) ? _c('div', {
	    staticClass: "form-group has-error"
	  }, [_c('span', {
	    staticClass: "help-block"
	  }, [_vm._v("Nom d'utilisateur ou mot de passe incorrect")])]) : _vm._e(), _c('div', {
	    staticClass: "form-group has-feedback"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('div', {
	    staticClass: "input-group-addon"
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-user"
	  })]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.username),
	      expression: "username"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "nom d'utilisateur"
	    },
	    domProps: {
	      "value": (_vm.username)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.logIn($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.username = $event.target.value
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('div', {
	    staticClass: "input-group-addon"
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-lock"
	  })]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.password),
	      expression: "password"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "password",
	      "placeholder": "mot de passe"
	    },
	    domProps: {
	      "value": (_vm.password)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.logIn($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.password = $event.target.value
	      }
	    }
	  })])]), _c('button', {
	    staticClass: "btn btn-block btn-primary",
	    attrs: {
	      "disabled": _vm.isLogingIn,
	      "type": "button"
	    },
	    on: {
	      "click": _vm.logIn
	    }
	  }, [_vm._v("se connecter"), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.isLogingIn),
	      expression: "isLogingIn"
	    }]
	  }, [_vm._v(" "), _c('span', {
	    staticClass: "fa fa-circle-o-notch fa-spin"
	  })])]), _c('button', {
	    staticClass: "btn btn-block btn-link",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.mode = 'registration'
	      }
	    }
	  }, [_vm._v("s'inscrire")])]), _c('registration-form', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.mode === 'registration'),
	      expression: "mode === 'registration'"
	    }],
	    on: {
	      "switch-to-connection": function($event) {
	        _vm.mode = 'connection'
	      },
	      "close": function($event) {
	        return _vm.$emit('close')
	      }
	    }
	  })], 1)])])])
	},staticRenderFns: []}

/***/ }),
/* 602 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "navigation-bar-small"
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/",
	      "id": "home-control-small"
	    }
	  }), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "page-title"
	    }
	  }, [_vm._v(_vm._s(this.assessmentName))]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": '/progress/course/' + this.$route.params.id,
	      "id": "map-control-small"
	    }
	  }), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "mapController"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "leftLink"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.previous()
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "rightLink"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.next()
	      }
	    }
	  })])], 1)
	},staticRenderFns: []}

/***/ }),
/* 603 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "self"
	  }, [_c('router-link', {
	    staticClass: "home-link",
	    attrs: {
	      "to": "/"
	    }
	  }), _c('span', {
	    staticClass: "title"
	  }, [_vm._v(_vm._s((_vm.project && _vm.project.name)))]), _c('div', {
	    staticClass: "close-link",
	    on: {
	      "click": _vm.goBack
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 604 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.user) ? _c('div', [_c('h3', [_vm._v("Utilisateurs > " + _vm._s(_vm.user.username))]), _c('form', [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": "user-edition-project-name"
	    }
	  }, [_vm._v("email")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.email),
	      expression: "user.email"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "user-edition-project-name",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.user.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.user, "email", $event.target.value)
	      }
	    }
	  })]), _c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.showUserProfile
	    }
	  }, [_vm._v("annuler")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.updateUser
	    }
	  }, [_vm._v("enregistrer les modifications")])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 605 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.user) ? _c('div', [_c('h3', [_vm._v("Utilisateurs > " + _vm._s(_vm.user.username))]), _c('div', {
	    staticClass: "panel panel-default"
	  }, [_c('dl', [_c('dt', [_vm._v("email")]), _c('dd', [_vm._v(_vm._s(_vm.user.email))])])]), _c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.editUser
	    }
	  }, [_vm._v("modifier les informations")])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.5c73a7c13362f220134e.js